import { totemPresencePtBR } from "./totem-presence-messages";
import { giftPreflightPtBR } from "./gift-preflight-messages";
import { trailChatV3PtBR } from "./trail-chat-v3-messages";
import { giftRefundPtBR } from "./gift-refund-messages";
import { roomToolsPtBR } from "./room-tools-messages";
import { reportsDashboardPtBR } from "./reports-dashboard-messages";

export const ptBRMessages = {
  totemPresence: totemPresencePtBR,
  quizReview: {
  "title": "Revisão com Jev",
  "scope": "Confira clareza, alternativas que se confundem e pistas que entregam a resposta antes de publicar.",
  "disclaimer": "A revisão é opcional e analisa apenas o texto. Os indícios podem falhar; confira o conteúdo e o gabarito antes de publicar.",
  "button": "Revisar quiz",
  "loading": "Revisando quiz…",
  "retry": "Tentar novamente",
  "again": "Revisar novamente",
  "summary": "Questões: {{attention}} com indícios · {{uncertain}} inconclusivas · {{clear}} sem indícios detectados",
  "question": "Questão {{number}}",
  "media": "Imagens, vídeos e outros anexos não foram avaliados. Confira a questão junto com a mídia.",
  "criteria": {
    "clarity": "Clareza do enunciado",
    "answerOverlap": "Alternativas que se confundem",
    "answerLeak": "Pistas da resposta"
  },
  "status": {
    "attention": "Atenção",
    "uncertain": "Inconclusivo",
    "clear": "Nenhum indício detectado",
    "not_applicable": "Não se aplica"
  },
  "suggestions": {
    "clarity": "Confira se o enunciado diz exatamente o que o aluno deve responder e traz o contexto necessário.",
    "answerOverlap": "Confira se apenas uma alternativa pode ser defendida como correta. Diferencie opções com sentidos próximos.",
    "answerLeak": "Confira se o enunciado ou a forma de escrever as alternativas entrega qual é a resposta correta."
  },
  "errors": {
    "incomplete": "Preencha o título, os enunciados e as alternativas e indique o gabarito para revisar.",
    "limits": "A revisão aceita até 30 questões e 10 alternativas por questão. Limites de texto: título 200, descrição e enunciado 4.000, alternativa 1.000 e total 60.000 caracteres.",
    "unavailable": "Não foi possível revisar agora. Tente novamente em instantes.",
    "invalidResponse": "A revisão retornou dados incompletos. Tente novamente."
  }
},
  trailChatV3: trailChatV3PtBR,
  giftRefund: giftRefundPtBR,
  giftPreflight: giftPreflightPtBR,
  debugMenu: {
    trigger: "Debug",
    subscriptionGroup: "Assinatura",
    trialEnded: "Trial encerrado",
    onboardingGroup: "Onboarding",
    onboardingTitle: "Debug: onboarding",
    school: "Onboarding da escola",
    professor: "Onboarding do professor",
    firstSteps: "Primeiros passos",
    emailGroup: "Emails transacionais",
    emailTitle: "Debug: emails transacionais",
    welcomeTrial: "Boas-vindas com trial (14 dias)",
    welcomePaid: "Boas-vindas sem trial",
    sending: "Enviando...",
    emailSent: 'Email "{{label}}" enviado para o seu email.',
    emailFailed: 'Falha ao enviar o email "{{label}}".',
    environmentGroup: "Ambiente",
    geo: "Geografia e moeda",
  },
  app: {
    defaultTitle: "Gamefik Escolas no level máximo.",
    loadingCachedData: "Atualizando dados",
  },
  accessInstructions: {
    title: "Instruções de acesso de {{name}}",
    pageSubtitle: "Entre com uma das opções abaixo",
    step1Title: "Baixe o app da Gamefik",
    step1Stores: "Disponível na App Store e Google Play",
    appStore: "App Store",
    googlePlay: "Google Play",
    step2Title: "Escolha como fazer login",
    scanQrTitle: "Ler QR Code",
    scanQrHint: "Melhor em dispositivo com câmera",
    scanQrHintPage: "Melhor em um dispositivo com câmera",
    scanQrStep1: "1. Abra a câmera do celular",
    scanQrStep2: "2. Escaneie o QR Code",
    scanQrStep3: "3. O link abrirá automaticamente",
    scanQrStep1Long: "Abra a câmera do celular ou um leitor de QR Code",
    scanQrStep2Long: "Escaneie o QR Code acima",
    scanQrStep3Long: "O link de login abrirá automaticamente no navegador",
    loginLinkTitle: "Link de login",
    linkHintStart: "Melhor em dispositivo ",
    linkHintEmphasis: "sem",
    linkHintEnd: " câmera",
    linkHintLongStart: "Melhor em um dispositivo",
    linkHintLongMid: "sem",
    linkHintLongEnd: "câmera",
    pasteInBrowser: "Cole o link abaixo em um navegador",
    generatingLink: "Gerando link...",
    copyLink: "Copiar link",
    copied: "Copiado!",
    privacyNote:
      "Alunos não conseguirão acessar ou ver o trabalho de outros alunos com estas instruções",
    helpTitle: "Precisa de ajuda?",
    helpSubtitle: "Acesse a central de ajuda para mais informações",
    generatingAccessLink: "Gerando link de acesso...",
    modalTrigger: "Instruções de acesso para {{name}}",
    resetLink: "Resetar link",
    resetConfirmTitle: "Atenção: esta ação é irreversível!",
    resetConfirmQuestion: "Você tem certeza que deseja resetar o link de {{name}}?",
    resetWarnInvalidate:
      "O link atual será permanentemente invalidado e um novo será gerado no lugar.",
    resetWarnQrCard:
      "Se o jogador possui um cartão QR Code impresso, ele também será invalidado — será necessário gerar e imprimir um novo cartão.",
    resetting: "Resetando...",
  },
  navigation: {
    dashboard: "Dashboard",
    launches: "Lançamentos",
    players: "Jogadores",
    classes: "Turmas",
    attitudes: "Atitudes",
    quizzes: "Quizzes",
    manage: "Gerenciar",
    createWithAi: "Criar com IA✨",
    createFromScratch: "Criar do zero",
    newMissions: "Missões novas",
    missions: "Missões",
    approve: "Aprovar",
    mural: "Mural",
    studentApp: "App do aluno",
    reports: "Relatórios",
    shopping: "Shopping",
    overview: "Visão geral",
    orders: "Pedidos",
    rewards: "Recompensas",
    giftCards: "Gift cards",
    statement: "Extrato",
    invoices: "Faturas",
    settings: "Configurações",
    history: "Histórico",
    games: "Segmentos",
    userManagement: "Gestão de Usuários",
    automations: "Automações",
    advanced: "Avançadas",
    home: "Home",
    chatIa: "Início",
    activities: "Atividades",
    trails: "Trilhas",
  },
  pageTitles: {
    dashboard: "Dashboard",
    players: "Jogadores",
    missions: "Missões",
    approveMissions: "Aprovar missões",
    quizzes: "Quizzes",
    shop: "Minha Loja",
    shoppingOrders: "Shopping - Pedidos",
    history: "Histórico",
    attitudes: "Atitudes",
    newAttitude: "Nova atitude",
    editAttitude: "Editar atitude",
    createQuiz: "Criar Quiz",
    shopping: "Shopping",
    reviewOpenQuestions: "Revisar discursivas",
    rewards: "Minha Loja",
    requests: "Shopping - Pedidos",
  },
  history: {
    loadingStarting: "Iniciando...",
    loadingHistory: "Carregando histórico...",
    loadedPeriods: "{{loaded}} de {{total}} períodos carregados",
    loadedRecordsHint: "{{count}} registros carregados até agora — você já pode usar os filtros enquanto o resto chega.",
    filtersAndSearch: "Filtros e busca",
    search: "Buscar",
    searchActivities: "Pesquisar atividades...",
    startDate: "Data início",
    endDate: "Data fim",
    category: "Categoria",
    allCategories: "Todas as categorias",
    type: "Tipo",
    noTypesAvailable: "Nenhum tipo disponível",
    allTypes: "Todos os tipos",
    playerHistory: {
      title: "Histórico do aluno",
      description: "Registros de atitudes, missões e transações deste aluno.",
      searchPlaceholder: "Buscar no histórico",
      filterByGame: "Filtrar por segmento",
      allGames: "Todos os segmentos",
      gameLabel: "Segmento",
      appliedBy: "Aplicado por",
      collectDate: "Data de coleta",
      createdAt: "Data",
      activities: "Atividades",
      collected: "Coletado",
      pendingCollect: "Pendente de coleta",
      noGame: "Sem segmento",
      empty: "Não existe registro de atitudes para este aluno.",
      sectionToday: "Hoje",
      sectionYesterday: "Ontem",
      sectionThisWeek: "Esta semana",
      sectionMoreTimeAgo: "Em um passado não tão distante",
      print: "Imprimir histórico",
      close: "Fechar",
      details: {
        title: "Detalhes do Registro",
        tabDetails: "Detalhes",
        tabTechnical: "JSON Técnico",
        registerId: "ID do Registro",
        type: "Tipo",
        typeManual: "Atividade Manual",
        typeGame: "Atividade de Jogo",
        titleLabel: "Título/Descrição",
        gameName: "Nome do Segmento",
        appliedBy: "Aplicado por",
        points: "Pontos Obtidos",
        noPoints: "Nenhum ponto especificado",
        createdAt: "Data de Criação",
        collectDate: "Data de Coleta",
        stackedIds: "IDs Empilhados ({{count}})",
        technicalData: "Dados Técnicos (JSON)",
        technicalHint: "Copie este JSON para análise técnica ou debugging.",
        close: "Fechar",
      },
      remove: {
        title: "Confirmar remoção",
        body: "Tem certeza que deseja remover este registro?",
        confirm: "Remover",
        cancel: "Cancelar",
      },
      normalizeGames: {
        button: "Normalizar segmentos",
        buttonTitle: "Unificar game_id de todas as transações para o segmento atual do aluno",
        viewJson: "Ver JSON",
        hideJson: "Ocultar JSON",
        viewJsonTitle: "Mostrar JSON completo do histórico",
        title: "Normalizar segmentos",
        description:
          "Reatribui todas as transações (hot e cold) para o segmento atual do aluno. O saldo por tipo de ponto permanece o mesmo — apenas a partição por segmento muda.",
        loadingDryRun: "Calculando prévia…",
        errorTitle: "Não foi possível carregar a prévia",
        errorGeneric: "Erro ao normalizar segmentos",
        retry: "Tentar novamente",
        targetGame: "Segmento alvo",
        targetBadge: "alvo",
        otherGames: "Outros segmentos",
        before: "Antes (por segmento)",
        after: "Depois (consolidado)",
        alreadyNormalized: "Todas as transações já estão no segmento alvo. Nada a alterar.",
        saldNoteTitle: "Saldo consolidado (não muda)",
        saldNoteBody:
          "A soma por tipo de ponto é a mesma antes e depois. Esta operação só corrige o game_id nas transações.",
        confirmApply: "Confirmar normalização",
        applying: "Aplicando…",
        successTitle: "Segmentos normalizados com sucesso",
        filtersTitle: "Incluir transações",
        includeCollected: "Pontos coletados",
        includeUncollected: "Pontos não coletados",
        noFilterSelected: "Selecione ao menos um tipo de ponto para continuar.",
        journeyConflictTitle: "Bônus de jornada duplicados",
        journeyConflictBody:
          "{{count}} transação(ões) de bônus de jornada serão removidas para evitar conflito de índice único (mesmo cycleKey no segmento alvo).",
      },
    },
  },
  missions: {
    allGames: "Todos os segmentos",
    allClasses: "Todas as turmas",
    allTeachers: "Todos os professores",
    tips: {
      clearObjectivesTitle: "Defina objetivos claros",
      clearObjectivesDescription: "Estabeleça claramente o que o aluno deve fazer para completar a missão.",
      clearObjectivesPlaceholder: "Video mostrando como definir objetivos claros para missões",
      adjustComplexityTitle: "Ajuste a complexidade",
      adjustComplexityDescription: "Adapte a complexidade da missão ao nível e capacidade dos alunos.",
      adjustComplexityPlaceholder: "Video demonstrando como ajustar a complexidade das missões",
      quickFeedbackTitle: "Forneça feedback rápido",
      quickFeedbackDescription: "Valide as missões o mais rápido possível para manter o engajamento.",
      quickFeedbackPlaceholder: "Video sobre a importância do feedback rápido nas missões",
      aiVariationsTitle: "Use a IA para criar variações",
      aiVariationsDescription: "Utilize a IA para criar diferentes versões de missões similares.",
      aiVariationsPlaceholder: "Video tutorial sobre como usar IA para criar variações de missões",
      curriculumConnectionTitle: "Conecte com o currículo",
      curriculumConnectionDescription: "Relacione as missões com o conteúdo curricular para reforçar o aprendizado.",
      curriculumConnectionPlaceholder: "Video explicando como conectar missões ao currículo escolar",
    },
    tabs: {
      all: "Todas",
      active: "Ativas",
      inactive: "Inativas",
    },
    createWithAi: "Criar missão com IA",
    createFromScratch: "Criar do zero",
    searchByName: "Pesquisar por nome",
    selectGame: "Selecione um segmento",
    selectClass: "Selecione uma turma",
    selectTeacher: "Selecione um professor",
    itemsPerPage: "Itens por página",
    perPage: "{{count}} por página",
    previous: "Anterior",
    next: "Próxima",
    closeAll: "Fechar todas",
    openAll: "Abrir todas",
    emptyTitle: "Nenhuma missão foi encontrada",
    emptySubtitle: "Mude os filtros ou cadastre mais missões",
    missionUpdatedSuccess: "Missão atualizada com sucesso!",
    missionUpdatedError: "Houve um erro ao atualizar a missão, tente novamente.",
    missionDeletedSuccess: "Missão excluída com sucesso!",
    viewProofs: "Ver comprovantes",
    manualValidation: "Validação manual",
    edit: "Editar",
    deleteMission: "Excluir missão",
    confirmDeletion: "Confirmar exclusão",
    editMission: "Editar missão",
    viewFullBank: "Ver banco completo",
    createdBy: "Criado por",
    creatorUnavailable: "Usuário excluído ou indisponível",
    games: "Segmentos",
    status: "Status",
    inactive: "Inativa",
    active: "Ativa",
    proofUncollectedAndRemoved: "Comprovante descoletado e removido",
    errorUncollectingProof: "Falha ao descoletar o comprovante, contate o suporte",
  },
  activities: {
    title: "Atividades",
    creatorUnavailable: "Usuário excluído ou indisponível",
    subtitle: "{{count}} atividades · {{active}} ativas",
    subtitleLoading: "Carregando...",
    createManual: "Criar manual",
    createManualShort: "Manual",
    createShort: "Criar",
    createWithAi: "Criar com IA",
    createWithAiShort: "IA",
    createManualModal: {
      title: "O que você quer criar?",
      hint: "Escolha o tipo de atividade para criar do zero, sem IA.",
      quiz: "Quiz",
      quizDesc: "Perguntas com alternativas ou respostas discursivas.",
      quizFormatTitle: "Qual formato de quiz você quer criar?",
      quizFormatHint: "Escolha o tipo de resposta. Você poderá editar todas as questões depois.",
      quizMultiple: "Múltipla escolha",
      quizMultipleDesc: "O aluno seleciona uma alternativa e recebe correção automática.",
      quizDiscursive: "Discursiva",
      quizDiscursiveDesc: "O aluno escreve uma resposta aberta para avaliação.",
      mission: "Missão",
      missionDesc: "Tarefa com entrega de comprovante pelo aluno.",
      flashcards: "Flashcards",
      flashcardsVf: "Flashcards V ou F",
    },
    createWithAiDialog: {
      title: "Criar atividade com IA",
      hint: "Descreva o que você quer (tema, série, tipo de atividade). Ao continuar, a IA já começa a gerar a partir do seu pedido.",
      placeholder:
        "Ex.: Quiz sobre frações para o 5º ano, com 10 perguntas de múltipla escolha…",
      submit: "Criar atividade",
      cancel: "Cancelar",
      promptRequired: "Descreva o que deseja criar",
      typeAuto: "Tipo: automático",
    },
    tabs: {
      all: "Todos",
      quizzes: "Quizzes",
      missions: "Missões",
      flashcards: "Flashcards",
    },
    searchPlaceholder: "Buscar...",
    filterClasses: "Turmas",
    filterClassesSearch: "Buscar turma...",
    filterStatus: "Status",
    filterCreatorsSearch: "Buscar professor...",
    deletedTeacher: "Professor excluído {{index}}",
    filterClassesNoResults: "Nenhum resultado",
    filterClassesClear: "Limpar seleção",
    filterPending: "Com pendências",
    createdBy: "Criado por",
    filters: "Filtros",
    filtersAriaLabel: "Abrir filtros",
    clearFilters: "Limpar filtros",
    showResults: "Ver {{count}} atividades",
    createAriaLabel: "Criar atividade",
    editAriaLabel: "Editar atividade",
    toggleAriaLabel: "Alterar status de {{title}}",
    moreActionsAriaLabel: "Mais ações",
    status: {
      active: "Ativa",
      ended: "Encerrada",
      scheduled: "Agendada",
      draft: "Rascunho",
    },
    actions: {
      edit: "Editar",
      duplicate: "Duplicar",
      duplicating: "Duplicando...",
      delete: "Excluir",
      report: "Relatório",
      reviewProofs: "Revisar comprovantes",
      reviewAnswers: "Corrigir respostas",
      fullResults: "Resultados",
      reviewProofsCount: "Revisar {{count}} comprovantes",
      apply: "Aplicar",
      playLiveTooltip: "Jogar ao vivo com a turma",
      presentTooltip: "Apresentar na TV ou projetor",
      copyLinkTooltip: "Copiar link da atividade",
      copyLinkSuccess: "Link copiado!",
    },
    typeSelection: {
      title: "Novo tipo de atividade",
      subtitle: "Escolha uma opção abaixo",
      quiz: "Quiz",
      quizDescription: "Perguntas de múltipla escolha",
      mission: "Missão",
      missionDescription: "Tarefas com comprovante",
    },
    emptyState: {
      title: "Nenhuma atividade encontrada",
      withSearch: "Tente buscar por outro termo",
      withoutSearch: "Crie sua primeira atividade",
    },
    duplicateSuccess: "\"{{title}}\" duplicada com sucesso",
    deleteDialog: {
      title: "Excluir atividade",
      description: "Tem certeza que deseja excluir {{title}}? Esta ação não pode ser desfeita.",
      cancel: "Cancelar",
      confirm: "Excluir",
      deleting: "Excluindo...",
    },
    toast: {
      duplicateError: "Erro ao duplicar a atividade. Tente novamente.",
      editError: "Não foi possível identificar a atividade para editar.",
      loadQuizError: "Não foi possível carregar o quiz original para edição.",
      loadMissionError: "Não foi possível carregar a missão original para edição.",
      prepareEditError: "Não foi possível preparar a edição agora. Tente novamente.",
      deleteError: "Erro ao excluir a atividade. Tente novamente.",
      deleteSuccess: "Atividade excluída com sucesso!",
      statusUpdateSuccess: "Status da atividade atualizado com sucesso!",
    },
  },
  languages: {
    ptBR: "Português",
    enUS: "English",
    esES: "Español",
  },
  languageSelector: {
    label: "Idioma",
    description: "Escolha o idioma da plataforma",
  },
  common: {
    close: "Fechar",
    cancel: "Cancelar",
    save: "Salvar",
    help: "Ajuda",
    logout: "Sair",
    settings: "Configurações",
    helpAndSupport: "Ajuda e Suporte",
    language: "Idioma",
    login: "Login",
    email: "Email",
    password: "Senha",
    selectUnit: "Selecionar unidade",
    selectGender: "Selecione um gênero",
    requiredField: "Campo obrigatório",
    ok: "Ok",
    send: "Enviar",
    loading: "Carregando",
    fetchErrorTitle: "Não foi possível carregar",
    fetchErrorDescription:
      "Algo deu errado ao buscar os dados. Verifique sua conexão e tente novamente.",
    tryAgain: "Tentar novamente",
    back: "Voltar",
    create: "Criar",
    edit: "Editar",
    change: "Alterar",
    success: "Sucesso",
    error: "Erro",
    add: "Adicionar",
    remove: "Remover",
    confirm: "Confirmar",
    selectGame: "Escolha seu segmento",
    testEnvironmentOnly: "Somente HMG",
    testEnvironmentBadge: "HMG",
    testEnvironmentDescription: "Fica disponível apenas no ambiente de testes por enquanto.",
    testEnvironmentTemporary: "Temporário em HMG",
  },
  clearTheme: {
    loadingAria: "Carregando conteúdo",
  },
  login: {
    pageTitle: "Login | Gamefik Escolas no level máximo.",
    title: "Entrar",
    description: "Coloque suas informações para entrar na Gamefik",
    emailPlaceholder: "Coloque seu email",
    passwordPlaceholder: "Coloque sua senha",
    submit: "Fazer login",
    forgotPassword: "Esqueceu sua senha?",
    needHelp: "Precisa de ajuda?",
    clickHere: "Clique aqui",
    invalidCredentials: "Usuário ou senha inválidos!",
    footerLabel: "Idioma da plataforma",
  },
  forgotPassword: {
    heading: "Esqueceu sua senha?",
    subtitle: "Digite o e-mail da sua conta para receber um link de alteração de senha",
    emailLabel: "E-mail",
    invalidEmail: "E-mail inválido",
    submit: "Receber link",
    back: "Voltar",
    successMessage: "Enviamos um link de alteração de senha para seu e-mail!",
    userNotFound: "Desculpe, mas não encontramos nenhum usuário cadastrado com esse e-mail.",
    userNotVerified: "Sua conta ainda não foi verificada. Enviamos um novo convite para seu e-mail.",
    genericError: "Desculpe, ocorreu um erro ao enviar o link para seu e-mail. Entre em contato com o suporte.",
  },
  loginCode: {
    continueSubmit: "Continuar",
    invalidEmail: "E-mail inválido",
    verifyHeading: "Confira seu e-mail",
    verifySubtitle: "Enviamos um código de login para {{email}}",
    codeLabel: "Código de login",
    codePlaceholder: "Digite o código de 6 dígitos",
    helper: "Enviamos um código para {{email}}. Verifique sua caixa de entrada e o spam.",
    sentToast: "Código enviado! Confira seu e-mail.",
    userNotFound: "Não encontramos nenhuma conta com esse e-mail. Confira o endereço ou crie uma conta.",
    sendError: "Não foi possível enviar o código. Tente novamente em instantes.",
    invalidCode: "Código incorreto ou expirado. Confira o e-mail ou reenvie o código.",
    changeEmail: "Trocar e-mail",
    usePassword: "Entrar com senha",
    useCode: "Entrar com código por e-mail",
  },
  signup: {
    tabLogin: "Entrar",
    tabSignup: "Criar conta",
    loginHeading: "Seja bem-vindo de volta",
    loginSubheading: "Entre para continuar sua jornada épica",
    profileHeading: "Selecione seu perfil",
    profileSubheading: "Comece sua jornada épica agora",
    formHeading: "Crie sua conta",
    formSubheading: "Escolha como prefere continuar: Google, Apple ou seu e-mail",
    verifyHeading: "Verifique seu email",
    verifySubheading: "Insira o código enviado para {{email}}",
    profileSchools: "Escolas",
    profileTeachers: "Professores",
    profileNext: "Avançar",
    toastResendSuccess: "Enviamos um novo código para o seu e-mail.",
    toastResendError: "Não foi possível reenviar o código.",
    firstName: "Nome",
    firstNamePlaceholder: "Digite seu nome",
    lastName: "Sobrenome",
    lastNamePlaceholder: "Digite seu sobrenome",
    email: "Email",
    emailPlaceholder: "seu@email.com",
    emailInvalid: "E-mail inválido",
    firstNameRequired: "Nome é obrigatório",
    lastNameRequired: "Sobrenome é obrigatório",
    password: "Senha",
    passwordPlaceholder: "••••••••",
    passwordMin: "Mínimo de 6 caracteres",
    confirmPassword: "Confirmar senha",
    passwordMismatch: "As senhas não coincidem",
    rememberMe: "Lembrar de mim",
    forgotPassword: "Esqueci minha senha",
    termsText: "Ao criar sua conta, você declara que leu e concorda com os",
    termsAnd: "e a",
    termsOfUse: "Termos de uso",
    privacyPolicy: "Política de privacidade",
    loginSubmit: "Entrar no Gamefik",
    signupSubmit: "Criar conta",
    appleLogin: "Fazer login com a Apple",
    appleSignup: "Inscrever-se na Apple",
    dividerLogin: "OU ENTRE COM",
    dividerSignup: "OU CRIE COM",
    noAccount: "Ainda não tem conta?",
    startFree: "Começar gratuitamente",
    hasAccount: "Já tem conta?",
    loginLink: "Entrar",
    verificationCode: "Código de verificação",
    verificationPlaceholder: "Digite o código recebido",
    verificationHelper: "Enviamos um código para {{email}}. Verifique sua caixa de entrada.",
    verifySubmit: "Verificar e continuar",
    resendCode: "Reenviar código",
    resendCountdown: "Reenviar código em {{countdown}}s",
    toastFillAllFields: "Preencha e-mail, senha e confirmação corretamente.",
    toastAccountCreated: "Conta criada. Enviamos um código para o seu e-mail.",
    toastEnterCode: "Informe o código recebido por e-mail.",
    toastInvalidCode: "Código inválido. Tente novamente.",
    toastVerified: "Conta verificada com sucesso.",
    toastLoginError: "E-mail ou senha inválidos",
    toastGoogleError: "Erro ao autenticar com Google",
    toastGoogleNotFound: "Conta não encontrada para este email Google",
    toastAppleSoon: "Login com Apple em breve",
    toastAppleError: "Erro ao autenticar com Apple",
    toastAppleNotFound: "Conta não encontrada para este Apple ID",
    toastAppleNotConfigured: "Login com Apple não configurado neste ambiente",
    toastSignupError: "Não foi possível criar sua conta agora.",
  },
  schoolOnboarding: {
    pageTitle: "Configurar escola — Gamefik",
    step1Title: "Agora nos conte um pouco mais sobre você!",
    step2Title: "Conte-nos sobre a sua escola",
    step3Title: "O que você quer alcançar com a Gamefik?",
    step4Title: "Personalize o ambiente da sua escola",
    panel1Title: "Onde salas de aula se tornam aventuras",
    panel2Title: "+1.000 escolas já transformaram engajamento em rotina",
    panel3Title: "Escolas gamificadas têm até 40% mais engajamento",
    panel4Title: "Seus alunos vão acessar um ambiente com a cara da sua escola",
    roleLabel: "Qual é o seu cargo na escola?",
    rolePlaceholder: "Selecione seu cargo",
    roleDirector: "Diretor(a)",
    roleCoordinator: "Coordenador pedagógico",
    roleMaintainer: "Mantenedor",
    roleOther: "Outro",
    countryLabel: "Em que país sua escola está localizada?",
    countryPlaceholder: "Selecione o país",
    countrySearch: "Buscar país...",
    countryEmpty: "Nenhum país encontrado",
    schoolNameLabel: "Nome da escola",
    schoolNamePlaceholder: "Digite o nome da escola",
    studentCountLabel: "Quantidade de alunos",
    studentCountPlaceholder: "Selecione a quantidade",
    studentUpTo100: "Até 100",
    student100to200: "De 100 a 200",
    student200to500: "De 200 a 500",
    student500to1000: "De 500 a 1000",
    studentAbove1000: "Acima de 1000",
    teacherCountLabel: "Quantidade de professores",
    teacherUpTo5: "Até 5",
    teacher5to20: "De 5 a 20",
    teacher20to50: "De 20 a 50",
    teacherAbove50: "Acima de 50",
    goalEngagement: "Aumentar engajamento dos alunos",
    goalPerformance: "Melhorar o desempenho acadêmico",
    goalPedagogy: "Facilitar o acompanhamento pedagógico",
    goalMotivate: "Motivar professores a usar tecnologia",
    goalRetention: "Reduzir a evasão escolar",
    goalOther: "Outro",
    goalOtherPlaceholder: "Descreva seu objetivo...",
    uploadHelp: "Arraste uma foto aqui ou escolha do seu dispositivo",
    uploadLater: "Você pode fazer isso depois nas configurações",
    back: "Voltar",
    next: "Avançar",
    finish: "Concluir",
    phoneLabel: "Telefone / celular de contato",
    phonePlaceholder: "(11) 99999-9999",
    errorRole: "Selecione seu cargo na escola.",
    errorCountry: "Selecione o país da escola.",
    errorPhone: "Informe o número de telefone.",
    errorPhoneInvalid: "Número de telefone inválido.",
    errorSchoolName: "Informe o nome da escola.",
    errorStudentCount: "Selecione a quantidade de alunos.",
    errorTeacherCount: "Selecione a quantidade de professores.",
    errorGoals: "Selecione pelo menos um objetivo.",
    errorSave: "Não foi possível salvar as informações. Tente novamente.",
  },
  teacherOnboarding: {
    welcomeTitleNoName: "Sua próxima aula começa aqui.",
    welcomeSubtitle: "Vamos fazer sua primeira aula brilhar.",
    welcomeMicro: "Uma pergunta e a IA cria sua primeira atividade.",
    nameQuestion: "Qual seu nome?",
    namePlaceholder: "Seu nome",
    countryQuestion: "Em qual país você leciona?",
    countryPlaceholder: "Selecione seu país",
    countrySearch: "Buscar país",
    countryEmpty: "Nenhum país encontrado",
    phoneLabel: "WhatsApp (opcional)",
    phonePlaceholder: "Seu número",
    phoneInvalid: "Número inválido. Inclua o DDD e use apenas números.",
    phoneWhy: "Só para avisar quando sua atividade ficar pronta. Sem spam.",
    ctaContinue: "Continuar",
    subjectTitle: "Qual matéria você leciona?",
    subjectSubtitle: "A IA monta a atividade certa para sua turma.",
    topicLabel: "O que você vai ensinar essa semana?",
    topicPlaceholder: "Ex.: frações, Revolução Francesa",
    ctaCreate: "Criar minha primeira atividade",
    welcomeCta: "Começar",
    activitySubtitle: "Escreva o tema. O resto é com a gente.",
    suggestionsLabel: "Ou comece com uma ideia de {subjects}",
    suggestionsLabelGeneric: "Ou comece com uma destas ideias",
    topic: {
      matematica_fractions: "Frações",
      matematica_linear_equations: "Equações lineares",
      matematica_plane_geometry: "Geometria plana",
      matematica_percentages: "Porcentagens",
      portugues_text_interpretation: "Interpretação de texto",
      portugues_figures_of_speech: "Figuras de linguagem",
      portugues_verb_agreement: "Concordância verbal",
      portugues_spelling: "Ortografia",
      ingles_verb_tenses: "Tempos verbais",
      ingles_phrasal_verbs: "Phrasal verbs",
      ingles_daily_vocabulary: "Vocabulário cotidiano",
      ingles_reading_comprehension: "Compreensão de leitura",
      espanhol_present_tense: "Verbos no presente",
      espanhol_basic_vocabulary: "Vocabulário básico",
      espanhol_false_friends: "Falsos cognatos",
      espanhol_pronunciation: "Pronúncia",
      ciencias_solar_system: "Sistema solar",
      ciencias_ecosystems: "Ecossistemas",
      ciencias_human_body: "Corpo humano",
      ciencias_states_of_matter: "Estados da matéria",
      fisica_kinematics: "Cinemática",
      fisica_newtons_laws: "Leis de Newton",
      fisica_electricity: "Eletricidade",
      fisica_thermodynamics: "Termodinâmica",
      quimica_periodic_table: "Tabela periódica",
      quimica_chemical_reactions: "Reações químicas",
      quimica_stoichiometry: "Estequiometria",
      quimica_organic_chemistry: "Química orgânica",
      biologia_genetics: "Genética",
      biologia_evolution: "Evolução",
      biologia_digestive_system: "Sistema digestório",
      biologia_cell_biology: "Citologia",
      historia_french_revolution: "Revolução Francesa",
      historia_world_war_2: "Segunda Guerra Mundial",
      historia_middle_ages: "Idade Média",
      historia_ancient_civilizations: "Civilizações antigas",
      geografia_world_climates: "Climas do mundo",
      geografia_landforms: "Relevo",
      geografia_globalization: "Globalização",
      geografia_cartography: "Cartografia",
      filosofia_socrates_plato: "Sócrates e Platão",
      filosofia_ethics: "Ética",
      filosofia_enlightenment: "Iluminismo",
      filosofia_modern_philosophy: "Filosofia contemporânea",
      sociologia_culture_identity: "Cultura e identidade",
      sociologia_work: "Mundo do trabalho",
      sociologia_social_movements: "Movimentos sociais",
      sociologia_citizenship: "Cidadania",
      ed_fisica_team_sports: "Esportes coletivos",
      ed_fisica_olympic_history: "História das olimpíadas",
      ed_fisica_athletics: "Atletismo",
      ed_fisica_game_rules: "Regras de jogos",
      arte_renaissance: "Renascimento",
      arte_impressionism: "Impressionismo",
      arte_modern_art: "Arte moderna",
      arte_color_composition: "Cores e composição",
      musica_notes_rhythm: "Notas e ritmos",
      musica_great_composers: "Grandes compositores",
      musica_instruments: "Instrumentos musicais",
      musica_world_music: "Música do mundo",
      computacao_algorithms: "Algoritmos básicos",
      computacao_how_internet_works: "Como funciona a internet",
      computacao_programming_logic: "Lógica de programação",
      computacao_digital_safety: "Segurança digital",
      financas_interest_rates: "Juros simples e compostos",
      financas_personal_budget: "Orçamento pessoal",
      financas_investments: "Investimentos",
      financas_financial_literacy: "Educação financeira",
      redacao_argumentation: "Argumentação",
      redacao_essay_structure: "Estrutura dissertativa",
      redacao_cohesion: "Coesão e coerência",
      redacao_writing_techniques: "Técnicas de escrita",
      religiao_world_religions: "Religiões do mundo",
      religiao_ethics_values: "Ética e valores",
      religiao_religious_tolerance: "Tolerância religiosa",
      religiao_mythology: "Mitologia",
      outra_citizenship: "Cidadania",
      outra_sustainability: "Sustentabilidade",
      outra_critical_thinking: "Pensamento crítico",
      outra_current_affairs: "Atualidades",
    },
    stepProgress: "Passo {current} de {total}",
    ctaToEditor: "Abrir no editor",
    submitError: "Não consegui abrir o editor agora. Tente novamente.",
    creating: "Criando…",
    nextStepsLabel: "Seus próximos passos",
    loadingPulse1: "Analisando seu tema…",
    loadingPulse2: "Montando as perguntas…",
    loadingPulse3: "Deixando tudo gamificado…",
    loadingPulse4: "Caprichando nos detalhes…",
    loadingTitle: "Estamos quase lá, {name}…",
    loadingTitleNoName: "Estamos quase lá…",
    loadingSubtitle: "Enquanto a IA monta sua atividade, veja como transformar sua escola.",
    card1Title: "Crie sua turma",
    card1Desc: "Organize seus alunos em segundos e compartilhe atividades com todos.",
    card2Title: "Convide seus alunos",
    card2Desc: "Um link ou código e seus alunos entram. Eles jogam, você acompanha.",
    card3Title: "Acompanhe os resultados",
    card3Desc: "Veja quem participou, acertos e engajamento, em tempo real.",
    celebrationTitle: "Pronto, {name}. Sua aula virou jogo.",
    celebrationTitleNoName: "Pronto. Sua aula virou jogo.",
    celebrationSubtitle: "Abra o editor para deixá-la com a sua cara antes de publicar.",
    ctaPublish: "Publicar pros meus alunos",
    ctaAdjust: "Ajustar antes",
    previewUnavailable: "Não consegui carregar a prévia do aluno agora, mas sua atividade está pronta.",
    back: "Voltar",
    handoffPrompt: "Crie uma atividade gamificada de {subjects}{topic}.",
    handoffPromptTopic: " sobre {topic}",
    subject: {
      matematica: "Matemática",
      portugues: "Português",
      ingles: "Inglês",
      espanhol: "Espanhol",
      ciencias: "Ciências",
      fisica: "Física",
      quimica: "Química",
      biologia: "Biologia",
      historia: "História",
      geografia: "Geografia",
      filosofia: "Filosofia",
      sociologia: "Sociologia",
      ed_fisica: "Ed. Física",
      arte: "Arte",
      musica: "Música",
      computacao: "Tecnologia",
      financas: "Finanças",
      redacao: "Redação",
      religiao: "Religião",
      outra: "Outra",
    },
  },
  profile: {
    referAndEarn: "Indique e ganhe",
    accountNameFallback: "Minha conta",
    editUser: "Editar usuário",
    emailLabel: "Email",
    finalizeTitle: "Finalize seu cadastro",
    editTitle: "Edite seu usuário",
    missingFieldsFinalize: "Para finalizar seu cadastro, preencha os campos: {{fields}}",
    missingFieldsEdit: "Por favor, preencha todos os campos obrigatórios: {{fields}}",
    fullName: "Nome completo",
    fullNamePlaceholder: "Nome",
    birthDate: "Data de nascimento",
    gender: "Gênero",
    whatsappNumber: "Número do WhatsApp",
    finishing: "Finalizando...",
    saving: "Salvando...",
    finishRegistration: "Finalizar cadastro",
    saveChanges: "Salvar",
    missingFieldNames: {
      fullName: "Nome completo",
      email: "Email",
      whatsappNumber: "Número do WhatsApp",
      gender: "Gênero",
      birthDate: "Data de nascimento",
    },
    genderOptions: {
      female: "Feminino",
      male: "Masculino",
      preferNot: "Prefiro não informar",
    },
    modal: {
      title: "Meu Perfil",
      changePhoto: "Alterar foto",
      firstName: "Nome",
      firstNamePlaceholder: "Seu nome",
      firstNameRequired: "Nome é obrigatório",
      firstNameMinLength: "Nome deve ter pelo menos 2 caracteres",
      lastName: "Sobrenome",
      lastNamePlaceholder: "Seu sobrenome",
      lastNameRequired: "Sobrenome é obrigatório",
      lastNameMinLength: "Sobrenome deve ter pelo menos 2 caracteres",
      email: "Email",
      userType: "Tipo de usuário",
      accountType: "Tipo de conta",
      userTypes: {
        manager: "Gestor",
        teacher: "Professor",
        secretary: "Secretaria",
        financial_admin: "Administrador financeiro",
      },
      accountTypes: {
        individual_teacher: "Professor individual",
        new_manager_school: "Escola New Manager",
        legacy_school: "Escola Legacy",
      },
      phone: "Telefone",
      phonePlaceholder: "(XX) XXXXX-XXXX",
      school: "Escola onde leciona",
      schoolPlaceholder: "Nome da escola",
      schoolRequired: "Escola é obrigatório",
      subjects: "Matérias que leciona",
      subjectsPlaceholder: "Selecione as matérias",
      subjectsSelected: "{{count}} matéria selecionada",
      subjectsSelectedPlural: "{{count}} matérias selecionadas",
      subjectsRequired: "Selecione pelo menos uma matéria",
      subjectLabels: {
        Matematica: "Matemática",
        Portugues: "Português",
        Historia: "História",
        Geografia: "Geografia",
        Ciencias: "Ciências",
        Fisica: "Física",
        Quimica: "Química",
        Biologia: "Biologia",
        Ingles: "Inglês",
        Espanhol: "Espanhol",
        "Educacao Fisica": "Educação Física",
        Artes: "Artes",
        Filosofia: "Filosofia",
        Sociologia: "Sociologia",
        Outros: "Outros",
      },
      cancel: "Cancelar",
      save: "Salvar",
      saved: "Salvo",
    },
  },
  sidebar: {
    unitDialogTitle: "Selecionar unidade",
    unitLabel: "Unidade",
    accountCodeLabel: "Cód. da conta:",
    accountCodeCopyTitle: "Copiar código da escola",
    accountCodeCopied: "Copiado!",
    help: "Ajuda",
    helpAriaLabel: "Abrir central de ajuda",
    supportSectionLabel: "Suporte",
    menuAriaLabel: "Abrir menu de navegação",
    logout: "Sair",
    launchMenu: "Menu de lançamentos",
    changeUnitError: "Erro ao trocar de unidade",
    newBadge: "Novo",
    comingSoonBadge: "Em breve",
    activities: "Atividades",
    trails: "Trilhas",
    firstSteps: "Primeiros passos",
    collapseSidebar: "Recolher sidebar",
    expandSidebar: "Expandir sidebar",
  },
  premiumModal: {
    exclusiveBadge: "Funcionalidade exclusiva",
    title: "{{funcionalidade}} é uma funcionalidade {{planName}}",
    features: {
      rewards: "Recompensas",
    },
    description: "Essa funcionalidade faz parte do plano {{planName}}. Faça upgrade para desbloquear todas as vantagens exclusivas.",
    planName: "Teacher Shiny",
    planNameSchool: "School Pro",
    includesLabel: "Inclui:",
    highlight1: "Moeda personalizada",
    highlight2: "IA ilimitada",
    highlight3: "Recompensas exclusivas",
    highlight4: "Loja de recompensas",
    includedBadge: "Incluído",
    ctaButton: "Desbloquear com {{planName}}",
    viewPlans: "Ver planos",
    dismiss: "Agora não",
  },
  novaRecompensa: {
    notifyStudents: "Notificar alunos",
    notifyStudentsDescription: "Enviar uma notificação de nova recompensa aos alunos dos segmentos selecionados.",
    title: "Nova Recompensa",
    back: "Voltar",
    close: "Fechar",
    step: "Passo {{current}} de {{total}}",
    next: "Próximo",
    creating: "Criando...",
    createReward: "Criar Recompensa",
    payAndCreate: "Pagar e Criar",
    stepType: "Tipo",
    stepDetails: "Detalhes",
    stepValues: "Valores",
    stepClasses: "Segmentos",
    stepGiftCards: "Gift Cards",
    stepCheckout: "Checkout",
    typeTitle: "Tipo de Recompensa",
    typeDescription: "Escolha o tipo de recompensa que deseja criar.",
    normalTitle: "Recompensa Normal",
    normalDescription: "Adesivos, brindes, privilégios e outras recompensas",
    giftcardTitle: "Gift Card",
    giftcardDescription: "Compre gift cards para seus alunos resgatarem",
    comingSoon: "Em breve",
    detailsTitle: "Detalhes da Recompensa",
    detailsDescription: "Adicione a imagem, nome e descrição.",
    imageLabel: "Imagem",
    imageOptional: "Opcional",
    uploadLabel: "Enviar",
    nameLabel: "Nome da recompensa",
    namePlaceholder: "Ex: Adesivo Especial",
    nameMinError: "O nome deve ter pelo menos 3 caracteres",
    descriptionLabel: "Descrição",
    descriptionPlaceholder: "Descreva a recompensa para os alunos...",
    descriptionRequiredError: "A descrição é obrigatória",
    advanced: "Avançadas",
    availabilityDateLabel: "Data de disponibilidade",
    availabilityDateDescription: "A recompensa estará disponível para resgate a partir desta data.",
    valuesTitle: "Valores e Quantidades",
    valuesDescription: "Defina o valor em moedas e a disponibilidade da recompensa.",
    coinValueLabel: "Valor em moedas",
    stockLabel: "Estoque disponível",
    limitLabel: "Limite por aluno",
    previewSentence: "{{stock}} unidades disponíveis. Cada aluno pode resgatar até {{limit}} {{times}} por {{price}} moedas cada.",
    timesOne: "vez",
    timesMany: "vezes",
    classesTitle: "Selecione os Segmentos",
    classesDescription: "Escolha quais segmentos terão acesso a esta recompensa.",
    allClasses: "Todos os segmentos",
    noClasses: "Nenhum segmento encontrado",
    selectedCount: "{{selected}} de {{total}} selecionado{{plural}}",
    giftcardsTitle: "Monte seus Gift Cards",
    giftcardsDescription: "Selecione a marca, valor e quantidade de cada gift card.",
    brandColumn: "Marca",
    valueColumn: "Valor",
    qtyColumn: "Qtd",
    addGiftcard: "Adicionar outro gift card",
    giftcardTotal: "Total ({{count}} gift cards)",
    checkoutTitle: "Confirmar Compra",
    checkoutDescription: "Revise seu pedido antes de prosseguir para o pagamento.",
    orderSummary: "Resumo do Pedido",
    totalToPay: "Total a pagar",
    howItWorks: "Como funciona:",
    checkoutInfo: "Após o pagamento, os gift cards serão adicionados como rascunho na sua lista de recompensas. Você poderá configurar valor em moedas e estoque antes de disponibilizar para os alunos.",
    brandInfoWhere: "Onde pode ser usado",
    brandInfoInstructions: "Instruções de resgate",
    brandInfoValues: "Valores disponíveis",
    brandInfoTerms: "Ver termos e condições",
    successToast: "Recompensa criada com sucesso!",
    errorToast: "Erro ao criar a recompensa. Tente novamente.",
  },
  editarRecompensa: {
    title: "Editar Recompensa",
    subtitle: "Modifique os detalhes da recompensa",
    descriptionLabel: "Descrição",
    descriptionPlaceholder: "Descrição opcional...",
    coinValueLabel: "Valor em moedas",
    stockLabel: "Estoque",
    stockGiftCardLocked: "Estoque definido pelos gift cards comprados — não editável",
    limitLabel: "Limite por aluno",
    classesLabel: "Segmentos",
    selectAll: "Selecionar todos",
    noClasses: "Nenhum segmento encontrado",
    selectedCount: "{{selected}} de {{total}} selecionados",
    nameMinError: "Mínimo 3 caracteres",
    uploadImage: "Alterar imagem",
    uploadingImage: "Enviando...",
    removeImage: "Remover imagem",
    changeImage: "Alterar imagem",
    imageUploadError: "Erro ao enviar a imagem. Tente novamente.",
    cancel: "Cancelar",
    save: "Salvar Alterações",
    saving: "Salvando...",
    successToast: "Recompensa atualizada com sucesso!",
    errorToast: "Erro ao salvar as alterações.",
  },
  calculadoraCoins: {
    trigger: "Calculadora",
    title: "Calculadora de coins",
    description: "Informe quanto a recompensa vale em dinheiro para ver o valor sugerido em moedas.",
    reaisLabel: "Valor em reais",
    reaisPlaceholder: "Ex: 10,00",
    suggestedLabel: "Valor sugerido",
    rarityLabel: "Raridade:",
    useValue: "Usar este valor",
  },
  rewardCard: {
    giftBadge: "Gift",
    autoDeliveryBadge: "Entrega automática",
    autoDeliveryBadgeShort: "Auto",
    enableAutoDelivery: "Ativar entrega automática",
    disableAutoDelivery: "Desativar entrega automática",
    inactiveBadge: "Inativa",
    edit: "Editar",
    delete: "Excluir",
    coinsUnit: "moedas",
    stockPrefix: "Estoque",
    stockCount: "{{count}} em estoque",
    moreActions: "Mais ações",
  },
  excluirRecompensa: {
    title: "Excluir Recompensa",
    description: "Tem certeza que deseja excluir {{name}}? Esta ação não pode ser desfeita.",
    stockInfo: "{{coins}} moedas — {{stock}} em estoque",
    cancel: "Cancelar",
    confirm: "Excluir",
    deleting: "Excluindo...",
  },
  orderStatus: {
    todos: "Todos",
    pendentes: "Pendentes",
    created: "Pendente",
    accepted: "Aceito",
    delivered: "Entregue",
    cancelled: "Cancelado",
    acceptTitle: "Aceitar",
    rejectTitle: "Recusar",
    cancelTitle: "Cancelar",
    markDelivered: "Entregar",
  },
  helpChat: {
    title: "Central de Ajuda",
    subtitle: "Como podemos ajudar?",
    closeAriaLabel: "Fechar central de ajuda",
    successTitle: "Mensagem enviada!",
    successThanks: "Obrigado por entrar em contato.",
    successReply: "Nosso time responderá em até {{hours}} horas.",
    nameLabel: "Nome",
    namePlaceholder: "Seu nome",
    emailLabel: "Email",
    emailPlaceholder: "seu@email.com",
    typeLabel: "Tipo de solicitação",
    typePlaceholder: "Selecione o tipo",
    typeFeedback: "Feedback",
    typeDuvidas: "Dúvidas",
    typeSugestoes: "Sugestões",
    typeBugs: "Bugs",
    typeOutros: "Outros",
    messageLabel: "Mensagem",
    messagePlaceholder: "Descreva sua solicitação em detalhes...",
    attachmentsLabel: "Anexos (opcional)",
    attachButton: "Anexar imagens ou vídeos",
    removeAttachmentAriaLabel: "Remover anexo {{name}}",
    submitButton: "Enviar mensagem",
    submitting: "Enviando...",
  },
  unitSelector: {
    title: "Selecionar Unidade",
    subtitle: "Escolha a unidade que deseja gerenciar",
    searchPlaceholder: "Buscar unidade...",
    emptyTitle: "Nenhuma unidade encontrada",
    emptySubtitle: "Tente buscar por outro termo",
    addUnit: "Adicionar nova unidade",
  },
  publicPost: {
    defaultTitle: "Comunicado",
    notFoundTitle: "Comunicado não encontrado",
    notFoundDescription: "Este link pode ter expirado ou o comunicado foi removido.",
    eventBadge: "EVENTO",
    noReactions: "Sem reações ainda",
    reactionsCount: {
      one: "{{count}} reação",
      other: "{{count}} reações",
    },
    viewsCount: {
      one: "{{count}} visualização",
      other: "{{count}} visualizações",
    },
    footerBrand: "Gamefik - Escolas no level máximo",
  },
  acceptInvite: {
    pageTitle: "Registro | Gamefik Escolas no level máximo.",
    title: "Crie sua senha de acesso",
    description: "Defina uma senha para aceitar o convite e entrar automaticamente no Gamefik.",
    passwordLabel: "Nova senha",
    confirmPasswordLabel: "Confirmar senha",
    invalidPassword: "Senha inválida",
    passwordTooShort: "A senha deve ter pelo menos 6 caracteres.",
    passwordsDoNotMatch: "As senhas não conferem",
    passwordHint: "Use pelo menos 6 caracteres. Você poderá alterar a senha depois em seu perfil.",
    showPassword: "Mostrar senha",
    hidePassword: "Ocultar senha",
    submit: "Criar senha e entrar",
    submitting: "Criando senha...",
    loginCta: "Login",
    successMessage: "Sua senha foi registrada, você já pode fazer o login",
    errorMessage: "Erro ao processar a solicitação. Seu token pode ter expirado. Solicite um novo convite ou entre em contato com o suporte.",
    invalidOrExpired: "Este convite é inválido, expirou ou já foi utilizado. Solicite um novo convite.",
  },
  changePassword: {
    pageTitle: "Registro | Gamefik Escolas no level máximo.",
    title: "Alteração de senha",
    description: "A senha deve conter no mínimo 6 caracteres.\nA senha não deve conter símbolos (@,#,%,ˆ,& )",
    newPasswordLabel: "Nova senha",
    confirmNewPasswordLabel: "Confirmar nova senha",
    invalidPassword: "Senha inválida",
    passwordsDoNotMatch: "As senhas não conferem",
    submit: "Alterar",
    successMessage: "Senha alterada!",
    tokenExpiredError: 'O seu token de alteração de senha expirou. Solicite outro clicando em "Esqueci minha senha" na tela de login.',
    genericError: "Desculpe, ocorreu um erro ao alterar sua senha. Entre em contato com o suporte.",
  },
  account: {
    createPageTitle: "Criar Conta | Gamefik Escolas no level máximo.",
  },
  notFound: {
    pageTitle: "404 - Página não encontrada | Gamefik Escolas no level máximo.",
    title: "Página não encontrada...",
    goBack: "Voltar",
  },
  sharedInfoModal: {
    trigger: "Boas práticas",
    title: "Boas práticas: {{pageName}}",
    videosTab: "Vídeos",
    textTab: "Texto",
    understood: "Entendi",
  },
  suspendedAccount: {
    payOverdueInvoices: "Pagar faturas em atraso",
    payInvoice: "Pagar fatura",
    permanentlySuspendedTitle: "Sua conta está suspensa.",
    suspendedForPaymentTitle: "Sua conta está suspensa por falta de pagamento!",
    permanentlySuspendedDescription:
      "Sua conta está suspensa em definitivo por falta de pagamento por mais de {{days}} dias após o vencimento da sua fatura. Realize o pagamento e a conta será desbloqueada em 30 minutos ou entre em contato com o suporte.",
    suspendedForPaymentDescription:
      "Para desbloquear sua conta, pague as faturas atrasadas clicando no botão \"Pagar fatura\". Após o pagamento, sua conta será desbloqueada automaticamente.",
  },
  rewards: {
    bannerTitle: "Sistema de recompensas inteligente",
    bannerDescription: "Crie recompensas personalizadas e use IA para sugestões automáticas.",
    watchTutorial: "Assistir tutorial",
    deleteSelected: "Excluir selecionadas",
    newReward: "Nova recompensa",
    rewardSuggestion: "Sugestão de Loja",
    searchPlaceholder: "Pesquisar recompensa por nome",
    rewardsCount: {
      one: "{{count}} recompensa",
      other: "{{count}} recompensas",
    },
    selectedCount: {
      one: "{{count}} selecionada",
      other: "{{count}} selecionadas",
    },
    deselectAll: "Desmarcar todas",
    selectAll: "Selecionar todas",
    outOfStock: "Fora de estoque",
    viewMode: "Visualização:",
    grid: "Grade",
    list: "Lista",
    table: "Tabela",
    rewardDetails: "Detalhes da recompensa",
    noGamesAssigned: "Sem segmentos",
    sendToStore: "Enviar para a loja",
    details: "Detalhes",
    noRewardFound: "Nenhuma recompensa encontrada",
    editTitle: "Editar recompensa",
    editPageTitle: "Editar recompensa | Gamefik Escolas no level máximo.",
    newRewardPageTitle: "Nova recompensa | Gamefik Escolas no level máximo.",
    newRewardTitle: "Nova Recompensa",
    rewardSavedSuccess: "Recompensa salva com sucesso.",
    redeemError: "Ocorreu um erro ao processar sua solicitação",
    requestError: "Ocorreu um erro ao processar sua requisição. Tente novamente mais tarde.",
    rewardRemovedSuccess: "Recompensa removida com sucesso.",
    rewardsPageTitle: "Recompensas | Gamefik Escolas no level máximo.",
    myStore: "Minha Loja",
    smartRewardsSystem: "Sistema de recompensas inteligente",
    smartRewardsDescription: "Crie recompensas personalizadas e use IA para sugestões automáticas.",
    shinyOnlyTitle: "Recompensas estão disponíveis no plano Shiny",
    shinyOnlyDescription: "Assine o Shiny para liberar recompensas personalizadas, gift cards e a loja completa para sua turma.",
    shinyOnlyCta: "Assinar Shiny",
    shinyOnlySecondary: "Voltar",
    deleteSelectedButton: "Excluir Selecionadas",
    newRewardButton: "Nova Recompensa",
    storeSuggestionButton: "Sugestão de Loja",
    searchRewardsPlaceholder: "Pesquisar recompensas...",
    confirmDeletion: "Confirmar exclusão",
    confirmDeletionMessage: "Você tem certeza que deseja excluir as seguintes recompensas?",
    cancel: "Cancelar",
    deleteAction: "Excluir",
    editRewardDialog: "Editar Recompensa",
    newRewardDialog: "Nova Recompensa",
    rewardsDeletedSuccess: "Recompensas deletadas com sucesso",
    processingError: "Ocorreu um erro ao processar sua solicitação",
    closeButton: "Fechar",
    uploadImage: "Faça o upload de uma imagem",
    productName: "Nome do Produto*",
    productNameLabel: "Nome que aparecera para os alunos",
    descriptionLabel: "Descrição*",
    descriptionPlaceholder: "Breve descrição do item",
    categoryLabel: "Categoria*",
    createCategory: "Criar Categoria",
    availableQuantity: "Quantidade disponível*",
    stockQuantity: "Quantidade de estoque",
    playerLimitLabel: "Limite por jogador",
    noLimits: "Sem limites",
    coinsCalculator: "Calculadora de coins",
    rarityIs: "A raridade é",
    useThisValue: "🪙 Usar este valor 🪙",
    defineCoinsValue: "Defina o valor em coins",
    rarityLabel: "Raridade",
    coinsCalculatorButton: "Calculadora de coins 🤑",
    rarityImportantInfo: "Informações Importantes sobre a raridade da recompensa",
    applicableGames: "Em quais segmentos esta recompensa é aplicável?",
    advancedSettings: "Configurações avançadas",
    scheduleLabel: "Programar",
    notifyStudents: "Notificar Alunos",
    automaticDeliveryLabel: "Entrega automática",
    automaticDeliveryHint: "Alunos recebem a recompensa sem precisar de validação manual.",
    automaticDeliveryBadge: "Entrega automática",
    automaticDeliveryYes: "Sim",
    automaticDeliveryNo: "Não",
    activateAutomaticDelivery: "Ativar entrega automática",
    activateAutomaticDeliveryConfirm: "Ativar entrega automática para as recompensas selecionadas?",
    activateAutomaticDeliveryDescription: "{{count}} recompensa(s) serão entregues automaticamente aos alunos sem validação manual.",
    activateAutomaticDeliverySuccess: "Entrega automática ativada com sucesso.",
    activateAutomaticDeliveryPartialError: "{{count}} recompensa(s) não puderam ser atualizadas.",
    savingReward: "Aguarde, salvando recompensa...",
    fillRewardName: "Preencha o nome da recompensa",
    fillRewardDescription: "Preencha a descrição da recompensa",
    fillAvailableQuantity: "Preencha a quantidade disponível",
    selectAtLeastOneGame: "Selecione ao menos um segmento",
    addToStore: "Adicionar na loja",
    browseButton: "Procurar",
    removeButton: "Remover",
    defineValueIn: "Defina o valor em {{point}}",
    rarityCommon: "comum",
    rarityUncommon: "incomum",
    rarityRare: "raro",
    rarityEpic: "épico",
    rarityLegendary: "lendário",
    rarityCommonTime: "Tempo até o resgate: 1 a 2 semanas",
    rarityUncommonTime: "Tempo até o resgate: 2 a 4 semanas",
    rarityRareTime: "Tempo até o resgate: 1 a 3 meses",
    rarityEpicTime: "Tempo até o resgate: 3 a 6 meses",
    rarityLegendaryTime: "Tempo até o resgate: 6 a 10 meses",
    rewardsDialogTitle: "Recompensas",
    chooseRewardsToRedeem: "Escolhas as recompensas que deseja resgatar da conta de",
    totalLabel: "Total",
    redeemButton: "Resgatar",
    rewardsRedeemedSuccess: "Recompensas recolhidas com sucesso.",
    insufficientScore: "O aluno não possui pontuação sufuciente para esta compra.",
    duplicatedTransaction: "Lançamento duplicado.",
    insufficientBalanceReward: "Saldo insuficiente para esta recompensa.",
    rewardNotFoundError: "Recompensa não encontrada ou indisponível.",
    playerNotFoundError: "Jogador não encontrado.",
    gameNotFoundError: "Segmento não encontrado.",
    rewardAlreadyRedeemed: "Recompensa já foi resgatada anteriormente.",
    purchaseFinishError: "Houve um erro ao finalizar esta compra. Verifique sua conexão e tente novamente.",
    playerNotLinkedToGame: "O jogador selecionado não está vinculado a um segmento.",
    cannotAssignMultipleGames: "Não é possível atribuir recompensas para alunos vinculados em segmentos diferentes.",
    noGames: "Sem segmentos!",
    noRewardsFound: "Nenhuma recompensa encontrada",
    startCreatingRewards: "Comece criando sua primeira recompensa para motivar seus alunos.",
    imageColumn: "Imagem",
    descriptionColumn: "Descrição",
    gamesColumn: "Segmentos",
    statusColumn: "Status",
    dateColumn: "Data",
    actionsColumn: "Ações",
    outOfStore: "Fora da loja",
    noStockBadge: "Sem estoque",
    createdAtLabel: "Criado em",
    sendToStoreButton: "Enviar para a loja",
    editAction: "Editar",
    tipCreateTitle: "Crie recompensas atrativas",
    tipCreateDesc: "Ofereça recompensas variadas que motivem diferentes tipos de alunos.",
    tipPriceTitle: "Configure preços estratégicos",
    tipPriceDesc: "Balance o valor das moedas para manter o engajamento sem tornar as recompensas muito fáceis.",
    tipAITitle: "Use a IA para sugestões",
    tipAIDesc: "Aproveite a geração automática de recompensas para economizar tempo.",
    tipStockTitle: "Monitore o estoque",
    tipStockDesc: "Mantenha controle sobre as recompensas disponíveis e reponha quando necessário.",
    tipPopTitle: "Analise a popularidade",
    tipPopDesc: "Veja quais recompensas são mais procuradas e ajuste sua estratégia.",
    xpRecommendation: "Recomendamos que seja atribuído apenas valor em coins para recompensas, afim de que o jogador não perca experiência. Deseja continuar?",
    noButton: "Não",
    yesButton: "Sim",
    inStock: "Em estoque",
    createdOn: "Criado em",
    atTime: "às",
    quantityLabel: "Quantidade",
    reaisLabel: "Reais",
  },
  purchases: {
    pageTitle: "[Shopping] - Pedidos | Gamefik Escolas no level máximo.",
    walletBalance: "Meu saldo em carteira",
    addBalance: "Adicionar saldo",
    rewardSuggestion: "Sugestão de recompensas",
    giftCardStock: "Estoque de gift cards",
    giftCardDescription: "Selecione um gift card para disponibilizar na loja",
    buyGiftCard: "Comprar gift card",
    cartWizardEntry: "Comprar gift cards (carrinho)",
    rewardsSectionTitle: "Recompensas",
    ordersSectionTitle: "Pedidos",
    manageStore: "Gerenciar Loja",
    itemMadeAvailableInStore: "Item disponibilizado na loja.",
    addGiftCard: "Adicionar Gift Card",
    selectedGiftCard: "Gift Card {{name}}",
    quantityToMakeAvailable: "Quantos gifts você quer disponibilizar?",
    availableCount: "{{count}} disponíveis",
    gameLabel: "Segmento",
    costInCoins: "Quanto custará (em coins)",
    costInCoinsPlaceholder: "Valor em coins",
    playerLimit: "Limite por jogador",
    unlimited: "Sem limites",
    limitPerPlayerSummary: "Limite de {{count}} por jogador",
    optional: "Opcional",
    schedule: "Programar",
    scheduleHint: "Insira uma data caso queira que a recompensa esteja disponível apenas na data selecionada. Deixe esse campo em branco caso queira disponibilizar a recompensa instantaneamente.",
    errorMakingAvailable: "Erro ao disponibilizar na loja",
    makeAvailableInStore: "Disponibilizar na loja",
    currentScores: "Pontuações Atuais",
    coins: "Moedas",
    noOrderToApprove: "Nenhum pedido pra ser aprovado!",
    toDeliver: "Por entregar",
    waiting: "Aguardando",
    approved: "Aprovado",
    cancelledStatus: "Cancelado",
    nameColumn: "Nome",
    priceColumn: "Preço",
    totalColumn: "Total",
    nothingFound: "Nada encontrado",
    quantityLabel: "Quantidade",
    giftCardUnavailable: "Gift Card Indisponível",
    giftCardUnavailableDesc: "O gift card da marca {{brand}} com o valor R$ {{value}} não está mais disponível.",
    selected: "Selecionado",
    bulkProcessingTitle: "Processando Itens em Massa",
    bulkProcessingProgress: "Processando {{current}} de {{total}}...",
    successLabel: "Sucesso",
    processingLabel: "Processando...",
    closeAndUpdate: "Fechar e Atualizar",
    importantInfo: "Informações Importantes",
    acceptButton: "Aceitar",
    deliverButton: "Entregar",
    cancelButton: "Cancelar",
    itemsPerPage: "Itens por página",
    noRewardRequest: "Nenhuma solicitação de recompensa até o momento. Verifique se a sua loja está disponível em",
    advancedSettingsLink: "Configurações Avançadas",
    pendingStatus: "Pendente",
    acceptedStatus: "Aceito",
    acceptAll: "Aceitar Todos",
    deliverAll: "Entregar Todos",
    cancelAll: "Cancelar Todos",
    orderDate: "Data do pedido",
    deliveredBy: "Entregue por",
    deliveryDate: "Data da entrega",
    createdBy: "Criador por",
    acceptedBy: "Aceito por",
    acceptanceDate: "Data da aceitação",
    cancelledBy: "Cancelado por",
    statusChangedSuccess: "Status do pedido alterado com sucesso.",
    internalError: "Um problema interno ocorreu.",
    invalidProductCode: "Código do produto inválido. Verifique se o produto ainda está disponível.",
    insufficientBalance: "Saldo insuficiente para realizar a compra.",
    playerNotFound: "Jogador não encontrado. Verifique se o jogador ainda está ativo.",
    gameNotFound: "Segmento não encontrado. Verifique se o segmento ainda está ativo.",
    purchaseAlreadyProcessed: "Este pedido já foi processado anteriormente.",
    processingError: "Ocorreu um erro ao processar o pedido. Entre em contato com o suporte.",
    connectionError: "Problema de conexão. Verifique sua internet e tente novamente.",
    timeoutError: "A operação demorou muito para responder. Tente novamente.",
    serverError: "Erro de comunicação com o servidor.",
    giftCardInstructions: "Instruções de uso do gift card",
    redemptionUrl: "URL de Resgate",
    openRedemptionPage: "Abrir página de resgate",
    giftCode: "Código do gift",
    complementaryCode: "Código complementar",
    printGiftVoucher: "Imprimir vale presente",
    viewGiftCardResult: "Ver resultado do gift card",
    selectItem: "selecionar item",
    deliveredStatus: "Entregue",
    filtersTitle: "Filtros",
    selectStatus: "Selecione um status",
    pendingCount: "Pendente",
    cancelledCount: "Cancelado",
    acceptedCount: "Aceito",
    deliveredCount: "Entregue",
    updateError: "Erro ao atualizar",
    confirmBulkAction: "Confirma alterar o status de {{count}} itens para {{status}}?",
    unknown: "Desconhecido",
    failedToLoadOrders: "Falha ao carregar pedidos",
    failedToLoadOrdersDesc: "Não foi possível buscar os pedidos. Tente novamente.",
    retryButton: "Tentar novamente",
    loadingOrders: "Carregando pedidos...",
    loadingOrdersProgress: "Carregando pedidos... {{loaded}} de {{total}}",
    selectGiftToReplace: "Selecionar um gift pra substituir o gift card indisponível",
    contactSupportRefund: "Contate o suporte para realizar o reembolso desse gift card",
    giftCardUnavailableTitle: "Gift Card Indisponível",
    giftCardUnavailableText: "O gift card da marca {{brand}} com o valor R$ {{value}} não está mais disponível.",
    newValuesAvailable: "Novos valores disponíveis para esta marca:",
    selectedButton: "Selecionado",
    selectButton: "Selecionar",
    closeButton: "Fechar",
    confirmButton: "Confirmar",
    processingBulkTitle: "Processando Itens em Massa",
    processingProgress: "Processando {{current}} de {{total}}...",
    successResult: "Sucesso",
    unknownError: "Erro desconhecido",
    processingButton: "Processando...",
    closeAndUpdateButton: "Fechar e Atualizar",
    selectAllPending: "Selecionar Todos Pendentes",
    selectAllAccepted: "Selecionar Todos Aceitos",
    clearSelection: "Limpar Seleção ({{count}})",
    itemsPerPagePlaceholder: "Itens por página",
    perPage: "{{count}} por página",
    previousPage: "Anterior",
    nextPage: "Próxima",
    searchOrders: "Buscar pedidos",
    csvPlayerName: "Nome do Jogador",
    csvItemName: "Nome do Item",
    csvQuantity: "Quantidade",
    csvStatus: "Status",
    csvCreatedAt: "Data de Criação",
    downloadSummary: "Baixar resumo",
    importantInfoTitle: "Informações Importantes",
    importantInfoAccept: "Verifique se a recompensa que o aluno selecionou realmente está disponível, se sim, clique em",
    importantInfoAcceptAction: "Aceitar",
    importantInfoCancel: "A recompensa solicitada não está mais disponível? Clique em",
    importantInfoCancelAction: "Cancelar",
    importantInfoCancelResult: "e o aluno receberá o estorno do valor.",
    importantInfoDeliver: "Importante! Após realizar a entrega da recompensa sempre clique em",
    importantInfoDeliverAction: "Entregar",
    noRequestsMessage: "Nenhuma solicitação de recompensa até o momento. Verifique se a sua loja está disponível em",
    advancedSettings: "Configurações Avançadas",
    oneItemSelected: "1 item selecionado",
    selectedItemsCount: "{{count}} itens selecionados",
    itemsSelectedCount: "{{count}} item(s) selecionado(s)",
    pendingLabel: "Pendente",
    acceptedLabel: "Aceito",
    acceptAllButton: "Aceitar Todos",
    deliverAllButton: "Entregar Todos",
    cancelAllButton: "Cancelar Todos",
    confirmBulkStatusChange: "Confirma alterar o status de {{count}} itens para {{status}}?",
    confirmSingleStatusChange: "Confirma alterar o status deste pedido para {{status}}?",
    cancelAcceptedTitle: "Cancelar pedido aceito",
    confirmCancelOrder: "Cancelar este pedido? Os pontos serão devolvidos ao aluno.",
    confirmBulkCancellation: "Cancelar {{count}} pedidos? Os pontos serão devolvidos aos alunos.",
    confirmCancellationButton: "Confirmar cancelamento",
    selectedOrdersTitle: "Processar pedidos selecionados",
    refreshBeforeRetry: "Não foi possível confirmar a alteração. Atualize a página antes de tentar novamente.",
    errorUpdating: "Erro ao atualizar",
    unknownName: "Desconhecido",
    cancelOrderTooltip: "Cancelar pedido e devolver pontos ao aluno",
    makeAvailablePostPaid: "Disponibilizar (pós-pago)",
    postPaidHint: "O valor em R$ só é debitado quando você entregar o gift ao aluno.",
    postPaidCatalogTitle: "Disponibilizar gift card (pós-pago)",
    postPaidCatalogDescription: "Escolha um gift card do catálogo para disponibilizar na loja. O valor em R$ só é cobrado na entrega ao aluno.",
    makingAvailable: "Disponibilizando...",
    noBalanceToDeliverTitle: "Sem saldo para entregar este gift",
    noBalanceToDeliverBody: "Saldo atual: R$ {{balance}} — necessário: R$ {{required}}. Adicione saldo e tente entregar novamente.",
    addBalanceCta: "Adicionar saldo",
    cartWizardTitle: "Comprar gift cards",
    cartStepBuild: "Monte os gift cards",
    cartStepCheckout: "Checkout",
    cartTotal: "Total a pagar",
    cartPayNow: "Pagar agora",
    cartAwaitingPayment: "Aguardando pagamento. Assim que for confirmado, você define moedas e turmas aqui mesmo.",
    cartStepConfirm: "Confirmação",
    cartStepPublish: "Disponibilizar",
    cartConfirmWaiting: "Aguardando confirmação — esta janela avança sozinha quando o pagamento cair.",
    cartPublishIntro: "Pagamento confirmado!",
    cartPublishHint: "Agora defina quanto os alunos pagam em moedas e para quais turmas o gift card fica disponível.",
    cartPublishLater: "Deixar para depois",
    cartPublishStockMissing: "Estoque não encontrado para",
    cartAddRow: "Adicionar outro gift card",
    cartSelectBrand: "Marca",
    cartSearchBrand: "Buscar marca...",
    cartBrandNotFound: "Nenhuma marca encontrada.",
    cartSelectValue: "Valor",
    cartQuantity: "Qtd",
    cartPaymentMethod: "Forma de pagamento",
    cartPaymentPix: "Pix",
    cartPaymentBoleto: "Boleto",
    cartPaymentCreditCard: "Cartão de Crédito",
    cartOrderSummary: "Resumo do pedido",
    cartFieldName: "Nome completo",
    cartFieldEmail: "E-mail",
    cartFieldCpf: "CPF / CNPJ",
    cartFieldCardNumber: "Número do cartão",
    cartFieldCardHolder: "Nome no cartão",
    cartFieldExpiryMonth: "Mês de validade",
    cartFieldExpiryYear: "Ano de validade",
    cartFieldCcv: "CVV",
    cartFieldPostalCode: "CEP",
    cartFieldAddressNumber: "Número do endereço",
    cartLoadingCatalog: "Carregando catálogo...",
    cartSuccess: "Compra realizada com sucesso! Os gift cards aparecerão no seu estoque em breve.",
    cartError: "Erro ao processar pagamento. Tente novamente.",
    cartErrorCatalog: "Não foi possível carregar o catálogo de gift cards.",
    cartNext: "Próximo",
    cartBack: "Voltar",
    cartProcessing: "Processando...",
    cartPixCopyPaste: "Pix Copia e Cola",
    cartBoletoOpen: "Abrir boleto",
    cartUseBalance: "Usar saldo (R$ {{balance}} disponível)",
    cartBalanceApplied: "Saldo aplicado",
    cartToPay: "A pagar",
    cartPayWithBalance: "Pagar com saldo",
    addGiftCards: "Adicionar gift cards",
    addGiftCardsTitle: "Adicionar gift cards",
    addGiftCardsDesc: "Escolha como adicionar gift cards à loja.",
    modeCartTitle: "Comprar (carrinho)",
    modeCartDesc: "Monte um carrinho e pague na hora (pix, boleto, cartão ou saldo).",
    modePostPaidTitle: "Disponibilizar (pós-pago)",
    modePostPaidDesc: "Disponibilize agora e pague só quando entregar ao aluno.",
    modePrePaidTitle: "Comprar com saldo",
    modePrePaidDesc: "Compre gift cards usando o saldo da conta.",
    tabRewards: "Recompensas",
    tabOrders: "Pedidos",
    rewardsEmpty: "Nenhuma recompensa na loja ainda.",
    ordersEmpty: "Nenhum pedido pendente.",
    rewardStock: "Estoque",
  },
  attitudes: {
    pageTitle: "Atitudes | Gamefik Escolas no level máximo.",
    positiveAttitudes: "Atitudes Positivas",
    negativeAttitudes: "Atitudes Negativas",
    recommendation: "Recomendação",
    recommendationDescription: "Recomendamos manter no máximo 5 atitudes positivas e 3 negativas para facilitar o entendimento dos alunos.",
    searchPlaceholder: "Pesquisar por nome...",
    filterByGame: "Filtrar por segmento",
    newAttitude: "Nova Atitude",
    showingAttitudes: "Exibindo {{count}} atitudes",
    collapseAll: "Recolher todas",
    expandAll: "Expandir todas",
    emptyTitle: "Nenhuma atitude encontrada",
    emptySubtitle: "Tente ajustar seus filtros ou crie uma nova atitude",
    deletedSuccess: "Atitudes deletadas com sucesso",
    savedSuccess: "Atitude salva com sucesso.",
    removedSuccess: "Atitude removida com sucesso.",
    duplicatedSuccess: "Atitude duplicada com sucesso",
    appliedSuccess: "Atitude aplicada com sucesso",
    attitudesAppliedSuccess: "Atitudes aplicadas com sucesso!",
    attitudesLaunched: "Atitudes lançadas!",
    playersUpdated: "Jogadores atualizados",
    requestError: "Ocorreu um erro ao processar sua requisição. Tente novamente mais tarde.",
    processingError: "Ocorreu um erro ao processar sua solicitação",
    applyingAttitudes: "Aplicando atitudes/missões...",
    errorApplyingAttitudes: "Erro ao aplicar atitudes",
    contactSupport: "Algum erro aconteceu, contacte o suporte.",
    duplicatedTransaction: "Lançamento duplicado.",
    confirmDeleteTitle: "Você tem certeza que deseja excluir as atitudes abaixo?",
    confirmDuplicateTitle: "Você tem certeza que deseja duplicar esta atitude?",
    newAttitudePageTitle: "Nova atitude | Gamefik Escolas no level máximo.",
    editAttitudePageTitle: "Editar atitude | Gamefik Escolas no level máximo.",
    newMission: "Nova missão",
    deleteMissions: "Excluir missões",
    deleteAttitudesButton: "Excluir atitudes",
    createNewAttitude: "Criar uma nova atitude",
    chooseSuggestion: "Escolher uma sugestão",
    selectButton: "Selecionar",
    applyButton: "Aplicar",
    editButton: "Editar",
    deleteButton: "Excluir",
    showMore: "Mostrar mais",
    proceedAnyway: "Prosseguir mesmo assim",
    cancelCreation: "Cancelar criação",
    finalizeAndCreate: "Finalizar e Criar",
    finalizeAndSave: "Finalizar e Salvar",
    continueButton: "Continuar",
    nextRecurrence: "Próximo: Recorrência",
    selectAll: "Selecionar todos",
    applyEmoji: "🌟 Aplicar 🌟",
    or: "ou",
    ideal: "ideal",
    tooMuch: "muito",
    attitudeNameHeader: "Nome da Atitude",
    descriptionHeader: "Descrição",
    valueHeader: "Valor",
    activeHeader: "Ativa",
    nameHeader: "Nome",
    activeGamesHeader: "Segmentos ativos",
    classesHeader: "Turmas",
    editHeader: "Editar",
    descriptionPrefix: "Descrição:",
    createdBy: "Criado por:",
    deletedLabel: "deletada",
    allLabel: "Todas",
    noRewards: "Sem recompensas",
    editMission: "Editar missão",
    editAttitudeLabel: "Editar atitude",
    noPlayerFound: "Nenhum jogador foi encontrado",
    noPlayerFoundSubtitle: "Mude os filtros ou cadastre mais jogadores nos segmentos da atitude",
    searchByNamePlaceholder: "Buscar por nome...",
    allClasses: "Todas as Turmas",
    studentCount: "{{count}} aluno(s)",
    playersSelected: "{{count}} Jogador(es) selecionado(s)",
    selectAtLeastOneStudent: "Selecione pelo menos um aluno",
    applyAttitudeForStudents: "Aplicar atitude para {{count}} aluno(s)",
    applyAttitudeDialogTitle: "Aplicar Atitude: {{name}}",
    receivedTimes: "Recebeu {{count}} vezes",
    receivedOnce: "Recebeu 1 vez",
    notReceivedToday: "Não recebeu hoje",
    noClass: "Sem turma",
    levelImage: "imagem do level",
    configureRecurrence: "Configurar Recorrência",
    defineAutoApply: "Defina quando esta atitude será aplicada automaticamente",
    applicationFrequency: "Frequência de aplicação",
    howItWorks: "Como funciona:",
    autoApplyOnSelectedDays: "Aplicação automática nos dias selecionados",
    validForAllStudents: "Válido para todos os alunos das turmas",
    canBePausedAnytime: "Pode ser pausado a qualquer momento",
    newAttitudeDialogTitle: "Nova Atitude",
    howToCreateQuestion: "Como você deseja criar esta nova atitude?",
    suggestionBank: "Banco de Sugestões",
    suggestionBankDesc: "Explore nossa biblioteca com atitudes prontas para uso imediato.",
    createFromScratch: "Criar do Zero",
    createFromScratchDesc: "Personalize totalmente o nome, regras e recompensas.",
    attitudeLibrary: "Biblioteca de Atitudes",
    searchByNameOrDesc: "Buscar por nome ou descrição...",
    positiveTab: "Positivas",
    negativeTab: "Negativas",
    tryAnotherSearch: "Tente buscar por outro termo",
    showingOptions: "Mostrando {{count}} opções",
    notFoundCreateFromScratch: "Não encontrou? Criar do zero",
    attitudeDetailsTitle: "Detalhes da Atitude",
    customizeDescription: "Personalize como esta atitude será exibida e pontuada.",
    recurrenceMode: "Modo de Recorrência",
    recurrenceModeDesc: "Esta atitude será aplicada automaticamente. Apenas atitudes positivas são permitidas neste modo.",
    impactType: "Tipo de Impacto",
    positiveLabel: "Positiva",
    recognizeGoodBehavior: "Reconhecer bons comportamentos",
    negativeLabel: "Negativa",
    correctBehavior: "Corrigir comportamentos",
    attitudeNameLabel: "Nome da Atitude",
    attitudeNamePlaceholder: "Ex: Participação em aula",
    attitudeNameRequired: "Por favor, dê um nome para a atitude.",
    descriptionLabel: "Descrição",
    optionalLabel: "(Opcional)",
    descriptionPlaceholder: "Descreva brevemente o motivo desta atitude...",
    rewardPenalty: "Recompensa / Penalidade",
    impactOnXpAndCoins: "Impacto no XP e Moedas",
    impactOnCoins: "Impacto no Moedas",
    selectRewardValue: "Selecione um valor de recompensa.",
    customRewardValue: "Valor personalizado",
    whereToApply: "Onde aplicar?",
    selectGamesDesc: "Selecione os segmentos que terão acesso a esta atitude.",
    availableGames: "Segmentos Disponíveis ({{count}})",
    noGameFound: "Nenhum segmento encontrado.",
    limitExceededTitle: "Limite de atitudes excedido",
    limitExceededDesc: "Você já atingiu o limite recomendado de 5 atitudes positivas ou 3 atitudes negativas. Adicionar mais atitudes pode tornar o sistema confuso para os alunos e dificultar o entendimento das regras.",
    recommendationsTitle: "Recomendações:",
    recommendationKeepMax: "Mantenha no máximo 5 atitudes de cada tipo para facilitar o entendimento",
    recommendationConsolidate: "Considere revisar e consolidar atitudes similares",
    recommendationSimple: "Atitudes mais simples e claras são mais eficazes",
    confirmExceedLimit: "Entendo que estou excedendo o limite recomendado e que isso pode afetar negativamente a experiência dos alunos. Desejo prosseguir mesmo assim e usar o Gamefik em modo não recomendado.",
    continueAnyway: "Prosseguir mesmo assim",
    missionsType: "Missões",
    missionsTooltip: "As missões são eventuais, algo que acontece uma ou poucas vezes.",
    yesOption: "Sim",
    noOption: "Não",
    nameLabel: "Nome",
    positiveRecurrenceInfo: "Esta é uma recorrência positiva. As recorrências são sempre positivas e são aplicadas automaticamente nos dias selecionados.",
    selectType: "Selecione o tipo",
    gamesApplicableRecurrence: "Em quais segmentos esta recorrência é aplicável?",
    gamesApplicableMission: "Em quais segmentos esta missão é aplicável?",
    gamesApplicableAttitude: "Em quais segmentos esta atitude é aplicável?",
    pointsToGainMission: "Quantos pontos o jogador deverá ganhar ao realizar esta missão?",
    pointsToGainAttitude: "Quantos pontos o jogador deverá ganhar ao realizar esta atitude?",
    recurrencePriorityNegative: "Qual a prioridade dessa recorrência negativa?",
    recurrencePriorityPositive: "Qual a prioridade dessa recorrência positiva?",
    recurrenceTitle: "Recorrência",
    visibleOnlyInHmg: "Visível apenas em hmg",
    recurrenceSelectTooltip: "Se você selecionar sim, sera possivel selecionar determinar uma frequencia com que essa atitude seja aplicada automaticamente.",
    mandatoryCollection: "Invalidar pontos não coletados",
    mandatoryCollectionTooltip: "Quando ativado, o aluno precisa entrar no app e coletar a pontuação antes do fim do período. Em automações diárias, a coleta deve acontecer no mesmo dia; nas semanais, até o fim da semana. Se não coletar, a pontuação expira.",
    classesTitle: "Turmas",
    issuesFound: "Problemas encontrados:",
    operationInProgress: "Operação em andamento...",
    selectAtLeastOneGame: "Selecione pelo menos um segmento",
    fillName: "Preencha o nome",
    fillDescription: "Preencha a descrição",
    selectTypeReason: "Selecione o tipo",
    selectAtLeastOneClass: "Selecione pelo menos uma turma",
    saveButton: "Salvar",
    continuousMission: "Missão contínua",
    continuousMissionInfo1: "Uma missão contínua, continua disponível para o jogador mesmo após ser concluída.",
    continuousMissionInfo2: "Caso a missão possa ser realizada várias vezes, marque essa opção.",
    recurrenceAutoApplyInfo: "Esta recorrência será aplicada automaticamente com base na frequência selecionada",
    priorityVeryLow: "Muito Baixa",
    priorityLow: "Baixa",
    priorityModerate: "Moderada",
    priorityHigh: "alta",
    priorityVeryHigh: "Muito alta",
    difficultyQuick: "Rápida",
    difficultyVeryEasy: "Muito Fácil",
    difficultyEasy: "Fácil",
    difficultyHard: "difícil",
    difficultyVeryHard: "Muito difícil",
    difficultyLasting: "Duradoura",
    difficultyMedium: "Média",
    difficultyHardTeacher: "Difícil",
    applyAttitudesTitle: "Aplicar atitudes",
    studentsWhoWillReceive: "Alunos que receberão:",
    errorApplyingAttitudeToPlayer: "Erro ao aplicar a atitude {{attitude}} para o {{player}}.",
    otherAttitudesAppliedCorrectly: "Todas as outras atitudes foram lançadas corretamente.",
    playerNotLinkedToGame: "Um ou mais jogadores selecionados não estão vinculados a um segmento ({{name}}).",
    selectOneOrMorePlayers: "Selecione um ou mais jogadores",
    positiveAttitudesHeader: "Atitudes positivas",
    negativeAttitudesHeader: "Atitudes negativas",
    missionsHeader: "Missões",
    closeButton: "fechar",
    applyWithStars: "🌟 Aplicar 🌟",
    studentsLabel: "alunos",
    attitudesLabel: "atitudes",
    allStudentsWillReceive: "Todos os alunos receberão todas as atitudes selecionadas!",
    noAttitudesSelected: "Não há atitudes selecionadas",
    manualLaunchTitle: "Lançando manualmente: {{name}}",
    selectAClass: "Selecione uma turma",
    search: "Pesquisar",
    clearButton: "Limpar",
    launchAttitude: "Lançar atitude!",
    launchMission: "Lançar missão!",
    selectAtLeastOnePlayer: "Selecione ao menos um jogador",
    applyAttitudeButton: "Aplicar atitude",
    applyMissionButton: "Aplicar missão",
    general: "Geral",
    selectAType: "Selecione um tipo",
    multipliable: "Multiplicável",
    nothingAvailable: "Nada disponível aqui",
    selectAPlayer: "Selecione um jogador!",
    deletedClass: "deletada",
    allClassesChip: "Todas",
    editAttitudeTitle: "Editar Atitude",
    closeButtonLabel: "Fechar",
    createdSuccess: "Atitude criada com sucesso",
    headTitle: "Atitudes | Gamefik Escolas no level máximo.",
    positiveTitle: "Atitudes positivas",
    negativeTitle: "Atitudes negativas",
    recommendationTitle: "Recomendação",
    statusChangedSuccess: "Status da atitude alterado com sucesso",
    updatedSuccess: "Atitude atualizada com sucesso",
    showingCount: "Exibindo {{count}} atitudes",
    deleteAttitude: "Excluir atitude",
    editLabel: "Editar",
    apply: "Aplicar",
    linkedGames: "Segmentos vinculados",
    deleteLabel: "Excluir",
    objectiveLabel: "Objetivo",
    allGames: "Todos os segmentos",
    statusTabs: {
      all: "Todas",
      active: "Ativas",
      inactive: "Inativas",
    },
    typeTabs: {
      all: "Todas",
      positive: "Positivas",
      negative: "Negativas",
    },
    filterLabel: "Filtrar",
    filterWithType: "Filtrar: {{type}}",
    confirmDeleteDescription:
      "Tem certeza que deseja excluir esta atitude? Esta ação não pode ser desfeita.",
    editAttitudeTooltip: "Editar atitude",
    inactiveBadge: "Desativada",
    statusLabel: "Status:",
    detailsSectionTitle: "Detalhes",
    systemUser: "Sistema",
    debugJson: "Debug JSON",
    xpAndCoinAlt: "XP e moedas",
    coinsAlt: "Moedas",
    tips: {
      clearObjective: {
        title: "Defina atitudes claras e objetivas",
        description:
          "Crie atitudes com descrições claras para que os alunos entendam o que é esperado deles.",
        placeholder: "Video mostrando como criar uma atitude com descrição clara e objetiva",
      },
      balance: {
        title: "Equilibre atitudes positivas e negativas",
        description:
          "Mantenha um equilíbrio entre reconhecer comportamentos positivos e corrigir comportamentos negativos.",
        placeholder: "Video demonstrando o equilíbrio entre atitudes positivas e negativas",
      },
      consistency: {
        title: "Seja consistente na aplicação",
        description: "Aplique as atitudes de forma consistente e justa para todos os alunos.",
        placeholder: "Video mostrando como aplicar atitudes de forma consistente",
      },
      revisit: {
        title: "Revisite regularmente",
        description: "Revisite periodicamente as atitudes para garantir que continuem relevantes.",
        placeholder: "Video sobre como revisar e atualizar atitudes periodicamente",
      },
      fairValues: {
        title: "Use valores adequados",
        description: "Atribua valores de moedas e pontos de acordo com a importância da atitude.",
        placeholder: "Video explicando como definir valores adequados para atitudes",
      },
    },
    suggestions: {
      positive: {
        presence: { name: "Presença", desc: "Comparecer às aulas regularmente." },
        punctuality: { name: "Pontualidade", desc: "Chegar no horário correto para as atividades." },
        homework: { name: "Tarefa de casa", desc: "Cumprir os deveres de casa dentro do prazo." },
        classwork: { name: "Atividade em sala", desc: "Realizar as tarefas propostas com dedicação." },
        teamwork: {
          name: "Colaboração e trabalho em equipe",
          desc: "Ajudar colegas e trabalhar bem em grupo.",
        },
        respect: {
          name: "Respeitou professores e colegas",
          desc: "Tratar todos com educação e consideração.",
        },
        materials: {
          name: "Material completo",
          desc: "Trazer todos os materiais e estar devidamente uniformizado.",
        },
        participation: {
          name: "Participação ativa",
          desc: "Contribuir nas atividades e interagir nas aulas.",
        },
      },
      negative: {
        excessTalk: { name: "Excesso de conversa", desc: "Falar fora de hora e atrapalhar a aula." },
        phoneMisuse: {
          name: "Uso inadequado do celular",
          desc: "Mexer no celular sem permissão durante a aula.",
        },
        unexcusedAbsences: {
          name: "Faltas sem justificativa",
          desc: "Chegar tarde ou faltar sem motivo.",
        },
        carelessMaterial: {
          name: "Descuido com o material próprio ou da escola",
          desc: "Danificar livros, carteiras, equipamentos ou deixar lixo espalhado.",
        },
      },
    },
  },
  quizzes: {
    tipsQuestionTypesTitle: "Varie os tipos de perguntas",
    tipsQuestionTypesDescription: "Misture perguntas de múltipla escolha, verdadeiro/falso e resposta curta.",
    tipsQuestionTypesPlaceholder: "Video mostrando diferentes tipos de perguntas para quizzes",
    tipsDifficultyTitle: "Equilibre a dificuldade",
    tipsDifficultyDescription: "Inclua perguntas de diferentes níveis de dificuldade para desafiar todos os alunos.",
    tipsDifficultyPlaceholder: "Video sobre como equilibrar a dificuldade das perguntas",
    tipsResultsTitle: "Analise os resultados",
    tipsResultsDescription: "Use os relatórios para identificar pontos de melhoria no aprendizado.",
    tipsResultsPlaceholder: "Video tutorial sobre como analisar resultados de quizzes",
    tipsExplanationsTitle: "Forneça explicações",
    tipsExplanationsDescription: "Inclua explicações para respostas erradas para ajudar no aprendizado.",
    tipsExplanationsPlaceholder: "Video demonstrando como fornecer explicações úteis",
    tipsAiQuestionsTitle: "Use a IA para criar perguntas",
    tipsAiQuestionsDescription: "Aproveite a geração de perguntas com IA para economizar tempo.",
    tipsAiQuestionsPlaceholder: "Video sobre como usar IA para criar perguntas de quiz",
    editQuiz: "Editar quiz",
    alternative: "Alternativa {{index}}",
    removeAlternative: "Remover alternativa",
    save: "Salvar",
    cancel: "Cancelar",
    exportToExcel: "Exportar para Excel",
    createQuiz: "Criar Quiz",
    quizzes: "Quizzes",
    loading: "Carregando...",
    checkingIaCredits: "Verificando créditos/plano de IA...",
    iaCheckError: "Não foi possível verificar seus créditos de IA agora. Tente novamente mais tarde.",
    basicInfo: "Informações básicas",
    selectGames: "Selecione os segmentos",
    enableCoins: "Habilitar moedas",
    deadlinesAndSettings: "Prazos e configurações",
    questionIndex: "Questão {{index}}",
    discursiveEvaluation: "Avaliação das respostas discursivas",
    byAi: "🤖 Por IA",
    manually: "👨‍🏫 Manualmente",
    titleRequired: "O título do quiz é obrigatório.",
    descriptionRequired: "A descrição do quiz é obrigatória.",
    atLeastOneQuestion: "O quiz deve ter pelo menos uma questão.",
    questionStatementRequired: "Preencha o enunciado de todas as questões.",
    alternativesRequired: "Preencha todas as alternativas; cada questão objetiva precisa de pelo menos duas.",
    correctAlternativeRequired: "Selecione uma alternativa correta válida em todas as questões objetivas.",
    createError: "Não foi possível criar o quiz. Revise os dados e tente novamente.",
    rewardsRequired: "As recompensas do quiz são obrigatórias.",
    selectEvaluationMethod: "Selecione como as respostas discursivas serão avaliadas (IA ou manual).",
    classesRequired: "As turmas do quiz são obrigatórias.",
    cannotExpireNow: "A missão não pode acabar agora! De mais tempo para seus alunos.",
    back: "voltar",
    waiting: "Aguarde...",
    create: "Criar",
    previewTitle: "Preview do quiz",
    questionsGenerated: "{{count}} questões geradas",
    moreQuestions: "+{{count}} questões...",
    difficultyEasy: "Fácil",
    difficultyMedium: "Médio",
    difficultyAdvanced: "Avançado",
    rename: {
      questions: "questão",
      rewards: "recompensas",
      classes: "turmas",
      alternatives: "alternativas",
      startDate: "data de inicio",
      expirationDate: "data de expiração",
      title: "Título",
      description: "Descrição",
      statement: "Enunciado",
      teacherCanValidate: "Professor pode validar",
      notifyStudents: "Notificar alunos",
      startsAt: "📅 Começará em",
      endsAt: " 📅 Acabará em",
    },
    selectImage: "Selecione uma Imagem",
    searchImages: "Buscar imagens...",
    imageSearchHint:
      "Pesquise na web e escolha uma imagem. Os resultados aparecem abaixo — role a lista para ver mais.",
    imageSearchEmptyTitle: "Busque uma imagem",
    imageSearchEmptyHint:
      "Digite um termo (ex.: “cultura alimentar”) e toque em Pesquisar.",
    imageSearchNoResults: "Nenhuma imagem encontrada",
    imageSearchNoResultsHint: "Tente outro termo ou palavras mais gerais.",
    imageSearchBack: "Voltar à busca",
    imageSearchOpenSource: "Abrir página de origem",
    confidenceHigh: "alta",
    confidenceMedium: "média",
    confidenceLow: "baixa",
    search: "Pesquisar",
    searchFailed: "Falha ao buscar imagens. Tente novamente.",
    noTitle: "Sem título",
    image: "Imagem",
    from: "De:",
    unknown: "Desconhecido",
    confidence: "Confiança:",
    confidenceUnknown: "desconhecida",
    confirmSelection: "Confirmar Seleção",
    editImage: "Editar Imagem",
    confirm: "Confirmar",
    reviewDiscursive: "Revisar Discursivas",
    exportToExcelButton: "📊 Exportar para Excel",
    correctAnswers: "Acertos",
    partialAnswers: "Parciais",
    errors: "Erros",
    averageCorrect: "Média acertos",
    uniqueStudents: "Alunos únicos",
    resubmissions: "Reenvios",
    review: "Revisão",
    questionsLabel: "Questões",
    answerDistribution: "Distribuição das respostas",
    totalAnswers: "{{count}} respostas totais",
    submitted: "Enviados",
    pending: "Pendentes",
    correct: "Corretas",
    partialOrWrong: "Parcial/Errado",
    all: "Todos",
    pendingTab: "Pendentes",
    reviewed: "Revisados",
    searchAnswerContent: "Buscar por conteúdo da resposta",
    submissions: "Submissões",
    clickToEvaluate: "Clique para abrir e avaliar",
    repeated: "REPETIDO",
    answersCount: "{{count}} respostas",
    players: "Jogadores",
    clickPlayerRow: "Clique na linha do jogador para abrir a revisão",
    name: "Nome",
    classLabel: "Turma",
    reviewedCount: "Revisadas",
    pendingCount: "Pendentes",
    actions: "Ações",
    reviewPending: "Revisar pendente",
    allReviewed: "Tudo revisado",
    noSubmissions: "Nenhum envio encontrado",
    classRanking: "Ranking de Turmas",
    orderedByReviewRate: "Ordenado por taxa de revisão",
    reviewedOfSubmissions: "{{reviewed}} revisadas de {{total}} submissões",
    noClassData: "Sem dados por turma",
    reviewSubmission: "Revisar envio",
    close: "Fechar",
    statusReviewed: "Revisado",
    statusPending: "Pendente",
    statusAi: "IA",
    statusCorrect: "CORRETO",
    statusPartial: "PARCIAL",
    statusWrong: "ERRADO",
    toggleCorrect: "Correto",
    togglePartial: "Parcial",
    toggleWrong: "Errado",
    student: "Aluno",
    sentAt: "Enviado em",
    evaluation: "Avaliação",
    evaluationManual: "Manual",
    evaluationAi: "IA",
    status: "Status",
    totalResponses: "Total de respostas",
    statementLabel: "Enunciado",
    studentAnswer: "Resposta do aluno",
    teacherFeedback: "Feedback do professor",
    feedbackPlaceholder: "Escreva um feedback/justificativa para o aluno",
    aiReasoning: "Raciocínio da IA",
    coins: "coins",
    totalEstimated: "Total estimado: {{total}} coins",
    saving: "Salvando...",
    saveEvaluation: "Salvar avaliação",
    noDataToExport: "Não há dados para exportar",
    studentName: "Nome do aluno",
    game: "Segmento",
    noClass: "Sem turma",
    totalCorrect: "Total de acertos",
    totalErrors: "Total de erros",
    totalPartial: "Total de parciais",
    coinsReceived: "Coins recebidos",
    quizAnswers: "Respostas Quiz",
    questions: "Questões",
    totalQuestions: "Total: {{count}} questões",
    addQuestion: "Adicionar questão",
    newQuestion: "Nova pergunta",
    removeQuestion: "Remover questão",
    addAlternative: "Adicionar alternativa",
    multipleChoice: "Múltipla escolha",
    discursive: "Discursiva",
    quizTopic: "Tema do Quiz",
    topicPlaceholder: "Ex: Quiz sobre Sistema Solar, História do Brasil, Matemática Básica...",
    topicHint: "Seja específico para obter melhores resultados. Ex: \"Quiz sobre as capitais dos países da Américado Sul\"",
    detailedDescription: "Descrição detalhada (opcional)",
    descriptionPlaceholder: "Descreva com mais detalhes o conteúdo que deseja abordar no quiz, tópicos específicos, abordagem, etc.",
    numberOfQuestions: "Número de questões",
    nQuestions: "{{count}} questões",
    age6to10: "6 a 10 anos",
    age6to10Desc: "Ensino infantil, fundamental 1 ou crianças em geral",
    simpleLanguage: "Linguagem simples",
    age10to15: "10 a 15 anos",
    age10to15Desc: "Fundamental 2 ou adolescentes",
    deepLanguage: "Linguagem aprofundada",
    age15to18: "15 a 18 anos",
    age15to18Desc: "Ensino médio ou técnico",
    technicalLanguage: "Linguagem técnica",
    age18plus: "Acima de 18 anos",
    age18plusDesc: "Ensino superior ou profissional",
    academicLanguage: "Linguagem acadêmica",
    teacherTip: "Dica para professores",
    educationLevelTip: "O nível educacional ajusta automaticamente o vocabulário e a complexidade das questões para se adequar ao público-alvo.",
    easyDesc: "Questões comuns e corriqueiras sobre o tema, sem conhecimentos prévios específicos",
    mediumDesc: "Questões mais complicadas que exigem conhecimentos prévios sobre o tema",
    advancedDesc: "Questões super incomuns que exigem formação específica na área",
    difficultyTip: "Escolha um nível de dificuldade que seja adequado para o público-alvo do seu quiz e pontuação.",
    goBack: "Voltar",
    nextStep: "Próximo Passo",
    generateQuiz: "GERAR QUIZ",
    createWithAi: "Criar Quiz com IA",
    createFromScratch: "Criar do Zero",
    searchQuizByName: "Pesquisar quiz por nome",
    selectAGame: "Selecione um segmento",
    selectAClass: "Selecione uma turma",
    selectATeacher: "Selecione um professor",
    allGames: "Todos os segmentos",
    allClasses: "Todas as turmas",
    allTeachers: "Todos os professors",
    allDifficulties: "Todas as dificuldades",
    allTab: "Todos",
    activeTab: "Ativos",
    inactiveTab: "Inativos",
    noGameSelected: "Nenhum segmento selecionado",
    more: "+{{count}} mais",
    noQuizFound: "Nenhum quiz foi encontrado",
    noQuizFoundSub: "Mude os filtros ou cadastre mais quizzes",
    quizActivated: "Quiz ativado com sucesso.",
    quizDeactivated: "Quiz desativado com sucesso.",
    quizRemoved: "O quiz foi removido com sucesso.",
    quizUpdated: "O quiz foi atualizado com sucesso.",
    noIaCreditsTitle: "Sem crédito de IA disponível",
    noIaCreditsDesc: "A conta da sua escola não possui créditos de IA. Crie seu quiz manualmente ou entre em contato com o gestor da conta.",
    createManualQuiz: "Criar quiz manual",
    discursiveLabel: "Discursivo",
    multipleChoiceLabel: "Múltipla escolha",
    autoApproval: "Aprovação automática",
    aiApproval: "Aprovação com IA",
    manualApproval: "Aprovação manual",
    disabled: "Desativado",
    createdBy: "Criado por:",
    userFallback: "Usuário",
    difficulty: "Dificuldade:",
    creationDate: "Data de criação:",
    expirationDate: "Data de expiração:",
    noExpiration: "Sem data de expiração",
    statusLabel: "Status:",
    gamesLabel: "Segmentos:",
    classesLabel: "Turmas:",
    performance: "Desempenho:",
    hitRate: "Taxa de acertos: {{rate}}%",
    results: "Resultados",
    bncc: "BNCC",
    delete: "Excluir",
    debugJson: "Debug JSON",
    confirmDelete: "Confirmar exclusão",
    confirmDeleteMessage: "Tem certeza que deseja excluir este quiz?",
    confirmDeleteAction: "Confirmar exclusão",
    discursiveSummary: "Resumo das discursivas",
    studentsSent: "Alunos que enviaram: {{count}}",
    awaitingEvaluation: "Aguardando avaliação: {{count}}",
    approvedCorrect: "Aprovadas (certo): {{count}}",
    incomplete: "Incompletas: {{count}}",
    wrong: "Erradas: {{count}}",
    awaitingTeacherReview: "{{count}} aguardando revisão do professor",
    reviewAction: "Revisar",
    requiredField: "Campo obrigatório",
    requiredFieldDesc: "Por favor, informe o tema do quiz.",
    requiredSelection: "Seleção obrigatória",
    requiredSelectionDesc: "Por favor, selecione a faixa etária do público-alvo.",
    questionType: "Tipo de questões",
    multipleChoiceOption: "Múltipla escolha",
    discursiveOption: "Discursivas",
    questionTypeHint: "Escolha se quer apenas questões de múltipla escolha ou apenas discursivas.",
    cancelButton: "CANCELAR",
    backButton: "VOLTAR",
    nextStepButton: "PRÓXIMO PASSO",
    generatingQuiz: "GERANDO QUIZ...",
    generateQuizButton: "GERAR QUIZ",
    preparingQuiz: "Preparando o quiz...",
    generatingQuestion: "Gerando questão nº {{number}}",
    finishingDetails: "Finalizando últimos detalhes",
    createWithFiles: "Criar Quiz com arquivos",
    createWithFilesTitle: "Criar Quiz com Arquivos",
    createWithFilesDesc: "Faça upload para criar um quiz baseado no conteúdo visual",
    upload: "Upload",
    processing: "Processando",
    completed: "Concluído",
    quizTitle: "Título do Quiz",
    quizTitlePlaceholder: "Ex: Quiz sobre Biologia Marinha",
    uploadImages: "Upload de Imagens",
    clickToUpload: "Clique para fazer upload",
    supportedFormats: "Formatos suportados: JPG, PNG, WEBP, PDF",
    imagesSelected: "{{count}} imagens selecionadas",
    imageSelected: "{{count}} imagem selecionada",
    clearAll: "Limpar tudo",
    processFiles: "Processar Arquivos",
    limitExceeded: "Limite excedido",
    limitExceededDesc: "Você pode enviar no máximo 50 imagens.",
    noImages: "Nenhuma imagem",
    noImagesDesc: "Por favor, faça upload de pelo menos uma imagem.",
    titleRequiredToast: "Título obrigatório",
    titleRequiredDesc: "Por favor, informe um título para o quiz.",
    processingImages: "Processando imagens...",
    processingComplete: "Processamento concluído!",
    processingDesc: "Nossa IA está analisando suas imagens e gerando perguntas relevantes para o quiz. Isso pode levar alguns minutos.",
    processingDoneDesc: "Todas as imagens foram processadas com sucesso. Seu quiz está pronto para revisão.",
    percentComplete: "{{percent}}% concluído",
    hundredComplete: "100% concluído",
    quizGeneratedSuccess: "Quiz gerado com sucesso!",
    quizGeneratedDesc: "Nossa IA analisou suas imagens e criou um quiz personalizado. Agora você pode revisar e ajustar as perguntas antes de publicar.",
    quizSummary: "Resumo do Quiz",
    titleLabel: "Título:",
    processedImages: "Imagens processadas:",
    generatedQuestions: "Perguntas geradas:",
    estimatedDifficulty: "Dificuldade estimada:",
    reviewQuiz: "Revisar Quiz",
    quizGeneratedToast: "Quiz gerado com sucesso!",
    quizGeneratedToastDesc: "Agora você pode revisar e configurar o quiz antes de publicá-lo.",
    undo: "Desfazer",
    redo: "Refazer",
    heading1: "Título 1",
    heading2: "Título 2",
    bold: "Negrito",
    italic: "Itálico",
    strikethrough: "Tachado",
    superscript: "Sobrescrito",
    subscript: "Subscrito",
    bulletList: "Lista com Marcadores",
    orderedList: "Lista Numerada",
    blockquote: "Citação",
    code: "Código",
    textColor: "Cor do Texto",
    colorLabel: "Cor {{color}}",
    insertLink: "Inserir Link",
    link: "Link",
    insertImage: "Inserir Imagem",
    insertVideo: "Inserir vídeo",
    insertVideoPrompt: "Cole o link do YouTube ou URL do vídeo",
    videoDialogHint: "Escolha como adicionar o vídeo ao conteúdo.",
    videoSourceChoose: "Como deseja adicionar?",
    videoSourceYoutube: "Vídeo do YouTube",
    videoSourceYoutubeDesc: "Cole o link do YouTube — incorporamos o player no texto.",
    videoSourceUpload: "Enviar arquivo",
    videoSourceUploadDesc: "MP4, WebM e outros formatos hospedados na Gamefik.",
    videoSourceLink: "Link de vídeo",
    videoSourceLinkDesc: "URL direta de um arquivo .mp4 ou similar.",
    videoBack: "Voltar às opções",
    videoYoutubePanelHint: "Siga os passos para incorporar um vídeo do YouTube.",
    videoUploadPanelHint: "Envie o arquivo de vídeo do seu computador.",
    videoLinkPanelHint: "Cole a URL pública do arquivo de vídeo.",
    videoYoutubeStep1: "Abra o vídeo no YouTube.",
    videoYoutubeStep2: "Clique em Compartilhar → Copiar link.",
    videoYoutubeStep3: "Cole o link abaixo e confira a pré-visualização do embed.",
    videoYoutubeFieldLabel: "Link do YouTube",
    videoYoutubePlaceholder: "https://www.youtube.com/watch?v=…",
    videoYoutubeInvalid: "Não reconhecemos esse link. Use o link completo do vídeo no YouTube.",
    videoYoutubeValid: "Link válido — confira o player abaixo.",
    videoYoutubeConfirm: "Usar este embed",
    videoYoutubeReady: "Embed do YouTube pronto. Clique em Inserir para adicionar ao texto.",
    videoEmptyTitle: "Nenhum vídeo selecionado",
    videoPreviewLabel: "Pré-visualização",
    videoLinkLabel: "URL do vídeo",
    videoLinkPlaceholder: "https://exemplo.com/video.mp4",
    videoLinkApply: "Usar link",
    videoUpload: "Enviar vídeo",
    imageLabel: "Imagem",
    imageDialogHint:
      "Envie uma imagem, pesquise na web ou escolha do banco de imagens educacionais.",
    imageEmptyTitle: "Nenhuma imagem selecionada",
    imagePreviewLabel: "Pré-visualização",
    insertAttachment: "Inserir Anexo",
    attachmentDialogHint:
      "Envie um arquivo, pesquise na web ou escolha do banco de imagens educacionais.",
    attachmentUpload: "Enviar arquivo",
    attachmentSearch: "Pesquisar na web",
    attachmentBank: "Banco de imagens",
    attachmentReady: "Arquivo pronto para inserir",
    attachment: "Anexo",
    mobilePreview: "Visualização Mobile",
    viewOnMobile: "Ver no celular",
    formattingToolbar: "Formatação de texto",
    mediaToolbar: "Inserir mídia e pré-visualizar",
    insert: "Inserir",
    closeModal: "Fechar modal",
    iphonePreview: "iPhone 12/13 (375 × 812 px)",
    imageBank: "Banco de Imagens Educacionais",
    coverDefaultsTitle: "Padrão de capas da escola",
    coverDefaultsDescription: "Escolha a origem e, abaixo, a disciplina usada nas novas atividades.",
    coverSourceLabel: "Origem das capas",
    coverDefaultCategoryLabel: "Disciplina padrão",
    coverSourceSubject: "Disciplina selecionada",
    coverSourceCharacters: "Personagens Gamefik",
    coverSourceMixed: "Disciplina e personagens",
    saveCoverDefault: "Salvar padrão",
    coverDefaultSaved: "Padrão salvo para esta escola.",
    coverDefaultSaveError: "Não foi possível salvar o padrão. Verifique sua permissão e tente novamente.",
    selectCategoryForCoverDefault: "Selecione uma disciplina ou categoria abaixo para salvar este padrão.",
    categoriesLabel: "Categorias",
    allCategories: "Todas",
    searchCategories: "Pesquisar categorias...",
    noResults: "Nenhum resultado encontrado.",
    loadingCategories: "Carregando categorias...",
    noImagesCategory: "Nenhuma imagem nesta categoria",
    tryAnotherCategory: "Tente selecionar outra categoria ou subcategoria.",
    exploreImageBank: "Explore o Banco de Imagens",
    selectCategoryToStart: "Selecione uma categoria acima para começar.",
    clearSelection: "Limpar seleção",
    useImage: "Usar imagem",
    previousImage: "Imagem anterior",
    nextImage: "Próxima imagem",
    addToFavorites: "Adicionar aos favoritos",
    removeFromFavorites: "Remover dos favoritos",
    closePreview: "Fechar preview",
    resultsTitle: "Resultados:",
    participation: "Participação",
    completionRate: "{{rate}}% de conclusão",
    hitRateTitle: "Taxa de Acertos",
    information: "Informações",
    difficultyLabel: "Dificuldade:",
    valueLabel: "Valor:",
    createdByLabel: "Criado por:",
    dateLabel: "Data:",
    questionsByHitRate: "Questões por Taxa de Acerto",
    questionsByHitRateDesc: "Ordenadas da questão com maior taxa de acerto para a menor",
    hitsCount: "{{count}} acertos ({{rate}}%)",
    errorsCount: "{{count}} erros ({{rate}}%)",
    noQuestionsFound: "Nenhuma questão encontrada para este quiz",
    playersTitle: "Jogadores",
    playersDesc: "Lista de alunos que concluíram o quiz",
    allClassesFilter: "Todas as turmas",
    searchByName: "Pesquisar por nome",
    nameNotAvailable: "Nome não disponível",
    classNotAvailable: "Turma não disponível",
    noPlayersFound: "Nenhum jogador encontrado com os filtros selecionados",
    showingPlayers: "Mostrando {{filtered}} de {{total}} jogadores",
    classRankingTitle: "Ranking de Turmas",
    classRankingDesc: "Desempenho por turma ordenado pela taxa de acertos",
    hitPercentage: "{{rate}}% de acertos",
    studentsCount: "{{completed}}/{{total}} alunos ({{rate}}%)",
    hitsOfResponses: "{{hits}} acertos de {{total}} respostas",
    questionDetails: "Detalhes da Questão",
    correctAnswer: "Resposta Correta: {{answer}}",
    hitsTab: "Acertos ({{count}})",
    errorsTab: "Erros ({{count}})",
    noStudentsCorrect: "Nenhum aluno acertou esta questão",
    allStudentsCorrect: "Todos os alunos acertaram esta questão",
    nameErrorNotAvailable: "Erro: Nome do aluno não disponível",
    classStudents: "Alunos da Turma",
    completedCount: "{{completed}}/{{total}} concluíram",
    hitRateLabel: "Taxa de acertos",
    studentsTookQuiz: "Alunos que fizeram",
    participationRate: "Taxa de participação",
    studentList: "Lista de Alunos",
    position: "Pos.",
    date: "Data",
    noStudentsTookQuiz: "Nenhum aluno desta turma fez o quiz ainda",
    showingStudents: "Mostrando {{count}} alunos que fizeram o quiz",
    studentPerformance: "Desempenho do Aluno",
    questionsCorrect: "Questões acertadas",
    allQuestions: "Todas ({{count}})",
    hitsTabPlayer: "Acertos ({{count}})",
    errorsTabPlayer: "Erros ({{count}})",
    correctLabel: "CORRETO",
    wrongLabel: "ERRADO",
    studentAnswerLabel: "Resposta do aluno:",
    correctAnswerLabel: "Resposta correta:",
    answerLabel: "Resposta:",
    noQuestionsAnswered: "O aluno não respondeu nenhuma questão",
    noCorrectAnswers: "O aluno não acertou nenhuma questão",
    allQuestionsCorrect: "O aluno acertou todas as questões!",
    noAnswersYet: "Sem respostas ainda",
    noStudentsCompleted: "Nenhum aluno concluiu este quiz até o momento.",
    refresh: "Atualizar",
    errorOccurred: "Ocorreu um erro",
    errorLoadingData: "Falha ao carregar dados do quiz ou jogadores. Verifique sua conexão e tente novamente.",
    dataNotAvailable: "Dados do quiz não disponíveis.",
    tryAgain: "Tentar novamente",
    undoQuiz: "Desfazer quiz ( HMG )",
    itemsRemoved: "Itens removidos",
    undoQuizDesc: "O quiz \"{{title}}\" foi desfeito para este aluno. As transações e o comprovante abaixo foram removidos e o registro foi enviado ao histórico.",
    undoQuizGeneric: "O quiz foi desfeito para este aluno. As remoções foram enviadas ao histórico.",
    receipt: "Comprovante",
    receiptRemoved: "Comprovante marcado como removido",
    noReceiptReturned: "Nenhum comprovante retornado.",
    transactionsRemoved: "Transações removidas",
    transactionsCount: "{{count}} transações removidas",
    transactionsSummary: "Resumo das transações removidas",
    noTransactionsFound: "Nenhuma transação encontrada para remoção.",
    historyNote: "Obs.: Um registro detalhando as remoções foi enviado para o histórico desta conta.",
    undoConfirm: "Tem certeza que deseja desfazer este quiz? Esta ação remove as transações associadas.",
    receiptNotFound: "Comprovante não encontrado para este aluno",
    quizUndone: "Quiz desfeito com sucesso",
    undoFailed: "Falha ao desfazer o quiz, contate o suporte",
    nameHeader: "Nome",
    classHeader: "Turma",
    hitsHeader: "Acertos",
    rateHeader: "Taxa",
    descriptionHeader: "Descrição",
    pointHeader: "Ponto",
    valueHeader: "Valor",
    createdAtHeader: "Criada em",
    idLabel: "ID:",
    descriptionFieldLabel: "Descrição:",
    correctFieldLabel: "Corretas:",
    wrongFieldLabel: "Erradas:",
    totalFieldLabel: "Total:",
    createdAtFieldLabel: "Criado em:",
    classesResult: "Turmas",
    studentLabel: "Aluno",
    studentHitRate: "Taxa de acerto",
    viewBtn: "Ver",
    downloadBtn: "Baixar",
    imageFallback: "Imagem {{index}}",
    descriptionPlaceholderModal: "📝 Descreva detalhes adicionais sobre o conteúdo...",
    addNewQuestionTooltip: "Adicionar nova questão",
    multipleSubmissionsTooltip: "Este jogador possui múltiplas submissões",
    allClassesShort: "Todas",
  },
  historyPage: {
    startLoading: "Iniciando...",
    loadingHistory: "Carregando histórico...",
    loadedPeriods: "{{loaded}} de {{total}} períodos carregados",
    progressText: "{{count}}% ",
    loadedRecords: "{{count}} registros carregados até agora — você já pode usar os filtros enquanto o resto chega.",
    filtersAndSearch: "Filtros e Busca",
    search: "Buscar",
    searchPlaceholder: "Pesquisar atividades...",
    startDate: "Data início",
    endDate: "Data fim",
    category: "Categoria",
    allCategories: "Todas as categorias",
    type: "Tipo",
    noTypeAvailable: "Nenhum tipo disponível",
    allTypes: "Todos os tipos",
    khanBonus: "Bônus Khan Academy",
    otherTypes: "Outros Tipos",
    previousPage: "Anterior",
    nextPage: "Próxima",
  },
  historyCategory: {
    players: "Jogadores",
    game: "Segmento",
    launch: "Lançamento",
    class: "Turma",
    shop: "Loja",
    attitude: "Atitude",
    block: "Bloqueio",
    missions: "Missões",
    transactions: "Transações",
    system: "Sistema",
    khan: "Khan Academy",
    recurrence: "Recorrência",
    ai: "IA",
    missionProofs: "Comprovantes",
    quizzes: "Quizzes",
    nullifiedTransactions: "Transações Anuladas",
    security: "Segurança",
    aiCredits: "Créditos IA",
    letrus: "Letrus",
  },
  historyType: {
    create: "Criação",
    update: "Atualização",
    remove: "Remoção",
    delete: "Exclusão",
    accepted: "Aceito",
    delivered: "Entregue",
    canceled: "Cancelado",
    changeClass: "Mudança de Turma",
    changeGame: "Mudança de Segmento",
    generateQrCode: "Geração QR Code",
    resetGame: "Reset de Segmento",
    apply: "Aplicação",
    edit: "Edição",
    freeze: "Congelamento",
    prove: "Comprovação",
    tempUnlock: "Desbloqueio Temporário",
    khanDailyBonus: "Bônus Diário Khan",
    khanWeeklyBonus: "Bônus Semanal Khan",
    khanMonthlyBonus: "Bônus Mensal Khan",
    khanWeeklyMasteryBonus: "Bônus Domínio Khan (Semanal)",
    khanMonthlyMasteryBonus: "Bônus Domínio Khan (Mensal)",
    khanOccasionalPercentBonus: "Bônus Percentual Khan",
    nullify: "Anulação",
    applyRecurrence: "Aplicar Recorrência",
    startApplyRecurrence: "Iniciar Recorrência",
    aiActivate: "Ativar IA",
    aiDeactivate: "Desativar IA",
    aiScheduleCancel: "Cancelar Agendamento IA",
    aiChangePlan: "Mudar Plano IA",
    aiApplyDiscount: "Aplicar Desconto IA",
    aiToggle: "Alternar IA",
    aiSelectStudents: "Selecionar Alunos IA",
    aiSelectStudentsV2: "Seleção de alunos IA 2.0",
    aiGenerateAttempt: "Geração IA iniciada",
    aiGenerateSuccess: "Geração IA concluída",
    aiGenerateFailure: "Falha na geração IA",
    generateQrCodeVoleimania: "Geração QR Code Voleimania",
    khanMarcosBonus: "Bônus de marcos Khan",
    xpDisable: "Desativação de XP",
    xpEnable: "Ativação de XP",
    spent: "Gasto",
    adjust: "Ajuste",
    dailyAlert: "Alerta Diário",
    impersonationTokenGenerated: "Token de Acesso Gerado",
    impersonationLoginSuccess: "Login de Acesso",
    letrusMonthly: "Relatório Mensal Letrus",
  },
  historyDialog: {
    noData: "Nenhum dado disponível",
    activityDetails: "Detalhes da Atividade",
    overview: "Visão Geral",
    details: "Detalhes",
    technicalData: "Dados Técnicos",
    dateAndTime: "Data e Hora",
    categoryAndType: "Categoria e Tipo",
    affectedPlayers: "Jogadores Afetados ({{count}})",
    identifiers: "Identificadores",
    account: "Conta",
    completeDataJson: "Dados Completos (JSON)",
    showJson: "Mostrar JSON",
    hideJson: "Ocultar JSON",
    downloadQrCode: "Baixar QR Code",
    submissions: "Submissões",
    pending: "Pendentes",
    reviewed: "Revisados",
    searchAnswerContent: "Buscar por conteúdo da resposta",
    answerDistribution: "Distribuição das respostas",
    totalAnswers: "{{count}} respostas totais",
    submitted: "Enviados",
    correct: "Corretas",
    partialOrWrong: "Parcial/Errado",
    repeat: "Reenvio",
    reviewRate: "Revisão",
    uniqueStudents: "Alunos únicos",
    averageCorrect: "Média acertos",
    questions: "Questões",
    responses: "Respostas",
    partial: "Parciais",
    errors: "Erros",
    repeated: "REPETIDO",
    submittedAt: "Enviado em {{date}}",
    unknownDate: "Data desconhecida",
    missionNotFound: "Missão não encontrada",
    backToSelection: "Voltar para seleção",
    selectMission: "Selecione uma missão",
    pendingOne: "{{count}} pendente",
    pendingOther: "{{count}} pendentes",
    noMissionAvailable: "Nenhuma missão disponível",
    exportCsv: "Exportar CSV",
    loadErrorTitle: "Houve um erro ao carregar os dados.",
    loadErrorDescription: "Verifique sua conexão e tente novamente.",
    retry: "Tentar novamente",
    loadingData: "Carregando dados...",
    updating: "Atualizando...",
    approvedOne: "{{count}} premiado",
    approvedOther: "{{count}} premiados",
    activities: "{{count}} atividades",
    students: "{{count}} alunos",
    periodSummary: "Resumo do Período",
    processedMonthReport: "Relatório do Mês Processado",
    generatedAt: "Gerado em {{date}}",
    writes: "Escritas",
    rewrites: "Reescritas",
    totalDistributed: "Total distribuído",
    operationPerformed: "Operação realizada:",
    monthlyLetrusReport: "Relatório Mensal Letrus",
    pageSummary: "Página {{page}} de {{totalPages}} • {{count}} atividades",
    noActivityFound: "Nenhuma atividade encontrada",
    noActivityDescription: "Tente ajustar os filtros ou realizar algumas ações no sistema",
    applyingFilters: "Aplicando filtros...",
    processingData: "Processando dados",
    clearFilters: "Limpar Filtros",
    allUsers: "Todos os usuários",
    processed: "Processados",
    awarded: "Premiados",
    allGames: "Todos os segmentos",
    allClasses: "Todas as turmas",
    noStudentFound: "Nenhum aluno encontrado",
    adjustFilters: "Tente ajustar os filtros",
    noClass: "Sem turma",
    searchingTransactions: "Buscando transactions com",
    noTransactionFound: "Nenhuma transaction encontrada",
    transactionsRemovedOrNotSaved: "As transactions podem ter sido removidas ou não foram salvas",
    attitudeRemovedNoDetails: "Atitude removida sem dados detalhados",
    removalRecordKeptInHistory: "Apenas o registro da remoção foi mantido no histórico",
    noPlayersAffected: "Nenhum jogador afetado",
    noScoringSystemConfigured: "Nenhum sistema de pontuação configurado",
    noPointTypeSpecified: "Nenhum tipo de ponto especificado",
    progressZeroed: "Progresso zerado",
    missionsReset: "Missões resetadas",
    productImage: "Imagem do produto",
    removedProductImage: "Imagem do produto removido",
    noGameLinked: "Nenhum segmento vinculado",
    showingTransactions: "Mostrando transactions com",
    user: "Usuário",
    actions: "Ações",
  },
  balance: {
    walletBalanceTitle: "Meu Saldo em Carteira",
    updated: "Atualizado",
    totalDeposits: "Total de Depósitos",
    totalPurchases: "Total de Compras",
    totalTransactions: "Total de Transações",
    back: "Voltar",
    overviewExtractTitle: "Visão Geral - Extrato",
    overviewExtractDescription: "Acompanhe todas as suas transações financeiras",
    refresh: "Atualizar",
    tutorial: "Tutorial",
    addBalanceTitle: "Adicionar saldo e encantar seus alunos com nossos Gift Cards",
    addBalanceDescription: "Você pode adicionar um saldo igual ou superior a R$50,00.",
    minimumValueDescription: "Você pode adicionar um saldo igual ou superior a R$50,00.",
    enterValue: "Insira o valor",
    addBalanceAction: "Adicionar Saldo",
    fullName: "Nome completo",
    cpfOrCnpj: "CPF/CNPJ",
    acceptTerms: "Aceito os termos e condições",
    continue: "Continuar",
    pay: "Pagar",
    overview: "Visão Geral",
    addBalancePage: "Adicionar Saldo",
    namePlaceholder: "Nome",
    emailLabel: "Email",
    emailPlaceholder: "Email",
    termsTitle: "TERMOS DE USO DO SALDO E GIFT CARDS DA GAMEFIK",
    cancelButton: "Cancelar",
    acceptButton: "Aceitar",
    invalidName: "Nome inválido",
    invalidCpfCnpj: "CPF/CNPJ inválido",
    invalidEmail: "Email inválido",
    acceptTermsError: "Aceite os termos de uso",
    payValue: "Pagar R${{value}}.00",
    backButton: "Voltar",
    refundNotice: "Saldo reembolsável apenas para solicitações feitas até no máximo 7 dias após o pagamento",
    cardData: "Dados do Cartão",
    cardNumber: "Número do Cartão",
    month: "Mês",
    year: "Ano",
    holderData: "Dados do Titular",
    holderName: "Nome do Titular",
    cardHolder: "Titular do Cartão",
    cellphoneLabel: "Celular",
    zipCode: "Cep",
    creditCard: "Cartão de crédito",
    paymentSuccess: "Pagamento Concluído com sucesso",
    pixKey: "Chave Pix:",
    pixInstruction: "Use a chave pix acima, ou o QR code no seu aplicativo de banco para efetuar o pagamento.",
    finalize: "Finalizar",
    pixPayment: "Pagamento via PIX!",
    boletoGenerated: "Seu boleto foi gerado!",
    boletoInstruction: "Pague seu boleto agora ou até a data do vencimento. Para pagar, copie o código de barras, abra o aplicativo ou site do seu banco e efetue o pagamento.",
    orderDetails: "Detalhes do Pedido",
    taxesAndFees: "Taxas e Tarifas",
    includingTaxes: "Incluindo taxas",
    extractDetailedTitle: "Extrato Detalhado",
    extractType: "Tipo",
    extractDetails: "Detalhes",
    extractValue: "Valor",
    extractPurchaseValue: "Valor da compra",
    extractMethod: "Forma",
    extractQuantity: "Quantidade",
    extractDate: "Data",
    accumulatedBalance: "Saldo Acumulado",
    receipt: "Comprovante",
    noTransactions: "Nenhuma transação encontrada",
    transactionsWillAppear: "Suas transações aparecerão aqui quando disponíveis.",
    giftPurchase: "Compra de Gift",
    refund: "Reembolso",
    userOrigin: "Usuário",
    adminAddBalance: "Admin - Adicionar saldo",
    adminRemoveBalance: "Admin - Remover saldo",
    boletoPix: "Boleto/Pix",
    boletoMethod: "Boleto",
    creditCardMethod: "Cartão de crédito",
    adminMethod: "Admin",
    pixMethod: "PIX",
    notInformed: "Não informado",
    balanceMethod: "Saldo",
    paymentTitle: "Pagamento",
    payWith: "Pagar com",
    pixLabel: "Pix",
    cardDataTitle: "Dados do Cartão",
    cardNumberLabel: "Número do Cartão",
    monthLabel: "Mês",
    yearLabel: "Ano",
    cvvLabel: "CVV",
    holderDataTitle: "Dados do Titular",
    holderNameLabel: "Nome do Titular",
    holderNamePlaceholder: "Titular do Cartão",
    cpfCnpjLabel: "CPF/CNPJ",
    cpfCnpjPlaceholder: "Digite o CPF/CNPJ do titular!",
    phoneLabel: "Telefone",
    mobilePhoneLabel: "Celular",
    postalCodeLabel: "Cep",
    numberLabel: "Número",
    complementLabel: "Complemento",
    complementPlaceholder: "Casa/Apto",
    saveCardData: "Salvar meus dados do Cartão",
    payAmount: "Pagar R${{value}}.00",
    creditCardTitle: "Cartão de crédito",
    paymentSuccessTitle: "Pagamento Concluído com sucesso",
    thankYouPurchase: "Obrigado pela compra",
    returnToHome: "Retornar para home",
    privacyNotice: "Seus dados pessoais serão usados ​​para processar seu pedido, apoiar sua experiência em todo este site e para outros fins descritos em nossa política de privacidade.",
    pixKeyLabel: "Chave Pix:",
    pixInstructions: "Use a chave pix acima, ou o QR code no seu aplicativo de banco para efetuar o pagamento.",
    finalizeButton: "Finalizar",
    pixPaymentTitle: "Pagamento via PIX!",
    emailCopySent: "Enviamos uma cópia no seu e-mail",
    valueLabel: "Valor: R${{value}}.00",
    extractButton: "Extrato",
    boletoGeneratedTitle: "Seu boleto foi gerado!",
    boletoPayInstructions: "Pague seu boleto agora ou até a data do vencimento.",
    boletoPayDetails: "Para pagar, copie o código de barras, abra o aplicativo ou site do seu banco e efetue o pagamento.",
    viewBoleto: "Visualizar Boleto",
    orderDetailsTitle: "Detalhes do Pedido",
    balanceRecharge: "Recarga de saldo",
    subtotalLabel: "Subtotal",
    feesLabel: "Taxas e Tarifas",
    totalLabel: "Total",
    includingFees: "Incluindo taxas",
    refundNoticePayment: "Saldo reembolsável apenas para solicitações feitas até no máximo 7 dias após o pagamento",
    januaryMonth: "Janeiro",
    februaryMonth: "Fevereiro",
    marchMonth: "Março",
    aprilMonth: "Abril",
    mayMonth: "Maio",
    juneMonth: "Junho",
    julyMonth: "Julho",
    augustMonth: "Agosto",
    septemberMonth: "Setembro",
    octoberMonth: "Outubro",
    novemberMonth: "Novembro",
    decemberMonth: "Dezembro",
  },
  gift: {
    pageTitle: "[GiftCard] - GiftCard | Gamefik Escolas no level máximo.",
    overview: "Visão Geral",
    buyGifts: "Comprar Gifts",
    details: "Detalhes do gift card",
    viewSpecifications: "Ver especificações",
    specificationsDescription: "Leia as regras, role até o fim e aceite os termos para continuar a compra.",
    termsPending: "Termos pendentes. Revise e aceite",
    termsAccepted: "Termos lidos e aceitos",
    reviewAndAcceptTerms: "Revisar e aceitar termos",
    scrollTermsToEnd: "Role até o final para liberar o aceite dos termos.",
    termsEndReached: "Você chegou ao final. Agora marque a confirmação abaixo.",
    acceptTermsExplicitly: "Li todas as especificações e aceito os termos deste gift card.",
    acceptTermsAction: "Aceitar termos deste gift card",
    usageLocations: "Onde pode ser usado",
    description: "Descrição",
    receiptMessage: "Mensagem do recibo",
    howToUse: "Como usar",
    termsAndConditions: "Termos e condições",
    termsAndConditionsLink: "Termos e condições (link)",
    redeemInstructionsFallback: "Consulte as instruções de resgate abaixo.",
    usageTermsAccept: "Li e aceito os termos de uso",
    confirmAndAdd: "Confirmar e adicionar",
    search: "Pesquisar",
    loadError: "Não foi possível carregar os gift cards.",
    tryAgain: "Tentar novamente",
    selectValue: "Selecionar valor",
    stock: "Saldo",
    addBalance: "Adicionar Saldo",
    emptyCart: "Esvaziar",
    finalizeWithBalance: "Finalizar com Saldo",
    purchaseSummary: "Resumo da compra",
    items: "Itens",
    subtotal: "Subtotal",
    balance: "Saldo",
    minimumValueDescription: "Você pode adicionar um saldo igual ou superior a R$50,00.",
    cancel: "Cancelar",
    confirm: "Confirmar",
    close: "Fechar",
    viewTerms: "ver termos",
    filtersTitle: "Filtros",
    valueLabel: "Valor",
    myBalance: "Meu Saldo",
    availableValues: "Valores disponíveis",
    continueButton: "Continuar",
    congratsPurchase: "Parabéns pela compra!",
    makeCardsAvailable: "Disponibilize os cards para os alunos!",
    finishButton: "Concluir",
    startingFrom: "A partir de R$ {{value}}",
    viewProduct: "Ver Produto",
    makeAvailableInStore: "Disponibilizar na Loja",
    howToUseLabel: "Como Usar",
    continueShopping: "Continuar Comprando",
    sendToStore: "Enviar para loja",
    buyGift: "Comprar Gift",
    refundButton: "Reembolso",
    selectGiftForDelivery: "Selecione um do gifts para realizar a entrega",
    giftCardDiscontinued: "Infelizmente, este gift card foi descontinuado",
    requestRefund: "Solicitar reembolso",
    deliverGiftToStudent: "Entregar gift para o aluno",
    giftCardDescriptionTitle: "Descrição",
    giftCardDetails: "Detalhes do gift card",
    copyIssuedCode: "Copiar código de {{name}}",
    issuedTitle: "Gifts emitidos",
    issuedStudent: "Aluno",
    issuedStudentUnavailable: "Não informado",
    receiptDetails: "Detalhes do recibo",
    receiptMessageTitle: "Mensagem do recibo",
    readAndAcceptTerms: "Li e aceito os termos de uso",
    finishWithBalance: "Finalizar com Saldo",
    clearCart: "Esvaziar",
  },
  communication: {
    pageTitle: "Mural",
    pageSubtitle: "Gerencie comunicados, eventos e prazos da escola",
    viewing: "Visualizando:",
    selectClass: "Selecione a turma",
    feed: "Feed",
    shinyOnlyTitle: "O Mural está disponível no plano Shiny",
    shinyOnlyDescription: "O Mural faz parte do plano Shiny. Assine o Shiny para liberar comunicados, eventos e o feed completo da turma.",
    shinyOnlySecondary: "Voltar",
    calendar: "Calendário",
    metrics: "Métricas",
    announcements: "Comunicados",
    views: "Visualizações",
    events: "Eventos",
    upcomingDeadlines: "Próximos Prazos",
    viewAll: "Ver todos",
    noScheduledDeadline: "Nenhum prazo agendado",
    mostViewed: "Mais Visualizados",
    noAnnouncementForClass: "Nenhum comunicado para esta turma",
    allDeadlines: "Todos os Prazos",
    noActivityThisDay: "Nenhuma atividade neste dia",
    createActivityThisDay: "Criar atividade neste dia",
    details: "Detalhes",
    description: "Descrição",
    studentCompletion: "Conclusão dos alunos",
    studentsCompleted: "{{percent}}% dos alunos concluíram",
    noStudentAssigned: "Nenhum aluno atribuído ainda",
    edit: "Editar",
    delete: "Excluir",
    whatToCreate: "O que deseja criar?",
    eventLabel: "Evento",
    eventDesc: "Reuniões, festas, apresentações",
    quizLabel: "Quiz",
    quizDesc: "Perguntas e avaliações rápidas",
    missionLabel: "Missão",
    missionDesc: "Desafios e atividades com prazo",
    newEvent: "Novo Evento",
    newQuiz: "Novo Quiz",
    newMission: "Nova Missão",
    eventTitleLabel: "Título do evento",
    quizTitleLabel: "Título do quiz",
    missionTitleLabel: "Título da missão",
    eventTitlePlaceholder: "Ex: Reunião de pais",
    quizTitlePlaceholder: "Ex: Quiz de Matemática",
    missionTitlePlaceholder: "Ex: Leitura Mensal",
    schedule: "Horário",
    deadlineTime: "Prazo (horário)",
    location: "Local",
    locationPlaceholder: "Ex: Auditório",
    coins: "Coins",
    numberOfQuestions: "Número de questões",
    descriptionOptional: "Descrição (opcional)",
    describeEvent: "Descreva o evento...",
    describeQuiz: "Descreva o quiz...",
    describeMission: "Descreva a missão...",
    cancel: "Cancelar",
    createEvent: "Criar Evento",
    createQuiz: "Criar Quiz",
    createMission: "Criar Missão",
    deleteEvent: "Excluir evento",
    deleteQuiz: "Excluir quiz",
    deleteMission: "Excluir missão",
    deleteConfirm: "Tem certeza que deseja excluir",
    actionCannotBeUndone: "Esta ação não pode ser desfeita.",
    viewAnnouncementTitle: "Visualizar comunicado",
    duplicatedSuccess: "Comunicado duplicado com sucesso",
    duplicateError: "Erro ao duplicar comunicado",
    createPostError: "Falha ao criar publicação. Tente novamente.",
    createEventError: "Falha ao criar evento. Tente novamente.",
    deleteSuccess: "Excluído com sucesso",
    deleteError: "Erro ao excluir. Tente novamente.",
    editSuccess: "Alterações salvas com sucesso",
    editError: "Erro ao salvar alterações. Tente novamente.",
    createEventSuccess: "Evento criado com sucesso",
    questions: "questões",
    completed: "completaram",
    participants: "participantes",
    monthNames: "Janeiro,Fevereiro,Março,Abril,Maio,Junho,Julho,Agosto,Setembro,Outubro,Novembro,Dezembro",
    weekDays: "Dom,Seg,Ter,Qua,Qui,Sex,Sáb",
    now: "Agora",
    minAgo: "{{count}} min atrás",
    hoursAgo: "{{count}} hora{{suffix}} atrás",
    daysAgo: "{{count}} dia{{suffix}} atrás",
    roleTeacher: "Professor",
    roleSecretary: "Secretaria",
    roleFinancial: "Financeiro",
    roleManager: "Gestor",
    more: "+{{count}} mais",
    wholeSchool: "Toda escola",
    allClasses: "Todas as turmas",
    teachers: "Professores",
    students: "Alunos",
    teachingStaff: "Corpo docente",
    editAction: "Editar",
    duplicateAction: "Duplicar",
    shareLink: "Compartilhar link",
    deleteAction: "Excluir",
    inspectJson: "Inspecionar JSON",
    reactions: "reações",
    noReactionsYet: "Sem reações ainda",
    viewsCount: "visualizações",
    viewsTitle: "Visualizações ({{count}})",
    reactionsTitle: "Reações ({{count}})",
    seeMore: "Ver mais ({{count}})",
    deleteAnnouncement: "Excluir comunicado",
    deleteAnnouncementConfirm: "Tem certeza que deseja excluir este comunicado? Esta ação não pode ser desfeita.",
    linkCopied: "Link copiado",
    noReactionYet: "Nenhuma reação ainda",
    whatToCommunicate: "O que você gostaria de comunicar?",
    postTitleRequired: "Título *",
    eventName: "Nome do evento *",
    eventDescOptional: "Descrição do evento (opcional)",
    date: "Data",
    time: "Horário",
    bold: "Negrito",
    italic: "Itálico",
    underline: "Sublinhado",
    list: "Lista",
    numberedList: "Lista numerada",
    insertLink: "Inserir link",
    enterLinkUrl: "Digite a URL do link:",
    photo: "Foto",
    video: "Vídeo",
    attachment: "Anexo",
    addImage: "Adicionar imagem",
    addVideo: "Adicionar vídeo",
    attachFile: "Anexar arquivo",
    embedQuiz: "Embedar quiz",
    embedMission: "Embedar missão",
    createEventAction: "Criar evento",
    backToAnnouncement: "Voltar para comunicado",
    publishAction: "Publicar",
    published: "Publicado!",
    sendingProgress: "Enviando {{done}}/{{total}}...",
    publishing: "Publicando...",
    publishError: "Erro ao publicar. Tente novamente.",
    publishWhen: "Quando publicar",
    publishNow: "Publicar agora",
    schedulePost: "Agendar",
    muralAiButton: "Criar com IA",
    muralAiOpen: "Criar texto do Mural com IA",
    muralAiTitle: "Criar texto com IA",
    muralAiDescription: "Descreva o comunicado. A IA sugere um título e um texto que você poderá editar antes de publicar.",
    muralAiPromptLabel: "O que você quer comunicar?",
    muralAiPromptPlaceholder: "Ex.: Escreva um aviso acolhedor sobre a feira cultural de sexta-feira.",
    muralAiCost: "Esta sugestão custa {{cost}} créditos de IA.",
    muralAiGenerate: "Gerar sugestão",
    muralAiGenerating: "Gerando...",
    muralAiPromptRequired: "Descreva o comunicado que você quer criar.",
    muralAiError: "Não foi possível gerar o texto agora. Seu conteúdo foi preservado; tente novamente.",
    scheduleDateTime: "Data e horário",
    scheduleHint: "O push e os demais efeitos serão enviados no horário escolhido.",
    scheduleFutureError: "Escolha uma data e um horário futuros.",
    scheduleAction: "Agendar",
    scheduling: "Agendando...",
    scheduledSuccess: "Agendado!",
    scheduledPosts: "Agendadas",
    scheduledPostsHint: "Edite o conteúdo, reagende ou cancele publicações pendentes.",
    backToFeed: "Voltar ao mural",
    noScheduledPosts: "Nenhuma publicação agendada.",
    scheduledBadge: "Agendada",
    untitledPost: "Publicação sem título",
    rescheduleAction: "Reagendar",
    cancelScheduledAction: "Cancelar agendamento",
    rescheduledSuccess: "Publicação reagendada com sucesso.",
    scheduledCancelledSuccess: "Agendamento cancelado com sucesso.",
    scheduledConflictError: "Esta publicação já foi liberada ou alterada. Atualize o Mural para ver o estado atual.",
    scheduledActionError: "Não foi possível alterar o agendamento. Tente novamente.",
    scheduledEditorHint: "O horário é alterado na área Agendadas.",
    schedulingCapabilityError: "Não foi possível verificar se o agendamento está disponível.",
    retryAction: "Tentar novamente",
    emptyContentError: "Escreva um texto ou anexe uma imagem/arquivo antes de salvar.",
    notifyPushLabel: "Notificar alunos por push",
    notifyPushHint: "Os alunos recebem uma notificação no celular com o início do aviso.",
    where: "Onde:",
    classes: "Turmas:",
    all: "Todas",
    classesCount: "{{count}} turmas",
    embeddedQuiz: "Quiz embedado",
    embeddedMission: "Missão embedada",
    quizAvailable: "Quiz disponível",
    missionAvailable: "Missão disponível",
    selectQuiz: "Selecionar Quiz",
    selectMission: "Selecionar Missão",
    searchQuiz: "Buscar quiz...",
    searchMission: "Buscar missão...",
    noQuizFound: "Nenhum quiz encontrado",
    noMissionFound: "Nenhuma missão encontrada",
    editAnnouncement: "Editar Comunicado",
    duplicateAnnouncement: "Duplicar Comunicado",
    saveChanges: "Salvar alterações",
    publishCopy: "Publicar cópia",
    sending: "Enviando...",
    uploadError: "Erro ao enviar arquivos:",
    current: "Atual",
    future: "Futuro",
    until: "Até",
    legendEvents: "Eventos",
    legendQuizzes: "Quizzes",
    legendMissions: "Missões",
    linkUrlPrompt: "URL do link:",
    schoolBadge: "Escola",
    quizBadge: "QUIZ",
    missionBadge: "MISSÃO",
    eventBadgeLabel: "EVENTO",
    moreStudentsCount: "+{{count}} alunos",
    coinsUnit: "coins",
    freeLimitBannerTitle: "Limite do plano Free atingido",
    freeLimitBannerDescription: "O plano Free permite até {{limit}} comunicados no mural. Faça upgrade para o Shiny para publicar sem limites.",
    freeUnavailableBannerTitle: "Mural indisponível no plano Free",
    freeUnavailableBannerDescription: "O plano Free não inclui comunicados no mural. Faça upgrade para o Shiny para publicar.",
    freeLimitBannerCta: "Ver planos",
    freeLimitUsageLabel: "Comunicados publicados",
    freeLimitModalTitle: "Você atingiu o limite do plano Free",
    freeLimitModalDescription: "Você já publicou {{count}} de {{limit}} comunicados disponíveis no plano Free. Assine o plano Shiny para publicar sem limites.",
    freeLimitModalCta: "Assinar Shiny",
    freeLimitModalDismiss: "Entendi",
  },
  recurrence: {
    pageTitle: "Automações & Recorrências",
    eyebrow: "Automação",
    pageDescription: "Programe atitudes recorrentes, acompanhe o que está ativo e defina quando pontos não coletados devem expirar.",
    summaryTitle: "Resumo das automações",
    summaryActive: "Automações ativas",
    summaryPaused: "Automações pausadas",
    summaryExpiring: "Com expiração de pontos",
    listTitle: "Suas automações",
    listDescription: "Gerencie frequência, segmentos, coleta e status em um só lugar.",
    totalCount: "{{count}} automações",
    rewardsLabel: "Recompensa",
    createDialogDescription: "Configure a atitude, a frequência e as regras de coleta desta automação.",
    creating: "Criando...",
    createNew: "Criar Nova Recorrência",
    coinDistributionAnalysis: "Análise de Distribuição de Moedas por Recorrência",
    analyzedRecurrences: "Recorrências Analisadas",
    totalCoins: "Total de Moedas",
    totalTransactions: "Total de Transações",
    monthlyDistributionHistory: "Histórico de Distribuição Mensal de Moedas",
    detailByRecurrence: "Detalhamento por Recorrência",
    attitudeNotFound: "Atitude não encontrada",
    active: "Ativa",
    inactive: "Inativa",
    createdAt: "Criada em:",
    transactions: "transações",
    monthlyDistribution: "Distribuição mensal desta recorrência:",
    aboutAnalysis: "Sobre esta análise:",
    analysisInfo1: "Esta análise mostra o histórico real de distribuição de moedas pelas recorrências",
    analysisInfo2: "Os dados são baseados em transações efetivamente realizadas",
    analysisInfo3: "Cada recorrência pode ter padrões diferentes de distribuição mensal",
    analysisInfo4: "Use essas informações para otimizar suas estratégias de gamificação",
    progressAnalysis: "Análise de Progresso: Distribuído vs Previsto",
    alreadyDistributed: "Já Distribuído",
    predictedRemaining: "Previsto (Restante)",
    yearTotal: "Total do Ano",
    progress: "Progresso",
    annualDistributionProgress: "Progresso Anual de Distribuição",
    yearStart: "Início do ano",
    yearEnd: "Fim do ano",
    distributed: "Distribuído:",
    remaining: "Restante:",
    timelineHistoryVsPrediction: "Linha Temporal: Histórico vs Previsão",
    historicalData: "Dados Históricos (moedas já distribuídas)",
    predictionForPeriod: "Previsão para o período",
    greenBarExplanation: "A barra verde aparece sobre a azul para comparar desempenho real vs previsto",
    progressInsights: "Insights de Progresso:",
    distributionRhythm: "Ritmo de Distribuição:",
    coinsPerMonth: "Média de {{count}} moedas/mês",
    annualGoal: "Meta Anual:",
    completedOfTotal: "{{percent}}% concluído do total projetado",
    projection: "Projeção:",
    coinsUntilDecember: "Restam {{count}} moedas até dezembro",
    efficiency: "Eficiência:",
    transactionsCompleted: "{{count}} transações realizadas",
    detailedCoinPredictions: "Cálculo Detalhado das Previsões de Moedas",
    activeRecurrences: "Recorrências Ativas",
    daysUntilYearEnd: "Dias até o fim do ano",
    totalPredicted: "Total Previsto",
    detailedCalcByRecurrence: "Cálculo Detalhado por Recorrência",
    totalOfThisRecurrence: "Total desta recorrência",
    stepByStepCalc: "Cálculo passo a passo:",
    applicationFrequency: "Frequência de aplicação",
    applications: "aplicações",
    coinsPerApplication: "Moedas por aplicação",
    configuredInAttitude: "Valor configurado na atitude",
    eachTimeApplied: "Cada vez que a atitude é aplicada a um aluno",
    coinsLabel: "moedas",
    affectedStudents: "Alunos afetados",
    totalStudentsReceiving: "Total de alunos que receberão a atitude",
    studentsLabel: "alunos",
    finalCalc: "Cálculo final",
    applicationsTimesCoinsTimesStudents: "{{apps}} aplicações × {{coins}} moedas × {{students}} alunos",
    distributionByGame: "Distribuição por segmento:",
    unknownGame: "Segmento desconhecido",
    calcFormula: "Fórmula de Cálculo:",
    formulaTotalCoins: "Total de Moedas",
    formulaApplications: "Aplicações",
    formulaCoinsPerApp: "Moedas por Aplicação",
    formulaStudentCount: "Número de Alunos",
    formulaApplicationsDesc: "Calculado com base na frequência (diária, semanal, mensal) e dias restantes no ano",
    formulaCoinsPerAppDesc: "Valor configurado na atitude",
    formulaStudentCountDesc: "Alunos ativos nos segmentos associados à recorrência",
    individualPrediction: "Previsão Individual: Moedas por Aluno",
    averagePerStudent: "Média por Aluno",
    averageCalc: "Cálculo da Média:",
    totalCoinsLabel: "Total de moedas:",
    numberOfStudents: "Número de alunos:",
    average: "Média:",
    yearlyPreviewByGame: "Previsão Total de Moedas até o Fim do Ano por Segmento",
    generalTotal: "Total Geral",
    coinsDistributedTo: "Moedas que serão distribuídas para {{count}} alunos",
    untilDate: "até 31/12/{{year}}",
    detailByGame: "Detalhamento por Segmento",
    studentsCount: "{{count}} alunos",
    perStudent: "{{count}} por aluno",
    gameTotal: "Total do segmento",
    activeRecurrencesInGame: "Recorrências ativas neste segmento:",
    totalOfThisRecurrenceShort: "Total desta recorrência",
    applicationsLabel: "Aplicações:",
    perApplication: "Por aplicação:",
    days: "Dias:",
    daysOfMonth: "Dias do mês:",
    importantInfo: "Informações importantes:",
    info1: "Esta previsão considera apenas recorrências ativas",
    info2: "Cada recorrência é aplicada 1x por dia por aluno conforme o padrão configurado",
    info3: "Os valores mostram o total de moedas que serão distribuídas por segmento",
    info4: "O cálculo considera todos os alunos ativos em cada segmento",
    info5: "A previsão é calculada desde hoje até 31/12/{{year}}",
    noRecurrenceFound: "Nenhuma recorrência encontrada",
    createFirstRecurrence: "Crie sua primeira recorrência para automatizar atitudes",
    createFirstButton: "Criar Primeira Recorrência",
    mandatoryCollection: "Coleta obrigatória:",
    yes: "Sim",
    no: "Não",
    everyDay: "Todos os dias",
    everyWeekdays: "Toda(s) {{days}}",
    monthDays: "Dia(s) {{days}} do mês",
    createdOn: "Criada em",
    gamesLabel: "Segmentos:",
    deleteButton: "Excluir",
    invalidateUncollectedPoints: "Invalidar pontos não coletados",
    invalidateUncollectedPointsDescription: "O aluno precisa coletar no app dentro do período da automação. Caso contrário, a pontuação expira.",
    pauseButton: "Pausar",
    reactivateButton: "Reativar",
    createNewRecurrence: "Criar Nova Recorrência",
    confirmDeletion: "Confirmar Exclusão",
    confirmDeleteMessage: "Tem certeza que deseja excluir esta recorrência? Esta ação não pode ser desfeita.",
    recurrenceLabel: "Recorrência:",
    frequencyLabel: "Frequência:",
    cancelButton: "Cancelar",
    deleting: "Excluindo...",
    deleteAction: "Excluir",
    loadError: "Erro ao carregar recorrências",
    createSuccess: "Recorrência criada com sucesso! 🎉",
    createError: "Erro ao criar recorrência",
    activatedSuccess: "Recorrência ativada com sucesso!",
    deactivatedSuccess: "Recorrência desativada com sucesso!",
    mandatoryCollectionActivatedSuccess: "Pontos não coletados passarão a expirar.",
    mandatoryCollectionDeactivatedSuccess: "Pontos futuros não expirarão por falta de coleta.",
    toggleError: "Erro ao atualizar recorrência",
    deleteSuccess: "Recorrência excluída com sucesso!",
    deleteError: "Erro ao excluir recorrência",
    recurrenceNotFound: "Recorrência não encontrada",
    daily: "Diária",
    weekly: "Semanal",
    monthly: "Mensal",
    dailyApplication: "Aplicação diária",
    weeklyApplication: "Aplicação semanal: {{days}}",
    monthlyApplication: "Aplicação mensal: dias {{days}}",
    daysRemainingCalc: "{{days}} dias restantes × 1 aplicação por dia",
    daysPerWeekCalc: "{{daysPerWeek}} dias por semana × {{weeks}} semanas",
    daysPerMonthCalc: "{{daysPerMonth}} dias por mês × {{months}} meses",
    dayNameSun: "Dom",
    dayNameMon: "Seg",
    dayNameTue: "Ter",
    dayNameWed: "Qua",
    dayNameThu: "Qui",
    dayNameFri: "Sex",
    dayNameSat: "Sáb",
    monthNameShort: "Jan,Fev,Mar,Abr,Mai,Jun,Jul,Ago,Set,Out,Nov,Dez",
    current: "Atual",
    future: "Futuro",
  },
  bncc: {
    pageTitle: "Seleção de BNCC",
    pageSubtitle: "Selecione uma competência da Base Nacional Comum Curricular através do modal interativo",
    openSelection: "Abrir Seleção BNCC",
    selectedCompetency: "Competência Selecionada",
    id: "ID: ",
    title: "Título: ",
    descriptionLabel: "Descrição: ",
    area: "Área: ",
    levels: "Níveis: ",
  },
  details: {
    pageTitle: "Jogadores | Gamefik Escolas no level máximo.",
    playersTitle: "Jogadores",
    playersSubtitle: "Gerencie alunos, aplique atitudes e ajuste coins sem sair da lista.",
    filteredPlayersCount: "{{filtered}} de {{total}}",
    loadingPlayers: "Carregando jogadores...",
    filtersLabel: "Filtros",
    historyButton: "Histórico",
    aiSelectionButton: "Selecionar com IA",
    actionsPanelTitle: "Ações em lote",
    selectedPlayersCount: "{{count}} selecionado(s)",
    selectPlayersHint: "Selecione alunos na grade para liberar ações em lote, atitudes e ajustes de coins.",
    quickCoinsTitle: "Ajuste rápido de coins",
    quickCoinsEmptyHint: "Selecione alunos para aplicar",
    searchByName: "Pesquisar por nome",
    appliedAttitudesHistory: "Histórico de atitudes aplicadas",
    selectStudentsWithAi: "Selecionar alunos com IA",
    loadingHistory: "Carregando histórico...",
    playersUpdated: "Jogadores atualizados",
    updatingPlayers: "Atualizando {{count}} jogadores",
    attitudesAppliedSuccess: "Atitudes lançadas com sucesso!",
    inStudents: "em {{count}} aluno{{suffix}}",
    andMore: "... e mais {{count}}",
    clickToSeeAttitudes: "Clique aqui para ver as atitudes",
    addAction: "Adicionar",
    removeAction: "Remover",
    coinsAndXp: "coins e xp",
    confirmAddRemoveTitle: "{{action}} {{amount}} coins {{xpText}}",
    confirmAddRemoveMessage: "Tem certeza que deseja {{action}} {{amount}} coins {{xpText}} dos alunos:",
    confirmButton: "Confirmar",
    cancelButton: "Cancelar",
    quickCoinApplication: "Aplicação de coins rápida",
    selectYourClasses: "Selecione as suas turmas",
    classesPlaceholder: "Turmas",
    saveButton: "Salvar",
    appliedAttitudesTitle: "Histórico de Atitudes Aplicadas",
  },
  requestAttitude: {
    attitudeValidatedSuccess: "Atitude validada com sucesso.",
    requestError: "Ocorreu um erro ao processar sua requisição. Tente novamente mais tarde.",
    points: "Pontos:",
    creationDate: "Data de criação:",
    reject: "Rejeitar",
    accept: "Aceitar",
  },
  news: {
    systemUpdates: "Novidades no sistema 🎉",
    newUpdates: "Novidades",
    alreadySeen: "Já Vistas",
    allUpToDate: "Tudo em dia!",
    allUpdatesViewed: "Você já viu todas as novidades.",
    noUpdateSeen: "Nenhuma atualização vista",
    seenUpdatesAppearHere: "Suas atualizações vistas aparecerão aqui.",
    newLabel: "Novo",
    accessPage: "Acessa a página",
    close: "Fechar",
    dashboardTitle: "Página dashboard",
    dashboardDetails: "Agora você tem acesso a dados em tempo real sobre engajamento, dados de loja, uso dos professores e muito mais...",
    recurrencesTitle: "Página de recorrências",
    recurrencesDetails: "Automatize entrega de coins para os alunos, excelente prática para sempre garantir uma coleta para todos os alunos matriculados.",
    quizzesTitle: "Página de Quizzes",
    quizzesDetails: "Crie e aplique quizzes gamificados com correção automática. Uma revolução na avaliação!",
    attitudesTitle: "Atualização na página de atitudes",
    attitudesDetails: "Novo design, e agora é possível aplicar atitudes por essa tela, e verificar todos os jogadores que receberam o lançamento.",
  },
  acessoAluno: {
    pageTitle: "Acesso Aluno",
    pageDescription: "Visualize como o aplicativo aparece para cada aluno e copie os dados de acesso",
    browserTitle: "Acesso Aluno | Gamefik",
    bannerTitle: "Dica",
    bannerBody: 'Clique em "Copiar acesso" ao lado do nome do aluno para copiar o link, ou use "Imprimir acessos da turma" para gerar um PDF/planilha com os links.',
    bannerDismissAria: "Dispensar dica",
    printButton: "Imprimir acessos da turma",
    printButtonAllClassesTooltip: "Selecione uma turma para imprimir os acessos",
    copyAccess: "Copiar acesso",
    accessCopied: "Copiado!",
    copyAccessUnavailable: "Indisponível para este aluno",
    credentialsCardAccessLinkLabel: "Link de acesso",
    credentialsCardCopyButton: "Copiar dados de acesso",
    credentialsCardCopiedButton: "Dados copiados!",
    openInNewTab: "Abrir em nova aba",
  },
  classes: {
    general: "Geral",
    pageTitle: "Turmas | Gamefik Escolas",
    pageDescription: "Gerencie as turmas e estudantes da sua escola no Gamefik.",
    editPageTitle: "Editar turma | Gamefik Escolas no level máximo.",
    newPageTitle: "Nova turma | Gamefik Escolas no level máximo.",
    newPageDescription: "Crie uma nova turma para organizar seus estudantes e aplicar gamificação no aprendizado.",
    errorLoadingClasses: "Erro ao carregar turmas",
    errorLoadingClassesTitle: "Erro ao carregar turmas",
    errorLoadingClassesDescription: "Não conseguimos carregar suas turmas agora. Tente novamente — suas turmas não foram apagadas.",
    retryLoadingClasses: "Tentar novamente",
    deleteSelected: "Excluir Selecionadas ({{count}})",
    newClass: "Nova Turma",
    classList: "Lista de Turmas",
    classesFound: "{{count}} turma(s) encontrada(s)",
    searchPlaceholder: "Pesquisar turmas...",
    sortBy: "Ordenar por:",
    alphabetical: "Alfabética",
    studentsLabel: "Estudantes",
    clear: "Limpar",
    noClassFound: "Nenhuma turma encontrada",
    noClassCreated: "Nenhuma turma criada",
    adjustSearchTerms: "Tente ajustar os termos de pesquisa",
    startCreatingClass: "Comece criando sua primeira turma para organizar os estudantes",
    createFirstClass: "Criar primeira turma",
    clickToSortByName: "Clique para ordenar por nome",
    clickToSortByStudents: "Clique para ordenar por quantidade de estudantes",
    classColumn: "Turma",
    gameColumn: "Segmento",
    actionsColumn: "Ações",
    confirmDeletion: "Confirmar Exclusão",
    confirmDeletionDescription: "Você tem certeza que deseja excluir as turmas selecionadas? Esta ação não pode ser desfeita.",
    classesToBeDeleted: "Turmas que serão excluídas:",
    deleting: "Excluindo...",
    deleteClasses: "Excluir Turmas",
    classStudents: "Estudantes da Turma",
    noStudentFound: "Nenhum estudante encontrado",
    noStudentsRegistered: "Esta turma ainda não possui estudantes cadastrados.",
    studentsFound: "{{count}} estudante(s) encontrado(s)",
    gamesLabel: "Segmentos:",
    moreGames: "+{{count}} mais...",
    noGame: "Nenhum segmento",
    gamesNotFound: "Segmentos não encontrados",
    classDeletedSuccess: "Turma deletada com sucesso",
    classesDeletedSuccess: "Turmas deletadas com sucesso",
    processingError: "Ocorreu um erro ao processar sua solicitação",
    classSavedSuccess: "Turma salva com sucesso.",
    classRemovedSuccess: "Turma removida com sucesso.",
    requestError: "Ocorreu um erro ao processar sua requisição. Tente novamente mais tarde.",
    creatingClass: "Criando turma...",
    classCreatedSuccess: "Turma criada com sucesso!",
    readyForStudents: "A turma foi criada e está pronta para receber estudantes!",
    configuring: "Configurando...",
    settings: "Configurações",
    classLabel: "Turma",
    finalization: "Finalização",
    guidedSetup: "Configuração Guiada",
    preselectedGameHint: "O segmento foi pré-selecionado para facilitar o processo",
    newClassTitle: "Nova Turma",
    configureNewClass: "Configure uma nova turma para seus estudantes",
    editClass: "Editar Turma",
    classFormDescription: "Configure os detalhes da turma e selecione o segmento correspondente",
    className: "Nome da Turma",
    classNameHint: "(Digite um nome descritivo)",
    classNamePlaceholder: "Ex: 6º Ano A, Turma do Matutino...",
    classNameRequired: "O nome da turma é obrigatório",
    classNameMinLength: "O nome deve ter pelo menos 2 caracteres",
    classNameMaxLength: "O nome deve ter no máximo 50 caracteres",
    characters: "{{count}}/50 caracteres",
    nearLimit: "Próximo ao limite",
    classGame: "Segmento da Turma",
    classGameHint: "(Selecione o segmento da turma)",
    classGameRequired: "Selecione um segmento para a turma",
    preselectedGame: "Segmento Pré-selecionado",
    preselectedGameDescription: "O segmento foi definido automaticamente",
    updateClass: "Atualizar Turma",
    createClass: "Criar Turma",
    completeRequiredFields: "Complete todos os campos obrigatórios para continuar",
    confirmDeleteTitle: "Confirmar Exclusão",
    confirmDeleteDescription: "Você tem certeza que deseja excluir essa turma? Esta ação é <strong>irreversível</strong> e todos os dados relacionados à turma serão perdidos permanentemente.",
    deleteWhatWillBeDeleted: "O que será excluído:",
    deleteClassData: "Dados da turma",
    deleteActivityHistory: "Histórico de atividades",
    deleteStudentLinks: "Vinculações com estudantes",
    deleteReportsAndStats: "Relatórios e estatísticas",
    deletePermanently: "Excluir Permanentemente",
    errorDuplicateName: "Já existe uma turma com este nome. Escolha outro nome.",
    errorInvalidGame: "Segmento selecionado não é válido. Verifique se o segmento ainda está ativo.",
    errorTeacherNotFound: "Professor não encontrado. Verifique se o professor ainda está ativo.",
    errorInsufficientPermissions: "Você não tem permissão para criar turmas.",
    errorMaxClassesReached: "Limite máximo de turmas atingido.",
    errorGeneric: "Erro ao criar turma. Verifique os dados e tente novamente.",
    errorConnection: "Problema de conexão. Verifique sua internet e tente novamente.",
    errorTimeout: "A operação demorou muito para responder. Tente novamente.",
    errorServerCommunication: "Erro de comunicação com o servidor.",
    editClassTitle: "Editar turma",
    nameColumn: "Nome",
    createdColumn: "Criado",
    editColumn: "Editar",
    nothingFound: "Nada encontrado",
    allClasses: "TODAS AS TURMAS",
    all: "TODAS",
    some: "ALGUMAS",
    allYourClasses: "Todas as suas turmas",
    allClassesLabel: "Todas as turmas",
    allYourClassesCanSee: "Todas as suas turmas poderão ver esta missão",
    allClassesCanSee: "Todas as turmas dos segmentos selecionados poderão ver esta missão",
    selectClasses: "Selecione as turmas",
    selectAClass: "Selecione uma turma",
    selectGameFirst: "Selecione um segmento para ver as turmas",
    noOptionFound: "Nenhuma opção encontrada",
    selected: "{{count}} selecionadas",
    studentsCount: "{{count}} alunos",
    turmasHeading: "Turmas",
    turmasToolbarSearchPlaceholder: "Pesquisar...",
    turmasSortNameAsc: "Nome A-Z",
    turmasSortNameDesc: "Nome Z-A",
    turmasSortRecent: "Mais recentes",
    turmasSortOldest: "Mais antigos",
    turmasSortPerformance: "Melhor desempenho",
    turmasSortMostStudents: "Mais alunos",
    turmasSortFewestStudents: "Menos alunos",
    turmasSortMostXp: "Mais XP",
    turmasSortMostCoins: "Mais moedas",
    importTemplateColClass: "Turma",
    importTemplateColStudent: "Nome do aluno",
    importTemplateFileName: "modelo_importacao_turmas.csv",
    turmasSelectMultiple: "Selecionar várias",
    turmasExitSelectionMode: "Sair da seleção",
    turmasSelectAll: "Selecionar todos",
    turmasCancelSelection: "Cancelar seleção",
    turmasSortByLabel: "Ordenar por",
    turmasMoreOptionsAria: "Mais opções",
    turmasImportLong: "Importar turmas",
    turmasImportShort: "Importar",
    turmasPedagogicalReport: "Gerar relatorio pedagogico",
    turmasPedagogicalReportShort: "Relatorio",
    turmasLaunch: "Lançar ({{count}})",
    turmasMoreActionsAria: "Mais acoes",
    turmasAccessStudents: "Acesso alunos ({{count}})",
    turmasEditClassAction: "Editar turma",
    turmasDeleteWithCount: "Excluir ({{count}})",
    noStudentsInSelection: "Nenhum aluno nas turmas selecionadas.",
    accessInstructionsDownloadStarted: "Download das instruções de acesso iniciado.",
    turmasPaginationSelection: "{{selected}} de {{total}} {{label}} selecionada(s)",
    turmasPaginationPage: "Pagina {{current}} de {{total}}",
    turmasLabelShort: "turma(s)",
    turmasPrevPageAria: "Pagina anterior",
    turmasNextPageAria: "Proxima pagina",
    turmasAllStudentsCard: "Todos os Alunos",
    turmasUnlinkedStudentsCard: "Alunos desvinculados",
    turmasUnlinkedStudentsCount: "{{count}} sem turma ou sem segmento",
    turmasLimitReached: "Limite atingido",
    turmasAtLimitToast: "Voce atingiu o limite de {{limit}} turma(s) do seu plano.",
    turmasGameRequired: "Cadastre ou selecione um segmento antes de criar turmas.",
    turmasImportSuccess: "Importacao concluida.",
    turmasImportError: "Erro ao importar turmas ou alunos.",
    importTurmasProgressToast: "Importando {{current}} de {{total}} alunos...",
    turmasModalNewTitle: "Nova Turma",
    turmasModalEditTitle: "Editar Turma",
    turmasModalClassNameLabel: "Nome da turma",
    turmasModalClassNamePlaceholder: "Ex: Turma 3A",
    turmasModalSegmentLabel: "Segmento",
    turmasModalSegmentPlaceholder: "Selecione o segmento",
    turmasModalCancel: "Cancelar",
    turmasModalCreate: "Criar turma",
    turmasModalSave: "Salvar alteracoes",
    turmasModalCloseAria: "Fechar",
    turmasAccessModalTitle: "Acesso dos Alunos",
    turmasAccessModalSubtitle: "Baixe os dados de acesso dos alunos",
    turmasAccessFormatLabel: "Formato do arquivo",
    turmasAccessPdfHint: "Documento para impressao",
    turmasAccessSpreadsheetLabel: "Planilha",
    turmasAccessSpreadsheetHint: "Excel / Google Sheets",
    turmasAccessInfoBox:
      "O arquivo contera os dados de acesso de cada aluno: nome, usuario, senha e QR Code para acesso rapido ao aplicativo.",
    turmasAccessDownloaded: "Baixado!",
    turmasAccessGenerating: "Gerando...",
    turmasAccessDownloadButton: "Baixar {{format}}",
    accessMissingWarning: "{{count}} aluno(s) ainda sem código de acesso — sairiam sem link no arquivo. Ao baixar, vamos pedir confirmação para gerar automaticamente.",
    accessMissingConfirmTitle: "Gerar códigos de acesso?",
    accessMissingConfirmDesc: "{{count}} aluno(s) ainda não têm código de acesso.",
    accessMissingConfirmHint: "Vamos gerar o código de acesso de {{count}} aluno(s) automaticamente e continuar o download. Os códigos dos demais alunos não mudam.",
    accessMissingGenerate: "Gerar e baixar",
    accessMissingGenerating: "Gerando códigos...",
    accessGenerateError: "Erro ao gerar códigos de acesso. Tente novamente.",
    accessGeneratePartial: "{{count}} aluno(s) continuaram sem código — o arquivo foi gerado sem esses links.",
    accessZipOptionTitle: "QR Codes",
    accessZipOptionHint: "ZIP com cards para impressão",
    accessZipModeLabel: "Códigos dos alunos",
    accessZipKeepTitle: "Manter códigos atuais",
    accessZipKeepHint: "Usa os QR codes já vinculados — cards impressos continuam valendo.",
    accessZipOverwriteTitle: "Gerar novos códigos",
    accessZipOverwriteHint: "Sobrescreve os códigos de todos os alunos selecionados — QR codes e cards antigos param de funcionar.",
    accessZipMissingWarning: "{{count}} aluno(s) ainda sem código de acesso — sairiam no ZIP com QR desvinculado. Escolha \"Gerar novos códigos\" para vinculá-los.",
    accessZipInfoBox: "O ZIP conterá um card com QR Code por aluno, organizado em pastas por turma — pronto para enviar para impressão.",
    accessZipGeneratingInfo: "Gerando o ZIP no servidor — pode levar alguns minutos. O arquivo também ficará disponível na página Histórico.",
    accessZipReadyInfo: "ZIP pronto! Clique em \"Baixar ZIP\" para salvar o arquivo.",
    accessZipTimeout: "A geração está demorando mais que o esperado. Ela continua no servidor — confira a página Histórico em alguns minutos para baixar o arquivo.",
    accessZipRequestError: "Não foi possível iniciar a geração do ZIP (erro {{status}}). Tente novamente.",
    accessZipOverwriteConfirmTitle: "Gerar novos códigos?",
    accessZipOverwriteConfirmDesc:
      "Os QR codes atuais de {{count}} aluno(s) serão sobrescritos — códigos antigos e cards já impressos param de funcionar imediatamente. Essa ação é irreversível.",
    accessZipGenerateButton: "Gerar ZIP",
    accessZipGeneratingButton: "Gerando ZIP...",
    accessZipDownloadButton: "Baixar .zip",
    accessZipPrintOptionButton: "Pronto para impressão",
    accessZipPrintTitle: "Impressão dos cards",
    accessZipPrintDesc: "Escolha como os cards ficam dispostos na folha A4",
    accessZipPrintPresetLabel: "Disposição na página",
    accessZipPrintPresetOption: "{{count}} por página ({{grid}})",
    accessZipPrintPageIndicator: "Página {{page}} de {{total}}",
    accessZipPrintLoading: "Preparando os cards...",
    accessZipPrintLoadError: "Não foi possível carregar as imagens do ZIP. Baixe o .zip diretamente ou tente novamente.",
    accessZipPrintDownloadButton: "Baixar PDF",
    accessZipPrintGeneratingPdf: "Montando PDF...",
    accessZipPrintPdfError: "Não foi possível gerar o PDF. Tente novamente.",
    searchEllipsis: "Buscar...",
    classesForCreation: "Turmas para Criação",
    classCount: "{{count}} turma",
    classesCountLabel: "{{count}} turmas",
    viewJsonClasses: "Ver JSON - Turmas para Criação ({{count}})",
    viewJsonPlayersAndClasses: "Ver JSON - Jogadores e Turmas ({{playersCount}} jogadores, {{classesCount}} turmas)",
    playersForCreation: "Jogadores para Criação ({{count}}):",
    existingClasses: "Turmas Existentes no Sistema ({{count}}):",
    createNClasses: "Criar {{count}} Turma",
    createNClassesPlural: "Criar {{count}} Turmas",
    classesCreatedSuccess: "Turmas criadas com sucesso!",
    errorCreatingClasses: "Erro ao criar as turmas",
    creatingClasses: "Criando turmas...",
    classCreatedToast: "Turma criada com sucesso!",
    errorCreatingClass: "Erro ao criar turma.",
    configureNewClassForStudents: "Configure uma nova turma para organizar seus alunos",
    detailPageTitle: "Gestão de turma | Gamefik",
    detailPageDescription: "Gestão de turma — visualize e gerencie alunos.",
    classNotFoundHeadTitle: "Turma não encontrada | Gamefik",
    classNotFoundPageMessage: "Turma não encontrada.",
    detailLoadErrorTitle: "Não foi possível carregar a turma",
    detailLoadErrorHint: "Verifique sua conexão e tente novamente.",
    tryAgain: "Tentar novamente",
    detailClassMissingTitle: "Turma não encontrada",
    detailClassMissingDescription: "A turma solicitada não foi encontrada.",
    backToClasses: "Voltar para turmas",
    staleDataBanner: "Falha ao atualizar — exibindo dados anteriores.",
    editClassButtonAria: "Editar turma",
    refreshingDataAria: "Atualizando dados",
    refreshingTitle: "Atualizando...",
    refreshingInline: "Atualizando…",
    balanceLoading: "Atualizando saldo do aluno",
    balanceUnavailable: "Saldo indisponível. Atualize a página.",
    updatedAt: "Atualizado às {{time}}",
    lastUpdatedTooltip: "Última atualização às {{time}}",
    toastSelectStudentForLaunch: "Selecione pelo menos um aluno para lançar",
    toastSelectStudentForBulk: "Selecione pelo menos um aluno para usar as ações em massa",
    detailLaunchWithCount: "Lançar ({{count}})",
    moveClassWithCount: "Mover de turma ({{count}})",
    noStudentMatchSearchTitle: "Nenhum aluno encontrado",
    noStudentMatchSearchHint: "Tente ajustar os termos de busca",
    turmasStudentsLabelShort: "aluno(s)",
    playersDeletedSuccess: "Aluno(s) excluído(s) com sucesso",
    playersDeleteError: "Erro ao excluir aluno(s)",
    playersDeletePartialError: "Falha ao excluir {{count}} aluno(s).",
    alunoCardViewMenu: "Ver aluno",
    alunoCardEditMenu: "Editar",
    novoAlunoCardLabel: "Novo aluno",
    studentsMovedClassSuccess: "Alunos movidos de turma com sucesso!",
    studentsMoveClassError: "Erro ao mover alunos de turma.",
    playerUpdatedSuccess: "Aluno atualizado com sucesso",
    playerUpdateError: "Erro ao atualizar aluno",
    deleteStudentsTitleOne: "Excluir aluno",
    deleteStudentsTitleMany: "Excluir alunos",
    deleteStudentConfirmIntro: "Tem certeza que deseja excluir",
    deleteStudentConfirmOutro: "? Esta ação não pode ser desfeita.",
    thisStudentFallback: "este aluno",
    nStudentsCount: "{{count}} alunos",
    deletingStudentsAria: "Excluindo alunos...",
    editStudentModalTitle: "Editar aluno",
    editStudentSegmentLabel: "Segmento (segmento)",
    editStudentSegmentHint:
      "O segmento é definido pelas turmas e não pode ser alterado diretamente.",
    newStudentTitle: "Novo aluno",
    importManyStudentsLink: "Importar vários alunos de uma vez",
    importStudentsShort: "Importar alunos",
    studentFirstNameLabel: "Nome",
    studentFirstNamePlaceholder: "Ex: João",
    studentLastNameLabel: "Sobrenome",
    studentLastNamePlaceholder: "Ex: Silva",
    studentEmailLabel: "E-mail do aluno",
    studentEmailPlaceholder: "aluno@escola.com.br",
    studentEmailHint: "Opcional. Remova o conteúdo para desvincular o e-mail.",
    studentEmailInvalid: "Informe um e-mail válido.",
    studentClassesFieldLabel: "Turmas",
    selectClassesPrompt: "Selecione as turmas",
    oneClassSelectedSummary: "1 turma",
    nClassesSelectedSummary: "{{count}} turmas selecionadas",
    searchClassPlaceholder: "Buscar turma...",
    noClassInFilter: "Nenhuma turma encontrada.",
    clearClassesSelection: "Limpar seleção",
    studentMultipleClassesHint: "O aluno pode fazer parte de várias turmas",
    addingStudent: "Adicionando...",
    addStudentCta: "Adicionar aluno",
    studentAddedToast: "Aluno {{name}} adicionado com sucesso",
    createStudentError: "Erro ao criar aluno",
    lancarSidebarLabel: "Lançar",
    lancarExpandAria: "Expandir",
    lancarBackAria: "Voltar",
    lancarSubmitting: "Lançando...",
    lancarTabAttitudes: "Atitudes",
    lancarTabFeedback: "Feedback",
    lancarAttitudesTitle: "Atitudes",
    lancarAttitudesSubtitle: "Selecione as atitudes para lançar",
    lancarDefaultAttitudesBalanceDescription: "Atitudes padrão (fora do catálogo): {{summary}}",
    lancarPositive: "Positiva",
    lancarNegative: "Negativa",
    lancarAttitudeOrderSaving: "Salvando ordem...",
    lancarAttitudeReorderHandle: "Reordenar {{name}}",
    lancarAttitudeOrderSaveError: "Não foi possível salvar a ordem das atitudes.",
    lancarAddAttitudeType: "Adicionar {{type}}",
    lancarAddTypePositive: "positiva",
    lancarAddTypeNegative: "negativa",
    lancarFeedbackTitle: "Feedback personalizado",
    lancarFeedbackSubtitle: "Envie um feedback personalizado com moedas para os alunos selecionados.",
    lancarReasonLabel: "Motivo",
    lancarReasonPlaceholder: "Insira o motivo do saldo ser modificado...",
    lancarAddCoins: "Adicionar",
    lancarRemoveCoins: "Remover",
    lancarCoinsLabel: "Moedas",
    lancarSetCoins: "Definir saldo",
    lancarManualBalanceDescription: "Ajuste manual de moedas",
    lancarTabChests: "Baús",
    lancarChestsHmgBadge: "HMG",
    lancarChestsHmgNotice: "Recurso exclusivo de homologação (localhost/hmg) — não aparece em produção.",
    lancarChestsTitle: "Dar baús",
    lancarChestsSubtitle: "Conceda baús surpresa para os alunos selecionados abrirem no app",
    lancarChestsQuantityLabel: "Quantidade de baús",
    lancarStudentsListHeading: "Alunos ({{count}})",
    lancarHeaderManyStudents: "{{count}} alunos",
    lancarCoverageWarningSingle:
      "\"{{attitude}}\" não será lançada para {{count}} de {{total}} alunos selecionados porque a atitude não está configurada para o segmento desses alunos.",
    lancarCoverageWarningMulti:
      "{{count}} de {{total}} alunos selecionados não vão receber todas as atitudes ({{attitudes}}) porque elas não estão configuradas para o segmento desses alunos.",
    lancarSearchAttitudePlaceholder: "Pesquisar atitude...",
    lancarNoAttitudeFound: "Nenhuma atitude encontrada",
    quickLaunchBarLabel: "Lançamento rápido",
    quickLaunchValueAria: "Lançar {{value}} moedas",
    quickLaunchOpenFullPanel: "Lançar completo",
    quickLaunchTitleAdd: "Adicionar {{count}} moedas",
    quickLaunchTitleRemove: "Remover {{count}} moedas",
    quickLaunchSubtitleOne: "para o aluno selecionado",
    quickLaunchSubtitleMany: "para {{count}} alunos selecionados",
    quickLaunchReasonOptional: "(opcional)",
    quickLaunchReasonPlaceholder: "Ex.: participação na aula",
    quickLaunchConfirm: "Lançar agora",
    // O servidor prefixa a descrição com "Reajuste de Coins: " e o valor já
    // aparece como o valor da transação — repetir qualquer um dos dois aqui
    // deixa o extrato do aluno redundante.
    quickLaunchDefaultDescription: "Lançamento rápido",
    quickLaunchApplying: "Lançando moedas...",
    quickLaunchSuccess: "{{value}} moedas lançadas",
    quickLaunchError: "Não foi possível lançar as moedas.",
    viewStudentModalTitle: "Aluno(a)",
    studentProfileTab: "Perfil",
    studentHistoryTab: "Histórico",
    studentCollectionTab: "Coleção",
    studentRowCreatedAt: "Criado em",
    collectionLoading: "Carregando coleção...",
    collectionError: "Não foi possível carregar a coleção. Tente novamente.",
    collectionEmptyTitle: "Nenhum colecionável ainda",
    collectionEmptyHint: "Os colecionáveis que o aluno ganhar ou comprar aparecem aqui.",
    collectionObtainedAt: "Obtido em {{date}}",
    historicoTypeOther: "Outros",
    historySearchPlaceholder: "Buscar no histórico...",
    historyFilterAll: "Todos",
    historyTypeFilterLabel: "Tipo de registro",
    historyViewModeLabel: "Visualização",
    historyViewSimple: "Simples",
    historyViewComplete: "Completa",
    historyFilterEmpty: "Nada encontrado com esses filtros.",
    historyProgressLoading: "Carregando histórico completo... ({{loaded}} de {{total}})",
    historyLoadError: "Não foi possível carregar o histórico. Tente novamente.",
    studentRowClass: "Turma",
    studentRowEmail: "E-mail",
    studentRowCoins: "Moedas",
    studentRowGems: "Gemas",
    studentRowXp: "XP",
    studentRowCollectibles: "Colecionáveis",
    studentQrCode: "QR Code",
    studentCopied: "Copiado!",
    studentAccessLink: "Link de acesso",
    studentAppButton: "Acessar app do aluno",
    studentNoHistoryTitle: "Nenhum registro",
    studentNoHistoryHint: "O histórico do aluno aparecerá aqui",
    historicoTypeAttitude: "Atitude",
    historicoTypeMission: "Missão",
    historicoTypeQuiz: "Quiz",
    studentHistoryAt: "{{date}} às {{time}}",
    studentHistoryLaunchedBy: "Lançado por {{author}}",
    studentHistoryUnknownAuthor: "Responsável não identificado",
    studentHistoryCollectedAt: "Coletado em {{date}} às {{time}}",
    studentHistoryApplicationDate: "Data de aplicação",
    studentHistoryCollectionDate: "Data de coleta",
    studentHistoryResponsible: "Responsável",
    studentHistoryCollectionStatus: "Status da coleta",
    studentHistoryCollected: "Coletada",
    studentHistoryPending: "Pendente",
    studentHistoryDateUnavailable: "Data não informada",
    studentHistoryNotCollected: "Não coletada",
    studentHistoryRewards: "Recompensas",
    studentHistoryNoRewards: "Nenhuma recompensa registrada",
    historyPartialLoadError: "Parte do histórico antigo não pôde ser carregada. Os registros disponíveis continuam visíveis.",
    undoLaunchAria: "Desfazer lançamento",
    deleteStudentButton: "Excluir aluno",
    editStudentButton: "Editar aluno",
    studentNoClass: "Sem turma",
    importTurmasTitleUpload: "Importar turmas e alunos",
    importTurmasTitleValidating: "Validando planilha...",
    importTurmasTitlePreview: "Revisar importação",
    importTurmasTitleImporting: "Importando...",
    importTurmasTitleResult: "Importação concluída",
    importTurmasHowTitle: "Como funciona",
    importTurmasHowBody:
      "Baixe o modelo e repita o mesmo nome completo em todas as turmas do aluno. O sistema criará um único aluno associado a todas elas.",
    importTurmasTemplateTitle: "Modelo de planilha",
    importTurmasTemplateHint: "Use o modelo para garantir que o formato está correto",
    importTurmasDownloadCsv: "Baixar modelo (.csv)",
    importTurmasOr: "ou",
    importTurmasDropHere: "Solte o arquivo aqui",
    importTurmasDragOrClick: "Arraste o arquivo ou clique para selecionar",
    importTurmasFormats: "Formatos aceitos: .csv, .xlsx, .xls",
    importTurmasErrorUnsupportedFile: "Use um arquivo .csv, .xlsx ou .xls.",
    importTurmasErrorEmptyFile: "O arquivo não contém turmas e alunos para importar.",
    importTurmasErrorInvalidColumns: "A planilha deve ter exatamente duas colunas: turma e nome do aluno.",
    importTurmasErrorMalformedCsv: "O CSV tem aspas sem fechamento. Corrija o arquivo e tente novamente.",
    importTurmasErrorReadFile: "Não foi possível ler o arquivo. Verifique se ele não está corrompido ou protegido por senha.",
    importTurmasStructureTitle: "Estrutura da planilha",
    importTurmasColClass: "Turma",
    importTurmasColStudent: "Nome do aluno",
    importTurmasValidatingTitle: "Validando planilha",
    importTurmasValidatingHint: "Verificando estrutura e dados...",
    importTurmasClassesFoundLabel: "turmas encontradas",
    importTurmasStudentsTotalLabel: "alunos no total",
    importTurmasProblemsFound: "Atenção: {{count}} problema(s) encontrado(s)",
    importTurmasProblemsHint:
      "Os itens com erros serão ignorados. Você pode corrigir na planilha e importar novamente.",
    importTurmasValidatedTitle: "Planilha validada com sucesso",
    importTurmasValidatedHint: "Todos os dados estão corretos e prontos para importação.",
    importTurmasListToCreate: "Turmas a serem criadas",
    importTurmasClassNamed: "Turma {{name}}",
    importTurmasNStudentsInClass: "{{count}} aluno(s)",
    importTurmasNWithErrors: "- {{count}} com erro",
    importTurmasImportingTitle: "Importando turmas e alunos",
    importTurmasImportingCounts: "{{classes}} — {{students}}",
    importTurmasCountTurmasOne: "{{count}} turma",
    importTurmasCountTurmasMany: "{{count}} turmas",
    importTurmasCountAlunosOne: "{{count}} aluno",
    importTurmasCountAlunosMany: "{{count}} alunos",
    importTurmasResultTitle: "Importação concluída!",
    importTurmasResultSubtitle: "Todas as turmas e associações de alunos foram processadas com sucesso.",
    importTurmasCreatedClassesLabel: "turmas criadas",
    importTurmasAddedStudentsLabel: "alunos processados",
    importTurmasSkippedRecords: "{{count}} registro(s) ignorado(s) por erro",
    importTurmasLocalOnly: "Todos os dados são processados localmente",
    importTurmasNewSheet: "Nova planilha",
    importTurmasImportNClasses: "Importar {{count}} turma(s)",
    importTurmasImportingBtn: "Importando...",
    importTurmasImportMore: "Importar mais",
    importTurmasDone: "Concluir",
    importTurmasErrStudentName: "Nome obrigatório",
    importTurmasErrClassName: "Nome da turma obrigatório",
    importTurmasUnnamedClass: "Sem nome",
    importAlunosTitleInput: "Importar alunos",
    importAlunosTitlePreview: "Revisar alunos",
    importAlunosModeCopyPaste: "Copiar/colar",
    importAlunosModeExcel: "Importar Excel",
    importAlunosPasteListTitle: "Cole sua lista de alunos",
    importAlunosExcelImportTitle: "Importe do Excel",
    importAlunosPasteHint: "Importaremos automaticamente sua lista e removeremos duplicados.",
    importAlunosExcelHint: "Selecione um arquivo Excel (.xlsx, .xls) ou .csv com a lista de alunos.",
    importAlunosTargetClass: "Turma de destino:",
    importAlunosDownloadTemplate: "Baixar modelo de planilha",
    importAlunosClickSelectFile: "Clique para selecionar um arquivo",
    importAlunosFileTypesShort: ".xlsx, .xls ou .csv",
    importAlunosFileContentPlaceholder: "Conteúdo do arquivo...",
    importAlunosPastePlaceholder:
      "Cole os nomes dos alunos aqui. Coloque cada nome em uma nova linha.\n\nExemplos:\n\nJoão Silva\nMaria Santos\nPedro Oliveira",
    importAlunosFoundLine: "{{count}} aluno(s) encontrado(s)",
    importAlunosReviewHeading: "Revise os alunos antes de importar",
    importAlunosReviewHint: "Você pode editar ou remover alunos da lista antes de confirmar.",
    importAlunosToImportLine: "{{count}} aluno(s) para importar",
    importAlunosErrorReadFile: "Erro ao ler o arquivo",
    importAlunosErrorImport: "Erro ao importar alunos",
    importAlunosNoSegment: "Esta turma esta sem segmento definido. Defina um segmento para a turma antes de importar alunos — sem isso os alunos nao recebem recompensa nem aparecem no ranking.",
    importAlunosNothingToImport: "Nenhum aluno valido para importar. Preencha ao menos um nome.",
    importAlunosReviewList: "Revisar lista",
    importAlunosImporting: "Importando...",
    importAlunosImportN: "Importar {{count}} aluno(s)",
    importAlunosSuccessToast: "{{count}} aluno(s) importado(s) com sucesso",
    importAlunosFailToast: "Falha ao importar {{count}} aluno(s)",
    importAlunosSuccessCount: "{{count}} sucesso(s)",
    importAlunosErrorCount: "{{count}} erro(s)",
    moveClassDialogTitle: "Mover de turma",
    moveClassSelectedLine: "{{count}} aluno(s) selecionado(s)",
    moveClassHowApply: "Como aplicar as turmas?",
    moveClassReplace: "Substituir",
    moveClassReplaceHint: "Remove das turmas atuais e move para as novas",
    moveClassAdd: "Adicionar",
    moveClassAddHint: "Mantém turmas atuais e adiciona as novas",
    moveClassSelectTarget: "Selecionar turmas de destino",
    moveClassSearchPlaceholder: "Buscar turma...",
    moveClassNoResults: "Nenhuma turma encontrada",
    moveClassNClassesSelected: "{{count}} turma(s) selecionada(s)",
    moveClassTabClasses: "Turmas",
    moveClassTabStudents: "Alunos ({{count}})",
    moveClassSegmentHint:
      "Cada aluno fica em um só segmento — o da turma escolhida.",
    moveClassAddSegmentHint:
      "No modo Adicionar o aluno mantém as turmas atuais, então só dá para escolher turmas do segmento {{segment}}. Para trocar de segmento, use Substituir.",
    moveClassSegmentBlocked: "Turma de outro segmento",
    segmentChangeWarningTitle: "Os alunos também mudam de segmento",
    segmentChangeWarning:
      "Todos os alunos da turma \"{{turma}}\" passam para o novo segmento.",
    segmentChangeWarningWithCount:
      "Os {{count}} aluno(s) da turma \"{{turma}}\" passam para o novo segmento.",
    segmentChangeConfirmCta: "Confirmar mudança de segmento",
    segmentConflictTitle: "{{count}} aluno(s) também estão em outras turmas",
    segmentConflictDesc:
      "Eles têm outras turmas no segmento atual. Escolha o que fazer:",
    segmentConflictMore: "e mais {{count}}",
    segmentConflictOptionMove: "Levar para o novo segmento",
    segmentConflictOptionMoveDesc:
      "Saem das outras turmas e ficam só nesta.",
    segmentConflictOptionKeep: "Manter no segmento atual",
    segmentConflictOptionKeepDesc:
      "Saem desta turma e continuam nas outras.",
    segmentFixAlertTitle: "Alunos fora do segmento da turma",
    segmentFixAlertDescription:
      "{{students}} aluno(s) em {{turmas}} turma(s) precisam de correção.",
    segmentFixAlertCta: "Corrigir agora",
    segmentFixModalTitle: "Corrigir segmentos",
    segmentFixModalCount: "{{count}} aluno(s) para corrigir",
    segmentFixModalDescription:
      "Escolha para cada aluno: mover para o segmento da turma ou remover da turma.",
    segmentFixTurmaSegment: "Segmento da turma: {{segment}}",
    segmentFixStudentSegment: "Segmento atual do aluno: {{segment}}",
    segmentFixOptionMove: "Mover para {{segment}}",
    segmentFixOptionRemove: "Remover da turma",
    segmentFixCancel: "Agora não",
    segmentFixApply: "Corrigir {{count}} aluno(s)",
    segmentFixApplying: "Corrigindo...",
    segmentFixSuccess: "Segmentos corrigidos.",
    segmentFixError: "Não foi possível corrigir: {{names}}. Tente novamente.",
    multipleGamesAlertTitle: "Turmas com mais de um segmento",
    multipleGamesAlertDescription: "{{count}} turma(s) precisam escolher um único segmento.",
    multipleGamesAlertCta: "Corrigir agora",
    multipleGamesModalTitle: "Corrigir segmentos das turmas",
    multipleGamesModalCount: "{{count}} turma(s) para corrigir",
    multipleGamesModalDescription:
      "Escolha qual segmento deve permanecer em cada turma. Os alunos não serão movidos nesta etapa.",
    multipleGamesChooseSegment: "Escolha o segmento que será mantido",
    multipleGamesCancel: "Agora não",
    multipleGamesApply: "Corrigir {{count}} turma(s)",
    multipleGamesApplying: "Corrigindo...",
    multipleGamesSuccess: "Segmentos das turmas corrigidos.",
    multipleGamesError: "Não foi possível corrigir: {{names}}. Tente novamente.",
    settingsTurmasColName: "Turma",
    settingsTurmasColSegment: "Segmento",
    settingsTurmasColStudents: "Alunos",
    settingsTurmasEmpty: "Nenhuma turma encontrada.",
    settingsTurmasDeleteCta: "Excluir turma",
    settingsTurmasDeleteTitle: "Excluir a turma \"{{turma}}\"?",
    settingsTurmasDeleteDesc:
      "Esta ação não pode ser desfeita. {{count}} aluno(s) estão nesta turma e deixarão de pertencer a ela.",
    settingsTurmasDeleteDescStudents:
      "Esta ação não pode ser desfeita. {{count}} aluno(s) desta turma serão excluídos permanentemente, junto com seus pontos e histórico.",
    settingsTurmasDeleteDescEmpty: "Esta ação não pode ser desfeita.",
    settingsTurmasDeleteDescShared:
      "{{count}} aluno(s) também pertencem a outras turmas e não serão excluídos — apenas deixarão de pertencer à(s) turma(s) excluída(s).",
    deleteClassStudentsCheckbox:
      "Entendo que {{count}} aluno(s) serão excluídos permanentemente, com todos os seus pontos e histórico.",
    deleteClassStudentsError:
      "Não foi possível excluir {{count}} aluno(s). A(s) turma(s) não foi(ram) excluída(s) — tente novamente.",
    settingsTurmasDeleted: "Turma excluída.",
    moveClassStudentsListTitle: "Alunos que serão movidos",
    moveClassMoving: "Movendo...",
    moveClassConfirm: "Mover alunos",
    lancarAtitude: {
      ajudar: "Ajudar o próximo",
      participacao: "Participação",
      criatividade: "Criatividade",
      persistencia: "Persistência",
      "trabalho-equipe": "Trabalho em equipe",
      esforco: "Esforço",
      respeito: "Respeito",
      dedicacao: "Dedicação aos estudos",
      lideranca: "Liderança",
      superacao: "Superação",
      indisciplina: "Indisciplina",
      conversa: "Conversa excessiva",
      atraso: "Atraso",
      desrespeito: "Desrespeito",
      desatencao: "Desatenção",
      "nao-participacao": "Não participação",
    },
    editarAtitudeTitulo: "Editar atitude",
    editarAtitudeTipoLabel: "Tipo",
    editarAtitudePositiva: "Positiva",
    editarAtitudeNegativa: "Precisa melhorar",
    editarAtitudeNomeLabel: "Nome",
    editarAtitudeNomePlaceholder: 'Ex: "Participação"',
    editarAtitudeNomeRequired: "Por favor, insira um nome para a atitude.",
    editarAtitudeMoedasLabel: "Moedas",
    editarAtitudeMoedasCustomPlaceholder: "Valor personalizado",
    atitudeMoedasCustomOption: "Personalizado",
    atitudeMoedasCustomInvalid: "Informe um valor inteiro entre 1 e {{max}}.",
    editarAtitudeGamesLabel: "Segmentos",
    editarAtitudeGamesPlaceholder: "Selecione os segmentos",
    editarAtitudeGamesAll: "Todos os segmentos",
    editarAtitudeGamesRequired: "Selecione ao menos um segmento.",
    editarAtitudeGamesSearchPlaceholder: "Buscar segmento...",
    editarAtitudeGamesNoResults: "Nenhum segmento encontrado",
    editarAtitudeSalvar: "Salvar alterações",
    excluirAtitudeTitulo: "Excluir atitude",
    excluirAtitudeDescricao: "Tem certeza que deseja excluir a atitude \"{{name}}\"?",
    excluirAtitudeAviso: "Esta ação não pode ser desfeita.",
    excluirAtitudeConfirmar: "Excluir atitude",
    printAccessAllStudents: "Imprimir acessos de toda a turma",
    printAccessSelectedStudents: "Imprimir acessos dos {{count}} alunos selecionados",
    printAccessButton: "Imprimir acessos",
    alunoCardAccessMenu: "Dados de acesso",
    alunoCardAccessCopied: "Copiado!",
    classAccessLinkModalTitle: "Link de Acesso",
    classAccessLinkModalScanHint: "Escaneie o QR Code ou copie o link abaixo",
    classAccessLinkModalShareHint:
      "Compartilhe este link com seus alunos. Ao acessar, eles criam uma conta e entram automaticamente na turma.",
    classAccessLinkModalPrintPdf: "Imprimir PDF",
    classAccessLinkModalPrintTitle: "Acesso - {{name}}",
    classAccessLinkModalPrintSubtitle: "Plataforma de Gamificação Educacional",
    classAccessLinkModalPrintCardLabel: "Link de Acesso da Turma",
    classAccessLinkModalPrintInstructions:
      "Escaneie o QR Code acima ou acesse o link abaixo para entrar na turma",
    classAccessLinkModalQrAlt: "QR Code",
    classAccessLinkCopy: "Copiar",
    classAccessLinkCopied: "Copiado",
    classAccessLinkButtonAria: "Link de acesso da turma",
    classAccessLinkButtonLabel: "Link de acesso",
  },
  players: {
    pageTitle: "Jogadores | Gamefik Escolas no level máximo.",
    total: "Total",
    playersUpdated: "Jogadores atualizados",
    errorUpdatingPlayers: "Erro ao atualizar jogadores",
    qrCodesBeingGenerated: "QR Codes estão sendo gerados! Aguarde 5 minutos e verifique o histórico!",
    qrCodesGenerationError: "Erro ao gerar QR Codes. Tente novamente.",
    qrCodesDownloadError: "Erro ao baixar QR Codes. Tente novamente.",
    errorDeleting: "Erro ao fazer a exclusão",
    errorChangingClass: "Erro ao fazer a mudança de turma",
    errorChangingGame: "Erro ao fazer a mudança de segmento",
    editPageTitle: "Editar jogador | Gamefik Escolas no level máximo.",
    editPlayerTitle: "Editar jogador",
    requestError: "Ocorreu um erro ao processar sua requisição. Tente novamente mais tarde.",
    playerRemovedSuccess: "Usuário removido com sucesso.",
    createPageTitle: "Criar Aluno | Gamefik - Escolas no level máximo",
    createPageDescription: "Cadastre novos alunos de forma rápida e intuitiva",
    createNewPlayer: "Criar Novo Aluno",
    registrationForm: "Formulário de Cadastro",
    completeSteps: "Complete todas as etapas para finalizar o cadastro",
    createGameClassTooltip: "Os botões de criação de Segmento e Turma estão disponíveis dentro do formulário",
    playerCreatedSuccess: "Aluno cadastrado com sucesso!",
    playerCreatedMessage: "Aluno criado com sucesso!",
    createPlayerError: "Erro ao cadastrar aluno.",
    personalData: "Dados Pessoais",
    basicStudentInfo: "Informações básicas do aluno",
    complete: "Completo",
    firstName: "Primeiro nome",
    surname: "Sobrenome",
    email: "E-mail do aluno",
    emailHint: "Opcional. Esse e-mail pode ser usado no acesso do aluno quando a unidade ativar o login por e-mail.",
    emailInvalid: "Informe um e-mail válido.",
    firstNameRequired: "Nome é obrigatório",
    surnameRequired: "Sobrenome é obrigatório",
    personalDataComplete: "Dados pessoais completos",
    selectGameAndClasses: "Selecionar Segmento e Turmas",
    gameAndClassesEnvironment: "Ambiente de segmentos e turmas para o aluno",
    selectGame: "Selecionar Segmento",
    createNewGame: "Criar novo segmento",
    selectGameToContinue: "Selecione um segmento para continuar",
    gameSelectedSuccess: "Segmento selecionado com sucesso",
    chooseClasses: "Escolher Turmas",
    createNewClass: "Criar nova turma",
    selectAtLeastOneClass: "Selecione pelo menos uma turma",
    classesSelected: "{{count}} turma(s) selecionada(s)",
    selectGameFirstForClasses: "Selecione um segmento primeiro para criar turmas",
    saving: "Salvando...",
    saveChanges: "Salvar Alterações",
    registerPlayer: "Cadastrar Aluno",
    removePlayer: "Remover jogador",
    confirmDeletePlayer: "Você tem certeza que deseja excluir este jogador?",
    deletePlayerWarning: "Essa ação é irreversível, todos os pontos e histórico serão completamente perdidos.",
    createNewClassTitle: "Criar Nova Turma",
    createNewGameTitle: "Criar Novo Segmento",
    configureNewGameEnvironment: "Configure um novo ambiente de segmentos para seus alunos",
    gameName: "Nome do Segmento",
    gameNameRequired: "Nome do segmento é obrigatório",
    setCoinsLimit: "Definir limite de coins para o segmento",
    coinsLimit: "Limite de Coins",
    creating: "Criando...",
    createGame: "Criar Segmento",
    gameCreatedSuccess: "Segmento criado com sucesso!",
    createGameError: "Erro ao criar segmento.",
    changeClassTitle: "Alterar turma — {{name}}",
    howToChangeClasses: "Como deseja alterar as turmas?",
    replaceClasses: "Substituir turmas",
    replaceClassesDescription: "Remove das turmas atuais e coloca apenas nas selecionadas",
    addClasses: "Adicionar turmas",
    addClassesDescription: "Mantém as turmas atuais e adiciona as selecionadas",
    modeAdd: "Modo: Adicionar",
    modeReplace: "Modo: Substituir",
    addModeDescription: "O aluno permanecerá em suas turmas atuais e será adicionado às turmas selecionadas acima.",
    replaceModeDescription: "O aluno será removido de todas as turmas atuais e ficará apenas nas turmas selecionadas acima.",
    classUpdatedSuccess: "Turma atualizada com sucesso.",
    classUpdateError: "Erro ao atualizar turma.",
    changeGameTitle: "Alterar segmento — {{name}}",
    changeGameWarning: "Essa ação removerá o aluno de suas turmas atuais, pois as turmas estão vinculadas ao segmento anterior.",
    gameUpdatedSuccess: "Segmento atualizado com sucesso.",
    gameUpdateError: "Erro ao atualizar segmento.",
    profileTitle: "Perfil do Aluno",
    viewProfile: "Ver perfil do aluno",
    basicInfo: "Informações Básicas",
    fullName: "Nome Completo",
    accessHash: "Hash de Acesso",
    accessHashCopied: "Hash copiado para a área de transferência.",
    accessHashCopyError: "Não foi possível copiar o hash.",
    copyLabel: "Copiar",
    accessLink: "Link de Acesso",
    classesTitle: "Turmas",
    classesEnrolled: "Turmas em que o aluno está inscrito",
    noClassAssigned: "Nenhuma turma atribuída",
    classSummary: "Resumo das Turmas",
    generalScore: "Pontuação Geral",
    scoreDescription: "Pontos e experiência do aluno",
    coins: "Moedas",
    experience: "Experiência",
    pendingRewards: "Recompensas Pendentes",
    pendingRewardsDescription: "Recompensas a serem coletadas",
    toCollect: "Para Coletar",
    totalMissions: "Total de Missões",
    gamesAndProgress: "Segmentos e Progresso",
    gamesAndProgressDescription: "Detalhes dos segmentos em que o aluno participa",
    coinsToCollect: "Moedas a Coletar",
    xpToCollect: "XP a Coletar",
    levelLabel: "Nível {{order}}",
    progress: "Progresso: {{percent}}%",
    runningQuests: "Missões em Andamento",
    activeQuests: "{{count}} missão(ões) ativa(s)",
    accessAccount: "Acessar a conta",
    access: "ACESSAR",
    editPlayer: "Editar jogador",
    level: "Nível",
    name: "Nome",
    noPlayerFound: "Nenhum jogador encontrado para sua busca.",
    noPlayerFoundAlt: "Nenhum jogador encontrado.",
    selectAll: "Marcar todos",
    selectInBulk: "Marcar em massa",
    selectDuplicates: "Marcar os duplicados",
    selectWithoutQrCode: "Marcar os sem qrcode",
    selectWithoutClass: "Marcar os sem turma",
    selectWithoutGame: "Marcar os sem segmento",
    extractData: "Extrair dados",
    generateQrCodesBlank: "Gerar QR Codes sem nome",
    blankQrCodesDescription: "Informe quantos QR Codes sem nome devem ser gerados para impressão (máximo: {{max}}).",
    blankQrCodesAmountLabel: "Quantidade de QR Codes",
    blankQrCodesProcessing: "Estamos preparando os QR Codes",
    blankQrCodesProcessingDescription: "Mantenha esta janela aberta enquanto o arquivo é preparado.",
    blankQrCodesPollingHint: "O status é atualizado automaticamente a cada 5 segundos.",
    blankQrCodesReady: "Seus QR Codes estão prontos",
    blankQrCodesReadyDescription: "O arquivo foi gerado e já pode ser baixado.",
    blankQrCodesDownload: "Baixar QR Codes",
    blankQrCodesFailed: "Não foi possível gerar os QR Codes",
    blankQrCodesFailedDescription: "Tente gerar o arquivo novamente. Se o problema continuar, fale com o suporte.",
    blankQrCodesRetry: "Tentar novamente",
    putStudentDataHere: "Coloque aqui os dados de seus alunos",
    confirm: "Confirmar",
    studentsSelectedSuccess: "Alunos selecionados com sucesso!",
    couldNotFindStudents: "Não foi possível encontrar os alunos selecionados!",
    download: "Baixar",
    qrCodesWillBeGenerated: "QR Codes serão gerados em no máximo 10 minutos, confira no histórico",
    generate: "Gerar",
    tableLevel: "Nível",
    tableStudent: "Nome",
    tableBalance: "Saldo",
    tableClass: "Turma",
    tableGame: "Segmento",
    noStudentFound: "Nenhum aluno encontrado.",
    generatingQrCodes: "Gerando os QR Codes... Esse processo pode demorar até 5 minutos.",
    selectClassesToMove: "Selecione para quais turmas deseja mover os alunos:",
    selectGamesToMove: "Selecione para quais segmentos deseja mover os alunos:",
    removeFromCurrentClasses: "Essa ação removerá os alunos selecionados de suas turmas atuais, mantendo-os apenas nas turmas selecionadas.",
    removeFromCurrentClassesForGames: "Essa ação removerá os alunos selecionados de suas turmas atuais, mantendo-os apenas nas turmas selecionadas.",
    confirmDeletePlayers: "Você tem certeza que deseja excluir estes jogadores?",
    deletePlayersWarning: "Essa ação é irreversível, todos os pontos e historico dos alunos selecionados abaixo serão completamente perdidos.",
    playersRemovedSuccess: "Jogadores removidos com sucesso.",
    deletionError: "Erro ao fazer a exclusão",
    playersMovedClassSuccess: "Jogadores movidos de turma com sucesso.",
    classChangeError: "Erro ao fazer a mudança de turma",
    playersMovedGameSuccess: "Jogadores movidos de segmento com sucesso.",
    gameChangeError: "Erro ao fazer a mudança de segmento",
    selectAtLeastOnePlayer: "Selecione pelo menos um player!",
    confirmGenerateQrCodes: "Deseja realmente gerar os QR Codes de {{count}} alunos?",
    failedToGenerateQrCodes: "Falha ao gerar QR Codes",
    newPlayer: "novo jogador",
    newPlayerTooltip: "Caso queira adicionar apenas um aluno ao segmento, selecione esta opção!",
    importPlayers: "importar alunos",
    importPlayersTooltip: "Precisa adicionar vários alunos de uma só vez? Essa é a melhor opção! Faça o download da planilha e siga o passo a passo.",
    bulkMarkWithAi: "marcar em massa com IA",
    bulkMarkWithAiTooltip:
      "Use a IA para selecionar vários alunos de uma vez com base em um prompt ou arquivo.",
    aiAgentV2: "IA 2.0 (Agente)",
    aiAgentV2Tooltip:
      "IA agêntica com ferramentas (JS, bash, visão) para seleção inteligente de alunos.",
    applyAttitudes: "Aplicar atitudes/missões",
    deselectAll: "desmarcar todos",
    adjustBalance: "ajustar saldo",
    setBalance: "definir saldo",
    giveChests: "dar baús",
    chestQuantity: "Quantidade de baús",
    chestsGrantedSuccess: "Baús concedidos com sucesso!",
    studentsLabel: "Alunos",
    changeClass: "mudar de turma",
    changeGame: "mudar de segmento",
    deleteLabel: "excluir",
    generateNewQrCodes: "Gerar QRCodes NOVOS",
    downloadExistingQrCodes: "Baixar QRCodes QUE JÁ EXISTEM",
    studentsSelectedOf: "alunos selecionados de",
    studentsSelected: "alunos selecionados",
    adjustPlayerCoins: "ajustar coins dos jogadores",
    filtersTitle: "Filtros",
    clearFilters: "Limpar Filtros",
    onlyPlayersWithoutQrCode: "Somente jogadores sem QR code",
    sortByLabel: "Ordenar por",
    deselectPlayers: "Deselecionar {{count}} jogadores",
    selectAllPlayers: "Selecionar todos os {{count}} jogadores",
    noGames: "SEM SEGMENTOS",
    noClasses: "SEM TURMAS",
    createdAt: "Data de criação:",
    notAvailable: "N/A",
    balanceLabel: "Saldo",
    missionsToCollect: "Missões por coletar:",
    attitudesToCollect: "Atitudes por coletar:",
    chestsToCollect: "Baús por coletar:",
    chestsPendingHint: "aguardando abertura",
    detailsLabel: "Detalhes",
    changeClassLabel: "Trocar turma",
    changeGameLabel: "Trocar segmento",
    historyLabel: "Histórico",
    accessAccountLabel: "Acessar conta",
    generalInfo: "Informações Gerais",
    noGameLabel: "Sem segmento",
    noClassLabel: "Sem turma",
    optionsLabel: "Opções",
    playerUpdatedSuccess: "Jogador atualizado com sucesso!",
    errorSavingChanges: "Erro ao salvar alterações.",
    playerRemovedSuccessAlt: "Jogador removido com sucesso.",
    errorRemovingPlayer: "Erro ao remover jogador.",
    errorLoadingPlayerData: "Erro ao carregar dados do jogador.",
    editPlayerDialogTitle: "Editar jogador — {{name}}",
    didNotReceiveToday: "não recebeu hoje",
    receivedTimes: "recebeu {{count}} vez",
    receivedTimesPlural: "recebeu {{count}} vezes",
    classesLabel: "Turmas:",
    noClassText: "Sem Turma",
    gameLabel: "Segmento:",
    noGameText: "Sem Segmento",
    qrCodeTitle: "Vincular QRCode",
    virtualCard: "Cartão Virtual",
    approachQrCode: "Aproxime o QRCode da câmera para vincular ao jogador.",
    generateCard: "Gerar cartão",
    generateNewCard: "Gerar novo cartão",
    downloadCard: "Baixar cartão",
    downloadCardError: "Não foi possível gerar a imagem do cartão. Tente novamente.",
    viewCard: "Visualizar cartão",
    confirmNewQrCode: "Você tem certeza que deseja vincular outro QRCode para este jogador?",
    qrCodeWarning: "Essa ação é irreversível e o QRCode antigo perderá instantaneamente acesso a todas as plataformas Gamefik.",
    playerSavedSuccess: "Jogador salvo com sucesso.",
    searchPlayersPlaceholder: "Buscar jogadores...",
    filtersSubtitle: "Refine a lista de jogadores",
    filterGameLabel: "Segmento",
    filterClassesLabel: "Turmas",
    filterSortLabel: "Ordenar",
    filterOtherLabel: "Outros",
    levelShort: "Lv {{order}}",
    chestAlt: "Baú",
    exportAccessInstructions: "Exportar instruções de acesso",
    exportAccessInstructionsTooltip: "Exporta planilha com nome e link de instrução de acesso dos alunos selecionados.",
    playerCountSingular: "{{count}} jogador",
    playerCountPlural: "{{count}} jogadores",
    cancel: "Cancelar",
    save: "Salvar",
    back: "Voltar",
    completeRequiredFields: "Complete todos os campos obrigatórios para continuar",
    search: "Buscar",
    selectClasses: "Selecione as turmas",
    selectOneClass: "Selecione uma turma",
    allClassesUpper: "TODAS",
    someClassesUpper: "ALGUMAS",
    searchEllipsis: "Buscar...",
    clearSearch: "Limpar busca",
    noOptionFound: "Nenhuma opção encontrada",
    allYourClasses: "Todas as suas turmas",
    allClasses: "Todas as turmas",
    allYourClassesCanSee: "Todas as suas turmas poderão ver esta missão",
    allClassesCanSee: "Todas as turmas dos segmentos selecionados poderão ver esta missão",
    selectGameToSeeClasses: "Selecione um segmento para ver as turmas",
    allClassesOption: "TODAS AS TURMAS",
    studentsCount: "alunos",
    editClassTitle: "Editar turma",
    nothingFound: "Nada encontrado",
    nameColumn: "Nome",
    gamesColumn: "Segmentos",
    createdColumn: "Criado",
    playersColumn: "Players",
    editColumn: "Editar",
    rowActionView: "Ver aluno",
    rowActionEdit: "Editar aluno",
    rowActionQrCode: "QR Code",
    rowActionOpenApp: "Acessar App",
    accessUnavailableGenerateQr: "Gere ou vincule o QR Code deste aluno antes de acessar o app.",
    rowActionCopyAccess: "Copiar acesso",
    rowActionAccessCopied: "Copiado!",
    importButton: "Importar",
    allPlayersTitle: "Todos",
    allPlayersSubtitle: "Visão consolidada de todos os alunos",
    allPlayersPageTitle: "Todos os Alunos | Gamefik",
    refreshingData: "Atualizando…",
    refreshingDataLabel: "Atualizando dados",
    updatedAt: "Atualizado às {{time}}",
    lastUpdatedAtTitle: "Última atualização às {{time}}",
    exportButton: "Exportar",
    exportAll: "Todos os alunos ({{count}})",
    exportSelected: "Selecionados ({{count}})",
    totalStudents: "Total de alunos",
    totalClasses: "Total de turmas",
    filterAllClasses: "Todas turmas",
    filterClassMobile: "Turma",
    filterSearchClass: "Buscar turma...",
    filterNoClass: "Nenhuma turma encontrada.",
    filterSingleClass: "1 turma",
    filterClassCount: "{{count}} turmas",
    filterClearClasses: "Limpar seleção ({{count}})",
    aiSelectionLabel: "Selecionar alunos com IA",
    aiSelectionButton: "Selecionar com IA",
    filterAllEngagement: "Todo engajamento",
    colEngagement: "Engajamento",
    colCollectiblesShort: "Coleç.",
    colCoins: "Moedas",
    colActions: "Ações",
    selectedCount: "{{count}} selecionado",
    selectedCountPlural: "{{count}} selecionados",
    clearSelectionButton: "Limpar",
    bulkActionsLabel: "Mais ações",
    bulkAccessStudents: "Acesso alunos ({{count}})",
    bulkMoveClass: "Mover de turma ({{count}})",
    bulkSetBalance: "Definir saldo ({{count}})",
    bulkDelete: "Excluir ({{count}})",
    filterWithoutAccess: "Sem código de acesso ({{count}})",
    filterWithoutAccessMobile: "Sem acesso",
    filterUnlinked: "Desvinculados ({{count}})",
    filterUnlinkedMobile: "Desvinculados",
    noClassMoveAction: "Aluno sem turma — clique para mover para uma turma",
    selectScopeTitle: "Selecionar alunos",
    selectScopeDesc: "A lista tem {{pages}} páginas ({{total}} alunos com os filtros atuais). O que você quer selecionar?",
    selectScopePage: "Esta página ({{count}})",
    selectScopeAll: "Todas as páginas ({{count}})",
    allHaveAccess: "Todos têm código de acesso",
    allHaveAccessMobile: "Acessos OK",
    addCta: "Adicionar",
    applyCta: "Aplicar",
    exportModalTitle: "Exportar alunos",
    exportModalSubtitle: "Baixe um CSV com nome, turma, XP e moedas.",
    exportDownloadCsv: "Baixar CSV",
    setBalanceTitle: "Definir saldo",
    setBalanceSubtitle:
      "Define o saldo alvo para os {{count}} alunos selecionados. O ajuste (adicionar ou remover) é calculado automaticamente para cada aluno.",
    setBalanceCoinLabel: "Moedas",
    setBalanceToggleAria: "Alterar saldo de {{currency}}",
    setBalanceTargetLabel: "Saldo alvo",
    setBalanceHint:
      "Moedas desligadas não são alteradas. O cálculo considera o saldo atual mais recompensas a coletar.",
    setBalanceProgress: "Aplicando: {{current}} de {{total}} alunos...",
    setBalanceApplying: "Aplicando...",
    setBalanceApply: "Definir saldo",
    setBalanceDescription: "[Definir saldo] Ajuste automático para atingir o saldo definido",
    setBalanceSuccess: "Saldo definido para {{count}} aluno(s).",
    setBalancePartialError: "Falha ao ajustar {{count}} aluno(s). Tente novamente.",
    emptyStateTitle: "Nenhum aluno encontrado",
    emptyStateSubtitle: "Tente ajustar os filtros de busca",
    loadError: "Não foi possível carregar os alunos",
    loadErrorSubtitle: "Verifique sua conexão e tente novamente.",
    retryButton: "Tentar novamente",
    staleDataWarning: "Falha ao atualizar — exibindo dados anteriores.",
    deleteStudentsTitleOne: "Excluir aluno",
    deleteStudentsTitleMany: "Excluir alunos",
    deleteStudentConfirmIntro: "Tem certeza que deseja excluir",
    deleteStudentConfirmOutro: "? Esta ação não pode ser desfeita.",
    thisStudentFallback: "este aluno",
    nStudentsCount: "{{count}} alunos",
    deleting: "Excluindo...",
    removedSuccess: "Alunos removidos com sucesso!",
    removeError: "Erro ao remover alunos.",
    updatedSuccess: "Aluno atualizado com sucesso!",
    updateError: "Erro ao atualizar aluno.",
    movedClassSuccess: "Alunos movidos de turma com sucesso!",
    movedClassSuccessWithWarning: "Alunos movidos de turma, mas alguns registros auxiliares não foram concluídos. Não é necessário tentar novamente.",
    movedClassPartial: "{{success}} aluno(s) movido(s); {{errors}} não puderam ser movidos.",
    movedClassPartialWithWarning: "{{success}} aluno(s) movido(s); {{errors}} não puderam ser movidos. Alguns registros auxiliares dos movimentos concluídos também falharam.",
    moveClassFailed: "Não foi possível mover {{errors}} aluno(s).",
    moveClassError: "Erro ao mover alunos de turma.",
    paginationInfo: "Mostrando {{from}} a {{to}} de {{total}} alunos",
    moreOptionsLabel: "Mais opções",
    selectAllMobileCta: "Selecionar todos",
    loadMoreButton: "Carregar mais ({{count}})",
    normalizeGamesBulk: {
      button: "Normalizar segmentos",
      buttonTooltip: "Unificar game_id de todos os alunos selecionados para o segmento atual de cada um",
      title: "Normalizar segmentos em lote",
      description:
        "Reatribui todas as transações (hot e cold) de cada aluno selecionado para o segmento atual dele. O saldo por tipo de ponto permanece o mesmo — apenas a partição por segmento muda. Cada aluno é processado separadamente com sua própria transação.",
      filtersTitle: "Incluir transações",
      includeCollected: "Pontos coletados",
      includeUncollected: "Pontos não coletados",
      noFilterSelected: "Selecione ao menos um tipo de ponto para continuar.",
      progressLabel: "{{current}} de {{total}} alunos",
      processingPlayer: "Processando {{name}}",
      statusQueued: "Na fila",
      statusPreviewing: "Calculando prévia",
      statusApplying: "Aplicando",
      statusSuccess: "Normalizado",
      statusFailure: "Falhou",
      statusSkipped: "Já estava normalizado",
      alreadyNormalized: "Sem alterações necessárias.",
      targetGame: "Segmento alvo",
      otherGames: "Outros segmentos",
      affectedTxs: "{{count}} txs afetadas",
      modifiedLabel: "{{hot}} hot · {{cold}} cold",
      summaryLabel: "{{success}} sucesso · {{failures}} falha(s) · {{skipped}} já normalizado(s)",
      noPlayersSelected: "Selecione ao menos um aluno para normalizar.",
      cancel: "Cancelar",
      canceling: "Cancelando…",
      close: "Fechar",
      retry: "Reprocessar falhas",
      runningHint: "Processando em paralelo (3 por vez). Você pode cancelar a qualquer momento — alunos em andamento terminam a operação atual.",
      completedHint: "Operação concluída. Cada aluno foi processado de forma independente e idempotente.",
    },
  },
  importPlayers: {
    pageTitle: "Importar Jogadores | Gamefik Escolas no level máximo.",
    back: "Voltar",
    title: "Importar Lista de Jogadores",
    subtitle: "Siga os passos abaixo para importar seus jogadores de forma simples e rápida",
    stepSelectGame: "Selecionar Segmento",
    stepDownload: "Baixar",
    stepSend: "Enviar",
    stepCreateClasses: "Criar Turmas",
    stepCreatePlayers: "Criar Jogadores",
    selectGameTitle: "Selecione o Segmento",
    selectGameDescription: "Vincule os jogadores ao segmento correspondente",
    selectGameWarning: "Todo jogador deve estar vinculado a um segmento. Esta etapa é <strong>obrigatória</strong> e fundamental para o processo.",
    downloadTemplateTitle: "Baixar Planilha Modelo",
    downloadTemplateDescription: "Use nossa planilha para padronizar os dados",
    downloadTemplateInstructions: "É necessário preencher essa planilha corretamente, pois é ela que vai fazer o nosso sistema entender as informações dos seus alunos.",
    important: "IMPORTANTE",
    downloadTemplateWarning: "Coloque nesta planilha <strong>apenas os alunos deste segmento</strong>. Para inserir alunos de outros segmentos, será necessário repetir o processo selecionando o segmento correto.",
    downloadTemplateButton: "Baixar Planilha Modelo",
    alreadyHaveTemplate: "Já tenho a planilha preenchida",
    uploadTitle: "Upload da Planilha",
    uploadDescription: "Envie o arquivo CSV com os dados dos jogadores",
    manualUpload: "Upload Manual (CSV/TXT)",
    processingFile: "Processando arquivo...",
    dragOrClick: "Arraste o arquivo aqui ou clique para selecionar",
    acceptedFormats: "Formatos aceitos: CSV, TXT",
    confirmUpload: "Confirmar Upload",
    fileSelected: "Arquivo selecionado",
    incompatibleFormat: "Formato Não Compatível com Upload Manual",
    fileNeedExactColumns: "O arquivo deve ter <strong>exatamente</strong> as colunas:",
    expectedFormat: "Formato Esperado",
    yourFile: "Seu Arquivo",
    columnsDetected: "{{count}} coluna detectada",
    columnsDetectedPlural: "{{count}} colunas detectadas",
    noColumnDetected: "Nenhuma coluna detectada",
    recommendedSolution: "Solução Recomendada",
    useAiUpload: "Use o <strong>Upload com Inteligência Artificial</strong> logo abaixo. A IA processará automaticamente qualquer formato de planilha!",
    acceptsAnyStructure: "Aceita qualquer estrutura",
    identifiesColumnsAutomatically: "Identifica colunas automaticamente",
    worksWithFormats: "Funciona com CSV, XLSX, PDF e mais",
    errorProcessingFile: "Erro ao Processar Arquivo",
    suggestion: "Sugestão",
    useAiSuggestion: "Use o <strong>Upload com IA</strong> abaixo para processar automaticamente arquivos em qualquer formato.",
    validatingFile: "Validando formato do arquivo...",
    fileReadyToProcess: "Arquivo pronto para ser processado",
    sendFile: "Enviar Arquivo",
    processing: "Processando...",
    or: "OU",
    aiUploadLabel: "Upload com Inteligência Artificial (APENAS PARA TESTES)",
    aiUploadDescription: "Use IA para processar automaticamente arquivos em qualquer formato. A IA vai padronizar para colunas \"nome\" e \"turma\".",
    codegenMode: "Modo Codegen (Experimental)",
    codegenDescription: "IA gera código de transformação ao invés de JSON direto",
    codegenActive: "Modo Codegen Ativo",
    codegenInfo: "A IA gerará código JavaScript para transformar os dados. Mais rápido, econômico e confiável. Suporta apenas CSV/XLSX.",
    processingWithAi: "Processando com IA...",
    selectFileForAi: "Selecionar Arquivo para IA",
    aiAcceptedFormats: "Formatos aceitos: CSV, XLSX, XLS, PDF, TXT",
    studentProcessed: "{{count}} aluno processado",
    studentsProcessed: "{{count}} alunos processados",
    realTime: "Em tempo real",
    downloadBatch: "Baixar Lote {{current}}",
    lastFound: "Últimos Encontrados:",
    previewJson: "Preview JSON",
    batchDownloaded: "Lote {{current}}/{{total}} baixado!",
    batchCompleted: "Lote {{current}}/{{total}} concluído",
    studentsInBatch: "{{count}} alunos neste lote. Total: {{total}}",
    aiNotFoundValid: "IA não encontrou dados válidos. Tente outro arquivo.",
    fileProcessedSuccess: "Arquivo processado com sucesso! {{count}} jogador encontrado.",
    fileProcessedSuccessPlural: "Arquivo processado com sucesso! {{count}} jogadores encontrados.",
    aiProcessingFailed: "Falha ao processar arquivo com IA",
    errorSendingToAi: "Erro ao enviar o arquivo para a IA.",
    csvError: "Por favor, envie um arquivo CSV ou TXT",
    invalidFormat: "Formato inválido",
    emptyFile: "Arquivo vazio ou sem dados válidos",
    validationError: "Erro ao validar arquivo. Formato não reconhecido.",
    spreadsheetProcessed: "Planilha processada com sucesso!",
    spreadsheetReadError: "Erro ao ler a planilha. Verifique o formato (CSV) e a codificação.",
    classValidation: "Validação das Turmas",
    classValidationDescription: "Confirme as turmas que serão criadas no sistema",
    reviewClassInfo: "Revise e confirme as informações sobre as turmas que serão criadas:",
    playerValidation: "Validação dos Jogadores",
    playerValidationDescription: "Confirme os jogadores que serão criados no sistema",
    reviewPlayerInfo: "Revise e confirme as informações sobre os jogadores que serão criados:",
    duplicateNamesFound: "{{count}} nome duplicado encontrado",
    duplicateNamesFoundPlural: "{{count}} nomes duplicados encontrados",
    duplicatesWillBeMerged: "Os jogadores duplicados serão mesclados automaticamente com suas turmas combinadas",
    unknown: "Desconhecido",
    linesWillBeCombined: "Linhas {{line1}} e {{line2}} - Turmas serão combinadas",
    playersForCreation: "Jogadores para Criação",
    playerCount: "{{count}} jogador",
    playersCount: "{{count}} jogadores",
    viewJson: "Ver JSON (Jogadores e Turmas)",
    playersLabel: "Jogadores ({{count}}):",
    availableClasses: "Turmas Disponíveis ({{count}}):",
    createNPlayers: "Criar {{count}} Jogador",
    createNPlayersPlural: "Criar {{count}} Jogadores",
    completed: "Concluído!",
    progressLabel: "Progresso:",
    of: "de",
    processingComplete: "Processamento completo",
    processingLabel: "Processando...",
    pleaseWait: "Por favor, aguarde enquanto processamos sua solicitação",
    creatingPlayers: "Criando jogadores...",
    creatingPlayersProgress: "Criando jogadores... ({{success}} criados{{errors}})",
    errorsLabel: ", {{count}} erros",
    playersCreatedWithWarning: "{{count}} jogadores criados com sucesso",
    failedDescription: "{{count}} falharam. Verifique o console para detalhes.",
    playersCreatedSuccess: "{{count}} jogadores criados com sucesso!",
    errorCreatingPlayers: "Erro ao criar os jogadores",
    invalidServerResponse: "Resposta inválida do servidor",
    startingProcessing: "Iniciando processamento...",
    aiProcessingFail: "Falha ao processar arquivo",
    batchLabel: "Lote {{current}}/{{total}}",
  },
  homePage: {
    metaTitle: "Home · Gamefik",
    greetingMorning: "Bom dia",
    greetingAfternoon: "Boa tarde",
    greetingEvening: "Boa noite",
    hello: "Olá",
    helloName: "Olá, {{name}}",
    tagline: "Vamos transformar sua aula no momento preferido dos seus alunos!",
    createWithAi: "Criar com IA",
    onboarding: {
      welcomeBadge: "Missão de boas-vindas",
      progress: "Progresso",
      reward: "Recompensa",
      setupTitle: "Configure sua conta em ",
      setupHighlight: "4 passos",
      setupSubtitle: "Em menos de 10 minutos você tá pronto pra jogar.",
      startHere: "Comece aqui!",
      startNow: "Começar agora",
      completed: "Feito",
      stepsCompleted: "passos concluídos",
      recommended: "Recomendado",
      tutorialTitle: "Tutorial completo da plataforma",
      tutorialDescription:
        "Aprenda a configurar turmas, criar atividades gamificadas e acompanhar o progresso dos seus alunos em tempo real.",
      watchNow: "Assistir tutorial",
      viewTutorial: "Ver como fazer",
      missionComplete: "Missão completa!",
      schoolReady: "Sua escola está pronta. Agora é só criar atividades incríveis para seus alunos.",
    },
    steps: {
      alunos: {
        title: "Adicione seus alunos",
        description: "Crie turmas e adicione seus primeiros alunos",
      },
      atividade: {
        title: "Crie sua primeira atividade",
        description: "Quiz ou missão com IA em segundos",
      },
      professores: {
        title: "Convide seus professores",
        description: "Traga sua equipe pra Gamefik",
      },
      app: {
        title: "Acesse o app dos alunos",
        description: "Veja como seus alunos vão usar",
      },
    },
    activities: {
      sectionTitle: "Criar atividade",
      sectionSubtitle: "Escolha um formato ou deixe a IA fazer pra você.",
      seeAllFormats: "Ver todos os formatos",
      createNow: "Criar agora",
      comingSoon: "Em breve",
      comingSoonColon: "Em breve:",
      footer: "Gamefik — Level máximo",
      quiz: {
        title: "Quiz",
        description: "Múltipla escolha pra testar conhecimento",
        fullDescription:
          "O Quiz é uma atividade interativa onde os alunos respondem perguntas de múltipla escolha. Cada pergunta pode ter de 2 a 5 alternativas, com feedback instantâneo ao selecionar a resposta. Ideal para revisão de conteúdo, verificação de aprendizado e preparação para provas. O professor pode definir tempo limite, ordem aleatória e quantidade de tentativas.",
      },
      missao: {
        title: "Missão",
        description: "Tarefas práticas com envio de evidências",
        fullDescription:
          "A Missão é uma atividade prática onde o aluno realiza uma tarefa no mundo real e envia um comprovante (foto, texto ou arquivo). O professor ou a IA da Gamefik valida a entrega. Perfeita para atividades hands-on, projetos criativos, exercícios físicos e tarefas de casa que precisam de comprovação.",
      },
      flashcard: {
        title: "Flashcard",
        description: "Memorização de conteúdos",
        fullDescription:
          "Cartões com frente e verso para estudo por repetição espaçada. Ideal para memorizar vocabulário, datas e conceitos. Pode ser do tipo vice-versa (termo/definição) ou verdadeiro/falso.",
      },
      trilha: {
        title: "Trilha",
        description: "Jornadas educacionais com conquistas",
        fullDescription:
          "A Trilha é uma jornada de aprendizagem com múltiplas etapas. O aluno progride por fases sequenciais, desbloqueando novos conteúdos e conquistas. Combina diferentes tipos de atividades (quizzes, missões, conteúdos) em uma experiência gamificada com progressão visual.",
      },
      comingCompletePhrase: "Complete a frase",
      comingAssociacao: "Associação",
      comingRedacao: "Redação",
      comingDesembaralhe: "Desembaralhe",
      moreAboutAria: "Mais informações sobre {{type}}",
    },
    dialog: {
      createWithType: "Criar {{type}}",
      describeTheme: "Descreva o tema e a IA cria para você",
      assistantAlt: "Assistente IA",
      aiBadge: "IA",
      assistantIntro: "Olá! Me conte sobre qual tema você quer criar",
      assistantOutroQuiz: "o quiz",
      assistantOutroMissao: "a missão",
      assistantOutroFlashcard: "o flashcard",
      assistantSuffix: ". Pode ser uma disciplina, assunto específico ou até colar um texto!",
      placeholderQuiz: "Ex: Revolução Francesa para 8º ano...",
      placeholderMissao: "Ex: Pesquisa sobre reciclagem no bairro...",
      placeholderFlashcard: "Ex: Vocabulário de inglês básico...",
      submitHint: "Pressione Enter ou clique no botão para criar com IA",
      aboutActivity: "Sobre esta atividade",
      createType: "Criar {{type}}",
      comingSoonButton: "Em breve",
    },
  },
  dashboard: {
    exportData: "Exportar dados",
    close: "Fechar",
    coinsGoal: {
      title: "Contraste: Progresso Temporal vs. Realidade dos Coins",
      descriptionPart1: "Análise comparativa entre o",
      descriptionIdealProgress: "progresso temporal ideal",
      descriptionPart2: "(baseado no tempo decorrido) e o",
      descriptionRealProgress: "progresso real dos coins",
      descriptionPart3: "(baseado na utilização efetiva)",
      temporal: "Temporal",
      real: "Real",
      analysisPeriod: "Período de Análise",
      selectPeriod: "Selecione o período desejado para análise temporal dos coins",
      startDate: "Data de Início",
      endDate: "Data de Fim",
      predefinedPeriods: "Períodos pré-definidos",
      schoolYear: "Ano Letivo",
      schoolYearTooltip: "Ano letivo: de fevereiro a dezembro do ano corrente",
      lastThreeMonths: "Últimos 3 meses",
      lastThreeMonthsTooltip: "Últimos 3 meses: do dia 1 do mês 3 meses atrás até hoje",
      semester: "Semestre",
      semesterTooltip: "Semestre atual: do início do semestre até hoje",
      timeVsReality: "Contraste: Tempo vs. Realidade",
      idealTimeProgress: "Progresso Temporal Ideal",
      realCoinsProgress: "Progresso Real de Coins",
      basedOnTimePeriod: "Baseado no tempo decorrido no período",
      basedOnCoinsUsed: "Baseado nos coins efetivamente utilizados",
      inSync: "✅ Em sincronia",
      aboveIdeal: "⚠️ Acima do ideal",
      belowIdeal: "⚠️ Abaixo do ideal",
      difference: "Diferença:",
      totalDays: "Dias totais",
      daysPassed: "Dias passados",
      daysRemaining: "Dias restantes",
      tabTemporal: "Temporal",
      tabAverage: "Média por Aluno",
      tabTop10: "Top 10%",
      temporalContrast: "Contraste Temporal: Ideal vs. Real",
      idealVsRealAnalysis: "Progresso Temporal Ideal vs. Progresso Real de Coins - Análise comparativa do ritmo esperado vs. realidade",
      temporalProgress: "Progresso temporal",
      temporalProgressIcon: "📊 Progresso Temporal:",
      ofPeriodElapsed: "do período decorrido",
      realProgressIcon: "💰 Progresso Real:",
      ofCoinsUsed: "dos coins utilizados",
      resolution: "Resolução:",
      weeklyPoints: "Pontos semanais",
      biweeklyPoints: "Pontos quinzenais",
      monthlyPoints: "Pontos mensais",
      timeVsRealityComparison: "Comparação: Tempo vs. Realidade",
      basedOnTimeElapsed: "Baseado no tempo decorrido",
      upToCurrentMoment: "Até o momento atual",
      futureProjection: "Projeção Futura",
      basedOnCurrentRate: "Baseada na taxa atual",
      currentPointToday: "Ponto atual (hoje)",
      timeVsCoins: "{{time}}% tempo vs {{coins}}% coins",
      averageVsMaxPrize: "Contraste: Média por Aluno vs. Prêmio Máximo",
      goalMaxPrizeVsAvg: "Meta de chegar ao prêmio máximo vs. Média real de coins por aluno - Análise do poder de compra",
      temporalGoalIcon: "🎯 Meta Temporal:",
      expectedCoins: "coins esperados",
      realAverageIcon: "💰 Média Real:",
      coinsPerStudent: "coins por aluno",
      maxPrize: "Prêmio máximo:",
      coins: "coins",
      purchasingPowerGoalVsReality: "Poder de Compra: Meta vs. Realidade",
      temporalGoalLabel: "Meta Temporal",
      towardsMaxPrize: "Rumo ao prêmio máximo",
      realAvgPerStudent: "Média Real por Aluno",
      currentCoins: "Coins atuais",
      projection: "Projeção",
      currentPoint: "Ponto atual",
      ofMaxPrize: "do prêmio máximo",
      top10VsMaxPrize: "Contraste: Top 10% vs. Prêmio Máximo",
      goalMaxPrizeVsTop10: "Meta de chegar ao prêmio máximo vs. Média dos top 10% dos alunos - Elite vs. Meta",
      eliteGoalIcon: "🏆 Meta Elite:",
      top10RealIcon: "⭐ Top 10% Real:",
      eliteVsGoal: "Elite vs. Meta: Top 10% dos Alunos",
      eliteGoalLabel: "Meta Elite",
      top10RealLabel: "Top 10% Real",
      currentElite: "Elite atual",
      eliteProjection: "Projeção Elite",
      temporalContrastAnalysis: "Análise do Contraste Temporal",
      syncEvaluation: "Avaliação da sincronia entre progresso temporal e real, com margem de ±10% para determinar se está em sincronia",
      behind: "Atrasado",
      ahead: "Adiantado",
      onTrack: "No Prazo",
      scheduleStatus: "Status do cronograma",
      margin: "Margem: ±10%",
      timeDiffProgress: "Diferença tempo/progresso",
      needToAccelerate: "Precisa acelerar o ritmo",
      spendingTooFast: "Gastando muito rápido",
      adequateRhythm: "Ritmo adequado",
      withinMargin: "Dentro da margem de ±10%",
      outsideMargin: "Fora da margem",
      requiredPacePerDay: "Ritmo necessário/dia",
      toRecoverDelay: "Para recuperar o atraso",
      toNotAccelerate: "Para não acelerar mais",
      toMaintainPace: "Para manter o ritmo",
      consideredProblematic: "⚠️ Considerado problemático",
      needsAttention: "⚠️ Precisa de atenção",
      idealSituation: "✅ Situação ideal",
      totalCoinsVolume: "Volume Total de Coins",
      totalCoinsVolumeDesc: "Comparação entre coins dos alunos e disponíveis na loja",
      totalFromStudents: "Total dos alunos",
      excludingStoreSpending: "(Sem contar gastos na loja)",
      totalAvailableInStore: "Total disponível na loja",
      avgCoinsVsMaxPrize: "Média de Coins por Aluno vs Prêmio Máximo",
      avgCoinsVsMaxPrizeDesc: "Relação entre média de coins por aluno e o item mais caro da loja",
      averagePerStudent: "Média por aluno",
      maxPrizeInStore: "Prêmio máximo da loja",
      top10AvgVsMaxPrize: "Média de Coins do Top 10% dos alunos vs Prêmio Máximo",
      top10AvgVsMaxPrizeDesc: "Relação entre média de coins do top 10% dos alunos e o item mais caro da loja",
      top10Average: "Média do top 10%",
      utilizationRate: "Taxa de utilização",
      purchasingPower: "Poder de compra",
      remainingCoins: "Coins restantes:",
      currentVsRequiredPace: "Ritmo atual vs necessário:",
      coinsPerDay: "{{value}} coins/dia",
      goalReached: "Meta atingida",
      chartIdealProgress: "Progresso Temporal Ideal",
      chartRealProgress: "Progresso Real de Coins",
      chartProjection: "Projeção Baseada na Taxa Atual",
      timeElapsed: "Tempo Decorrido",
      coinsUsedLabel: "Coins Utilizados",
      remaining: "Restante",
      temporalProgressTooltip: "Progresso temporal: {{value}}%",
    },
    coinsPerClass: {
      title: "Moedas por turma",
      totalClasses: "Quantidade total de turmas: {{count}}",
      allGames: "Todos os segmentos",
      selectGame: "Selecione um segmento",
      searchClass: "Procure pela turma...",
      nameCol: "Nome",
      coinsCol: "Moedas",
      playersCol: "Jogadores",
      averageCol: "Média",
    },
    generalInfo: {
      activeGames: "Segmentos Ativos",
      viewDetails: "Ver detalhes",
      participants: "Participantes",
      classes: "Turmas",
      averagePerClass: "Média por turma",
      studentsCount: "{{count}} alunos",
      students: "Alunos",
      activeMissions: "Missões Ativas",
      pendingCount: "{{count}} pendentes",
      totalStock: "Estoque Total",
      averagePerStudent: "Média/aluno",
      dataNotLoaded: "Os dados deste card não puderam ser carregados agora.",
      useRetryGlobal: "Use o retry global do dashboard para tentar carregar novamente.",
      gameCreatedSuccess: "Segmento criado com sucesso! 🎉",
      gameCreatedError: "Erro ao criar segmento",
      needGameName: "Você precisa definir um nome para o Segmento",
      whatIsGame: "O que é um Segmento?",
      whatIsGameDesc: "Todos os jogadores estarão debaixo das mesmas regras e loja, vão jogar juntos. É muito comum escolas separarem o segmento do Ensino Fundamental e do Ensino Médio, por exemplo.",
      studentsLabel: "{{count}} estudantes",
      active: "Ativo",
      inactive: "Inativo",
      creating: "Criando...",
      newGame: "Novo Segmento",
      studentsInGame: "Alunos",
      language: "Idioma",
      activePoints: "Pontos ativos",
      coinsLimit: "Limite de moedas",
      searchStudent: "Buscar aluno",
      editGame: "Editar Segmento",
      studentsOfGame: "Alunos do segmento",
      studentsBadge: "{{count}} alunos",
      studentFallback: "Aluno",
      noClass: "Sem turma",
      noStudentFound: "Nenhum aluno encontrado.",
      rewardsStore: "Loja de Recompensas",
      remainingStock: "Estoque Restante",
      averagePerStudentDialog: "Média por Aluno",
      pendingOrders: "Pedidos Pendentes",
      ordersBadge: "{{count}} pedidos",
      pendingBadge: "Pendente",
      storeManager: "Gerenciador de loja",
      viewPendingOrders: "Ver pedidos pendentes",
      gameDetailsUnavailable: "Detalhes do segmento indisponíveis",
      gameDetailsUnavailableDesc: "Não foi possível carregar os dados completos do modal agora. Use o retry global do dashboard para tentar novamente.",
      loadingGameDetails: "Carregando detalhes do segmento",
      loadingGameDetailsDesc: "Estamos preparando a lista completa de segmentos e jogadores para este modal.",
      missionDetailsUnavailable: "Detalhes das missões indisponíveis",
      missionDetailsUnavailableDesc: "Não foi possível carregar os dados auxiliares para este modal. Tente novamente pelo dashboard.",
      loadingMissionDetails: "Carregando detalhes das missões",
      loadingMissionDetailsDesc: "Estamos reunindo jogadores, turmas e segmentos relacionados a cada missão.",
      unknown: "Desconhecido",
      expired: "Expirada",
      startsOn: "Inicia em {{date}}",
      createdBy: "Criada por:",
      period: "Período:",
      classesLabel: "Turmas:",
      allLabel: "todas",
      gamesLabel: "Segmentos:",
      teachersCanValidate: "Professores podem validar",
      teachersCantValidate: "Professores não podem validar",
      completions: "Conclusões",
      evaluateProofs: "Avaliar {{count}} comprovantes pendentes",
    },
    links: {
      manuals: "Manuais",
      marketingFolder: "Pasta de marketing",
      storeSuggestion: "Sugestão de loja",
      gamefikInsta: "Insta da Gamefik",
    },
    loadingStatus: {
      reloadingDashboard: "Recarregando o dashboard",
      clearingAndReloading: "Limpando o que estava carregado e buscando tudo de novo.",
      tryingAgain: "Tentando novamente",
      loadingDashboard: "Carregando dashboard",
      retryingFailed: "Buscando novamente as seções que falharam.",
      loadingSections: "Buscando os dados de cada seção do dashboard.",
      couldNotLoad: "Não foi possível carregar o dashboard",
      mainNotResponding: "As partes principais não responderam. Tente novamente ou recarregue a página.",
      partialNotLoaded: "Parte dos dados não carregou",
      someNotLoaded: "A página abriu, mas algumas seções não conseguiram ser carregadas.",
      dashboardReady: "Dashboard pronto",
      allDataLoaded: "Todos os dados foram carregados com sucesso.",
      sectionLoaded: "{{count}} seção carregada",
      sectionsLoaded: "{{count}} seções carregadas",
      of: "de",
      restarting: "REINICIANDO",
      loading: "CARREGANDO",
      progress: "Progresso",
      loadingDashboardData: "Carregando dados do dashboard",
      sectionInLoading: "{{count}} seção em carregamento",
      sectionsInLoading: "{{count}} seções em carregamento",
      errorLoading: "Algo deu errado ao carregar",
      someNotResponded: "Algumas seções ainda não responderam. O resultado final aparecerá quando terminar.",
      failure: "FALHA",
      whatFailed: "O que falhou",
      noEssentialLoaded: "Nenhuma parte essencial conseguiu ser carregada nesta tentativa.",
      tryAgain: "Tentar novamente",
      restartLoading: "Reiniciar carregamento",
      restart: "Reiniciar",
      didNotLoad: "Não carregaram:",
    },
    missions: {
      title: "Missões",
      totalMissions: "Quantidade total de missões: {{count}}",
      nameCol: "Nome",
      participantsCol: "Participantes",
      approvalsCol: "Aprovações",
      rejectionsCol: "Reprovações",
      valueCol: "Valor",
      valueAcquiredCol: "Valor adquirido",
      descriptionLabel: "Descrição:",
      participantsLabel: "Participantes:",
      approvalsLabel: "Aprovações:",
      rejectionsLabel: "Reprovações:",
      valueLabel: "Valor:",
      valueAcquiredLabel: "Valor Adquirido:",
    },
    recentActions: {
      title: "Ações Recentes",
      viewFullHistory: "Ver histórico completo",
    },
    engagement: {
      title: "Engajamento com missões no ano",
      subtitle: "Percentual de jogadores que fizeram ao menos uma missão.",
      players: "Jogadores",
    },
    monthlyAccess: {
      title: "Acessos mensais",
      chartLabel: "acesso",
    },
    mostRedeemedItems: {
      title: "Produtos mais resgatados",
      totalRedeemed: "Quantidade de produtos já resgatados: {{count}}",
      totalSpentInStore: "Valor total gasto na loja:",
      product: "Produto",
      quantitySold: "Quantidade vendida",
      currentValue: "Valor atual",
      averageValue: "Valor Médio",
      totalSpent: "Total Gasto",
      stock: "Estoque",
      productInfo: "Informações do produto: {{name}}",
      productDetails: "Detalhes do Produto",
      priceLabel: "Preço:",
      stockLabel: "Estoque:",
      playerLimit: "Limite por jogador:",
      unlimited: "Ilimitado",
      categories: "Categorias:",
      startDateLabel: "Data de início:",
      giftCardLabel: "Gift Card:",
      yes: "Sim",
      no: "Não",
      giftCardInfo: "Informações do Gift Card",
      provider: "Provedor:",
      brand: "Marca:",
      valueLabel: "Valor:",
      messageLabel: "Mensagem:",
      instructionsLabel: "Instruções:",
      purchaseHistory: "Histórico de Compras",
      purchaseId: "ID da Compra",
      playerName: "Nome do Jogador",
      purchaseDate: "Data da Compra",
      statusCol: "Status",
      quantityCol: "Quantidade",
      totalValue: "Valor Total",
      delivered: "Entregue",
      pendingStatus: "Pendente",
      canceled: "Cancelado",
      noPurchases: "Este produto ainda não foi comprado por nenhum jogador.",
    },
    rewardsSection: {
      title: "Dashboard de Recompensas",
      subtitle: "Análise completa do sistema de recompensas.",
      spendingRanking: "Ranking de Gastos",
      totalOf: "Total de",
      playersLabel: "Jogadores",
      rewardsLabel: "Recompensas",
      inStore: "Na loja",
      stockPer: "Estoque por",
      playerLabel: "Jogador",
      deliveredLabel: "Entregues",
      deliveredPer: "Entregues por",
      deliveryRate: "Taxa de Entrega",
      purchased: "Compraram",
      percentPurchased: "{{percentage}}% dos estudantes realizaram",
      atLeastOnePurchase: "pelo menos uma compra na loja",
      notPurchased: "Não compraram",
      studentSpendingRanking: "Ranking de Gastos dos Alunos",
      exportXlsx: "📊 Exportar XLSX",
      position: "Posição",
      studentName: "Nome do Aluno",
      totalSpentCol: "Total Gasto",
      currentBalance: "Saldo Atual",
      totalBalance: "Saldo Total",
      purchases: "Compras",
      items: "Itens",
      deliveredCol: "Entregues",
      actions: "Ações",
      viewDetails: "Ver Detalhes",
      purchaseDetails: "Detalhes das Compras: {{name}}",
      purchaseId: "ID Compra",
      date: "Data",
      itemsCol: "Itens",
      statusCol: "Status",
      totalValueCol: "Valor Total",
      deliveredStatus: "Entregue",
      pendingStatus: "Pendente",
      canceledStatus: "Cancelado",
      includingToCollect: "Incluindo moedas a coletar",
    },
    pagination: {
      paginationMode: "Paginação",
      scrollMode: "Rolagem",
      perPage: "{{count}} / página",
      of: "de",
      firstPage: "Primeira página",
      previousPage: "Página anterior",
      nextPage: "Próxima página",
      lastPage: "Última página",
    },
    platformUsage: {
      title: "Uso da plataforma",
      totalRecords: "Quantidade total de registros: {{count}}",
      searchTeacher: "Procure pelo professor...",
      teacher: "Professor",
      accesses: "Acessos",
    },
    playersAccess: {
      neverCollected: "Nunca coletou",
      activationList: "Lista de ativação ({{count}})",
      activationSubtitle: "Ativação, saldo e último resgate dos jogadores.",
      exportCsv: "Exportar CSV",
      allGames: "Todos os segmentos",
      allClasses: "Todas as turmas",
      selectGame: "Selecione um segmento",
      selectClass: "Selecione uma turma",
      orderBy: "Ordenar por",
      lastCollection: "Última coleta",
      missionsSent: "Missões enviadas",
      quizzesSent: "Quizzes enviados",
      direction: "Direção",
      descending: "Descendente",
      ascending: "Ascendente",
      total: "Total",
      activeLabel: "Ativos",
      inactiveLabel: "Inativos",
      nameCol: "Nome",
      classesCol: "Turmas",
      gamesCol: "Segmentos",
      missionsCol: "Missões",
      statusCol: "Status",
      lastRedemption: "Último Resgate",
      active: "Ativo",
      inactive: "Inativo",
      lastRedemptionPerPlayer: "Último resgate por jogador",
      periodLabel: "Período",
      periodDays: "{{count}} dias",
    },
    playersRanking: {
      title: "Ranking de jogadores",
      totalPlayers: "Quantidade total de jogadores: {{count}}",
      searchPlayer: "Procure pelo jogador...",
      exportData: "📊 Exportar dados",
      student: "Aluno",
    },
    teacherUse: {
      title: "Uso dos professores",
      totalTeachers: "Quantidade total de professores: {{count}}",
      searchTeacher: "Procure pelo professor...",
      nameCol: "Nome",
      lastPlatformUse: "Último uso",
      ofPlatform: "da plataforma",
      missionsCreated: "Missões",
      missionsCreatedSub: "Criadas",
      quizzesCreated: "Quizzes",
      quizzesCreatedSub: "Criados",
      distributedCoins: "Coins",
      distributedCoinsSub: "distribuídas",
      playersCol: "Jogadores",
      avgCoinsPerPlayer: "Média de coins por jogadores",
      activeTag: "Ativo",
      absentTag: "Ausente",
    },
  },
  modal: {
    shopTitle: "Loja Gamefik",
    coins: "moedas",
    purchased: "Adquirido",
    buy: "Comprar",
    purchaseSuccess: "Compra realizada com sucesso! O item foi adicionado ao seu inventário.",
    insufficientBalance: "Saldo insuficiente. Complete mais tarefas para ganhar moedas.",
    availableItems: "Itens Disponíveis",
    myInventory: "Meu Inventário",
    emptyInventory: "Seu inventário está vazio",
    buyItemsToSee: "Compre itens na loja para vê-los aqui.",
    viewAvailableItems: "Ver Itens Disponíveis",
    purchasedAt: "Adquirido em",
    code: "Código:",
    copy: "Copiar",
    rankingTitle: "Ranking de Escolas",
    place: "lugar",
    weekly: "Semanal",
    monthly: "Mensal",
    yearly: "Anual",
    yourSchool: "Sua escola",
    completedPercent: "{{percent}}% concluído",
    points: "pontos",
    generalRanking: "Ranking Geral",
    yourSchoolLabel: "Sua escola",
    students: "alunos",
    days: "dias",
    howPointsCalculated: "Como os pontos são calculados",
    pointsDescription: "A pontuação é baseada em três fatores principais:",
    completionProgress: "Progresso de conclusão:",
    completionProgressDesc: "Até 100 pontos baseados na porcentagem de tarefas concluídas.",
    accumulatedCoins: "Moedas acumuladas:",
    accumulatedCoinsDesc: "Cada 10 moedas equivalem a 1 ponto no ranking.",
    completionSpeed: "Velocidade de conclusão:",
    completionSpeedDesc: "Até 100 pontos de bônus para escolas que completam o onboarding mais rapidamente.",
    ranking: "Ranking",
    shop: "Loja",
    earlyBonus: "Bônus antecipado!",
    estimatedTime: "Tempo estimado:",
    deadlineForCompletion: "Prazo para conclusão",
    start: "Início:",
    end: "Fim:",
    tip: "Dica:",
    completeBefore: "Complete esta tarefa antes do prazo para ganhar +{{bonus}} moedas de bônus!",
    takesOnly: "Leva apenas {{time}}",
    concludeBeforeDeadline: "Conclua antes do prazo para ganhar +{{bonus}} moedas de bônus!",
    completedEarly: "Concluído antecipadamente! +{{bonus}} moedas de bônus",
    dayUnit: "dia",
    daysUnit: "dias",
    deadlineExpired: "Prazo encerrado",
    oneDayRemaining: "1 dia restante",
    daysRemaining: "{{count}} dias restantes",
    zeroDays: "0 dias",
    oneMinute: "1 minuto",
    minutes: "{{count}} minutos",
    oneHour: "1 hora",
    hours: "{{count}} horas",
    easy: "Fácil",
    medium: "Médio",
    advanced: "Avançado",
    confirmPurchase: "Confirmar Compra",
    aboutToBuy: "Você está prestes a comprar",
    for: "por",
    insufficientMissing: "Saldo insuficiente. Faltam {{count}} moedas.",
    currentBalance: "Seu saldo atual:",
    cancel: "Cancelar",
    section1Title: "Bem-vindo a Gamefik!",
    section1Desc: "🎯 Etapa 1: Bem-vindo à Gamefik! Conheça nossa plataforma de gamificação educacional.",
    section1Content: "Bem-vindo ao Gamefik! Nossa plataforma de gamificação educacional permite que você transforme o aprendizado em uma experiência divertida e envolvente.",
    section2Title: "Crie seu primeiro Segmento",
    section2Desc: "🎮 Etapa 2: Crie seu primeiro Segmento! Aprenda a criar e configurar seu primeiro segmento na plataforma.",
    section2Content: "Criar seu primeiro segmento é simples! Defina um nome atraente, escolha um tema visual e estabeleça os objetivos de aprendizado. Você pode personalizar a experiência com diferentes níveis, desafios e sistemas de pontuação para manter seus alunos engajados.",
    section3Title: "Crie suas turmas e jogadores!",
    section3Desc: "🧑‍🏫 Etapa 3: Crie suas turmas e jogadores! Aprenda a criar turmas e adicionar alunos ao seu segmento.",
    section3Content: "Organize seus alunos em turmas para facilitar o gerenciamento. Adicione jogadores individualmente ou importe uma lista. Cada jogador terá seu próprio perfil, onde poderá acompanhar seu progresso, conquistas e recompensas obtidas.",
    section4Title: "Adicionando minhas missões (2 missões)!",
    section4Desc: "🎯 Etapa 4: Adicionando minhas missões! Aprenda a criar missões para engajar seus alunos.",
    section4Content: "Missões são tarefas que os alunos devem completar para avançar no segmento. Crie pelo menos duas missões iniciais com objetivos claros, prazos e pontuações. Você pode adicionar descrições detalhadas, recursos de apoio e critérios de avaliação para cada missão.",
    section5Title: "Adicionando minhas primeiras atitudes (2 Atitudes)!",
    section5Desc: "🧠 Etapa 5: Aprendendo sobre atitudes! Descubra como criar e utilizar atitudes para reconhecer comportamentos positivos.",
    section5Content: "Atitudes são comportamentos positivos que você deseja incentivar, como colaboração, pontualidade ou criatividade. Defina pelo menos duas atitudes iniciais e estabeleça como serão reconhecidas e recompensadas dentro do sistema de gamificação.",
    section6Title: "Criando minha primeira recompensa na Loja Gamefik!",
    section6Desc: "🛍️ Etapa 6: Criando minha primeira recompensa! Aprenda a criar recompensas para motivar seus alunos.",
    section6Content: "Recompensas motivam os alunos a participarem ativamente. Na Loja Gamefik, você pode criar recompensas virtuais ou físicas que os alunos podem 'comprar' com os pontos acumulados. Defina o nome, descrição, imagem e valor em pontos para cada recompensa.",
    section7Title: "Participar do treinamento Gamefik!",
    section7Desc: "Conteúdo sobre o treinamento",
    section7Content: "Aproveite ao máximo a plataforma participando do nosso treinamento completo. Aprenda estratégias avançadas de gamificação, dicas para aumentar o engajamento e como analisar os dados de desempenho para melhorar continuamente a experiência de aprendizado.",
    section8Title: "Treine seus professores!",
    section8Desc: "Conteúdo sobre como treinar os professores",
    section8Content: "Compartilhe o conhecimento com sua equipe! Organize sessões de treinamento para que todos os professores possam utilizar o Gamefik efetivamente. Mostre como criar conteúdo, acompanhar o progresso dos alunos e utilizar os recursos da plataforma para potencializar o aprendizado.",
    section9Title: "Lançamento do Segmento!",
    section9Desc: "Conteúdo ensinando boas práticas de lançamento",
    section9Content: "Está tudo pronto para o lançamento! Apresente o segmento aos alunos de forma empolgante, explicando os objetivos, regras e benefícios. Considere criar um evento especial de lançamento para gerar entusiasmo e garantir que todos entendam como participar.",
    shopItem1Name: "Gift Card R$25",
    shopItem1Desc: "Vale-presente digital no valor de R$25 para usar em qualquer loja parceira.",
    shopItem2Name: "Certificado Premium",
    shopItem2Desc: "Certificado digital premium de conclusão do curso com design exclusivo.",
    shopItem3Name: "Tema Exclusivo",
    shopItem3Desc: "Desbloqueie um tema visual exclusivo para personalizar sua experiência Gamefik.",
    shopItem4Name: "Acesso ao Plano de IA",
    shopItem4Desc: "Acesso gratuito ao plano de Inteligência Artificial por 2 meses para criar conteúdos personalizados.",
    completionCode: "Código de conclusão:",
    enterCodeHere: "Digite o código aqui",
    verify: "Verificar",
    coin: "Moeda",
    ob1Heading: "🎯 Etapa 1: Bem-vindo à Gamefik!",
    ob1WelcomeTitle: "👋 Seja bem-vindo à Gamefik! 🎉",
    ob1WelcomeP1: "Você está prestes a transformar a experiência dos seus alunos com engajamento, diversão e aprendizado real.",
    ob1WelcomeP2: "Este onboarding foi pensado para te guiar passo a passo, de forma leve, prática e gamificada.",
    ob1HowTitle: "🕹️ Como funciona o Onboarding Gamificado:",
    ob1HowItem1: "9 etapas simples:",
    ob1HowItem1Desc: "você será guiado por tudo que precisa saber para usar a Gamefik na prática.",
    ob1HowItem2: "Prazo ideal:",
    ob1HowItem2Desc: "finalize tudo em até 7 dias e esteja com sua escola pronta para o lançamento!",
    ob1HowItem3: "Sistema de pontos:",
    ob1HowItem3Desc: "a cada tarefa concluída, você ganha moedas e pontos. Além de aprender, você começa a montar sua reputação na plataforma!",
    ob1VideoTitle: "Tutorial completo de implantação da Gamefik",
    ob1VideoLabel: "👉 Tutorial completo de implantação da Gamefik!",
    ob1TourTitle: "🗺️ Comece com um tour guiado:",
    ob1TourButton: "👉 FAZER TOUR PELO SISTEMA",
    ob1TourDesc: "Esse tour vai te mostrar os primeiros passos diretamente na plataforma. É rápido e super útil!",
    ob1DeepTitle: "📚 Quer entender mais a fundo o que é a Gamefik?",
    ob1DeepDesc: "Confira nosso artigo com o passo a passo completo da implantação:",
    ob1DeepLink: "📖 Guia Simplificado da Gamefik",
    ob1NextTitle: "✅ O que vem a seguir?",
    ob1NextDesc: "Você verá um checklist com as próximas etapas. A cada tarefa completada, você ganha pontos e libera a próxima.",
    ob1CheckWelcome: "Bem-vindo à Gamefik! ✅",
    ob1CheckGame: "Crie seu primeiro Segmento",
    ob1CheckClasses: "Crie suas turmas e jogadores",
    ob1CheckMissions: "Adicione 2 missões",
    ob1CheckAttitudes: "Aprenda sobre atitudes",
    ob1CheckRewards: "Crie 2 recompensas na Loja",
    ob1CheckTraining: "Participe do treinamento Gamefik",
    ob1CheckTeachers: "Treine seus professores",
    ob1CheckLaunch: "Lançamento oficial da Gamefik! 🚀",
    ob2Heading: "🎮 Etapa 2: Crie seu primeiro Segmento!",
    ob2Intro1: "Agora é hora de começar o jogo de verdade! 🕹️",
    ob2Intro2: "Na Gamefik, tudo gira em torno dos Segmentos — eles são a base de toda a experiência gamificada da sua escola.",
    ob2WhatTitle: "🤔 O que é um Segmento?",
    ob2WhatDesc: "Um Segmento é como o \"universo do jogo\" para suas turmas. É nele que você configura:",
    ob2WhatItem1: "Quais turmas vão participar;",
    ob2WhatItem2: "Como os alunos ganham pontos;",
    ob2WhatItem3: "Missões, atitudes e recompensas.",
    ob2TipTitle: "💡 Dica: Crie diferentes segmentos para públicos distintos, como:",
    ob2TipItem1: "Fundamental I",
    ob2TipItem2: "Fundamental II",
    ob2TipItem3: "Ensino Médio",
    ob2TipExtra: "Para escolas extracurriculares, recomendamos a divisão por idade:",
    ob2TipAge1: "Crianças pequenas: 4 a 6 anos",
    ob2TipAge2: "Pré-adolescentes: 7 a 12 anos",
    ob2TipAge3: "Adolescentes: 13 a 17 anos",
    ob2TipAge4: "Adultos: 18 anos ou mais",
    ob2TipFreedom: "Isso te dá liberdade para personalizar a experiência e adaptar a gamificação a cada faixa etária.",
    ob2HowTitle: "⚙️ Como criar seu Segmento:",
    ob2HowStep1: "Para criar um segmento é só acessar Configurações > Avançadas menu lateral esquerdo",
    ob2HowStep2: "Clicar no botão \"+ Novo Segmento\".",
    ob2HowScreenAlt: "Tela de criação de novo segmento",
    ob2HowStep4: "Dê um nome para o Segmento!",
    ob2HowStep5: "Termine de configurar o restante dos campos.",
    ob2HowStep6: "Clique em salvar. Pronto! 🚀",
    ob2MoreTitle: "📚 Quer saber mais?",
    ob2MoreDesc: "Se quiser se aprofundar, veja nosso artigo completo:",
    ob2MoreLink: "📖 O que é um segmento? Como criar um segmento",
    ob2CoinTitle: "🪙 Ganhe suas primeiras moedas!",
    ob2CoinDesc: "Assim que criar seu primeiro Segmento, você ganha moedas automaticamente e desbloquea a próxima etapa! 🎉",
    ob3Heading: "🧑‍🏫 Etapa 3: Crie suas turmas e jogadores!",
    ob3Intro1: "É hora de criar suas turmas e adicionar os alunos que vão participar dos segmentos. 🚀",
    ob3Intro2: "Na Gamefik, os jogadores são os alunos. E as turmas são grupos onde você organiza os participantes por série, sala, disciplina ou do jeito que quiser.",
    ob3ClassTitle: "🧩 Como criar uma turma:",
    ob3ClassStep1: "Acesse o menu e clique em Configurações > Turmas.",
    ob3ClassStep2: "Clique em \"Nova turma\".",
    ob3ClassStep3: "Preencha as informações da turma.",
    ob3ClassStep4: "Salve. Pronto, sua turma está criada!",
    ob3ClassLink: "📖 Tutorial de como criar uma turma",
    ob3PlayerTitle: "🧍‍♂️ Como adicionar jogadores (alunos):",
    ob3PlayerDesc: "Você pode adicionar manualmente ou importar vários alunos de uma vez!",
    ob3ManualTitle: "✅ Adicionar manualmente:",
    ob3ManualStep1: "Acesse sua turma criada.",
    ob3ManualStep2: "Vá em Jogadores > Adicionar aluno.",
    ob3ManualStep3: "Preencha o nome, turma, e outras infos.",
    ob3ManualLink: "📖 Como incluir um novo aluno",
    ob3ImportTitle: "🗂️ Importar em lote (via planilha):",
    ob3ImportDesc: "Ideal para escolas com muitos alunos!",
    ob3ImportWarning: "Crie todas as turmas antes de importar os alunos! 💡",
    ob3ImportGuide: "Siga o tutorial do artigo abaixo para importar seus alunos:",
    ob3ImportLink: "📖 Como importar lista de alunos para o segmento",
    ob3DoneTitle: "🎯 Quando a etapa é concluída?",
    ob3DoneDesc: "✅ Após criar 2 turmas e adicionar alunos (manual ou por planilha), a tarefa é concluída automaticamente — e você ganha mais moedas!",
    ob4Heading: "🎯 Adicionando minhas missões (2 missões)",
    ob4VideoTitle: "🎥 Assista primeiro: Como criar uma missão",
    ob4VideoLink: "Clique aqui para ver o vídeo no YouTube",
    ob4VideoDesc: "Em menos de 2 minutos você aprende o passo a passo para criar uma missão na prática!",
    ob4NowTitle: "✍️ Agora que você viu como funciona…",
    ob4NowDesc1: "Vamos transformar o aprendizado dos seus alunos em uma jornada cheia de propósito! 🎮",
    ob4NowDesc2: "As Missões são atividades gamificadas que conectam eventos escolares, aprendizagem e engajamento.",
    ob4NowDesc3: "Elas são simples de criar — e poderosas nos resultados.",
    ob4WhyTitle: "🔥 Por que usar Missões?",
    ob4WhyDesc: "Missões ajudam você a:",
    ob4WhyItem1: "Estimular o cumprimento de tarefas.",
    ob4WhyItem2: "Motivar alunos com metas claras.",
    ob4WhyItem3: "Melhorar performance comercial →",
    ob4WhyItem3Bold: "+Matrículas +Retenção",
    ob4WhyItem4: "Melhorar o desempenho escolar e pedagógico.",
    ob4WhyInsight: "💡 Escolas que usam bem as missões relatam mais engajamento, melhores notas e redução de evasão!",
    ob4WhyIdeasLink: "Ideias de missões para começar seu Segmento",
    ob4HowTitle: "🛠️ Como criar uma missão (resumo do vídeo):",
    ob4HowStep1: "Vá até o menu Missões.",
    ob4HowStep2: "Clique em \"Gerenciar\".",
    ob4HowStep3a: "Criar com IA",
    ob4HowStep3b: "Criar do zero",
    ob4HowStep3Pre: "Clicar no botão de",
    ob4HowStep3Mid: "ou",
    ob4HowStep4: "Preencha as informações necessárias para terminar a configuração da missão.",
    ob4HowStep5: "Defina quantas moedas, pontos e XP os alunos vão ganhar (Use a escala de dificuldade indicada).",
    ob4HowStep6: "Salve. Missão criada! 🚀",
    ob4MoreTitle: "📚 Quer se aprofundar?",
    ob4MoreLink1: "Guia completo de Missões 2.0",
    ob4MoreLink2: "Como criar uma nova missão (seção do artigo)",
    ob4MoreLink3: "Ideias de missões para seus professores",
    ob4DoneTitle: "✅ Quando a etapa é concluída?",
    ob4DoneDesc1: "Após criar 2 missões na prática, a tarefa será concluída automaticamente.",
    ob4DoneDesc2: "E claro… você vai ganhar moedas extras para usar no seu segmento! 💰",
    ob5Heading: "🧠 Aprendendo sobre atitudes!",
    ob5Intro1: "Atitudes são ações rápidas que valem pontos e ajudam a construir uma cultura positiva na escola! ✨",
    ob5Intro2: "Enquanto as missões são mais estruturadas, com regras e prazos, as atitudes funcionam como reconhecimentos instantâneos — você pode lançar pontos com poucos cliques sempre que um aluno demonstrar um bom comportamento ou atitude desejada.",
    ob5ExamplesTitle: "🌟 Exemplos de atitudes:",
    ob5Example1: "Ajudar um colega na sala de aula",
    ob5Example2: "Ser gentil com funcionários",
    ob5Example3: "Organizar o espaço após a aula",
    ob5Example4: "Chegar no horário por 5 dias seguidos",
    ob5Example5: "Empenhar-se durante a aula de educação física",
    ob5ExampleInsight: "💡 O segredo está na frequência e consistência: atitudes bem usadas criam um reforço positivo no cotidiano escolar.",
    ob5DiffTitle: "🤔 Qual a diferença entre atitudes e missões?",
    ob5DiffMissionsHeader: "Missões",
    ob5DiffAttitudesHeader: "Atitudes",
    ob5DiffRow1Col1: "São desafios",
    ob5DiffRow1Col2: "São feedbacks comportamentais",
    ob5DiffRow2Col1: "Têm prazo e regras definidas",
    ob5DiffRow2Col2: "São ações rápidas e pontuais",
    ob5DiffRow3Col1: "São planejadas com antecedência",
    ob5DiffRow3Col2: "São lançadas na hora",
    ob5DiffRow4Col1: "Podem ter documentos ou evidências",
    ob5DiffRow4Col2: "São baseadas em observação direta",
    ob5DiffLink: "Saiba mais sobre essa diferença aqui",
    ob5HowTitle: "⚙️ Como criar uma atitude:",
    ob5HowStep1: "Acesse o menu Atitudes na barra lateral.",
    ob5HowStep2: "Clique em \"Nova Atitude\".",
    ob5HowStep3: "Dê um nome para a atitude (ex: \"Ajudou um colega\").",
    ob5HowStep4: "Escolha o valor em moedas, XP e pontos.",
    ob5HowStep5: "Salve. Agora você pode lançá-la sempre que quiser com 1 clique!",
    ob5HowLink1: "Como criar uma atitude",
    ob5HowLink2: "O que é uma atitude",
    ob5LaunchTitle: "🖱️ E como lançar uma atitude? Aprenda nos materiais abaixo:",
    ob5LaunchLink1: "Como Lançar uma atitude?",
    ob5LaunchLink2: "Como realizar um lançamento rápido?",
    ob5DoneTitle: "✅ Quando a etapa é concluída?",
    ob5DoneDesc1: "Você precisa criar uma atitude para desbloquear a próxima etapa.",
    ob5DoneDesc2: "Depois disso, as atitudes estarão disponíveis para usar com seus alunos!",
    ob6Heading: "Criando minha primeira recompensa na Loja Gamefik!",
    ob6VideoTitle: "🎥 Comece assistindo:",
    ob6VideoLink: "Como criar uma recompensa",
    ob6VideoDesc: "Em menos de 2 minutos, você aprende o passo a passo para criar uma recompensa e ativar sua loja!",
    ob6NowTitle: "✍️ Agora é com você!",
    ob6NowDesc1: "A Loja Gamefik é onde os alunos podem trocar as moedas que ganham por recompensas reais ou simbólicas. Isso é o que torna a experiência gamificada ainda mais concreta e motivadora!",
    ob6NowDesc2: "Você pode incluir prêmios simples (como sair 5 minutos mais cedo da aula) até itens físicos (como um mouse games, gift cards e outros).",
    ob6WhyTitle: "🧠 Por que isso importa?",
    ob6WhyDesc: "O sistema de recompensas ativa o chamado Ciclo de Recompensa do Aluno — um mecanismo que:",
    ob6WhyItem1: "Reforça comportamentos positivos",
    ob6WhyItem2: "Cria motivação constante",
    ob6WhyItem3: "Ajuda a manter o engajamento ao longo do tempo",
    ob6WhyItem4: "Conecta esforço com resultado de forma clara",
    ob6WhyLink: "Leia mais sobre o ciclo de recompensa do aluno",
    ob6HowTitle: "🛠️ Como criar uma recompensa:",
    ob6HowStep1: "Vá até o menu, clique em Shopping > Recompensas.",
    ob6HowStep2: "Clique em \"Nova recompensa\".",
    ob6HowStep3: "Dê um nome criativo.",
    ob6HowStep4: "Preencha todos os campos corretamente.",
    ob6HowStep5: "Não esqueça de definir o Estoque e número que cada aluno pode resgatar. 🚨",
    ob6HowStep6: "Salve. Pronto! Sua loja começou a ganhar vida! 🛍️",
    ob6HowLink: "Guia completo de como adicionar uma recompensa",
    ob6DoneTitle: "🪙 Quando a etapa é concluída?",
    ob6DoneDesc1: "Depois que você criar 2 recompensas diferentes, a tarefa será concluída automaticamente.",
    ob6DoneDesc2: "E claro: você também ganha moedas 🎉",
    ob7Heading: "🎓 Participar do treinamento Gamefik!",
    ob7VideoTitle: "🎥 Assista ao treinamento completo:",
    ob7VideoLink: "Treinamento Oficial Gamefik (Vídeo)",
    ob7VideoDesc: "Este vídeo é essencial para entender toda a lógica pedagógica, técnica e estratégica da Gamefik.",
    ob7LiveDesc: "Ou participe do nosso treinamento online ao vivo, basta agendar no link abaixo:",
    ob7LiveButton: "Agende seu treinamento online para gestores ✅",
    ob7LearnTitle: "✍️ O que você vai aprender:",
    ob7LearnItem1: "Como usar a gamificação como ferramenta pedagógica",
    ob7LearnItem2: "Boas práticas para engajar alunos, pais e professores",
    ob7LearnItem3: "Exemplos reais de uso nas escolas",
    ob7LearnItem4: "Como tirar o máximo da plataforma no dia a dia",
    ob7LearnInsight: "💡 Este conteúdo foi feito com carinho pela nossa equipe de especialistas — é seu mapa para ter sucesso com a Gamefik!",
    ob7CodeTitle: "🔐 Como concluir a etapa:",
    ob7CodeDesc1: "No final do vídeo, será revelado um código exclusivo.",
    ob7CodeDesc2: "Digite esse código no campo abaixo para concluir esta etapa e desbloquear a próxima!",
    ob7MissionTitle: "🎯 Essa é a sua missão:",
    ob7MissionDesc: "Assistir até o fim + inserir o código = tarefa cumprida + moedas garantidas!",
    ob8Heading: "👩‍🏫 Treine seus professores!",
    ob8WhyTitle: "✍️ Por que essa etapa é essencial?",
    ob8WhyDesc: "Seus professores são os protagonistas da gamificação. Quando eles entendem como aplicar a Gamefik no dia a dia, tudo flui melhor:",
    ob8WhyBold1: "o engajamento aumenta",
    ob8WhyBold2: "os alunos se envolvem mais",
    ob8WhyBold3: "os resultados aparecem!",
    ob8HowTitle: "👥 Como treinar seus professores",
    ob8HowDesc: "Você pode escolher entre duas formas de capacitar sua equipe:",
    ob8LiveTitle: "✅ 1. Treinamento ao vivo com a equipe da Gamefik (MAIS INDICADA)",
    ob8LiveLink: "Agendar treinamento dos professores",
    ob8LiveDesc: "Um encontro dinâmico, prático e com espaço para dúvidas, acontecem semanalmente.",
    ob8LiveCode: "🛡️ Ao final, os professores recebem um código exclusivo para validar a participação.",
    ob8AsyncTitle: "▶️ 2. Treinamento gravado (assíncrono)",
    ob8AsyncLink: "Assistir ao treinamento gravado",
    ob8AsyncDesc: "Ideal para professores que preferem assistir no próprio ritmo.",
    ob8AsyncCode: "📝 Ao final do vídeo, será exibido um código exclusivo para validar a conclusão.",
    ob8BonusTitle: "📥 Bônus: Guia rápido para professores",
    ob8BonusDesc: "Quer apoiar os professores desde o primeiro dia? Compartilhe esse material direto e prático:",
    ob8BonusLink: "📖 Guia prático para professores que querem mandar bem",
    ob8CodeTitle: "🔐 Como concluir esta etapa:",
    ob8CodeDesc1: "Após o treinamento (ao vivo ou gravado), os professores devem te enviar o código exibido no final.",
    ob8CodeDesc2: "Digite esse código no campo abaixo para concluir a etapa e liberar a missão final!",
    ob9Heading: "🚀 Lançamento oficial da Gamefik!",
    ob9TimeTitle: "🎉 Chegou a hora mais esperada!",
    ob9TimeDesc1: "Parabéns por ter chegado até aqui! Agora que tudo está configurado, é hora de lançar a Gamefik oficialmente na sua escola.",
    ob9TimeDesc2: "Esse momento é especial: ele marca o início da experiência gamificada para seus alunos — e pode ser o ponto de virada para o engajamento escolar.",
    ob9PrereqTitle: "✅ Antes de lançar, revise os pré-requisitos:",
    ob9PrereqDesc: "Certifique-se de que está com tudo pronto para um lançamento inesquecível:",
    ob9PrereqItem1Title: "Cards dos alunos estão prontos?",
    ob9PrereqItem1Desc: "Eles são a chave de acesso para a experiência gamificada.",
    ob9PrereqItem2Title: "Totem ou tablet posicionado?",
    ob9PrereqItem2Desc: "O ideal é que os alunos consigam consultar e coletar moedas com facilidade.",
    ob9PrereqItem3Title: "Configuração do Segmento finalizada?",
    ob9PrereqItem3Desc: "Verifique se todas as etapas anteriores estão concluídas, com turmas, jogadores, missões e recompensas ativas.",
    ob9PrereqItem4Title: "Loja visível para os alunos?",
    ob9PrereqItem4Desc: "Coloque os prêmios em uma vitrine ou imprima cartazes com as recompensas disponíveis — isso gera curiosidade e expectativa!",
    ob9LaunchTitle: "📣 Como realizar o lançamento:",
    ob9LaunchDesc: "Agora sim, vamos colocar o show pra rodar! Aqui está o passo a passo:",
    ob9LaunchStep1Title: "📢 Comunique alunos e pais - ",
    ob9LaunchStep1Link: "Materiais que preparamos para vocês usarem na divulgação",
    ob9LaunchStep1Desc: "Envie um aviso com a data oficial de início da Gamefik. Use canais como agenda, WhatsApp ou e-mail.",
    ob9LaunchStep2Title: "🗣️ Apresente a Gamefik para os alunos",
    ob9LaunchStep2Desc1: "Passe de sala em sala explicando como funciona e entregue os cards individualmente.",
    ob9LaunchStep2Desc2: "OU faça um evento especial com todos os alunos para anunciar o início do segmento! 🎊",
    ob9LaunchStep3Title: "👀 Acompanhe a primeira coleta",
    ob9LaunchStep3Desc: "Indique alguém da sua equipe para ficar perto do totem no dia do lançamento. Isso garante que os alunos aprendam a usar e se sintam acolhidos na experiência.",
    ob9BestTitle: "🔍 Boas práticas de outras escolas",
    ob9BestDesc: "Nada como se inspirar em quem já fez acontecer. Veja essa série de vídeos com exemplos reais de lançamentos de sucesso:",
    ob9BestVideo: "🎥 [Boas práticas de lançamento (em breve)]",
    ob9DoneTitle: "🪙 Quando essa etapa é concluída?",
    ob9DoneDesc1: "A etapa será finalizada automaticamente após 10% dos alunos realizarem a primeira coleta no sistema.",
    ob9DoneDesc2: "Ou seja: basta lançar oficialmente, que os alunos fazem o resto! 😉",
  },
  settingsAdvanced: {
    pageTitle: "Configurações Avançadas | Gamefik Escolas",
    pageDescription: "Gerencie configurações avançadas, segmentos, faturas e usuários da sua escola no Gamefik.",
    heading: "Configurações Avançadas",
    subheading: "Gerencie todas as configurações da sua escola",
    loadingConfig: "Carregando configurações...",
    loadError: "Não foi possível carregar as configurações.",
    tabSettings: "Configurações",
    tabFinancial: "Financeiro",
    tabGames: "Segmentos",
    tabClasses: "Turmas",
    tabUsers: "Usuários",
    tabAutomations: "Automações",
    tabHistory: "Histórico",
    systemSettingsTitle: "Configurações do Sistema",
    systemSettingsDescription: "Configure as preferências gerais do sistema",
    globalTestFlagTitle: "Teste global liberado",
    globalTestFlagDescription: "Este bloco só aparece para usuários do Manager em contas New Manager Global quando a feature flag feature-flag-global-test está ativa.",
    globalTestFlagEnabled: "Flag ativa",
    languageTitle: "Idioma da plataforma",
    languageDescription: "Escolha em qual idioma o painel administrativo deve ser exibido.",
    languagePreferenceTitle: "Idioma do painel",
    languagePreferenceDescription: "Na primeira visita, o sistema usa automaticamente o idioma do dispositivo e recorre ao inglês quando ele não é suportado.",
    xpManagementTitle: "Gerenciamento de XP",
    xpActive: "Ativo",
    xpDisabled: "Desativado",
    xpManagementDescription: "Ative ou desative o XP de todas as atitudes, missões e quizzes",
    xpIsActive: "XP está ativo",
    xpIsDisabled: "XP está desativado",
    xpActiveDescription: "Todas as atitudes, missões e quizzes estão concedendo XP normalmente.",
    xpDisabledDescription: "Desativado em {date}{user}. {count} registros afetados.",
    xpDisabledByUser: " por {user}",
    xpDisabledUnknownDate: "data desconhecida",
    xpToggleLabel: "Ativar/Desativar XP",
    xpHowItWorks: "Como funciona:",
    xpDisableExplanation: "Remove o XP de todas as atitudes, missões e quizzes, guardando os valores para restauração",
    xpEnableExplanation: "Restaura os valores de XP originais salvos anteriormente",
    xpCoinsUnaffected: "Os valores de moedas (coins) não são afetados",
    xpDisableTitle: "Desativar XP",
    xpDisableWarning: "Esta ação irá remover o XP de todas as atitudes, missões e quizzes. Os valores serão salvos e poderão ser restaurados posteriormente.",
    xpWhatWillBeAffected: "O que será afetado:",
    xpAttitudesZeroed: "Todas as atitudes terão o XP zerado",
    xpMissionsZeroed: "Todas as missões terão o XP zerado",
    xpQuizzesZeroed: "Todos os quizzes terão o XP zerado",
    xpCoinsUnchanged: "Os valores de moedas (coins) permanecerão inalterados",
    xpConfirmDisable: "Confirmar Desativação",
    xpSuccessDisabled: "XP desativado com sucesso! {count} registros afetados.",
    xpSuccessEnabled: "XP restaurado com sucesso! {count} registros restaurados.",
    xpErrorDisable: "Erro ao desativar XP",
    xpErrorEnable: "Erro ao ativar XP",
    iaEnhancementTitle: "Aprimoramento com IA",
    iaOptionalAddon: "Adicional Opcional",
    iaEnhancementDescription: "Adicione recursos com IA a qualquer plano. O preço da IA é baseado no número de alunos.",
    iaResourcesTitle: "✨ Recursos de IA Gamefik",
    iaActive: "Ativo",
    iaMonthlyPlan: "Plano Mensal",
    iaInactiveDescription: "Aprimore sua experiência Gamefik com insights baseados em IA",
    iaProcessing: "Processando...",
    iaCancelScheduled: "Cancelamento agendado para {date}. O acesso permanece ativo até lá.",
    iaCancelEndOfMonth: "a virada do mês",
    iaReactivationBlocked: "A reativação só estará disponível após a virada do mês.",
    iaToggleLabel: "Ativar Recursos de IA",
    iaActivatedSuccess: "IA ativada com sucesso!",
    iaActivateError: "Erro ao ativar IA",
    iaDeactivatedSuccess: "IA desativada com sucesso!",
    iaDeactivateError: "Erro ao desativar IA",
    iaPricingError: "Não foi possível calcular a precificação da IA.",
    invoicesTitle: "Faturas",
    invoicesDescription: "Visualize e gerencie suas faturas",
    noInvoicesFound: "Nenhuma fatura encontrada",
    invoiceStatusPaid: "Pago",
    invoiceStatusOpen: "Pendente",
    invoiceStatusDraft: "Rascunho",
    invoiceHeaderStatus: "Status",
    invoiceHeaderAmount: "Valor",
    invoiceHeaderSentDate: "Data de Envio",
    invoiceHeaderDueDate: "Vencimento",
    invoiceHeaderActions: "Ações",
    invoicePayWithPix: "Pagar com Pix",
    invoicePay: "Pagar",
    invoiceView: "Visualizar",
    gamesTitle: "Segmentos",
    gamesDescription: "Crie e gerencie os segmentos da sua escola",
    newGame: "Novo Segmento",
    noGamesYet: "Nenhum segmento criado ainda",
    createFirstGame: "Criar seu primeiro segmento",
    coinIconTitle: "Ícone do Coin",
    coinIconDescription: "Personalize o ícone de moeda exibido em todos os segmentos",
    coinIconGlobalHint: "Esta configuração vale para todos os segmentos da escola — painel, app do aluno e loja.",
    coinIconCurrent: "Prévia",
    coinIconUpload: "Enviar ícone",
    coinIconUploading: "Enviando...",
    coinIconSaving: "Salvando...",
    coinIconSaveSuccess: "Ícone do coin atualizado para todos os segmentos.",
    coinIconSaveError: "Erro ao salvar ícone do coin.",
    coinIconUploadError: "Erro ao enviar imagem.",
    resetGamesTitle: "Zerar Segmentos",
    resetGamesDescription: "Ação irreversível: remove todos os pontos dos alunos",
    resetGamesWarning: "É comum e recomendado zerar os pontos ao final do semestre ou ano letivo. Esta ação não pode ser desfeita.",
    classesTitle: "Turmas",
    classesDescription: "Gerencie as turmas da sua escola",
    usersTitle: "Gestão de Usuários",
    usersDescription: "Gerencie professores e administradores",
    automationsTitle: "Automações",
    automationsDescription: "Configure recorrências automáticas para atitudes",
    historyTitle: "Histórico de Atividades",
    historyDescription: "Visualize todas as atividades realizadas no sistema",
    gameSavedSuccess: "Segmento salvo com sucesso.",
    gameSaveError: "Erro ao salvar segmento",
    gameDeleteConfirm: "Tem certeza que deseja deletar este segmento?",
    gameNameRequired: "Você precisa definir um nome para o Segmento",
    cancel: "Cancelar",
    close: "Fechar",
    save: "Salvar",
    checkoutCancelled: "Checkout cancelado. Você pode escolher outro plano ou tentar novamente.",
    planActivatedSuccess: "Plano ativado com sucesso.",
    checkoutPaymentPending: "Não conseguimos confirmar o pagamento. Sua conta segue no plano Free — você pode tentar concluir o pagamento novamente.",
    checkoutConfirmError: "Não foi possível confirmar o checkout.",
    iaPricingTier0To100: "IA para escolas de 0 a 100 alunos",
    iaPricingTier100To200: "IA para escolas de 100 a 200 alunos",
    iaPricingTier200To400: "IA para escolas de 200 a 400 alunos",
    iaPricingTier400To600: "IA para escolas de 400 a 600 alunos",
    iaPricingTier600To1000: "IA para escolas de 600 a 1000 alunos",
    iaPricingTierAbove1000: "IA para escolas acima de 1000 alunos",
  },
  contractModal: {
    title: "Pacote IA Ilimitada",
    closeLabel: "Fechar",
    createMissionsWithAI: "Crie missões com IA",
    createQuizzesWithAI: "Crie quizzes com IA",
    missionApprovalWithAI: "Aprovação de missões com IA",
    andMoreComing: "E muito mais vindo por aí 👀",
    calculatingPricing: "Calculando precificação com base no número de alunos...",
    endsIn: "Termina em:",
    lifetimeOff: "20% OFF Vitalício",
    detectedStudents: "Detectamos <strong>{count}</strong> alunos. Plano: <strong>{tier}</strong>.",
    lifetimeDiscountUntil: "20% de desconto vitalício para contratações realizadas até {date}.",
    lifetimeDiscountEnded: "Oferta de 20% vitalícia encerrada. O valor vigente é {price} por mês.",
    perMonth: "/mês",
    agreeWithTerms: "Concordo com os",
    termsOfService: "termos de serviço",
    mustAgreeToTerms: "Você precisa concordar com os termos de serviço para continuar.",
    addToSubscription: "Adicionar na minha assinatura",
    expired: "Encerrada",
  },
  cancelModal: {
    title: "Cancelar Plano IA Ilimitada",
    reviewConditions: "Revise as condições de cancelamento antes de prosseguir.",
    cancellationRules: "Regras de Cancelamento:",
    ruleEndOfPeriod: "O cancelamento é efetivado ao final do período corrente (último dia do mês)",
    ruleUseUntilEnd: "As funcionalidades de IA poderão ser utilizadas até final do período corrente",
    ruleNoRefund: "Não há reembolso como previsto no termo de serviço",
    cancellationReasonLabel: "Motivo do cancelamento:",
    cancellationReasonPlaceholder: "Por favor, nos conte o motivo do cancelamento...",
    keepPlan: "Manter Plano",
    confirmCancellation: "Confirmar Cancelamento",
  },
  termsModal: {
    title: "Termo de Uso",
    readAndAccept: "Li e Aceito",
    documentTitle: "Termo de Uso – Pacote de IA Ilimitado Gamefik",
    lastUpdated: "Última atualização: 15/08/2025",
    intro: "O presente Termo de Uso (\"Termo\") regula a contratação e utilização do Pacote de IA Ilimitado oferecido pela Gamefik (\"Plataforma\"), por parte da instituição de ensino contratante (\"Escola\"). Ao aderir a este pacote, a Escola declara estar ciente e de acordo com as condições aqui descritas.",
    section1Title: "1. Objeto",
    section1Content: "O Pacote de IA Ilimitado oferece acesso irrestrito às funcionalidades de inteligência artificial disponibilizadas pela Gamefik durante o período contratado, conforme descrito nas comunicações e materiais comerciais da empresa.",
    section2Title: "2. Condições Comerciais",
    section21Title: "2.1. Cobrança Proporcional no Primeiro Mês",
    section21Item1: "A adesão pode ser feita a qualquer momento.",
    section21Item2: "No dia 1º do mês seguinte à contratação, será emitida cobrança proporcional ao número de dias de utilização no mês da adesão, incluída na fatura vigente da Escola como valor adicional.",
    section22Title: "2.2. Cobrança Integral a Partir do Segundo Mês",
    section22Content: "A partir do segundo mês, o valor integral vigente do Pacote de IA Ilimitado será cobrado mensalmente, de forma recorrente, como adicional na fatura da Escola, independentemente da frequência de uso.",
    section23Title: "2.3. Cancelamento e Cobrança Proporcional",
    section23Item1: "A Escola poderá cancelar o pacote a qualquer momento, utilizando o próprio sistema da Gamefik para isso.",
    section23Item2: "Em caso de cancelamento, será cobrado o valor inteiro do mês de cancelamento e o acesso às funcionalidades de IA estará disponível até o fim do período corrente.",
    section23Item3: "Caso a plataforma seja contratada e cancelada no mesmo mês, será cobrado o valor pró-rata do dia da contratação até o final do período corrente.",
    section3Title: "3. Forma de Pagamento",
    section3Content: "O valor do Pacote de IA Ilimitado será cobrado junto à fatura mensal da Escola já contratante da Gamefik, constando como item adicional discriminado. Em caso de inadimplência, as regras previstas no contrato principal serão aplicadas, incluindo eventuais multas e suspensão de serviços.",
    section4Title: "4. Alterações no Valor",
    section4Content: "A Gamefik poderá atualizar o valor do Pacote de IA Ilimitado, mediante comunicação à Escola com antecedência mínima de 30 (trinta) dias.",
    section5Title: "5. Vigência",
    section5Content: "O presente Termo passa a vigorar na data de adesão e permanece válido enquanto a Escola mantiver ativa a contratação do Pacote de IA Ilimitado.",
    section6Title: "6. Cancelamento pela Gamefik",
    section6Intro: "A Gamefik reserva-se o direito de suspender ou cancelar o acesso ao Pacote de IA Ilimitado, sem ônus para a Escola, nos seguintes casos:",
    section6Item1: "Uso indevido ou em desacordo com a finalidade educacional da Plataforma.",
    section6Item2: "Violação aos Termos de Uso gerais da Gamefik.",
    section7Title: "7. Disposições Gerais",
    section7Item1: "Este Termo complementa e integra o Contrato Principal e os Termos de Uso da Gamefik já aceitos pela Escola.",
    section7Item2: "Em caso de conflito entre este Termo e o Contrato Principal, prevalecerão as condições específicas do presente documento no que se refere ao Pacote de IA Ilimitado.",
    section7Item3: "Fica eleito o foro da comarca da sede da Gamefik para dirimir quaisquer controvérsias oriundas deste Termo.",
    agreementNote: "Ao clicar em \"Li e Aceito\" ou equivalente, a Escola declara ter lido, compreendido e concordado com todas as condições estabelecidas neste Termo.",
  },
  pixModal: {
    title: "Pagar com Pix",
    invoiceAmount: "Valor da fatura",
    dueDate: "Vencimento: {date}",
    qrCodeExpiresIn: "QR Code expira em:",
    expired: "Expirado",
    paymentConfirmed: "✓ Pagamento confirmado!",
    generatingQrCode: "Gerando QR Code...",
    paymentConfirmedLabel: "Pagamento confirmado",
    qrCodeUnavailable: "QR Code temporariamente indisponível",
    qrCodeError: "Erro ao gerar QR Code",
    qrCodePix: "QR Code Pix",
    scanWithBank: "Escaneie com o app do seu banco",
    paymentConfirmedSuccess: "Pagamento confirmado com sucesso!",
    orCopyCode: "Ou copie o código:",
    copy: "Copiar",
    codeCopied: "Código copiado!",
    howToPay: "Como pagar:",
    step1: "1. Abra o app do seu banco",
    step2: "2. Escolha pagar com Pix QR Code ou Pix Copia e Cola",
    step3: "3. Escaneie o código ou cole o código acima",
    step4: "4. Confirme o pagamento",
    pixPaymentError: "Erro ao criar pagamento PIX",
    paymentConfirmedToast: "Pagamento confirmado com sucesso!",
  },
  settingsForm: {
    loginWithoutQrCode: "Login sem QR Code",
    loginWithoutQrCodeDesc: "Permite login simplificado para testes",
    studentEmailLogin: "Login de aluno por e-mail",
    studentEmailLoginDesc: "Permite que alunos da unidade entrem com o e-mail cadastrado e um código temporário",
    controlledGame: "Segmento Controlado",
    controlledGameDesc: "Modo especial de controle para segmentos",
    missions2WithAI: "Missões 2.0 com IA",
    missions2WithAIDesc: "Comprovantes validados automaticamente por IA",
    classSelection: "Seleção de Turmas",
    classSelectionDesc: "Professor pode escolher suas próprias turmas",
    teacherMissions: "Missões do Professor",
    teacherMissionsDesc: "Permite que professores criem missões",
    appSounds: "Sons no Aplicativo",
    appSoundsDesc: "Efeitos sonoros e notificações",
    studentRanking: "Ranking dos Alunos",
    studentRankingDesc: "Classificação visível para estudantes",
    rankingDisableTooltip: "Ao desativar, o ranking fica oculto para os jogadores",
    studentShop: "Loja para Alunos",
    studentShopDesc: "Acesso à loja de recompensas",
    shopDisableTooltip: "Ao desativar, a loja fica oculta para os jogadores",
    authSection: "Autenticação",
    authSectionDesc: "Configurações de login e acesso",
    gamesSection: "Segmentos",
    gamesSectionDesc: "Configurações específicas dos segmentos",
    featuresSection: "Funcionalidades",
    featuresSectionDesc: "Recursos e capacidades do sistema",
    studentExperienceSection: "Experiência do Aluno",
    studentExperienceSectionDesc: "Interface e recursos para estudantes",
    testEnvironment: "Ambiente de Teste",
    loadError: "Erro ao carregar configurações",
    updateSuccess: "Configuração atualizada com sucesso!",
    updateError: "Erro ao atualizar configuração",
    loadingConfig: "Carregando configuração...",
  },
  teacherCoinLimits: {
    title: "Limites de moedas dos educadores",
    description: "Defina se educadores podem criar atividades e o limite de moedas por segmento.",
    activitiesEnabled: "Atividades de educadores habilitadas",
    activitiesDisabled: "Atividades de educadores desabilitadas",
    unlimited: "Ilimitado",
    controlled: "Controlado",
    limit: "Limite de moedas",
    segment: "Segmento",
    window30Days: "O consumo é apurado em uma janela móvel de 30 dias.",
    save: "Salvar",
    saving: "Salvando...",
    success: "Configuração de limites salva com sucesso.",
    failure: "Não foi possível salvar a configuração de limites.",
    loading: "Carregando limites dos educadores...",
    empty: "Nenhum segmento disponível para configurar.",
    explanationIndividual: "O limite é aplicado individualmente para cada educador e turma.",
  },
  gameFormDialog: {
    editGame: "Editar Segmento",
    createNewGame: "Criar Novo Segmento",
    updateGameSettings: "Atualize as configurações do segmento",
    configureNewGame: "Configure um novo segmento para sua escola",
    basicInfo: "Informações Básicas",
    gameName: "Nome do Segmento",
    required: "Obrigatório",
    gameNamePlaceholder: "Ex: Matemática Divertida, Inglês Quest...",
    gameNameRequired: "O nome do segmento é obrigatório",
    monthlyCoinsLimit: "Limite Mensal de Moedas",
    monthlyCoinsLimitTooltip: "Defina o máximo de moedas que professores podem dar aos alunos por mês",
    configureMaxMonthlyCoins: "Configure o limite máximo mensal de moedas para este segmento",
    limitEnabled: "Limite Ativado",
    noLimit: "Sem Limite",
    controlled: "Controlado",
    unlimited: "Ilimitado",
    limitEnabledDescription: "Professores terão um limite máximo de moedas por mês para criar missões e quizes",
    noLimitDescription: "Professores podem dar moedas ilimitadamente (sem controle mensal)",
    maxMonthlyLimit: "Limite Máximo Mensal",
    unlimitedModeActive: "Modo Ilimitado Ativado",
    unlimitedModeDescription: "Os professores podem dar quantas moedas quiserem aos alunos sem restrições mensais.",
    gameLanguage: "Idioma do Segmento",
    gameLanguageTooltip: "O idioma é escolhido apenas na criação do segmento e não pode ser alterado depois",
    selectLanguage: "Selecione o idioma para os textos padrões do segmento",
    fillRequiredFields: "Preencha todos os campos obrigatórios",
    updatingGame: "Atualizando segmento...",
    creatingGame: "Criando segmento...",
    waitAMoment: "Aguarde um momento...",
    updateGame: "Atualizar Segmento",
    createGame: "Criar Segmento",
    processError: "Erro ao processar solicitação",
  },
  gameLevelingConfig: {
    levelsAndRewards: "Configuração de Níveis e Recompensas",
    levelsConfigured: "{count} níveis configurados",
    level: "Nível {order}",
    confirmDelete: "Confirmar Exclusão",
    confirmDeleteDescription: "Tem certeza que deseja excluir o Nível {order}? Esta ação não pode ser desfeita.",
    levelImage: "Imagem do Nível",
    xpConfig: "Configuração de XP",
    xpForNextLevel: "XP necessário para próximo nível",
    range: "Faixa: {min} - {max} XP",
    difference: "Diferença: {diff} XP",
    rewards: "Recompensas",
    addNewLevel: "Adicionar Novo Nível",
    deleteAction: "Excluir",
    cancel: "Cancelar",
  },
  levelsConfig: {
    pageTitle: "Editar níveis do segmento",
    gameSavedSuccess: "Segmento salvo com sucesso.",
    gameSaveError: "Ocorreu um erro ao processar sua requisição. Tente novamente mais tarde.",
    saveLevels: "Salvar níveis",
  },
  gamesSelect: {
    allGames: "Todos os segmentos",
    gamesSelected: "{count} segmentos selecionados",
    searchGames: "Buscar segmentos...",
    noGamesFound: "Nenhum segmento encontrado.",
    noGamesAvailable: "Nenhum segmento disponível",
    selectGames: "Selecione os segmentos",
    selectAGame: "Selecione um segmento",
  },
  resetGamesForm: {
    whichGamesReset: "Quais segmentos vão ser zerados",
    whichPointsReset: "Quais pontos vão ser zerados",
    pointsTooltip: "Selecione qual ou quais moedas você deseja zerar, será aplicado em todos os jogadores do segmento selecionado.",
    missions: "Missões",
    missionsTooltip: "Marque apenas se quiser resetar as missões e permitir que os alunos possam realizá-las novamente.",
    resetMissions: "Resetar missões",
    reset: "Zerar",
    confirmResetTitle: "Tem certeza que deseja zerar os segmentos?",
    confirmResetDescription: "Zerar o segmento é uma ação irreversível, ao realiza-la todos os campos selecionados serão zerados e não poderão ser recuperados. Você realmente deseja continuar?",
    yesImSure: "Sim, tenho certeza!",
    selectAtLeastOne: "Você precisa selecionar pelo menos um segmento e pelo menos um ponto para continuar.",
    importFinished: "Processo de importação finalizado!",
  },
  activeSubscriptions: {
    yourPlans: "Seus Planos",
    yourPlansDescription: "Seus planos e próxima cobrança",
    plan: "plano",
    plans: "planos",
    noPlanFound: "Nenhum plano encontrado",
    errorLoadingPlans: "Erro ao carregar informações dos planos. Tente novamente mais tarde.",
    nextInvoice: "Próxima fatura",
    errorLoadingBreakdown: "Erro ao carregar breakdown da fatura.",
    description: "Descrição",
    qty: "Qtd",
    unitPrice: "Preço unitário",
    amount: "Valor",
    invoiceItem: "Item de fatura",
    item: "Item",
    proRata: "pró-rata",
    discount: "desconto",
    discounts: "Descontos",
    subtotal: "Subtotal",
    tax: "Imposto",
    total: "Total",
    nextCharge: "Próxima Cobrança",
    nextChargeOn: "Próxima cobrança em {{date}}",
    statusActive: "Ativo",
    statusPastDue: "Vencido",
    statusCanceled: "Cancelado",
    statusIncomplete: "Incompleto",
    statusTrialing: "Período de Teste",
    statusUnpaid: "Não Pago",
    statusPaused: "Pausado",
    statusExpired: "Expirado",
    perDay: "por dia",
    perWeek: "por semana",
    perMonth: "por mês",
    perYear: "por ano",
    every: "a cada {count} {interval}",
  },
  plans: {
    teacherPlanTitle: "Escolha seu plano de professor",
    schoolPlanTitle: "Escolha o plano da sua escola",
    teacherPlanSubtitle: "Escolha como quer entrar na Gamefik com o mesmo visual das novas páginas de planos, sem perder checkout, trial e seleção do signup.",
    schoolPlanSubtitle: "Última etapa antes de começar a gamificar a sua escola.",
    loadingPlans: "Carregando seus planos...",
    previewLocalhost: "Preview localhost",
    month: "mês",
    year: "ano",
    freeMonths: "{{count}} meses grátis",
    yearlySavings: "Maior economia no anual",
    onRequest: "Sob consulta",
    free: "Grátis",
    processing: "Processando...",
    compareFeatures: "Comparar todas as funcionalidades",
    feature: "Funcionalidade",
    noPlansFound: "Nenhum plano foi encontrado para este perfil agora. Tente novamente em alguns instantes.",
    dayLeft: "1 dia restante",
    daysLeft: "{{count}} dias restantes",
    trialEndsOn: "O trial termina em {{date}}. Depois disso, a conta volta para o plano Free se nenhuma assinatura for ativada.",
    plans: "Planos",
    inTrial: "no trial",
    schoolSelector: {
      socialProof: "Escolas no mundo todo confiam no Gamefik",
      trialTitle: "Quase lá. Comece seu trial de 14 dias sem cobrança.",
      trialDescription: "Cartão na próxima tela · Sem cobrança durante o trial · Email 3 dias antes do fim · Cancele e nada é debitado.",
      monthly: "Mensal",
      yearly: "Anual",
      yearlyBadge: "Maior economia no anual",
      cta: "Começar trial de 14 dias",
      ctaSubtext: "Cobrança só após o trial · Cancele quando quiser",
      processing: "Processando...",
      equivalentTo: "Equivale a {{price}} por mês",
      economyOf: "Economia de {{percent}}%",
      saveWithYearly: "Pague anual e economize {{percent}}%",
      addonHint: "Precisa de mais? Pacotes adicionais de alunos disponíveis",
      proExtrasTitle: "No Pro, além de tudo do Starter, você ganha:",
      proExtras: "moeda da escola · catálogo de recompensas · onboarding assistido · suporte dedicado com SLA",
      helpQuestion: "Em dúvida entre os planos?",
      helpLink: "Fale com nosso time",
      stripeNotice: "Pagamento processado pela Stripe",
      noCommitment: "Sem fidelidade ou multa de cancelamento",
      starterTag: "Comece pequeno",
      starterTagline: "Para pequenas escolas que querem crescer",
      starterBestFor: "Até 100 alunos · 15 professores",
      starterFeat1: "Até 100 alunos ativos",
      starterFeat2: "Até 15 professores",
      starterFeat3: "200 créditos de IA por professor / mês",
      starterFeat4: "Mural, comunicados e relatórios",
      starterFeat5: "Suporte por email",
      proTag: "Mais popular",
      proTagline: "Ideal para escolas em crescimento",
      proBestFor: "Até 300 alunos · professores ilimitados",
      proFeat1: "Até 300 alunos ativos",
      proFeat2: "Professores ilimitados",
      proFeat3: "500 créditos de IA por professor / mês",
      proFeat4: "Moeda da escola e recompensas",
      proFeat5: "Onboarding assistido",
      proFeat6: "Suporte dedicado com SLA",
    },
  },
  plansManagement: {
    tabLabel: "Planos",
    heading: "Gerenciar plano",
    subheading: "Gerencie sua assinatura, troque de plano e acompanhe cobranças.",
    currentPlan: "Plano atual",
    currentPlanDescription: "Detalhes da sua assinatura ativa",
    noPlanActive: "Nenhum plano ativo",
    noPlanActiveDescription: "Voce esta no Gamefik Free. Faca upgrade para desbloquear mais recursos.",
    planLabel: "Plano",
    statusLabel: "Status",
    cycleLabel: "Ciclo",
    currencyLabel: "Moeda",
    renewsOn: "Renova em {{date}}",
    trialEndsOn: "Trial termina em {{date}}",
    trialDaysLeft: "{{count}} dias restantes no trial",
    manageBilling: "Gerenciar no Stripe",
    manageBillingDescription: "Abra o portal do Stripe para gerenciar metodos de pagamento, faturas e cancelamentos.",
    changeOnStripe: "Mudar no Stripe",
    changePlan: "Trocar de plano",
    changePlanDescription: "Escolha um novo plano para sua conta.",
    upgradeCta: "Fazer upgrade",
    monthly: "Mensal",
    yearly: "Anual",
    proRataTitle: "Regras de alteracao de plano",
    proRataUpgrade: "Upgrade no meio do ciclo: cobranca proporcional imediata pelo valor restante do periodo.",
    proRataDowngrade: "Downgrade: credito proporcional aplicado automaticamente na proxima fatura.",
    proRataCycleChange: "Troca de ciclo (mensal para anual): cobranca do valor anual com credito do periodo mensal restante.",
    proRataNote: "Todas as alteracoes sao processadas pelo Stripe com calculo automatico de pro rata.",
    selectPlan: "Selecionar este plano",
    currentPlanBadge: "Plano atual",
    contactSales: "Falar com vendas",
    nextInvoice: "Proxima fatura",
    nextInvoiceDescription: "Previsao da proxima cobranca com base na assinatura ativa.",
    billingProfileSection: "Dados de faturamento",
    free: "Gratuito",
    perMonth: "/mês",
    perYear: "/ano",
    perTeacherShort: "/prof",
    closePlanSelector: "Fechar",
    openingStripe: "Abrindo Stripe...",
    plansTitle: "Planos Gamefik",
    plansSubtitle: "Desbloqueie todo o potencial da plataforma",
    billingPeriodToggle: "Alternar periodo de cobranca",
    cancelationScheduled: "Cancelamento agendado",
    keepPlan: "Manter plano",
    cancelNow: "Cancelar agora",
    cancelToFree: "Cancelar para Free",
    downgradeCta: "Fazer downgrade",
    switchToYearly: "Mudar para anual",
    switchToMonthly: "Mudar para mensal",
    cancellationConfirmed: "Cancelamento confirmado",
    nextPlanBadge: "Seu proximo plano",
    consumptionHeading: "Seu consumo atual",
    consumptionDescription: "Acompanhe o uso dos recursos do seu plano.",
    limit: "Limite",
    almostThere: "Quase la",
    unlimited: "Ilimitado",
    noLimit: "sem limite",
    ofMax: "de {{max}}",
    dayLeft: "dia restante",
    daysLeft: "dias restantes",
    accessUntil: "Acesso ate",
    cancellationInfo: "Voce ainda tem acesso a todas as funcionalidades do {{plan}} ate o fim do periodo. Depois disso, sua conta volta automaticamente para o plano Gamefik Free.",
    cancelNowWarning: "Cancelar agora encerra o acesso imediatamente, sem aguardar o fim do periodo. Nao geramos reembolso automatico do valor proporcional.",
    compareFeatures: "Comparar todas as funcionalidades",
    feature: "Funcionalidade",
    syncTimedOut: "A sincronizacao com o Stripe esta demorando mais do que o esperado. A tela vai mostrar o ultimo estado conhecido ate a atualizacao chegar.",
    stripeSyncingChange: "Aguardando o Stripe sincronizar sua alteracao de plano...",
    stripeSyncingUpdate: "Aguardando o Stripe sincronizar a atualizacao da assinatura...",
    syncingAutomatically: "Estamos sincronizando automaticamente o status da assinatura. Isso pode levar alguns segundos.",
    updateStatusNow: "Atualizar status agora",
    viewPlanOptions: "Ver opcoes de plano",
    planSaved: "Plano salvo",
    stripeSyncing: "Sincronizando Stripe",
    planSavedDescription: "Seu plano atual esta salvo no cadastro da conta.",
    stripeSyncingDescription: "Seu plano ja foi salvo. Estamos aguardando a assinatura chegar do Stripe.",
    paymentProblem: "Seu plano esta com problemas de pagamento ({{status}}). Seu consumo esta temporariamente limitado ao plano {{plan}} ate a regularizacao.",
    activeUntil: "Ativo ate {{date}}",
    endOfPeriod: "o fim do periodo",
    classes: "Turmas",
    students: "Alunos",
    activitiesCreated: "Atividades criadas",
    wallPosts: "Comunicados",
    aiCredits: "Creditos IA",
    syncSuccess: "Plano sincronizado com o Stripe.",
    syncTimeoutWarning: "O Stripe ainda esta sincronizando sua alteracao. Atualize novamente em alguns instantes.",
    syncError: "Erro ao sincronizar planos com Stripe:",
    cannotOpenStripe: "Nao foi possivel abrir o portal do Stripe agora. Tente novamente.",
    cannotStartCheckout: "Nao foi possivel iniciar o checkout agora. Tente novamente.",
    cannotIdentifySubscription: "Nao foi possivel identificar a assinatura atual para trocar de plano.",
    cannotIdentifySubscriptionItem: "Nao foi possivel identificar o item da assinatura para trocar de plano.",
    cannotOpenPlanChange: "Nao foi possivel abrir a troca de plano no Stripe agora. Tente novamente.",
    changingPlan: "Alterando plano...",
    syncing: "Sincronizando...",
    planChangedSuccess: "Plano alterado com sucesso mantendo os dias restantes do trial.",
    done: "Concluido!",
    cannotChangeTrialPlan: "Nao foi possivel alterar o plano do trial agora.",
    noActiveSubscription: "Nenhuma assinatura ativa para cancelar.",
    canceling: "Cancelando...",
    updatingData: "Atualizando dados...",
    cancelScheduledSuccess: "Cancelamento agendado. Seu plano atual continua ativo ate a data de vencimento.",
    cannotCancelSubscription: "Nao foi possivel cancelar a assinatura agora.",
    addonUpdateUnavailable: "A atualizacao de add-ons esta temporariamente indisponivel. Aguarde a atualizacao do sistema e tente novamente.",
    aiCoverageIncomplete: "Cobertura incompleta da IA Ilimitada",
    aiCoverageIncompleteBadge: "Cobertura incompleta",
    aiSeatsPurchased: "Assentos contratados",
    aiTeachersEligible: "Professores elegiveis",
    aiCoverageDeficit: "Deficit",
    aiCoverageSyncCta: "Ajustar para {{count}} assentos",
    aiCoverageSyncSuccess: "Quantidade de assentos ajustada com sucesso.",
    aiCoverageSyncError: "Nao foi possivel ajustar os assentos da IA Ilimitada.",
    aiCoverageUnknown: "A cobertura de IA ainda nao foi confirmada pelo servidor. A contratacao fica bloqueada ate a atualizacao.",
    aiNoEligibleTeachers: "Nao ha professores elegiveis nesta conta. Nenhuma cobranca de IA pode ser criada.",
    aiAddonRedundant: "A IA ilimitada ja esta inclusa no plano-base.",
    aiAddonRedundantDescription: "Este add-on e redundante e pode continuar gerando cobranca. Cancele-o sem aumentar a quantidade.",
    aiAddonCancelRedundant: "Cancelar add-on redundante",
    cancelingNow: "Cancelando agora...",
    cancelImmediatelySuccess: "Plano cancelado imediatamente. Sua conta voltou para o Gamefik Free.",
    cannotCancelNow: "Nao foi possivel cancelar agora.",
    reverting: "Revertendo...",
    revertSuccess: "Cancelamento revertido! Seu plano foi mantido.",
    cannotRevertCancellation: "Nao foi possivel reverter o cancelamento agora.",
  },
  planFeatures: {
    teacher: {
      activeClasses: "Turmas ativas",
      totalStudents: "Alunos totais",
      activitiesPerMonth: "Atividades/mes",
      trails: "Trilhas",
      aiCreditsPerMonth: "Creditos de IA/mes",
      xpAndBadges: "XP e badges",
      gems: "Gemas (moeda padrao)",
      customCurrency: "Moeda personalizada",
      rewards: "Recompensas",
      announcementsPerMonth: "Comunicados/mes",
    },
    school: {
      activeStudentsBase: "Alunos ativos (base)",
      teachers: "Professores",
      addon50Students: "Add-on +50 alunos",
      activities: "Atividades",
      aiCreditsPerTeacher: "Creditos de IA (por prof)",
      addonUnlimitedAI: "Add-on IA ilimitada",
      xpAndBadges: "XP e badges",
      customCurrency: "Moeda personalizada",
      rewardCatalog: "Catalogo de recompensas",
      rewardsPerClass: "Recompensas por turma",
      adminPanel: "Painel admin",
      assistedOnboarding: "Onboarding assistido",
      lmsIntegration: "Integracao LMS",
      dedicatedSupport: "Suporte dedicado + SLA",
    },
    unlimited: "Ilimitado",
    unlimitedFem: "Ilimitadas",
    unlimitedMasc: "Ilimitados",
    upTo2: "Ate 2",
    upTo30: "Ate 30",
    upTo50: "Ate 50",
    upTo100: "Ate 100",
    upTo15: "Ate 15",
    upTo300: "Ate 300",
    perMonth: "/mes",
    included: "Incluso",
    nA: "N/A",
    consumesCredits: "Consome creditos",
    oneTotal: "1 total",
    threePerMonth: "3 por mes",
    yes: "Sim",
    no: "Nao",
    highlights: {
      upTo2Classes: "Turmas ilimitadas",
      upTo30Students: "Ate 50 alunos",
      fiveActivitiesMonth: "5 atividades/mes",
      twoHundredAiCreditsMonth: "200 creditos de IA/mes",
      xpAndBadges: "XP e badges",
      gemsDefaultCurrency: "Gemas (moeda padrao)",
      unlimitedClasses: "Turmas ilimitadas",
      unlimitedActivities: "Atividades ilimitadas",
      fiveHundredAiCreditsMonth: "500 creditos de IA/mes",
      unlimitedAnnouncements: "Comunicados ilimitados",
      customCurrency: "Moeda personalizada",
      unlimitedAI: "IA ilimitada",
      exclusiveRewards: "Recompensas exclusivas",
      rewardStore: "Loja de recompensas",
      prioritySupport: "Suporte prioritario",
      upTo100Students: "Ate 100 alunos",
      upTo15Teachers: "Ate 15 professores",
      adminPanel: "Painel administrativo",
      consolidatedReports: "Relatorios consolidados",
      upTo300Students: "Ate 300 alunos",
      unlimitedTeachers: "Professores ilimitados",
      rewardCatalog: "Catalogo de recompensas",
      unlimitedStudents: "Alunos ilimitados",
      oneTrailTotal: "1 trilha total",
      threeAnnouncementsMonth: "3 comunicados por mes",
      unlimitedTeacherCore: "Turmas, alunos e atividades ilimitados",
      unlimitedAIIncluded: "IA ilimitada inclusa",
      rewardsPerClass: "Recompensas por turma",
      lmsIntegration: "Integracao LMS",
      multiUnits: "Multi-unidades",
      customContract: "Contrato customizado",
    },
    presentation: {
      freeTitle: "Gamefik Free",
      freeCta: "Comecar gratis",
      freePriceLabel: "Gratis",
      freePriceDetail: "Para sempre",
      epicSubtitle: "Desbloqueie todo o potencial",
      epicHighlightIntro: "Tudo do Free, e mais:",
      epicBadge: "Mais popular",
      epicCta: "Assinar agora",
      epicMonthlyFootnote: "Cancele quando quiser",
      shinySubtitle: "O maximo da gamificacao",
      shinyHighlightIntro: "Recursos premium para sua gamificacao:",
      shinyBadge: "Exclusivo",
      shinyCta: "Seja Shiny",
      shinyMonthlyFootnote: "Cancele quando quiser",
      starterCta: "Comecar trial de 14 dias",
      starterMonthlyFootnote: "Trial 14 dias - cartao obrigatorio",
      proSubtitle: "Ideal para escolas em crescimento",
      proHighlightIntro: "Tudo do Starter, e mais:",
      proBadge: "Mais popular",
      proCta: "Comecar trial de 14 dias",
      proMonthlyFootnote: "Trial 14 dias",
      enterpriseSubtitle: "Tudo do Pro, e mais:",
      enterpriseCta: "Fale com vendas",
      enterprisePriceLabel: "Sob consulta",
    },
  },
  billingProfile: {
    title: "Dados de Faturamento",
    description: "Informações usadas nas cobranças e notas fiscais",
    stripeAccount: "Conta no Stripe",
    nameLabel: "Nome/Razão Social",
    emailLabel: "E-mail",
    phoneLabel: "Telefone",
    addressLine1: "Endereço (linha 1)",
    addressLine2: "Complemento",
    city: "Cidade",
    state: "Estado",
    postalCode: "CEP",
    country: "País",
    taxDocument: "Documento Fiscal",
    number: "Número",
    select: "Selecione",
    saveSuccess: "Dados de faturamento atualizados",
    saveError: "Erro ao salvar dados de faturamento",
    addressManagedInStripe: "O endereço de cobrança é gerenciado diretamente no Stripe.",
    editAddressOnStripe: "Editar endereço no Stripe",
    vatEU: "VAT (UE)",
    other: "Outro",
  },
  gameList: {
    noGameFound: "Nenhum segmento encontrado",
    createFirstGame: "Crie seu primeiro segmento para começar a gerenciar pontos e recompensas para seus jogadores.",
    game: "Segmento",
    scoring: "Pontuação",
    coinsLimit: "Limite de Coins",
    limitNotDefined: "Limite não definido",
    noLimitLabel: "Sem limite",
    openMenu: "Abrir menu",
    editGame: "Editar Segmento",
    configureLevels: "Configurar Níveis",
    deleteGame: "Deletar Segmento",
  },
  modalGameLimit: {
    teacherMissions: "Missões dos professores",
    attentionTeacherMissions: "Seus professores agora podem criar e aprovar missões.",
    defineCoinsLimit: "Defina abaixo o limite de coins que cada professor receberá por mês para aplicar em cada uma de suas turmas.",
    unlimitedLabel: "Ilimitado",
    withLimit: "Com limite",
    coinsPerMonth: "{count} coins/mês",
    schoolsWithTeacherMissions: "Escolas nas quais os professores criam missões tem um resultado expressivamente melhor com a Gamefik!",
    featureEnabled: "Recurso ativado",
    featureDisabled: "Recurso desativado",
    featureToggleSuccess: "Recurso {status} com sucesso",
    enabled: "ativado",
    disabled: "desativado",
    featureToggleError: "Erro ao ativar/desativar recurso",
    updateCoinsError: "Erro ao atualizar limite de coins",
  },
  coinsLimits: {
    checkCoinsLimitByClass: "Verifique abaixo qual o limite de moedas por turma",
    classesCannotCreateMissions: "As seguintes turmas não podem criar missões:",
    limitReached: "{name}: limite atingido ({used} / {total})",
    classColumn: "Turma",
    usedLimit: "Limite Utilizado",
    remainingCoins: "Coins restantes",
    available: "Disponível",
    classMissions: "Missões desta turma",
    viewMissions: "missões",
    createdBy: "Criado por:",
    createdAt: "Criado em:",
    checkLimit: "Consultar limite",
    returnButton: "Retornar",
  },
  userManagement: {
    addUser: "Adicionar Usuário",
    importLabel: "Importar",
    importUsersTitle: "Importar Usuários",
    importUsersDescription: "Importe múltiplos usuários usando um arquivo CSV",
    startImport: "Começar Importação",
    importUsersBatchTitle: "Importar Usuários em Lote",
    importUsersBatchDescription: "Importe múltiplos usuários de uma vez usando um arquivo CSV",
    downloadTemplate: "Baixe o modelo do arquivo",
    downloadTemplateDescription: "Primeiro, baixe o arquivo modelo, preencha com os emails dos usuários e envie aqui.",
    downloadTemplateButton: "Fazer Download do Modelo",
    alreadyHaveFile: "Já tenho o arquivo preenchido",
    sendSpreadsheet: "Envie a planilha preenchida",
    verifyEmails: "Verifique se todos os emails estão corretos antes de enviar os convites.",
    selectCsvFile: "Selecione o arquivo CSV com os emails dos professores",
    noValidEmails: "Nenhum email válido encontrado no arquivo. Verifique se a coluna se chama 'Email' ou 'E-mail'.",
    emailsFound: "{count} email(s) encontrado(s)! Role para baixo para ver o preview e enviar os convites.",
    previewUsers: "Preview dos Usuários ({count})",
    verifyBeforeSending: "Verifique os emails antes de enviar os convites",
    email: "Email",
    status: "Status",
    sent: "Enviado",
    error: "Erro",
    waiting: "Aguardando",
    continue: "Continuar",
    sendInvites: "Enviar Convites ({{count}})",
    inviteSentSuccess: "Convite enviado com sucesso",
    inviteSendError: "Erro ao enviar convite",
    totalUsers: "Total de Usuários",
    administrators: "Administradores",
    teachers: "Professores",
    pendingInvites: "Convites Pendentes",
    userListTitle: "Lista de Usuários",
    userListDescription: "Visualize e gerencie todos os usuários do sistema",
    user: "Usuário",
    roles: "Funções",
    classes: "Turmas",
    actions: "Ações",
    pending: "Pendente",
    active: "Ativo",
    registered: "Registrado",
    resendingInvite: "Reenviando convite...",
    inviteResentTitle: "Convite Reenviado com Sucesso",
    inviteResentDescription: "O link de convite foi gerado. Você pode copiá-lo ou enviá-lo por email.",
    accessLink: "Link de acesso:",
    copyButton: "Copiar",
    attentionAutoFail: "Se o envio automático falhar, você pode enviar o convite manualmente.",
    sendEmailManually: "Enviar email manualmente",
    inviteResentSuccess: "Convite reenviado com sucesso!",
    resendInviteError: "Erro ao reenviar convite",
    linkCopied: "Link copiado para a área de transferência!",
    generatingAccess: "Gerando acesso seguro...",
    openingAccess: "Abrindo acesso em nova aba...",
    generateTokenError: "Erro ao gerar token de acesso",
    impersonateNotAllowed: "Você não pode acessar como este usuário: o nível de acesso dele não é menor que o seu.",
    noName: "Sem nome",
    accessAsUser: "Acessar como Usuário",
    viewEdit: "Visualizar/Editar",
    resendInvite: "Reenviar Convite",
    manageClasses: "Gerenciar Turmas",
    removeUser: "Remover Usuário",
    noUsersFound: "Nenhum usuário encontrado",
    addFirstUser: "Adicionar primeiro usuário",
    searchUsersPlaceholder: "Buscar por nome ou e-mail...",
    searchUsersAriaLabel: "Buscar usuários por nome ou e-mail",
    clearSearch: "Limpar busca",
    searchResultsCount: "{count} de {total} usuários",
    noUsersForSearch: "Nenhum usuário encontrado para \"{search}\"",
    noUsersForSearchHint: "Tente buscar por outro nome ou e-mail.",
    noClasses: "Nenhuma turma",
    classesNotFound: "Turmas não encontradas",
    classesCount: "{count} turmas",
    roleAdmin: "Administrador",
    roleManager: "Gestor",
    roleSecretary: "Secretário",
    roleTeacher: "Professor",
    roleSchoolTeacher: "Professor da escola",
    roleAdminFull: "Administrador(a)",
    roleManagerFull: "Gestor(a)",
    roleSecretaryFull: "Secretário(a)",
    roleTeacherFull: "Professor(a)",
    roleSchoolTeacherFull: "Professor(a) da escola",
    inviteSubject: "Convite para acesso ao sistema",
    inviteBody: "Olá!\n\nVocê foi convidado para acessar o sistema. Use o link abaixo para completar seu cadastro:\n\n{link}\n\nAtenciosamente.",
    importLimitedByPlan: "Seu plano permite adicionar mais {{remaining}} professor(es). {{excess}} email(s) foram removidos da importação.",
  },
  modalRemoveUser: {
    title: "Remover acesso à escola",
    subtitle: "Revise o impacto antes de remover {name}.",
    scopeTitle: "O usuário não será apagado",
    scopeDescription: "Esta ação remove somente o acesso à escola atual. Contas em outras escolas, conteúdos criados e autoria histórica serão preservados.",
    loadingImpact: "Verificando impacto",
    loadingImpactDescription: "Estamos consultando as turmas vinculadas na fonte primária.",
    previewErrorTitle: "Não foi possível verificar o impacto",
    previewErrorDescription: "Nenhuma alteração foi feita. Tente carregar os dados novamente antes de confirmar.",
    retry: "Tentar novamente",
    ownerBlockTitle: "O proprietário não pode ser removido",
    ownerBlockDescription: "Transfira primeiro a propriedade da escola para outro administrador e volte a esta tela.",
    impactTitle: "O que será afetado",
    impactDescription: "Ao confirmar, o vínculo com esta escola será removido com segurança.",
    classesAffected: "turmas vinculadas",
    preservedTitle: "O que será preservado",
    preserved: {
      other_accounts: "Acesso do usuário a outras escolas",
      historical_authorship: "Autoria e histórico das ações já realizadas",
      school_content: "Turmas, atividades e conteúdos da escola",
    },
    progressTitle: "Remoção em andamento",
    progressDescription: "Estamos revogando o vínculo com esta escola. Não feche esta janela; uma repetição segura usa a mesma operação.",
    partialErrorTitle: "A remoção foi concluída parcialmente",
    partialErrorDescription: "Algumas etapas já foram aplicadas. Tente novamente para retomar a mesma operação sem duplicar alterações.",
    removeErrorTitle: "Não foi possível remover o acesso",
    removeErrorDescription: "Nenhuma confirmação de conclusão foi recebida. Tente novamente ou contate o suporte se o problema continuar.",
    successTitle: "Acesso removido com segurança",
    successDescription: "O vínculo com esta escola foi revogado com segurança.",
    cancelButton: "Cancelar",
    deleteButton: "Remover acesso",
    finishButton: "Concluir",
  },
  voiceSearch: {
    start: "Pesquisar por voz",
    stop: "Parar pesquisa por voz",
    error: "Não foi possível usar a pesquisa por voz. Continue digitando.",
  },
  modalSelectClasses: {
    selectClassesFor: "Selecione as turmas de {name}",
    classesPlaceholder: "Turmas",
    addButton: "Adicionar",
    addSuccess: "Turma(s) adicionadas com sucesso",
    addError: "Houve um erro ao adicionar turma",
    searchPlaceholder: "Buscar turma...",
    noClassFound: "Nenhuma turma encontrada.",
    selectedCount: "{{count}} turma(s) selecionada(s)",
    loadError: "Não foi possível carregar as turmas do usuário.",
    retry: "Tentar novamente",
    segmentLoading: "Carregando segmento...",
    segmentsLoadError: "Segmentos indisponíveis",
    segmentUnavailable: "Segmento não identificado",
  },
  sendInvitation: {
    sendInvite: "Enviar Convite",
    emailLabel: "E-mail *",
    emailPlaceholder: "Digite o e-mail",
    permissionLabel: "Permissão *",
    selectPermission: "Selecione uma permissão",
    classesLabel: "Turmas *",
    searchClasses: "Digite para buscar turmas...",
    noClassSelected: "Nenhuma turma selecionada",
    noClassFound: "Nenhuma turma encontrada",
    clickToSelect: "Clique para selecionar/desselecionar turmas",
    selected: "Selecionado",
    selectAtLeastOneClass: "Selecione ao menos uma turma para enviar o convite",
    sending: "Enviando...",
    sendButton: "Enviar Convite",
    invitesSentSuccess: "Convites enviados com sucesso",
    invitesSentPartially: "Convites enviados parcialmente!",
    segmentLoading: "Carregando segmento...",
    segmentsLoadError: "Segmentos indisponíveis",
    segmentUnavailable: "Segmento não identificado",
  },
  viewUser: {
    editUser: "Editar Usuário",
    editUserDescription: "Visualize e edite as informações e permissões do usuário",
    noName: "Sem nome",
    verified: "Verificado",
    notVerified: "Não verificado",
    personalInfo: "Informações Pessoais",
    fullName: "Nome Completo",
    emailLabel: "E-mail",
    genderLabel: "Gênero",
    genderMale: "Masculino",
    genderFemale: "Feminino",
    genderOther: "Outro",
    genderNotInformed: "Não informado",
    settingsTitle: "Configurações",
    groupPermission: "Grupo/Permissão",
    selectGroup: "Selecione um grupo",
    birthDate: "Data de Nascimento",
    memberSince: "Membro desde",
    notInformed: "Não informado",
    invalidDate: "Data inválida",
    permissionChangeWarning: "Você está alterando as permissões deste usuário de <strong>{from}</strong> para <strong>{to}</strong>. Esta ação afetará o acesso do usuário ao sistema.",
    selectGroupError: "Por favor, selecione um grupo para o usuário",
    updateSuccess: "Permissões do usuário atualizadas com sucesso!",
    updateError: "Erro ao atualizar permissões do usuário",
    saving: "Salvando...",
    saveChanges: "Salvar Alterações",
  },
  userTypeTag: {
    legacyAdmin: "Admin · Legado",
    legacyManager: "Gestor · Legado",
    legacySecretary: "Secretário · Legado",
    legacyTeacher: "Professor · Legado",
    nmgTeacher: "Professor · NMG",
    nmgSchool: "Escola · NMG",
    nmgSchoolTeacher: "Professor-Escola · NMG",
  },
  rowUser: {
    editPermissions: "Editar permissões",
    editClasses: "Editar turmas",
    resendInviteLabel: "Reenviar convite",
    remove: "Remover",
    emailVerified: "E-mail verificado",
    emailNotVerified: "E-mail não verificado",
    loading: "Carregando...",
    lastUsedOn: "Último uso em {date}",
    neverUsed: "Nunca usou",
    userCreatedOn: "Usuário criado em {date}",
    unknown: "Desconhecido",
  },
  registerUser: {
    next: "PRÓXIMO",
    previous: "ANTERIOR",
    stepOf: "Passo {step} de {total}",
    wantToKnowMore: "Queremos saber um pouco mais sobre você ",
    invalidName: "Nome inválido",
    fullName: "Nome completo",
    sex: "Sexo",
    male: "Masculino",
    female: "Feminino",
    preferNotToSay: "Prefiro não informar",
    birthDate: "Data de Nascimento",
    schoolRole: "Qual o seu papel na escola?",
    teacher: "Professor",
    coordinator: "Coordenador",
    secretary: "Secretária(o)",
    others: "Outros",
    registrationSuccess: "Parabéns, seu cadastro está concluído!",
    registrationError: "Desculpe, um erro ocorreu ao completar seu cadastro, por favor entre em contato com o suporte.",
  },
  dialogRegisterAdmin: {
    newAccountIntro: "Conheça a nova conta gamefik",
    newAccountDescription: "A partir de agora você vai poder ter uma conta com uma senha exclusiva para acessar a conta Gamefik da sua escola e também criar uma conta exclusiva com acesso as informações da sua escola para cada membro da sua equipe.",
    readyToCreate: "E ai? Gostou? Então vamos criar a sua conta?",
    areYouManager: "Você é um gestor(a)?",
    yes: "Sim",
    no: "Não",
    whatIsYourEmail: "Qual o seu e-mail?",
    invalidEmail: "E-mail inválido",
    chooseNewPassword: "Escolha uma <strong>nova senha</strong> para o seu usuário individual.",
    passwordRequirements: "A senha deve conter no mínimo 6 caracteres. A senha não deve conter símbolos (@,#,%,ˆ,& )",
    invalidPassword: "Senha inválida",
    newPassword: "Nova senha",
    confirmNewPassword: "Confirmar nova senha",
    passwordsDontMatch: "As senha estão diferentes",
    almostThere: "Estamos quase lá!",
    confirmData: "Precisamos que você confirme os dados que nos informou. Depois que clicar em continuar não será possivel desfazer essa ação.",
    name: "Nome:",
    emailConfirm: "E-mail:",
    gender: "Gênero:",
    birthDateConfirm: "Data de nascimento:",
    schoolName: "Nome da escola:",
    contact: "Contato:",
    createUserError: "Ocorreu um erro ao criar o usuário, por favor tente novamente ou entre em contato com o suporte!",
    emailVerificationCode: "Você recebeu em seu e-mail (<strong>{email}</strong>) um <strong>código</strong> para a validação dos seus dados. Por favor, insira este código no campo abaixo.",
    code: "Código",
    resend: "Reenviar",
    accountCreatedSuccess: "Sua conta foi criada com sucesso.",
    addTeamMembers: "Agora você pode adicionar outros membros da sua equipe clicando",
    here: "aqui",
    onlyManagerAction: "Somente o gestor pode realizar esta ação!",
    contactManager: "Por favor comunique o gestor de sua escola.",
    schoolInfoNeeded: "Precisamos de algumas informações sobre a sua escola para completar o cadastro.",
    schoolNameLabel: "Nome da escola",
    nameTooShort: "Nome muito curto",
    telephone: "Telefone",
    invalidNumber: "Número Inválido",
    next: "PRÓXIMO",
    cancelButton: "CANCELAR",
  },
  dialogRegisterAccount: {
    welcome: "Seja bem-vindo à Gamefik!",
    welcomeDescription: "Para seguir seu cadastro precisaremos de alguns dados. Vamos lá?",
    choosePassword: "Escolha uma <strong>senha</strong> para o seu usuário individual.",
    profession: "Profissão",
    professionConfirm: "Profissão:",
    schoolCode: "O código da sua escola é : {code}",
    explorePlatform: "Agora você pode conhecer nossa plataforma clicando",
  },
  seletorUnidade: {
    switchUnitError: "Erro ao trocar de unidade",
  },
  iaCreditsExhausted: {
    creditsExhausted: "Créditos Esgotados",
    monthlyCreditsExhausted: "Seus créditos de IA do mês acabaram",
    missionsQuizzesWithAI: "Missões/Quizzes com IA",
    wantUnlimitedAI: "Quer contratar o pacote de IA ilimitado?",
    contractUnlimitedAI: "Contratar IA Ilimitada",
    contactAdminToContract: "Fale com o administrador da escola para contratar IA ilimitada.",
    notNow: "Agora não",
    creditsNeeded: "Você precisa de {{needed}} créditos pra criar com IA",
    adjustNeeded: "Cada ajuste no chat custa 10 créditos",
    muralAdjustNeeded: "Cada sugestão de texto do Mural custa 10 créditos",
    creditsAvailable: "Créditos disponíveis",
    usedThisMonth: "{{count}} comprometidos neste mês",
    quizContext: "Contexto: quiz",
    missionContext: "Contexto: missão",
    trailContext: "Contexto: trilha",
    muralContext: "Contexto: Mural",
    teacherEpicName: "Teacher Epic",
    teacherShinyName: "Teacher Shiny",
    mostPopular: "Mais popular",
    exclusive: "Exclusivo",
    unlimitedClasses: "Turmas ilimitadas",
    unlimitedStudents: "Alunos ilimitados",
    unlimitedActivities: "Atividades ilimitadas",
    aiCreditsPerMonth: "{{count}} créditos de IA/mês",
    customCurrency: "Moeda personalizada",
    unlimitedAI: "IA ilimitada",
    exclusiveRewards: "Recompensas exclusivas",
    onboardingAssisted: "Onboarding assistido",
    rewardStore: "Loja de recompensas",
    prioritySupport: "Suporte prioritário",
    monthShort: "/mês",
    unlockWithEpic: "Desbloquear com Epic",
    becomeShiny: "Virar Shiny",
  },
  iaUpgrade: {
    upgradeToAI: "Upgrade para Recursos de IA",
    reachedFreeLimit: "Você atingiu o limite mensal de criações gratuitas de {type}",
    activateForUnlimited: "Ative a IA para criações ilimitadas de {type}",
    currentPlanFree: "Plano Atual - Gratuito",
    aiCreationsThisMonth: "Criações de {type} com IA este mês:",
    remainingFreeCreations: "Restam {count} criações gratuitas este mês",
    monthlyLimitReached: "Limite mensal atingido - upgrade necessário para continuar",
    planWithAI: "Plano com IA",
    recommended: "Recomendado",
    enhanceExperience: "Aprimore sua experiência Gamefik com recursos baseados em IA",
    unlimitedCreations: "Criações ilimitadas de {type} com IA",
    autoAnalysis: "Análise automática de comprovantes por IA",
    smartFeedback: "Feedback inteligente para alunos",
    autoSuggestions: "Sugestões automáticas de melhorias",
    advancedReports: "Relatórios avançados com insights de IA",
    continueFreePlan: "Continuar com Plano Gratuito",
    activateAIResources: "Ativar Recursos de IA",
    freeResetInfo: "O limite de criações gratuitas é resetado todo dia 1º do mês",
  },
  xpResetModal: {
    xpResetDescription: "Queremos garantir que você entenda sua escolha",
    xpSystemUpdate: "Atualização do Sistema de XP",
    configureXpMigration: "Configure como deseja migrar o XP dos alunos",
    newAppLaunched: "A Gamefik lançou o <strong>Novo App do aluno</strong> com uma jornada incrível e mudanças importantes. Agora as escolas não precisam gerenciar a evolução de nível, nosso sistema cuida disso automaticamente. Alunos podem alcançar o <strong>level 100</strong>.",
    wantToKnowMore: "Quer saber mais?",
    clickHere: "Clique aqui",
    suggestResetXp: "Sugerimos fortemente zerar o XP para todos aproveitarem 100% a experiência do novo app.",
    dontReset: "Não Zerar",
    resetXp: "Zerar XP",
    areYouSure: "Tem certeza?",
    ensureChoice: "Queremos garantir que você entenda sua escolha",
    recommendReset: "Recomendamos zerar o XP para que todos aproveitem 100% a experiência do novo app.",
    newSystemDescription: "O novo sistema oferece uma jornada completa e equilibrada desde o início, com níveis até 100 e evolução automática.",
    understoodDontReset: "Entendi, mas não vou zerar",
    understoodWantReset: "Entendi, quero Zerar XP",
  },
  xpResetMigrationGate: {
    noGamesToReset: "Não encontramos segmentos para zerar o XP. Tente novamente em alguns segundos.",
    xpResetSuccess: "XP zerado com sucesso!",
    xpResetSaveError: "XP zerado, mas não foi possível salvar sua escolha. O aviso pode aparecer novamente.",
    xpResetError: "Não foi possível zerar o XP. Tente novamente.",
    decisionSaveError: "Não foi possível salvar sua escolha. O aviso pode aparecer novamente.",
    decisionRegistered: "Opção registrada. Nenhuma alteração foi feita no XP dos alunos.",
    noGamesForReset: "Nenhum segmento para resetar.",
  },
  aiCreditsDisplay: {
    iaCredits: "créditos IA",
    iaCreditsTitle: "Créditos de IA",
    creditsAvailable: "{count} créditos disponíveis",
    lowCredits: "Créditos baixos! Considere recarregar.",
    monthlyMovements: "Movimentações de IA (mês atual)",
    loadingLabel: "Carregando...",
    loadError: "Erro ao carregar movimentações de créditos de IA.",
    noMovements: "Nenhuma movimentação registrada neste mês.",
    creationWithAI: "Criação com IA",
    zeroedHere: "Zerou aqui",
    unlimitedAI: "IA Ilimitada",
    unlimitedAIDescription: "Crie quantas missões, quizzes e conteúdos quiser com IA, sem se preocupar com créditos.",
    contract: "Contratar",
    contactAdminToContract: "Fale com o administrador da escola para contratar",
    unlimitedFromPlan: "IA ilimitada conforme seu plano atual",
    currentPlanBudget: "Orçamento de IA do plano atual",
    planLabel: "Plano",
    limitSourceLabel: "Origem do limite",
    monthlyLimitLabel: "Limite mensal",
    usedInMonthLabel: "Usado no mês",
    availableLabel: "Disponível",
    unlimitedLabel: "Ilimitado",
    overrideAppliedBadge: "Override de limite aplicado",
    sourceAccountOverride: "Override configurado na conta",
    sourcePlanLimit: "Limite do plano atual",
    sourcePlanUnlimited: "Plano com IA ilimitada",
    sourcePremium: "Pacote IA premium",
    sourceLegacy: "Limite legado da conta",
    modalSubtitle: "Seu consumo mensal",
    remainingCreditsLabel: "Créditos restantes",
    reservedInProgress: "{{count}} créditos reservados em gerações em andamento",
    renewsOnFirstOfMonth: "Renova em 1 de {{month}}",
    recentActivityTitle: "Atividade recente",
    needMoreCreditsCta: "Precisa de mais créditos?",
    planEpicMonthly: "500 créditos/mês",
    viewPlanButton: "Ver plano {{plan}}",
    backButton: "Voltar",
    detailRowType: "Tipo",
    detailRowReason: "Motivo",
    detailRowWhen: "Quando",
    detailRowUser: "Usuário",
    detailRowCost: "Custo",
    detailRowId: "ID",
    costCreditsOne: "{{count}} crédito",
    costCreditsOther: "{{count}} créditos",
    reasonCreateMissionAI: "Criação de missão com IA",
    reasonCreateQuizAI: "Criação de quiz com IA",
    reasonAdjustChatAI: "Ajuste/iteração no chat com IA",
    reasonComprovantesOnCreation: "Comprovante incluído na criação da atividade",
    reasonDefault: "Consumo de créditos",
    itemQuiz: "Quiz",
    itemMission: "Missão",
    dateToday: "Hoje, {{time}}",
    dateYesterday: "Ontem, {{time}}",
  },
  iaContractCta: {
    unlimitedAIActive: "IA Ilimitada ativa",
    unlimitedAIPackage: "Pacote IA Ilimitada",
    manageDescription: "Seu pacote IA Ilimitada está ativo. Você pode gerenciar sua assinatura e cobrança nas configurações.",
    upgradeDescription: "Sua conta não possui créditos de IA. Contrate o pacote de IA Ilimitada para liberar a criação com IA imediatamente.",
    managePlan: "Gerenciar plano",
    contractNow: "Contratar IA agora",
    contactAdminToContract: "Fale com o administrador da escola para contratar ou gerenciar o plano de IA.",
    timeRemaining: "Faltam",
  },
  iaPlanIndicator: {
    unlimitedAI: "IA ilimitada",
  },
  iaUsageNotice: {
    loadingStatus: "Carregando status de IA...",
    checkError: "Não foi possível verificar seus créditos de IA agora.",
    unlimitedActive: "IA ilimitada ativa — nenhum crédito será descontado.",
    creditsAvailable: "Sua conta tem {{count}} créditos de IA disponíveis.",
    creditsCost: "Será descontado de {{min}} a {{max}} crédito(s) ao criar com IA.",
    contractUnlimited: "Contrate agora IA ilimitada",
    contactAdminToContract: "Fale com o administrador da escola para contratar IA ilimitada.",
  },
  iaUsageProgress: {
    premiumResources: "Recursos de IA Premium",
    activeLabel: "Ativo",
    unlimitedCreations: "Criações ilimitadas disponíveis",
    includedResources: "Recursos Incluídos:",
    unlimitedQuizzesMissions: "Quizzes e Missões com IA ilimitados",
    autoAnalysis: "Análise automática de comprovantes",
    smartFeedback: "Feedback inteligente personalizado",
    advancedReports: "Relatórios avançados com insights",
    freeAICreations: "Criações Gratuitas com IA",
    remainingCreations: "Restam <strong>{count}</strong> criações gratuitas este mês",
    monthlyLimitReached: "Limite mensal atingido - ative a IA para criar mais",
    nextReset: "Próximo reset: <strong>{date}</strong>",
    days: "{count} dias",
    availableInFreePlan: "Criações disponíveis no plano gratuito:",
    quizzesWithAI: "Quizzes com IA",
    missionsWithAI: "Missões com IA",
    freePlanLimitations: "Limitações do plano gratuito:",
    manualAnalysis: "Análise manual de comprovantes",
    basicReports: "Relatórios básicos sem insights de IA",
    standardFeedback: "Feedback padrão para alunos",
    upgradeToUnlimited: "Upgrade para IA ilimitada e muito mais!",
    lastCreation: "Última criação disponível - considere o upgrade!",
  },
  teacherModal: {
    noAICredits: "Sem crédito de IA disponível",
    noCreditsDescription: "A conta da sua escola não possui créditos de IA. Crie sua missão manualmente ou entre em contato com o gestor da conta.",
    createManualMission: "Criar missão manual",
  },
  trilhas: {
    pageTitle: "Trilhas de aprendizado | Gamefik",
    pageDescription:
      "Crie trilhas de aprendizado personalizadas com quizzes, flashcards e conteúdos em jornadas completas para seus alunos.",
    title: "Trilhas de aprendizado",
    comingSoon: "Em breve",
    description:
      "Estamos preparando uma experiência incrível para você criar trilhas de aprendizado personalizadas estilo Duolingo. Combine quizzes, flashcards e conteúdos em jornadas completas para seus alunos.",
    flashcards: "Flashcards",
    quizzes: "Quizzes",
    quests: "Quests",
    accessLinkButtonAria: "Link de acesso da trilha",
    accessLinkModalTitle: "Link de Acesso",
    accessLinkModalScanHint: "Escaneie o QR Code ou copie o link abaixo",
    accessLinkModalShareHint:
      "Compartilhe este link com seus alunos. Ao acessar, eles criam uma conta e entram automaticamente na trilha.",
    accessLinkModalPrintPdf: "Imprimir PDF",
    accessLinkModalPrintTitle: "Acesso - {{name}}",
    accessLinkModalPrintSubtitle: "Plataforma de Gamificação Educacional",
    accessLinkModalPrintCardLabel: "Link de Acesso da Trilha",
    accessLinkModalPrintInstructions:
      "Escaneie o QR Code acima ou acesse o link abaixo para entrar na trilha",
    accessLinkModalQrAlt: "QR Code",
    accessLinkCopy: "Copiar",
    accessLinkCopied: "Copiado",
    accessLinkDisabledHint: "Disponível após publicar a trilha",
    testEnv: {
      viewAnyway: "Ver trilhas (ambiente de teste)",
    },
    header: {
      eyebrow: "Biblioteca — Comunidade Global",
      title: "Trilhas",
      createFromScratch: "Criar trilha do zero",
    },
    tabs: {
      community: "Banco da comunidade",
      myTrails: "Minhas trilhas",
    },
    my: {
      searchPlaceholder: "Buscar suas trilhas...",
      filters: {
        turmas: "Turmas",
        subject: "Disciplina",
      },
      clearFilters: "Limpar ({{count}})",
      stats: {
        active: "{{count}} ativas",
        drafts: "{{count}} rascunhos",
        inactive: "{{count}} desativadas",
        expired: "{{count}} expiradas",
      },
      statusActive: "Ativa",
      statusInactive: "Desativada",
      statusScheduled: "Agendada",
      statusExpired: "Expirada",
    },
    card: {
      createTitle: "Criar nova trilha",
      createSubtitle: "Comece do zero",
      phases: "{{count}} fases",
      activities: "{{count}} atividades",
      participants: "{{count}} alunos",
      studentProgress: "Progresso dos alunos",
      studentProgressAverage: "Progresso médio dos alunos",
      classes: "{{count}} turmas",
      viewDetails: "Ver detalhes",
      openDetails: "Abrir detalhes de {{title}}",
      reactivate: "Reativar trilha",
      deactivate: "Desativar trilha",
    },
    report: {
      title: "Relatório: {{title}}",
      subtitle: "Desempenho dos alunos na trilha",
      noClassesTitle: "Nenhuma turma vinculada",
      noClassesDescription:
        "Vincule turmas a esta trilha para ver o relatório de desempenho dos alunos.",
      understood: "Entendi",
      loadErrorTitle: "Não foi possível carregar o relatório",
      loadErrorDescription: "Verifique sua conexão e tente novamente.",
      completionRate: "Taxa de conclusão",
      completionRateHint: "{{completed}} de {{total}} alunos completaram",
      averageProgress: "Progresso médio",
      averageProgressHint: "Média de todos os alunos",
      totalStudents: "Total de alunos",
      totalStudentsHint: "Em {{count}} {{unit}}",
      classUnit: "turma",
      classesUnit: "turmas",
      phasesTitle: "Desempenho por fase",
      phasesSubtitle: "Identifique onde os alunos estão com mais dificuldade",
      attention: "Atenção",
      difficultActivity: "Atividade com dificuldade:",
      studentsHere: "{{count}} alunos aqui",
      completion: "Conclusão",
      accuracy: "Taxa de acertos",
      averageTime: "Tempo médio: {{minutes}}min",
      classesTitle: "Conclusão por turma",
      classesSubtitle: "Turmas ordenadas pelo percentual de conclusão",
      completedRatio: "{{completed}}/{{total}} concluíram",
      classAverage: "Média: {{percent}}%",
      statusIncomplete: "Não concluída",
      criteriaAllSteps: "Critério: concluir todas as etapas",
      criteriaMinScore: "Critério: pontuação mínima de {{score}}%",
      hint: "Dica",
      openAttachment: "Abrir anexo",
      missionResponseUnavailable: "A conclusão foi registrada. Este relatório não disponibiliza a resposta ou o comprovante enviado nesta missão.",
      studentsTitle: "Conclusão e respostas dos alunos",
      studentsSubtitle: "Veja a conclusão de cada aluno e abra as atividades para consultar respostas e detalhes.",
      responses: "Respostas",
      viewStudentResponses: "Ver respostas",
      viewStudentResponsesLabel: "Ver respostas de {{name}}",
      noStudentsFound: "Nenhum aluno encontrado. Ajuste os filtros para continuar.",
      filterAllClasses: "Todas as turmas",
      filterClassesCount: "{{count}} turmas",
      searchClassPlaceholder: "Buscar turma...",
      noClassFound: "Nenhuma turma encontrada.",
      clearSelection: "Limpar seleção ({{count}})",
      filterAllStatus: "Todos os status",
      statusCompleted: "Concluído",
      statusInProgress: "Em progresso",
      statusNotStarted: "Não iniciou",
      statusAtRisk: "Em risco",
      searchStudentPlaceholder: "Pesquisar por nome",
      colStudent: "Aluno",
      colClass: "Turma",
      colCurrentPhase: "Fase atual",
      colProgress: "Progresso",
      colActivities: "Atividades",
      colAccuracy: "Taxa de acertos",
      showingStudents: "Mostrando {{shown}} de {{total}} participantes",
    },
    detailModal: {
      phasesLabel: "Fases",
      activitiesLabel: "Atividades",
      participantsLabel: "Alunos",
      classesLabel: "Turmas",
      linkedClasses: "Turmas",
      linkedClassesHint: "{{count}} turmas vinculadas · gerenciar",
      linkedClassesHintAll: "Todas as turmas da escola · gerenciar",
      classesAllShort: "Todas",
      editTrail: "Editar trilha",
      structureTitle: "Estrutura da trilha",
      structureSubtitle: "{{phases}} fases com {{activities}} atividades",
      phaseActivities: "{{count}} atividades",
      noPhases: "Nenhuma fase nesta trilha ainda.",
      structureLoadError: "Não foi possível carregar a estrutura da trilha.",
      backToStructure: "Voltar à estrutura",
      exploreHint: "Clique em qualquer item para ver mais detalhes",
      overviewTitle: "Visão geral da trilha",
      descriptionLabel: "Descrição",
      themeLabel: "Tema",
      gradeLabel: "Série",
      localeLabel: "Idioma",
      creatorLabel: "Criada por",
      creatorUnavailable: "Usuário excluído ou indisponível",
      statusTitle: "Status da trilha",
      phasesOverviewTitle: "Todas as fases",
      activitiesOverviewTitle: "Todas as atividades",
      classesOverviewTitle: "Turmas",
      classesPanel: {
        search: "Buscar turma…",
        filterAll: "Todas",
        filterLinked: "Vinculadas",
        filterUnlinked: "Não vinculadas",
        addVisible: "Vincular visíveis",
        removeVisible: "Desvincular visíveis",
        openToAll: "Liberar para todas as turmas",
        allClassesHint:
          "Sem restrição: todos os alunos da escola podem acessar esta trilha. Selecione uma turma abaixo para restringir o acesso.",
        allClassesHintReadonly:
          "Sem restrição: todos os alunos da escola podem acessar esta trilha.",
        unlinkDisabledHint:
          "Só é possível desvincular turmas enquanto a trilha está em rascunho.",
        keepOneClassHint:
          "Adicione outra turma antes de remover a última turma vinculada.",
        linkedTitle: "Turmas vinculadas a essa trilha ({{count}})",
        noLinked: "Nenhuma turma vinculada ainda.",
        addTitle: "Adicionar turma",
        restrictTitle: "Restringir a uma turma",
        statusLinked: "Vinculada",
        statusUnlinked: "Não vinculada",
        addOne: "Vincular {{name}}",
        removeOne: "Desvincular {{name}}",
        noResults: "Nenhuma turma encontrada com esse filtro.",
        loading: "Carregando turmas…",
        saveSuccess: "Turmas da trilha atualizadas.",
        saveError: "Não foi possível atualizar as turmas.",
      },
      classDetailTitle: "Turma",
      phaseDetailTitle: "Detalhes da fase",
      phaseDescriptionLabel: "Descrição",
      activityDetailTitle: "Detalhes da atividade",
      activityInPhase: "Na fase: {{phase}}",
      stepsLabel: "{{count}} etapas",
      stepsLabelOne: "1 etapa",
      orderInPhase: "Ordem {{order}} na fase",
      completionLabel: "Critério de conclusão",
      completionAllSteps: "Completar todas as etapas",
      completionMinScore: "Pontuação mínima de {{score}}%",
      deadlineLabel: "Prazo",
      noDescription: "Sem descrição cadastrada",
      filterTypeTitle: "{{type}} na trilha",
      filterTypeCount: "{{count}} atividades deste tipo",
      openInEditor: "Abrir no editor",
      rewardsLabel: "Recompensas",
      finalRewardTitle: "Recompensa final",
      finalRewardValue: "+{{coins}} coins",
      finalRewardGames: "Configurada para {{count}} segmento(s) vinculado(s)",
      curriculumTagsLabel: "Referências curriculares",
      viewPhase: "Ver fase {{n}}",
      viewActivity: "Ver atividade",
      clearFilter: "Limpar filtro",
      subjectLabel: "Disciplina",
      updatedLabel: "Atualizada em",
      updatedAtValue: "Atualizada em {{date}}",
      endsAtValue: "Encerra em {{date}}, às 23:59",
      expiredAtValue: "Expirou em {{date}}",
      expiredNotice: "Os alunos não podem mais concluir novas atividades nesta trilha.",
      tabStructure: "Estrutura",
      tabStudentsProgress: "Progresso dos alunos",
      studentsProgressSummary: "Média da turma na trilha",
      studentsProgressEligible: "{{count}} elegíveis",
      studentsProgressStarted: "{{count}} iniciaram",
      studentsProgressCompleted: "{{count}} concluíram",
      studentsProgressActivitiesTotal: "{{count}} atividades na trilha",
      studentsProgressActivitiesDone: "{{done}} de {{total}} atividades",
      studentsProgressSearch: "Buscar aluno…",
      studentsProgressFilterTurmas: "Turmas",
      studentsProgressFilterTurmasSearch: "Buscar turma…",
      studentsProgressFilterTurmasNoResults: "Nenhuma turma encontrada",
      studentsProgressFilterTurmasClear: "Limpar turmas",
      studentsProgressEmpty: "Nenhum aluno elegível para esta trilha.",
      studentsProgressNoSearch: "Nenhum aluno encontrado com esse filtro.",
      studentsProgressNoClassFilter: "Nenhum aluno nas turmas selecionadas.",
      studentsProgressLoadError: "Não foi possível carregar o progresso dos alunos.",
      studentsProgressUnknownName: "Aluno",
      studentsProgressNoClass: "Sem turma",
      studentDetail: {
        pageTitle: "Progresso do aluno na trilha",
        back: "Voltar",
        backToList: "Voltar à lista de alunos",
        trailLabel: "Trilha",
        overallProgress: "Progresso geral",
        completedAt: "Concluiu em {{date}}",
        phasesTitle: "Etapas e atividades",
        phaseProgress: "{{done}} de {{total}} atividades",
        activityNotStarted: "Ainda não realizou",
        activityCompleted: "Concluída",
        activityScore: "Nota {{score}}",
        loadError: "Não foi possível carregar o progresso deste aluno.",
        noPhases: "Esta trilha não possui fases cadastradas.",
        backToPhases: "Voltar às etapas",
      },
      studentActivity: {
        quizTitle: "Questões do quiz",
        writeTitle: "Respostas discursivas",
        flashcardsTitle: "Flashcards",
        flashcardTrueFalseTitle: "Verdadeiro ou falso",
        trueAnswer: "Verdadeiro",
        falseAnswer: "Falso",
        studentTrueFalseAnswer: "Resposta do aluno",
        contentTitle: "Conteúdo",
        missionTitle: "Missão",
        correctAnswer: "Correta",
        selectedAnswer: "Escolhida pelo aluno",
        answerNotRecorded: "Resposta do aluno não registrada.",
        legacySubmissionHint:
          "Esta conclusão foi feita antes do registro detalhado das respostas. As alternativas corretas aparecem abaixo; a escolha do aluno pode não estar disponível.",
        questionN: "Questão {{n}}",
        scorePercent: "{{score}}% de acerto",
      },
    },
    list: {
      title: "Trilhas",
      loadErrorTitle: "Não foi possível carregar suas trilhas",
      loadErrorDescription:
        "Algo deu errado ao buscar a lista. Verifique sua conexão e tente novamente.",
      subtitle: "{{count}} trilhas · {{published}} publicadas",
      subtitleLoading: "Carregando trilhas...",
      createWithAi: "Criar com IA",
      createWithAiShort: "IA",
      createManual: "Criar manual",
      createManualShort: "Manual",
      createWithAiDialog: {
        title: "Criar trilha com IA",
        hint: "Descreva o tema, a série e o que você quer na trilha ou adicione PDFs e imagens como fonte. Ao continuar, abriremos o editor e seu pedido será enviado no chat da IA.",
        placeholder:
          "Ex.: Trilha sobre Revolução Industrial para o 9º ano, com quiz e uma missão de pesquisa…",
        submit: "Criar trilha",
        cancel: "Cancelar",
        promptRequired: "Descreva o que deseja criar ou adicione um anexo",
      },
      searchPlaceholder: "Buscar trilhas...",
      filters: {
        all: "Todas",
      },
      status: {
        draft: "Rascunho",
        generating: "Gerando",
        published: "Publicada",
        archived: "Arquivada",
      },
      columns: {
        title: "Título",
        status: "Status",
        phases: "Fases",
        classes: "Turmas",
        createdAt: "Criada em",
        actions: "Ações",
      },
      mobileMeta: "{{phases}} fases · {{classes}}",
      empty: {
        title: "Crie sua primeira trilha",
        description:
          "Use IA ou crie manualmente trilhas de aprendizado gamificadas para seus alunos.",
      },
      emptyFiltered: {
        title: "Nenhuma trilha encontrada",
        description: "Tente outro termo de busca ou altere o filtro de status.",
      },
      actions: {
        menuLabel: "Ações",
        select: "Selecionar",
        edit: "Editar",
        publish: "Publicar",
        unpublish: "Despublicar",
        shareLink: "Link de acesso",
        shareLinkDisabledHint: "Publique para liberar",
        viewReport: "Ver relatório",
        delete: "Excluir",
      },
      selection: {
        selectedCount: "{{count}} selecionada(s)",
        selectedShort: "selecionadas",
        toolbarAria: "Ações de seleção em massa",
        enterMode: "Selecionar várias",
        enterModeTooltip: "Selecionar trilhas para excluir em massa",
        selectAll: "Selecionar todas",
        deselectAll: "Desmarcar todas",
        cancel: "Cancelar seleção",
        moreActions: "Mais ações",
        cancelTooltip: "Sair da seleção",
        deleteSelected: "Excluir selecionadas ({{count}})",
        deleteTooltip: "Excluir {{count}} selecionada(s)",
        cardAria: "Selecionar trilha {{title}}",
      },
      deleteDialog: {
        title: "Excluir trilha",
        description:
          "Tem certeza que deseja excluir \"{{title}}\"? Esta ação não pode ser desfeita.",
        cancel: "Cancelar",
        confirm: "Excluir",
        deleting: "Excluindo...",
      },
      bulkDeleteDialog: {
        title: "Excluir trilhas selecionadas",
        description:
          "Tem certeza que deseja excluir {{count}} trilhas? Esta ação não pode ser desfeita.",
        cancel: "Cancelar",
        confirm: "Excluir",
        deleting: "Excluindo...",
      },
      qr: {
        copySuccess: "Link copiado!",
        download: "Baixar QR",
        error: "Erro ao gerar QR Code",
      },
      toast: {
        deleted: "Trilha excluída",
        deleteError: "Erro ao excluir trilha",
        deletedMany: "{{count}} trilhas excluídas",
        deleteManyError: "Não foi possível excluir todas as trilhas selecionadas",
        published: "Trilha publicada",
        unpublished: "Trilha despublicada",
        unpublishError: "Erro ao despublicar trilha",
      },
      publishing: "Publicando...",
    },
    publish: {
      title: "Publicar trilha",
      description: "Defina o prazo e as turmas para publicar esta trilha.",
    },
    create: {
      back: "Trilhas",
      loadErrorTitle: "Não foi possível carregar esta trilha",
      loadErrorDescription:
        "Algo deu errado ao abrir a trilha para edição. Tente novamente ou volte à lista.",
      headerEditor: "Editor",
      saveDraft: "Salvar rascunho",
      headerMoreActions: "Mais opções",
      openChat: "Conversar com a IA",
      closeChat: "Fechar conversa",
      resizeChat: "Redimensionar chat IA",
      resizeChatHint: "Arraste para ajustar a largura. Use as setas, Home ou End. Clique duas vezes ou pressione Enter para restaurar o tamanho padrão.",
      mobileBackToChat: "Voltar ao chat",
      mobileViewTrail: "Ver trilha",
      sectionOverview: "Informações da trilha",
      sectionStructure: "Estrutura da trilha",
      metadataPhases: "{{count}} fases",
      metadataActivities: "{{count}} atividades",
      titleNew: "Criar trilha",
      titleEdit: "Editar trilha",
      modeAi: "Criar com IA",
      modeManual: "Criar manualmente",
      preview: "Preview",
      panelEdit: "Editar",
      panelPreview: "Preview",
      save: "Salvar",
      publish: "Publicar",
      qrCode: "QR Code",
      devJson: "JSON (dev)",
      devJsonDialog: {
        title: "JSON completo da trilha",
        hint: "Snapshot do formulário, API, job, visibilidade no app (status/turmas) e turmas/segmentos da escola (padrão chat-ia). Somente localhost.",
        copy: "Copiar JSON",
        copied: "JSON copiado!",
        close: "Fechar",
      },
      generating: "Gerando trilha...",
      generatingProgress: "{{completed}}/{{total}} fases geradas",
      resumingProgress: "Retomando o acompanhamento da geração…",
      fields: {
        title: "Título",
        titleRequired: "Título obrigatório para salvar",
        titlePlaceholder: "Nome da trilha",
        description: "Descrição",
        descriptionPlaceholder: "Breve descrição da trilha",
        subjectLabel: "Disciplina",
        subjectPlaceholder: "Selecione a disciplina",
        subjectSearchPlaceholder: "Buscar disciplina…",
        subjectNotFound: "Nenhuma disciplina encontrada",
        theme: "Tópico / conteúdo",
        themePlaceholder: "Ex: Frações, Revolução Francesa",
        grade: "Série",
        gradePlaceholder: "Ex: 8ª série",
        detailsToggle: "Disciplina, tópico e série",
      },
      subjects: {
        matematica: "Matemática",
        portugues: "Português",
        ingles: "Inglês",
        espanhol: "Espanhol",
        ciencias: "Ciências",
        fisica: "Física",
        quimica: "Química",
        biologia: "Biologia",
        historia: "História",
        geografia: "Geografia",
        filosofia: "Filosofia",
        sociologia: "Sociologia",
        ed_fisica: "Ed. Física",
        arte: "Arte",
        musica: "Música",
        computacao: "Tecnologia",
        financas: "Finanças",
        redacao: "Redação",
        religiao: "Religião",
        outra: "Outra",
      },
      moreActions: "Mais ações",
      publishDialog: {
        optionsTitle: "Trilha pronta! 🎉",
        optionsDescription: "Como você quer usar essa trilha agora?",
        title: "Enviar como tarefa",
        classesLabel: "Turmas",
        classesHint: "Selecione as turmas que terão acesso a esta trilha",
        noClasses: "Nenhuma turma encontrada",
        finalRewardLabel: "Recompensa final",
        finalRewardValue:
          "{{coins}} coins ao concluir a trilha ({{count}} segmentos vinculados)",
        finalRewardNone: "Sem coins finais configurados",
        cancel: "Cancelar",
        confirm: "Publicar",
      },
      finalReward: {
        title: "Recompensa final em coins",
        description:
          "Defina quantos coins o aluno recebe ao completar todas as fases da trilha. A recompensa é paga uma única vez.",
        coinsLabel: "Coins ao concluir",
        coinsPlaceholder: "Ex: 50",
        toggleLabel: "Ativar recompensa final",
        activeHint:
          "A recompensa será vinculada a {{count}} segmentos das turmas selecionadas. Sem turmas selecionadas, vale para todas as turmas.",
        disabledHint: "Ative para configurar uma recompensa final em coins.",
        emptyEnabledHint: "Informe a quantidade de coins para ativar a recompensa final.",
        noGamesHint:
          "Nenhum segmento encontrado nas turmas selecionadas. A trilha pode ser publicada, mas os coins não serão gerados até haver segmentos vinculados.",
        lockedTitle: "Disponível em planos com recompensas.",
        lockedDescription:
          "A configuração fica bloqueada neste plano, mas trilhas existentes mantêm seu contrato de premiação.",
      },
      previewIframeTitle: "Pré-visualização da trilha no app aluno",
      previewIframePreparing: "Preparando preview do app…",
      previewDialog: {
        title: "Preview no app",
        emptyPhases: "Adicione fases para visualizar",
        start: "INICIAR",
      },
      unsavedChangesConfirm:
        "Você tem alterações não salvas. Deseja sair mesmo assim?",
      toast: {
        saved: "Trilha salva",
        saveError: "Erro ao salvar",
        generateError: "Erro ao gerar trilha",
        published: "Trilha publicada!",
        publishError: "Erro ao publicar trilha. Tente novamente.",
        contentMissingTitle: "Há atividades sem conteúdo",
        contentMissingHelp: "Adicione texto, imagem, vídeo ou anexo nas atividades abaixo e tente novamente.",
        contentMissingPhase: "Fase {{number}}",
        contentMissingPhaseUnknown: "Fase não identificada",
        contentMissingUntitled: "Atividade sem título",
        turmasWithoutSegment: "Nao foi possivel publicar: a(s) turma(s) {{turmas}} estao sem segmento definido ou com o segmento excluido. Defina um segmento valido para essas turmas (em Turmas) antes de publicar — sem isso os alunos nao recebem a recompensa.",
        linkCopied: "Link copiado!",
      },
      qr: {
        title: "QR Code",
        download: "Baixar QR",
      },
    },
    addMenu: {
      manual: "Adicionar manualmente",
      withAi: "Adicionar com IA",
      aiDialogTitle: "Descreva o que adicionar",
      aiDialogHint:
        "Sua mensagem será enviada ao chat da IA com o contexto de onde você está no editor.",
      aiPromptPlaceholder: "Ex.: um quiz com 3 questões sobre alimentação saudável…",
      sendToChat: "Enviar para o chat",
      cancel: "Cancelar",
      sentToChat: "Pedido enviado ao chat da IA",
      aiUnavailable: "Use o modo IA ou edite uma trilha salva para adicionar com assistente",
    },
    chat: {
      title: "Professor Gamefik",
      subtitle: "Copiloto da Gamefik",
      welcomeNew:
        "Olá! Sou o Professor Gamefik, seu copiloto na criação de trilhas. Descreva o tema ou conteúdo que deseja transformar em uma trilha de aprendizado!",
      placeholderNew: "Ex: Brasil Colônia, 8ª série",
      placeholderEdit: "Peça um ajuste nessa fase...",
      suggestionsLabel: "Ações rápidas",
      quickChipAddActivity: "+ Adicionar atividade",
      quickChipMoreContent: "Mais conteúdo",
      quickChipReorder: "Reordenar atividades",
      quickChipDeletePhase: "Excluir fase",
      quickChipMorePhases: "Adicionar mais fases",
      quickChipDifficulty: "Mudar nível de dificuldade",
      quickChipRewards: "Adicionar recompensas",
      quickChipReformulate: "Reformular atividades",
      phaseProgress: "Fase {{completed}} de {{total}} gerada",
      generationStarted:
        "Vou criar sua trilha com base no que você descreveu. Acompanhe o progresso das fases abaixo.",
      runQueued: "Pedido recebido. A execução está na fila e continuará mesmo se você fechar esta aba.",
      v2: {
        placeholder: "Converse sobre a trilha ou peça uma alteração…",
        pdfStudyTitle: "Usar como base de estudo",
        pdfStudyDescription: "Criar explicações e atividades a partir dos materiais enviados.",
        pdfCopyTitle: "Copiar os exercícios 1:1",
        pdfCopyDescription: "Manter enunciados, alternativas e ordem dos exercícios, sem reescrever.",
        title: "Chat IA v2",
        legacy: "Chat anterior",
        versionLabel: "Versão do chat",
        draftTitle: "Nova trilha",
        running: "A IA está preparando a trilha completa com o contexto da conversa.",
        subtitle: "Conversa completa e trilha no mesmo contexto",
        historyError: "Não foi possível carregar a conversa. Tente novamente antes de enviar uma mensagem.",
        retry: "Tentar novamente",
        source: "Contexto do material {{count}} usado pela IA",
      },
      runRecovering: "Retomando a execução salva no servidor…",
      runRunning: "A IA está trabalhando nesta alteração. Você pode fechar a aba e voltar depois.",
      runRunningProgress: "Execução em andamento: {{completed}} de {{total}} fases concluídas.",
      generationDone: "Geração concluída! Você já pode ver e editar as fases.",
      generationError: "Erro na geração: {{error}}. Tente novamente.",
      sendError: "Erro ao enviar mensagem. Tente novamente.",
      noCreditsError:
        "Seus créditos de IA acabaram. Necessários: {{needed}}. Disponíveis: {{remaining}}. Contrate um plano ou adicione créditos para continuar.",
      actionApplied: "Alteração aplicada na trilha. Confira no editor ao lado.",
      sendAria: "Enviar mensagem",
      addAttachment: "Adicionar PDF ou imagem",
      removeAttachment: "Remover anexo {{name}}",
      attachmentsOnlyPrompt: "Use os anexos enviados como fonte para criar ou atualizar a trilha.",
      uploadProgress: "Enviando anexos",
      attachmentRejected: {
        type: "O arquivo \"{{name}}\" não é suportado. Use PDF ou imagem.",
        empty: "O arquivo \"{{name}}\" está vazio.",
        size: "O arquivo \"{{name}}\" excede o limite de 50 MB.",
        count: "O limite é de 4 anexos por mensagem.",
        total: "O total de anexos excede o limite de 100 MB.",
      },
      userFallback: "Você",
      memoryManage: "Memórias",
      memoryManageAria: "Gerenciar memórias do assistente",
      aiSettingsTrigger: "IA",
      aiSettingsManageAria: "Configurar tipos de atividade gerados pela IA",
      aiSettingsTitle: "Geração por tipo de atividade",
      aiSettingsDescription:
        "Escolha quais tipos o assistente pode criar ao gerar ou editar trilhas com IA.",
      aiSettingsLocalhostOnly: "Visível apenas em localhost. Valores ficam no navegador.",
      aiSettingsReset: "Restaurar padrões",
      memoryDialogTitle: "Memórias salvas",
      memoryDialogDescription:
        "Informações gerais que o assistente lembra sobre você nesta escola. Preferências de formato (ex.: não usar missões) são aplicadas nas gerações com IA; tema e estrutura seguem o que você pedir em cada trilha.",
      memoryEmpty:
        "Nenhuma memória salva ainda. Converse com o assistente — ele pode anotar seu público-alvo, preferências e outros detalhes estáveis.",
      memoryLoadError: "Não foi possível carregar as memórias.",
      memoryRetry: "Tentar novamente",
      memoryDeleteAria: "Excluir memória",
      memoryCategoryIdentity: "Identidade",
      memoryCategoryAudience: "Público-alvo",
      memoryCategoryPreferences: "Preferências",
      memoryCategoryTeaching: "Ensino",
      memoryCategoryOther: "Outro",
      memoryAddSection: "Adicionar memória",
      memoryAdd: "Adicionar",
      memoryCategoryLabel: "Categoria",
      memoryCustomCategoryLabel: "Nome da categoria",
      memoryCustomCategoryPlaceholder: "Ex.: Metodologia / Rotina da turma",
      activitySuggestionTitle: "Parece uma atividade avulsa",
      activitySuggestionDescription:
        "Quizzes, missões e flashcards soltos são criados no Chat IA. Quer continuar lá com esse pedido?",
      activitySuggestionGo: "Criar no Chat IA",
      activitySuggestionStay: "Continuar como trilha",
      memoryContentLabel: "Descrição",
      memoryAddPlaceholder: "Ex.: Chama-se de Ana / Trabalho com 7º ano",
      memoryAddEmpty: "Escreva uma descrição para salvar.",
      memoryAddTooLong: "Máximo de {{max}} caracteres.",
      memoryAddError: "Não foi possível salvar. Tente outra descrição.",
      memoryMaxReached: "Limite de {{max}} memórias atingido. Exclua uma para adicionar outra.",
      pdfUsage: {
        legend: "Como deseja usar este PDF?",
        required: "Escolha obrigatória",
        description: "Escolha uma opção para continuar.",
        inspirationTitle: "Usar como inspiração",
        inspirationDescription: "Usa as ideias do material para criar ou adaptar a trilha.",
        faithfulTitle: "Copiar fielmente",
        faithfulDescription: "Mantém a ordem e o conteúdo conforme o documento.",
        faithfulSelectedDescription:
          "Conteúdos, quizzes e flashcards seguirão somente o que está apresentado no PDF.",
        faithfulMultipleError:
          "Para copiar com fidelidade, anexe somente um PDF por vez, sem imagens ou outros arquivos adicionais.",
        selected: "Modo escolhido: {{mode}}",
      },
      pdfChapters: {
        analysisErrorTitle: "Não consegui analisar os capítulos do PDF",
        analysisErrorDescription:
          "O arquivo continua anexado. Verifique sua conexão e tente analisar novamente.",
        retry: "Tentar analisar novamente",
        multipleTitle: "Envie um PDF por vez para organizar por capítulos",
        multipleDescription:
          "Há mais de um PDF anexado. Você pode gerar usando todos os arquivos sem organização por capítulos ou reenviar apenas um PDF para escolher os capítulos.",
        changeFiles: "Alterar arquivos",
        notFoundTitle: "Não encontrei capítulos com segurança",
        notFoundDescription:
          "Você ainda pode gerar a trilha usando o PDF inteiro, mas a organização não será baseada nos capítulos.",
        faithfulNoHierarchyDescription:
          "O PDF tem texto pesquisável, mas não possui capítulos identificáveis. Você pode copiar o documento inteiro preservando a ordem e o conteúdo das páginas.",
        ocrRequiredDescription:
          "Este PDF parece ser digitalizado e precisa de reconhecimento de texto. Você ainda pode gerar uma trilha usando o arquivo inteiro.",
        generateNormally: "Gerar com o PDF inteiro",
        copyFullPdf: "Copiar o PDF inteiro",
        choiceTitle: "Encontrei {{count}} capítulos no PDF",
        choiceDescription:
          "O arquivo tem {{pages}} páginas. Escolha como deseja transformar o conteúdo em trilha.",
        completeTitle: "Criar uma trilha completa",
        completeDescription: "Será criada uma fase para cada capítulo, em {{count}} fases.",
        completeGroupedDescription:
          "Serão criadas {{count}} fases (o máximo é 10), agrupando capítulos próximos na mesma fase.",
        generateComplete: "Gerar trilha completa",
        specificTitle: "Usar somente um capítulo",
        specificDescription: "Escolha o capítulo que será usado como fonte da trilha.",
        chapterOption: "Capítulo {{order}} — {{title}}",
        generateSpecific: "Gerar com este capítulo",
        faithfulUnsupportedTitle: "Não é possível copiar este PDF com fidelidade",
        faithfulOcrError: "Não foi possível reconhecer conteúdo suficiente neste PDF. Tente um arquivo mais nítido ou escolha usar como inspiração.",
        faithfulMultipleError: "A cópia fiel aceita exatamente um PDF por vez. Altere os arquivos ou escolha usar como inspiração.",
        useInspirationInstead: "Usar como inspiração",
        scopeTitle: "Qual parte do PDF deseja usar?",
        scopePlaceholder: "Selecione o PDF, um macrogrupo ou um capítulo",
        fullPdfOption: "PDF completo",
        groupOption: "Macrogrupo — {{title}}",
        childOption: "↳ {{parent}} — {{title}}",
        leafOption: "Capítulo — {{title}}",
        scopeHint: "Escolha o PDF completo, um macrogrupo ou um capítulo específico.",
        groupDescription: "Este macrogrupo tem {{count}} capítulos. Será criada uma fase para cada capítulo filho.",
        groupGroupedDescription: "Este macrogrupo tem {{count}} capítulos. Para respeitar o máximo de {{phases}} fases, capítulos filhos adjacentes serão agrupados.",
        leafDescription: "A trilha será criada somente com o conteúdo de “{{title}}”.",
        generateSelection: "Gerar com esta seleção",
      },
    },
    editor: {
      phaseLabel: "Fase {{n}}",
      activityCount: "{{count}} atividades",
      activityCountOne: "1 atividade",
      updating: "Atualizando...",
      removing: "Removendo...",
      generatingContent: "Gerando conteúdo...",
      generatingPhase: "Gerando nova fase...",
      addActivity: "Adicionar atividade",
      dropInPhase: "Solte em Fase {{n}}: {{title}}",
      dragReorderInPhase: "Reordenando «{{title}}» na Fase {{phase}}",
      dragMoveToPhase:
        "Movendo «{{title}}» da Fase {{from}} para a Fase {{to}}: {{phaseName}}",
      addPhase: "Adicionar fase",
      deletePhase: "Excluir fase",
      deleteActivity: "Excluir atividade",
      renamePhase: "Renomear fase",
      moveActivityUp: "Mover atividade para cima",
      moveActivityDown: "Mover atividade para baixo",
      movePhaseUp: "Mover fase para cima",
      movePhaseDown: "Mover fase para baixo",
      activityActionsLabel: "Mais ações da atividade",
      phaseActionsLabel: "Mais ações da fase",
      expandPhase: "Expandir fase",
      collapsePhase: "Recolher fase",
      activityRemovedToast: "Atividade removida",
      phaseRemovedToast: "Fase removida",
      undo: "Desfazer",
      tasksCount: "{{count}} tarefas",
      tasksCountOne: "1 tarefa",
      blocksCount: "{{count}} blocos",
      blocksCountOne: "1 bloco",
      deletePhaseDialog: {
        title: "Excluir fase",
        description:
          "Excluir \"{{title}}\" e todas as atividades desta fase? Esta ação não pode ser desfeita.",
        cancel: "Cancelar",
        confirm: "Excluir",
      },
      activityModal: {
        written: {
          add: "Adicionar pergunta escrita",
          title: "Resposta escrita · correção automática por IA",
          hint: "A IA avalia a resposta do aluno e explica a correção. O resultado compõe a pontuação do quiz e segue o critério de conclusão escolhido.",
          expectedAnswer: "Resposta esperada (opcional)",
          expectedPlaceholder: "Ex.: pharmacy ou drugstore. Aceitar respostas equivalentes.",
          expectedHint: "Oriente a IA com a resposta esperada e os critérios de aceitação. Sem referência, a IA usa o enunciado. Essa orientação não aparece para o aluno.",
          correto: "Correto",
          incorreto: "Incorreto",
          incompleto: "Incompleto",
          review: "Correção automática por IA",
        },
        title: "Editar atividade",
        editTypeTitle: "Editar {{type}}",
        save: "Salvar alterações",
        close: "Fechar",
        titlePlaceholder: "Digite o título",
        markCorrectHint: "clique no círculo para marcar correta",
        questionLabel: "Questão {{n}}",
        questionOf: "de {{total}}",
        contentHint: "Adicione texto, vídeos ou anexos para os alunos estudarem",
        flashcardFrontPlaceholder: "Digite a pergunta ou termo…",
        flashcardBackPlaceholder: "Digite a resposta ou explicação…",
        flashcardFlipHint: "Clique no card para virar",
        flashcardOf: "Card {{current}} de {{total}}",
        hintPlaceholder: "Dica para o aluno",
        missionDescriptionPlaceholder: "Descreva o que o aluno deve fazer nesta tarefa…",
        addMissionStep: "Adicionar etapa",
        removeBlock: "Remover bloco {{n}}",
        fields: {
          title: "Título da atividade",
          type: "Tipo",
          completion: "Critério de conclusão",
          minScore: "Mín. %",
        },
        types: {
          quiz: "Quiz",
          flashcard: "Flashcard",
          flashcard_true_false: "Verdadeiro ou falso",
          content: "Conteúdo",
          mission: "Missão",
        },
        trueLabel: "Verdadeiro",
        falseLabel: "Falso",
        trueFalseCorrectLabel: "Resposta correta",
        addTrueFalseCard: "Adicionar card",
        completion: {
          allSteps: "Todas as etapas",
          minScore: "Pontuação mínima",
        },
        steps: "Etapas ({{count}})",
        addQuestion: "Adicionar pergunta",
        addFlashcard: "Adicionar flashcard",
        addBlock: "Adicionar bloco",
        stepLabels: {
          question: "Pergunta {{n}}",
          flashcard: "Flashcard {{n}}",
          block: "Bloco {{n}}",
          task: "Tarefa {{n}}",
        },
        statementLabel: "Enunciado",
        statementPlaceholder: "Enunciado da pergunta",
        alternativesLabel: "Alternativas",
        alternativePlaceholder: "Alternativa {{n}}",
        markCorrect: "Marcar alternativa {{n}} como correta",
        removeAlternative: "Remover alternativa {{n}}",
        removeQuestion: "Remover pergunta {{n}}",
        addAlternative: "Adicionar alternativa",
        front: "Frente",
        back: "Voltar para trilha",
        cardBack: "Verso",
        hint: "Dica (opcional)",
        contentMd: "Conteúdo (Markdown)",
        contentRich: "Conteúdo",
        missionDescription: "Descrição da tarefa",
        mediaUrl: "URL de mídia (opcional)",
        media: {
          label: "Mídia (opcional)",
          hint: "Imagem, vídeo, PDF, áudio, planilha ou outros arquivos — como no criar missão com IA.",
          dropzoneTitle: "Clique ou arraste o arquivo aqui",
          dropzoneSubtitle: "Vídeo, PDF, imagens, áudio, CSV, Excel e mais",
          remove: "Remover",
          uploading: "Enviando arquivo…",
          uploaded: "Mídia salva.",
          uploadError: "Falha ao enviar o arquivo.",
          previewTitle: "Pré-visualização",
          loadingPreview: "Carregando pré-visualização…",
          noPreview: "Pré-visualização não disponível para este tipo.",
          noTablePreview: "Não foi possível ler a planilha.",
          openFile: "Abrir arquivo",
        },
        verification: "Verificação",
        verificationTeacher: "Aprovação do professor",
        verificationPhoto: "Foto",
        verificationAuto: "Automática",
      },
      chooseActivityType: {
        title: "Tipo de atividade",
        hint: "Escolha o formato antes de adicionar à fase.",
      },
      activityTypes: {
        quiz: "Quiz",
        flashcard: "Flashcard",
        flashcardTrueFalse: "Verdadeiro ou falso",
        content: "Conteúdo",
        mission: "Missão",
      },
      stepsCount: "{{count}} etapas",
      stepsCountOne: "1 etapa",
      cardsCount: "{{count}} cartões",
      cardsCountOne: "1 cartão",
    },
  },
  exportButton: {
    exportData: "Exportar dados",
    records: "{count} registros",
    exportError: "Erro ao exportar dados",
  },

  missionApprove: {
    pageName: "Aprovar missões",
    updating: "(Atualizando...)",
    selectMission: "Selecione uma missão",
    pending: "pendente",
    exportCsv: "Exportar CSV",
    loadingProofs: "Carregando comprovantes...",
    selectMissionsToExport: "Selecionar missões para exportar",
    loadError: "Houve um erro ao carregar os dados.",
    checkConnection: "Verifique sua conexão e tente novamente.",
    tryAgain: "Tentar novamente",
    loadingData: "Carregando dados...",
    exportCsvTitle: "Exportar conclusões em CSV",
    exportCsvDesc: "Selecione as missões a serem exportadas.",
    selectAll: "Selecionar todas",
    deselectAll: "Desmarcar todas",
    concluded: "concluída(s)",
    cancel: "Cancelar",
    export: "Exportar",
    missionNotFound: "Missão não encontrada",
    backToSelection: "Voltar para seleção",
    noMissionsAvailable: "Nenhuma missão disponível",
    participation: "Participação",
    studentsParticipatedPercent: "{{percent}}% dos alunos participaram",
    completionRate: "Taxa de Missões Concluídas",
    pendingToApprove: "{{count}} missões pendentes para aprovar",
    information: "Informações",
    valueLabel: "Valor:",
    createdByLabel: "Criado por:",
    dateLabel: "Data:",
    continuousLabel: "Contínua:",
    yes: "Sim",
    no: "Não",
    unknown: "Desconhecido",
    unknownDate: "Data desconhecida",
    preApprovedByAI: "Comprovantes pré-aprovados pela IA",
    viewAll: "Ver todos",
    approveAll: "Aprovar todos",
    searchByStudentOrClass: "Buscar por nome do aluno ou turma",
    classFilterLabel: "Turma:",
    allClasses: "Todas",
    gameFilterLabel: "Segmento:",
    allGames: "Todos",
    reject: "Reprovar",
    approve: "Aprovar",
    noProofsFound: "Nenhum comprovante encontrado com os filtros selecionados.",
    preRejectedByAI: "Comprovantes pré-reprovados pela IA",
    rejectAll: "Reprovar todos",
    proofApprovedSuccess: "Comprovante aprovado com sucesso!",
    proofRejectedSuccess: "Comprovante reprovado com sucesso!",
    failedToApprove: "Falha ao aprovar comprovante",
    failedToReject: "Falha ao reprovar comprovante",
    noProofsToApprove: "Nenhum comprovante disponível para aprovar",
    allApprovedSuccess: "{{count}} comprovante(s) aprovado(s) com sucesso!",
    failedToApproveAll: "Falha ao aprovar comprovantes",
    noProofsToReject: "Nenhum comprovante disponível para reprovar",
    allRejectedSuccess: "{{count}} comprovante(s) reprovado(s) com sucesso!",
    failedToRejectAll: "Falha ao reprovar comprovantes",
    noClass: "Sem turma",
    noGame: "Sem segmento",
    noDate: "Sem data",
    textLabel: "Texto",
    thumbnail: "Miniatura",
    expandedProof: "Comprovante expandido",
    noDescAvailable: "Sem descrição disponível",
    sentOn: "Enviado em",
    at: "às",
    missionCompleted: "Missão concluída, Parabéns!!",
    notCompleted: "Não concluído",
  },
  proofReviewModal: {
    title: "Revisão de comprovantes",
    aiReviewBadge: "Revisão com IA",
    missionLabel: "Missão: {{title}}",
    tabs: {
      review: "Revisar",
      pending: "Pendentes",
      approved: "Aprovados",
      retry: "Tentar novamente",
      notSent: "Não enviaram",
      collected: "Coletados",
    },
    tabTooltips: {
      review: "Comprovantes aguardando sua decisão — a IA sugere aprovar ou rejeitar, você confirma",
      pending: "Comprovantes enviados aguardando sua revisão",
      approved: "Aprovados por você ou automaticamente pela IA — recompensa liberada para o aluno coletar",
      retry: "Rejeitados — o aluno precisa reenviar o comprovante",
      notSent: "Alunos da missão que ainda não enviaram comprovante",
      collected: "Comprovantes cuja recompensa o aluno já coletou no app",
    },
    searchPlaceholder: "Buscar aluno ou turma...",
    studentCount: "{{count}} aluno(s)",
    clearCount: "Limpar ({{count}})",
    approveBulk: "Aprovar",
    rejectBulk: "Rejeitar",
    selectAll: "Selecionar todos",
    empty: {
      noStudents: "Nenhum aluno",
      allSent: "Todos os alunos já enviaram",
      noPendingRetry: "Nenhum comprovante aguardando nova tentativa",
      nothingToReview: "Nenhum comprovante para revisar",
      noStudentsInFilter: "Não há alunos neste filtro",
      noCollected: "Nenhuma recompensa coletada ainda",
    },
    tag: {
      youApproved: "Você aprovou",
      retry: "Tentar novamente",
      iaApproved: "IA aprovou",
      approved: "Aprovado",
      iaRejected: "IA rejeitou",
      pending: "Pendente",
      newAttempt: "Nova tentativa",
      collected: "Coletado",
      iaSuggestApprove: "IA sugeriu aprovar",
    },
    proofSentLabel: "Comprovante enviado",
    expand: "Expandir",
    noImage: "Sem imagem",
    viewList: "Ver em lista",
    viewGrid: "Ver em grade",
    proofAlt: "Comprovante de {{name}}",
    expandedAlt: "Comprovante expandido",
    aiFeedbackTitle: "Feedback da IA",
    aiSuggestedReject: "IA sugeriu rejeitar",
    aiSuggestedApprove: "IA sugeriu aprovar",
    waitingForReview: "Aguardando sua revisão",
    reviewAndDecide: "Revise e decida manualmente",
    approve: "Aprovar",
    reject: "Rejeitar",
    approveAnyway: "Aprovar mesmo assim",
    confirmApproval: "Confirmar aprovação",
    alreadyReceived: "Já recebeu",
    iaApprovedAuto: "IA aprovou automaticamente",
    iaApprovedDesc: "O aluno já recebeu feedback positivo",
    iaApprovedPending: "IA aprovou — confirme para concluir",
    iaApprovedPendingDesc: "Confirme para concluir a missão e liberar a recompensa do aluno",
    undoIaApproval: "Desfazer aprovação da IA",
    undoApproval: "Desfazer aprovação",
    rewardCollected: "Recompensa já coletada pelo aluno",
    proofApproved: "Comprovante aprovado",
    approvedByYou: "Aprovado por você",
    waitingRetry: "Aguardando nova tentativa",
    needsResubmit: "O aluno precisa reenviar o comprovante",
    notSentDescription: "Este aluno ainda não enviou o comprovante da missão",
    validateManually: "Validar manualmente",
    selectStudent: "Selecione um aluno",
    selectStudentDesc: "Escolha um aluno da lista para visualizar e revisar",
    unknownStudent: "Aluno fora da missão",
    dates: {
      today: "Hoje",
      yesterday: "Ontem",
    },
    sentOn: "Enviado {{date}}, {{time}}",
    toast: {
      updateError: "Erro ao atualizar comprovante. Tente novamente.",
      alreadyApproved: "Este aluno já tem um comprovante aprovado para esta missão.",
      approved: "Comprovante aprovado",
      rejected: "Comprovante rejeitado, aluno poderá tentar novamente",
      undoIa: "Aprovação da IA desfeita",
      approvalUndone: "Aprovação desfeita, aluno poderá tentar novamente",
      manualValidation: "Aluno validado manualmente",
      manualValidationError: "Erro ao validar aluno. Tente novamente.",
      noEligibleProofs: "Nenhum comprovante elegível para aprovação.",
      bulkApproved: "{{count}} comprovante(s) aprovado(s)",
      bulkApproveError: "Erro ao aprovar comprovantes. Tente novamente.",
      bulkRejected: "{{count}} comprovante(s) rejeitado(s)",
      bulkRejectError: "Erro ao rejeitar comprovantes. Tente novamente.",
    },
    feedback: {
      missionCompleted: "Missão concluída com sucesso",
      rejected: "Comprovante não atende aos requisitos da missão",
      undoApproval: "Aprovação desfeita, aluno poderá tentar novamente",
    },
  },
  missionCreate: {
    basicInfo: "Informações básicas",
    selectGames: "Selecione os segmentos",
    deadlinesAndSettings: "Prazos e configurações",
    titleLabel: "Título",
    activeLabel: "Ativo",
    descriptionLabel: "Descrição",
    continuousMission: "Missão contínua ( pode ser feita várias vezes )",
    proofLabel: "Comprovação",
    defineGameAndValue: "Defina o segmento e valor da missão",
    willExpireAt: "Acabará em ",
    willStartAt: "Começará em",
    classesLabel: "Turmas",
    teacherCanValidate: "Professores podem validar essa missão",
    titlePlaceholder: "Título da missão",
    descriptionPlaceholder: "Escreva aqui a descrição da missão, explicando o que o aluno precisa saber para fazer a missão.",
    proofPlaceholder: "Detalhe como o aluno comprovará que fez a missão.",
    willExpireAtCalendar: "📅 Acabará em",
    willStartAtCalendar: "📅 Começará em",
    problemsFound: "Problemas encontrados",
    missionNeedsTitle: "A missão precisa ter um título.",
    missionNeedsDescription: "A missão precisa de uma descrição.",
    missionNeedsGameAndReward: "A missão precisa ter um segmento e uma recompensa",
    missionNeedsRewardCoverage: "A(s) turma(s) {{turmas}} não têm recompensa configurada para o segmento delas. Adicione uma recompensa no segmento certo — sem isso a missão não aparece para os alunos dessa(s) turma(s).",
    missionCantExpireNow: "A missão não pode acabar agora! De mais tempo para seus alunos.",
    missionNeedsClass: "A missão precisa ter pelo menos uma turma.",
    back: "voltar",
    next: "Próxima",
    pageTitle: "Criar missão",
    stepOf: "Passo {{current}} de {{total}}",
    addCoverOptional: "Adicionar capa (opcional)",
    changeCover: "Trocar capa",
    enableCoins: "Habilitar moedas",
    enableCoinsHint: "Para missões sem moedas os alunos continuarão ganhando baús e gemas no aplicativo da Gamefik",
    wantProofInApp: "Quer criar uma missão com comprovação dentro do app?",
    withProof: "Com envio de comprovante",
    withProofDesc: "Nesta opção os jogadores enviam um comprovante e a nossa IA vai analisar e ajudar na validação das missões.",
    withoutProof: "Sem envio de comprovante",
    withoutProofDesc: "Nesta opção os jogadores comprovam fora do app, e a validação é feita manualmente aqui no manager.",
    additionalCost: "Comprovante incluído na criação da atividade",
    selected: "Selecionado",
    selectBtn: "Selecionar",
    notifyStudents: "Notificar alunos",
    teachersCanValidateToggle: "Professores podem validar",
    creatingMission: "Criando missão...",
    createMission: "Criar missão",
    iaCreditsInsufficient: "Créditos de IA insuficientes para criar missão com comprovação. Necessários: {{needed}}. Disponíveis: {{remaining}}. Contrate um plano ou adicione créditos para continuar.",
    errorCreatingMission: "Erro ao criar missão.",
    autoApprovalByAI: "Aprovação automática por IA (HMG)",
  },
  missionCreateWithAi: {
    checkingCredits: "Verificando créditos/plano de IA...",
    cannotCheckCredits: "Não foi possível verificar seus créditos de IA agora. Tente novamente mais tarde.",
    letsCreateMission: "Vamos criar sua missão,",
    butFirst: "mas antes...",
    detailMission: "Detalhe a missão com poucas palavras",
    whatToCreate: "O que quer criar?",
    generateMission: "Gerar missão",
    generatingMission: "Gerando missão",
    missionPreview: "Preview da missão",
    proofPreviewLabel: "Comprovação: ",
    coinsLimitExceeded: "O limite de moedas por turma foi ultrapassado.",
    teachersCanSeeMission: "Professores podem ver essa missão",
  },
  missionBank: {
    goBack: "Voltar",
    title: "Banco de Missões",
    description: "Explore nossa coleção de missões prontas para usar. Adicione-as diretamente à sua lista de missões.",
    searchPlaceholder: "Pesquisar missões",
    popularTags: "Tags populares",
    all: "Todos",
    favorites: "Favoritos",
    removedFromFavorites: "A missão foi removida dos seus favoritos.",
    addedToFavorites: "A missão foi adicionada aos seus favoritos.",
    filters: "Filtros",
    educationLevel: "Nível de ensino",
    subject: "Matéria",
    difficulty: "Dificuldade",
    duration: "Duração",
    filtersApplied: "Filtros aplicados",
    noFiltersApplied: "Sem filtros aplicados",
    clearFilters: "Limpar filtros",
    clearAllFilters: "Limpar todos os filtros",
    noFavoritesYet: "Você ainda não tem missões favoritas",
    noMissionsFound: "Nenhuma missão encontrada",
    clickStarToFavorite: "Clique na estrela em qualquer missão para adicioná-la aos seus favoritos.",
    tryAdjustingFilters: "Tente ajustar seus filtros ou remover as tags selecionadas.",
    add: "Adicionar",
    removeFromFavorites: "Remover dos favoritos",
    addToFavorites: "Adicionar aos favoritos",
    seeMore: "Ver mais",
  },
  missionsOld: {
    pageName: "Missões",
    allGames: "Todos os segmentos",
    allClasses: "Todos as turmas",
    allTeachers: "Todos os professores",
    allDefault: "Todos",
    deleteMissions: "Excluir missões",
    createWithAi: "Criar missão com ia",
    checking: "Verificando...",
    createFromScratch: "Criar do zero",
    missionsDisabled: "Missões 2.0 desativadas",
    searchByName: "Pesquisar por nome",
    pendingProofs: "Comprovantes pendentes",
    perPage50: "50 por página",
    perPage100: "100 por página",
    perPage200: "200 por página",
    previous: "Anterior",
    nextPage: "Próxima",
    noAiCreditsTitle: "Sem crédito de IA disponível",
    noAiCreditsDesc: "A conta da sua escola não possui créditos de IA. Crie sua missão manualmente ou entre em contato com o gestor da conta.",
    cancel: "Cancelar",
    createManualMission: "Criar missão manual",
    editMission: "Editar missão",
    cancelBtn: "Cancelar",
    saveBtn: "Salvar",
    missionUpdatedSuccess: "Missão atualizada com sucesso!",
    missionUpdatedError: "Houve um erro ao atualizar a missão, tente novamente",
    missionDeletedSuccess: "Missão excluída com sucesso!",
    missionsDeletedSuccess: "Missões excluída com sucesso!",
    createdBy: "Criado por",
    game: "Segmento",
    activeClass: "Turma",
    activeMissions: "Missões ativas",
  },
  missionCard: {
    viewRejectedProofs: "Ver comprovantes reprovados",
    somePlayersAlreadyReceived: "Alguns players já receberam essa missão!",
    playersSelected: "{{count}} jogadores selecionados",
    onePlayerSelected: "1 jogador selecionado",
    conclusionsLabel: "Conclusões:",
    descriptionPrefix: "Descrição: ",
    createdByPrefix: "Criado por:",
    allClassesLabel: "todas",
    seeMore: "Ver mais",
    missionDeletedSuccess: "Missão excluída com sucesso!",
    missionUpdatedSuccess: "Missão atualizada com sucesso!",
    missionUpdateError: "Houve um erro ao atualizar a missão",
    disableAction: "desabilitar",
    deleteAction: "excluir",
    missionThumbnail: "thumbnail da missao",
    pendingProofsCount: "{{count}} comprovante(s) por aprovar",
    noPendingProofs: "Nenhum comprovante por aprovar",
    daysRemaining: "{{days}} dias restantes",
    lastDay: "Último dia!",
    expired: "Expirada",
    noExpiration: "Sem prazo",
    approveProofs: "Aprovar comprovantes",
    edit: "Editar",
    disableMission: "Desabilitar missão",
    enableMission: "Habilitar missão",
    deleteMission: "Excluir missão",
    validateManually: "Validação manual",
    aiValidation: "Validação por IA",
    searchPlayerByName: "Pesquisar jogador por nome",
    orderAlphabetically: "Ordenar por nome",
    orderByProofs: "Ordenar por comprovantes",
    selectAllFiltered: "Selecionar todos filtrados",
    deselectAll: "Desmarcar todos",
    approveMission: "Aprovar missão",
    approveMissionFor: "Aprovar missão para",
    player: "jogador",
    players: "jogadores",
    confirmApproval: "Confirmar aprovação",
    approvalSuccess: "Missão aprovada com sucesso! {{count}} jogador(es)",
    approvalError: "Erro ao aprovar missão, tente novamente",
    close: "Fechar",
    undoCollection: "Descoletar",
    undoCollectionTitle: "Descoletar missão",
    undoCollectionDesc: "Tem certeza que deseja descoletar essa missão para o jogador {{name}}?",
    undoCollectionConfirm: "Descoletar",
    undoCollectionSuccess: "Missão descoletada com sucesso",
    undoCollectionError: "Erro ao descoletar missão",
    debugTitle: "Debug Info",
    approveProofsTitle: "Aprovar Comprovantes",
    allProofs: "Todos",
    approvedByAi: "Aprovados pela IA",
    rejectedByAi: "Reprovados pela IA",
    pendingReview: "Pendentes",
    feedbackLabel: "Feedback:",
    aiFeedbackLabel: "Feedback da IA:",
    proofDateLabel: "Data:",
    approved: "Aprovado",
    rejected: "Reprovado",
    pendingStatus: "Pendente",
    rewarded: "Recompensado",
    approveBtn: "Aprovar",
    rejectBtn: "Reprovar",
    approvedSuccessToast: "Comprovante(s) aprovado(s) com sucesso!",
    rejectedSuccessToast: "Comprovante(s) reprovado(s) com sucesso!",
    errorUpdatingProofs: "Erro ao atualizar os comprovantes",
    missionCompletedFeedback: "Missão concluída, Parabéns!!",
    notCompletedFeedback: "Não concluído",
    noProofsAvailable: "Nenhum comprovante por aprovar.",
    selectAllVisible: "Selecionar Todos Visíveis",
    approveSelected: "Aprovar Selecionados",
    rejectSelected: "Reprovar Selecionados",
    debugJson: "Debug JSON",
    debugJsonTitle: "Debug JSON",
    jsonSerializationError: "Erro ao serializar JSON:",
    periodLabel: "Período",
    missionExpiredOn: "Missão expirou em",
    willStartOn: "Começa em",
    noGamesAlert: "Nenhum segmento atribuído a esta missão",
    teachersCanValidate: "Professores podem validar",
    teachersCantValidate: "Professores não podem validar",
    selectClassPlaceholder: "Selecionar turma",
    clearFilter: "Limpar filtro",
    sortByLabel: "Ordenar por",
    selectedLabel: "Selecionado",
    clearSelection: "Limpar seleção",
    confirmRejection: "Confirmar reprovação",
    confirmBatchAction: "Confirmar ação em lote para {{count}} comprovante(s)",
    processingBatch: "Processando em lote...",
    cancelBtn: "Cancelar",
    proofTitle: "Comprovante",
    addedToSelection: "Adicionado à seleção",
    selectPlayersTitle: "Selecionar alunos",
    collectedCount: "Coletado",
    receivedCount: "Recebido",
    rejectedCount: "Reprovado",
    collected: "Coletado",
    received: "Recebido",
    alreadyCollected: "Já coletado",
    alreadyReceived: "Já recebido",
    noProofsForStudent: "Nenhum comprovante encontrado para este aluno",
    selectProofToUncollect: "Selecionar comprovante para descoletar",
    undoCollectionConfirmMsg: "Tem certeza que deseja descoletar este comprovante?",
    approvingLabel: "Aprovando...",
    loading: "Carregando...",
    selectAtLeastOnePlayer: "Selecione pelo menos um aluno",
  },
  missionAlertBeforeDisable: {
    confirmDisable: "Você tem certeza que deseja {{action}} esta missão?",
    playersNotCollected: "Todos esses jogadores <strong>ainda não coletaram a missão!!</strong>, tem certeza que deseja {{action}} essa missão sem distribuir as recompensas?",
    andMoreStudents: "E mais {{count}} outros alunos...",
    disablingMessage: "Essa ação vai desabilitar a missão para todos os participantes, impossibilitando que eles a concluam.",
    deletingMessage: "Essa ação é irreversível, todos as informações da missão serão completamente perdidas.",
    cancel: "Cancelar",
    distributeAndAction: "Distribuir e {{action}}",
    disableAction: "desabilitar",
    deleteAction: "excluir",
  },
  missionIAFileConfirm: {
    title: "Confirmar arquivo",
    fileLabel: "Arquivo:",
    sizeLabel: "Tamanho:",
    typeLabel: "Tipo:",
    preview: "Pré-visualização",
    noPreview: "Pré-visualização não disponível para este tipo de arquivo.",
    cancel: "Cancelar",
    confirm: "Confirmar",
    loading: "Carregando...",
    imageAlt: "Preview do arquivo",
  },
  missionIASelectStudents: {
    title: "Selecionar alunos com IA",
    description: "Descreva quais alunos você quer selecionar ou envie um arquivo.",
    promptPlaceholder: "Ex: Selecione os 5 melhores alunos do 3º ano",
    orSendFile: "ou envie um arquivo",
    selectFile: "Selecionar arquivo",
    processing: "Processando...",
    processingDesc: "A IA está analisando sua solicitação...",
    selectedStudents: "Alunos selecionados",
    studentsCount: "{{count}} aluno(s) selecionado(s)",
    confirmSelection: "Confirmar seleção",
    cancel: "Cancelar",
    send: "Enviar",
    errorProcessing: "Erro ao processar a solicitação",
    noStudentsFound: "Nenhum aluno encontrado",
    sendingData: "Enviando dados...",
    deterministicCode: "Código Determinístico",
    aiProcessing: "processamento de IA",
    iaProcessedSelection: "IA processou a seleção",
    configuration: "Configuração",
    configDescription: "Descreva sua regra e, opcionalmente, envie uma planilha.",
    clickOrDragFile: "Clique ou arraste e solte o arquivo aqui",
    supportedFormats: "(.csv, .xlsx, .pdf, imagens)",
    removeFile: "Remover",
    aiPromptLabel: "Escreva aqui como a nossa IA deve selecionar os alunos",
    aiPromptPlaceholder: "Ex: Selecionar alunos que fizeram a tarefa na data 28/05",
    processWithAi: "Processar com IA",
    aiAnalysis: "Análise da IA",
    preview: "Prévia",
    selectedCountLabel: "Selecionados: {{count}}",
    searchStudent: "Buscar aluno",
    liveAiResponse: "Resposta da IA ao vivo",
    processingStatus: "Processando...",
    iaProcessingError: "Erro ao processar IA",
    notSentToAi: "Ainda não enviado para IA",
    iaFoundNoStudents: "IA não encontrou alunos",
    hideLogs: "Ocultar logs",
    viewAllLogs: "Ver todos os logs",
    viewProcessingLogs: "Ver todos os logs do processamento",
    debugIa: "🔍 Debug IA",
    studentHeader: "Aluno",
    actionsHeader: "Ações",
    removeStudent: "Remover",
    removeStudentTitle: "Remover aluno?",
    removeStudentConfirm: "Você deseja remover {{name}} da seleção?",
    thisStudent: "este aluno",
    cancelBtn: "Cancelar",
    closeBtn: "Fechar",
    applySelection: "Aplicar seleção",
    fileSelectedReady: "Arquivo selecionado. Pronto para processar com IA.",
    debugHistoryTitle: "🔍 Debug IA — Histórico completo de conversas",
    downloadJson: "⬇ Baixar JSON",
    attempt: "tentativa",
    step: "passo",
    promptSent: "📤 Prompt enviado",
    codeGenerated: "💻 Código gerado",
    responseResult: "📥 Resposta / resultado",
    selectionRegistered: "Seleção registrada no histórico.",
    selectionMayNotBeSaved: "Registro no histórico pode não ter sido salvo.",
    failedToRegisterSelection: "Falha ao registrar a seleção.",
    validationFailed: "Validação falhou após 2 tentativas: {{reason}}",
    inconsistentResult: "resultado inconsistente",
    failedToProcessAi: "Falha ao processar a seleção por IA",
    completed: "Concluído!",
  },
  missionCreateWithAiModal: {
    title: "Criar missão com IA",
    promptLabel: "O que você quer criar?",
    promptPlaceholder: "Descreva a missão que você quer criar...",
    generating: "Gerando...",
    generate: "Gerar missão",
    generatingPreview: "Preview da missão",
    titleLabel: "Título:",
    descriptionLabel: "Descrição:",
    proofLabel: "Comprovação:",
    cancel: "Cancelar",
    create: "Criar missão",
    aiDescription: "A IA irá gerar uma missão baseada na sua descrição. Este é um recurso inteligente que pode exigir créditos de IA.",
    errorGenerating: "Erro ao gerar missão com IA",
  },
  missionManualValidation: {
    title: "Validação manual",
    description: "Selecione os alunos que completaram a missão",
    searchPlaceholder: "Pesquisar aluno por nome",
    filterByClass: "Filtrar por turma",
    allClasses: "Todas as turmas",
    filterByGame: "Filtrar por segmento",
    allGames: "Todos os segmentos",
    selectAll: "Selecionar todos",
    deselectAll: "Desmarcar todos",
    noStudentsFound: "Nenhum aluno encontrado",
    cancel: "Cancelar",
    confirm: "Confirmar",
    selectedCount: "{{count}} selecionado(s)",
    collectedCount: "Coletado(s): {{count}}",
    collected: "Coletado",
    receivedCount: "Recebido(s): {{count}}",
    received: "Recebido",
    approvalSuccess: "Missão aprovada com sucesso!",
    approvalError: "Erro ao aprovar missão",
    noStudentsSubtitle: "Nenhum aluno participou desta missão ainda",
  },
  missionProofsModal: {
    title: "Comprovantes da missão",
    searchByName: "Buscar por nome do aluno",
    filterByGame: "Filtrar por segmento",
    filterByClass: "Filtrar por turma",
    allGames: "Todos",
    allClasses: "Todas",
    allProofs: "Todos",
    approvedByAi: "Aprovados pela IA",
    rejectedByAi: "Reprovados pela IA",
    pending: "Pendentes",
    noProofsFound: "Nenhum comprovante encontrado",
    proofDate: "Data do comprovante",
    playerName: "Nome do aluno",
    className: "Turma",
    gameName: "Segmento",
    status: "Status",
    actions: "Ações",
    approve: "Aprovar",
    reject: "Reprovar",
    close: "Fechar",
  },
  missionsFilter: {
    filterBtn: "Filtrar",
    selectFiltersTitle: "Selecione seus filtros",
    selectFilterType: "Selecione o tipo de filtro",
    clearFilter: "Limpar o filtro",
    selectFilterValue: "Selecione um valor para filtrar",
    activeNoValue: "Missões ativa não tem um valor atribuido a ela",
    cancel: "Cancelar",
    applyFilters: "Aplicar filtros",
    createdBy: "Criado por",
    game: "Segmento",
    activeMissions: "Missões ativas",
  },
  verComprovantesModal: {
    title: "Comprovantes",
    searchPlaceholder: "Buscar por nome do aluno",
    filterMission: "Filtrar por missão",
    allMissions: "Todas as missões",
    filterStatus: "Status",
    allStatuses: "Todos",
    approved: "Aprovados",
    rejected: "Reprovados",
    pendingStatus: "Pendentes",
    noProofs: "Nenhum comprovante encontrado",
    approve: "Aprovar",
    reject: "Reprovar",
    approveAll: "Aprovar todos",
    rejectAll: "Reprovar todos",
    close: "Fechar",
    proofDetails: "Detalhes do comprovante",
    playerLabel: "Aluno:",
    classLabel: "Turma:",
    gameLabel: "Segmento:",
    dateLabel: "Data:",
    statusLabel: "Status:",
    feedbackLabel: "Feedback:",
    aiFeedbackLabel: "Feedback da IA:",
    historyTitle: "Histórico de tentativas",
    attemptNumber: "Tentativa {{number}}",
    noFeedback: "Sem feedback",
    approvedStatus: "Aprovado",
    rejectedStatus: "Reprovado",
    pendingReview: "Pendente",
    rewardedStatus: "Recompensado",
    successApproved: "Comprovante(s) aprovado(s) com sucesso!",
    successRejected: "Comprovante(s) reprovado(s) com sucesso!",
    errorUpdating: "Erro ao atualizar comprovante(s)",
    missionCompletedFeedback: "Missão concluída, Parabéns!!",
    notCompletedFeedback: "Não concluído",
    unknown: "Desconhecido",
    noClass: "Sem turma",
    noGame: "Sem segmento",
    proofApprovedSuccess: "Comprovante aprovado com sucesso!",
    proofRejectedSuccess: "Comprovante reprovado com sucesso!",
    failedToApproveProof: "Falha ao aprovar comprovante",
    failedToRejectProof: "Falha ao reprovar comprovante",
    noProofsAvailable: "Nenhum comprovante disponível",
    batchApprovedSuccess: "{{count}} comprovante(s) aprovado(s) com sucesso!",
    batchRejectedSuccess: "{{count}} comprovante(s) reprovado(s) com sucesso!",
    failedToApproveAll: "Falha ao aprovar comprovantes",
    failedToRejectAll: "Falha ao reprovar comprovantes",
    collectedBadge: "Coletado",
    approvedBadge: "Aprovado",
    rejectedBadge: "Reprovado",
    approvedByAiBadge: "Aprovado IA",
    pendingBadge: "Pendente",
    noContent: "Sem conteúdo",
    videoLabel: "Vídeo",
    proofOfPlayer: "Comprovante de {{name}}",
    firstSubmission: "Este é o primeiro envio do aluno para esta missão.",
    attemptLabel: "Tentativa {{number}}",
    atTime: "às",
    mediaSent: "Mídia enviada",
    noDescription: "Sem descrição",
    selectMission: "Selecione uma missão",
    proofsCount: "{{count}} comprovantes",
    backToList: "Voltar para lista",
    aiFeedback: "Feedback da IA",
    teacherFeedback: "Feedback do Professor",
    sendFeedbackToStudent: "Enviar feedback ao aluno",
    feedbackPlaceholder: "Digite seu feedback para o aluno...",
    rejectBtn: "Reprovar",
    approveBtn: "Aprovar",
    attemptHistory: "Histórico de tentativas",
    searchByNameOrClass: "Buscar por nome do aluno ou turma",
    classFilterAll: "Todas",
    classFilterPrefix: "Turma:",
    gameFilterAll: "Todos",
    gameFilterPrefix: "Segmento:",
    tabAll: "Todos ({{count}})",
    tabApprovedAi: "Aprovados IA ({{count}})",
    tabRejectedAi: "Reprovados IA ({{count}})",
    tabPending: "Pendentes ({{count}})",
    noProofsWithFilters: "Nenhum comprovante encontrado com os filtros selecionados.",
    aiApprovedProofs: "Comprovantes aprovados pela IA",
    rejectAllBtn: "Reprovar todos",
    approveAllBtn: "Aprovar todos",
    noAiApprovedProofs: "Nenhum comprovante aprovado pela IA encontrado.",
    aiRejectedProofs: "Comprovantes reprovados pela IA",
    noAiRejectedProofs: "Nenhum comprovante reprovado pela IA encontrado.",
    pendingProofsForReview: "Comprovantes pendentes de avaliação",
    noPendingProofsFound: "Nenhum comprovante pendente encontrado.",
  },
  relatorioMissoesModal: {
    title: "Resultados: {{name}}",
    subtitleQuiz: "Relatorio detalhado da atividade",
    subtitleMission: "Relatorio detalhado da missao",
    eligibleOne: "1 aluno elegivel",
    eligibleMany: "{{count}} alunos elegiveis",
    completedOne: "1 concluido",
    completedMany: "{{count}} concluidos",
    pendingOne: "1 pendente",
    pendingMany: "{{count}} pendentes",
    classesOne: "1 turma",
    classesMany: "{{count}} turmas",
    loadingQuiz: "Carregando dados do quiz...",
    loadingMission: "Carregando dados da missao...",
    noEligibleTitleQuiz: "Nenhum aluno elegivel para este quiz",
    noEligibleTitleMission: "Nenhum aluno elegivel para esta missao",
    noEligibleBodyQuiz:
      "Os filtros de turma ou os segmentos configurados no quiz nao correspondem a nenhum aluno cadastrado. Revise as turmas selecionadas ou os segmentos do quiz para liberar a participacao.",
    noEligibleBodyMission:
      "Os filtros de turma ou os segmentos configurados na missao nao correspondem a nenhum aluno cadastrado. Revise as turmas selecionadas ou os segmentos da missao para liberar a participacao.",
    completionRateTitle: "Taxa de Conclusao",
    rateHigh: "Alta",
    rateMedium: "Media",
    rateLow: "Baixa",
    noEligibleStudentsRate: "Sem alunos elegiveis",
    completionProgress: "{{completed}} de {{total}} alunos completaram",
    studyTimeTitle: "Tempo de estudo",
    comingSoon: "Em breve",
    metricUnavailableQuiz: "Esta metrica ainda nao esta disponivel para quizzes.",
    metricUnavailableMission: "Esta metrica ainda nao esta disponivel para missoes.",
    studyTimeDescription: "Tempo total de estudo dos alunos",
    insightLabel: "Insight:",
    insightBest: "{{name}} lidera com {{pct}}% de conclusao",
    worstNeedsAttention: "{{name}} precisa de atencao com {{pct}}%",
    rankingSectionTitle: "Conclusao por Turma",
    rankingSectionHintQuiz: "Turmas ordenadas pelo percentual de conclusao do quiz",
    rankingSectionHintMission: "Turmas ordenadas pelo percentual de conclusao da missao",
    noClassTitle: "Nenhuma turma disponivel",
    noClassBecauseNoEligible: "Como nao ha alunos elegiveis, ainda nao ha turmas para exibir.",
    noClassOtherQuiz:
      "Os participantes deste quiz nao estao vinculados a turmas, ou as turmas filtradas nao possuem alunos elegiveis.",
    noClassOtherMission:
      "Os participantes desta missao nao estao vinculados a turmas, ou as turmas filtradas nao possuem alunos elegiveis.",
    percentCompleted: "{{pct}}% de conclusao",
    studentsCompletedRatio: "{{done}}/{{total}} alunos concluiram",
    pendingSuffixOne: "1 pendente",
    pendingSuffixMany: "{{count}} pendentes",
    participantsTitle: "Participantes",
    completedRatioBadge: "{{done}}/{{total}} concluidos",
    completionPerStudent: "Registro de conclusao por aluno",
    noneCompletedYetQuiz:
      "Nenhum aluno concluiu o quiz ainda. Ele pode ter sido recem-criado.",
    noneCompletedYetMission:
      "Nenhum aluno concluiu a missao ainda. Ela pode ter sido recem-criada ou estar aguardando aprovacao dos comprovantes.",
    allClassesFilter: "Todas as turmas",
    classesCountSelected: "{{count}} turmas",
    searchClassPlaceholder: "Buscar turma...",
    noClassFound: "Nenhuma turma encontrada.",
    clearSelection: "Limpar selecao ({{count}})",
    allGames: "Todos os segmentos",
    gameQuiz: "Quiz",
    gameMission: "Missao",
    gameTrail: "Trilha",
    gameChallenge: "Desafio",
    statusAll: "Todos",
    statusCompleted: "Concluido",
    statusNotCompleted: "Nao concluido",
    searchByNamePlaceholder: "Pesquisar por nome",
    colName: "Nome",
    colClass: "Turma",
    colStatus: "Status",
    colCompletionDate: "Data de conclusao",
    loadingParticipants: "Carregando participantes...",
    noEligibleParticipants: "Nenhum participante elegivel",
    noParticipantsForFilters: "Nenhum participante para os filtros aplicados",
    adjustFiltersHintQuiz: "Ajuste as turmas ou os segmentos do quiz para incluir alunos.",
    adjustFiltersHintMission: "Ajuste as turmas ou os segmentos da missao para incluir alunos.",
    tryClearFilters: "Tente limpar a busca ou trocar os filtros de turma e status.",
    statusBadgeCompleted: "Concluido",
    statusBadgeNotCompleted: "Nao concluido",
    showingParticipants: "Mostrando {{shown}} de {{total}} participantes",
    dash: "\u2014",
  },
  missionBncc: {
    bnccCorrelation: "Correlação com a BNCC",
    proposedAction: "Ação proposta:",
    justification: "Justificativa:",
    noBnccData: "Sem dados BNCC disponíveis",
    title: "BNCC",
    close: "Fechar",
    bnccCodes: "Códigos BNCC",
    noteLabel: "Nota:",
    noteText: "Para mais detalhes sobre a Base Nacional Comum Curricular (BNCC), consulte o documento oficial do MEC.",
  },
  bnccSelectionModal: {
    title: "Selecionar competências BNCC",
    searchPlaceholder: "Pesquisar competência...",
    categories: "Categorias",
    competencies: "Competências",
    selectedCount: "{{count}} selecionada(s)",
    confirm: "Confirmar",
    cancel: "Cancelar",
    noResults: "Nenhum resultado encontrado",
    clearSelection: "Limpar seleção",
    bnccTitle: "Seleção de Competência BNCC",
    home: "Início",
    searchByNameDescCode: "Buscar por nome, descrição ou código...",
    back: "Voltar",
    loadingBncc: "Carregando dados da BNCC...",
    loadError: "Erro ao carregar dados da BNCC.",
    ensureFileAvailable: "Certifique-se de que o arquivo bncc-competencias.json está disponível.",
    competencyCount: "{{count}} competência",
    competencyCountPlural: "{{count}} competências",
    noSearchResults: "Nenhum resultado encontrado para sua busca.",
    noCategoriesAvailable: "Nenhuma categoria ou competência disponível neste nível.",
  },
  rewardsShoppingDomain: {
    pageSubtitle: "Gerencie o catálogo de recompensas e acompanhe os pedidos dos alunos.",
    // rewards-form missing keys
    redeemError: "Ocorreu um erro ao processar sua solicitação",
    rewardDeletedSuccess: "Recompensa removida com sucesso.",
    newRewardTitle: "Nova Recompensa",
    confirmDeleteTitle: "Confirmar exclusão",
    confirmDeleteDescription: "Você tem certeza que deseja excluir as seguintes recompensas?",
    cancelButton: "Cancelar",
    pageTitle: "Recompensas | Gamefik Escolas no level máximo.",
    browse: "Procurar",
    removeImage: "Remover",
    productNamePlaceholder: "Nome que aparecerá para os alunos",
    description: "Descrição",
    descriptionPlaceholder: "Breve descrição do item",
    selectCategory: "Categoria",
    quantity: "Quantidade disponível",
    quantityPlaceholder: "Quantidade de estoque",
    limitPerPlayer: "Limite por jogador",
    allGames: "Em quais segmentos esta recompensa é aplicável?",
    scheduledStart: "Programar",
    noStoreGames: "Sem segmentos!",
    outOfStoreStock: "Fora da loja",
    rewardsGeneratorClose: "Fechar",
    rewardsDialogDescription: "Escolha as recompensas que deseja resgatar",
    redeemSuccess: "Recompensas resgatadas com sucesso.",
    editRewardPageTitle: "Editar recompensa | Gamefik Escolas no level máximo.",
    noButton: "Não",
    // rewards-form rarity keys
    rarityCommonName: "comum",
    rarityUncommonName: "incomum",
    rarityRareName: "raro",
    rarityEpicName: "épico",
    rarityLegendaryName: "lendário",
    rarityCommonTime: "Tempo até o resgate: 1 a 2 semanas",
    rarityUncommonTime: "Tempo até o resgate: 2 a 4 semanas",
    rarityRareTime: "Tempo até o resgate: 1 a 3 meses",
    rarityEpicTime: "Tempo até o resgate: 3 a 6 meses",
    rarityLegendaryTime: "Tempo até o resgate: 6 a 10 meses",
    uploadImage: "Faça o upload de uma imagem",
    rarityImportantInfo: "Informações Importantes sobre a raridade da recompensa",
    useThisValue: "🪙 Usar este valor 🪙",
    defineValueIn: "Defina o valor em {{point}}",
    savingReward: "Aguarde, salvando recompensa...",
    fillRewardName: "Preencha o nome da recompensa",
    fillRewardDescription: "Preencha a descrição da recompensa",
    fillAvailableQuantity: "Preencha a quantidade disponível",
    selectAtLeastOneGame: "Selecione ao menos um segmento",
    saveButton: "Salvar",
    // rewards-dialog error messages
    insufficientScore: "O aluno não possui pontuação suficiente para esta compra.",
    duplicatedTransaction: "Lançamento duplicado.",
    insufficientBalance: "Saldo insuficiente para esta recompensa.",
    rewardNotFound: "Recompensa não encontrada ou indisponível.",
    playerNotFound: "Jogador não encontrado.",
    gameNotFound: "Segmento não encontrado.",
    rewardAlreadyRedeemed: "Recompensa já foi resgatada anteriormente.",
    purchaseFinishError: "Houve um erro ao finalizar esta compra. Verifique sua conexão e tente novamente.",
    playerNotLinked: "O jogador selecionado não está vinculado a um segmento.",
    cannotAssignMultipleGames: "Não é possível atribuir recompensas para alunos vinculados em segmentos diferentes.",
    allOthersRedeemed: "Todas as outras recompensas foram resgatadas corretamente.",
    errorRedeemingReward: "Erro ao resgatar a recompensa",
    forPlayer: "para o",
    errorType: "Tipo",
    errorDetails: "Detalhes",
    genericError: "Erro Genérico",
    duplicatedTransactionType: "Transação Duplicada",
    insufficientBalanceType: "Saldo Insuficiente",
    rewardNotFoundType: "Recompensa Não Encontrada",
    playerNotFoundType: "Jogador Não Encontrado",
    gameNotFoundType: "Segmento Não Encontrado",
    alreadyRedeemedType: "Recompensa Já Resgatada",
    technicalError: "Erro Técnico",
    unknownError: "Erro desconhecido.",
    // rewards-list
    startCreatingRewards: "Comece criando sua primeira recompensa para motivar seus alunos.",
    // purchase-home & purchase-card labels
    gameLabel: "Segmento",
    classLabel: "Turma",
    totalLabel: "Total",
    selectItemAria: "selecionar item",
    // purchase-card error messages
    internalError: "Um problema interno ocorreu.",
    invalidProductCode: "Código do produto inválido. Verifique se o produto ainda está disponível.",
    insufficientBalancePurchase: "Saldo insuficiente para realizar a compra.",
    playerNotFoundPurchase: "Jogador não encontrado. Verifique se o jogador ainda está ativo.",
    gameNotFoundPurchase: "Segmento não encontrado. Verifique se o segmento ainda está ativo.",
    purchaseAlreadyProcessed: "Este pedido já foi processado anteriormente.",
    processingError: "Ocorreu um erro ao processar o pedido. Entre em contato com o suporte.",
    connectionError: "Problema de conexão. Verifique sua internet e tente novamente.",
    timeoutError: "A operação demorou muito para responder. Tente novamente.",
    serverError: "Erro de comunicação com o servidor.",
    // gift page missing keys
    receiptMessageTitle: "Mensagem do recibo",
    readAndAcceptTerms: "Li e aceito os termos de uso",
    finishWithBalance: "Finalizar com Saldo",
    clearCart: "Esvaziar",
    // balance page terms
    termsIntroTitle: "1. INTRODUÇÃO",
    termsIntroText: "Ao optar por adicionar saldo à sua conta Gamefik, você estará concordando com os seguintes Termos de Uso. Estes termos abordam as regras associadas à adição de saldos, compra de Gift Cards e outros aspectos relevantes.",
    termsServiceTitle: "2. DESCRIÇÃO DO SERVIÇO",
    termsServiceText: "A Gamefik oferece a opção para usuários adicionarem saldo à sua conta e, em seguida, utilizarem esse saldo para adquirir Gift Cards de várias empresas parceiras.",
    termsAddBalanceTitle: "3. ADICIONANDO SALDO",
    termsAddBalanceMinValue: "a) O valor mínimo para adicionar saldo é de R$50,00.",
    termsAddBalanceRefund: "b) Caso deseje, o usuário poderá solicitar o reembolso total do saldo adicionado em até 7 dias após a compra, contanto que nenhum Gift Card tenha sido adquirido.",
    termsGiftCardsTitle: "4. AQUISIÇÃO DE GIFT CARDS",
    termsGiftCardsNoReturn: "a) Uma vez adquirido um Gift Card, ele não pode ser devolvido ou reembolsado.",
    termsGiftCardsCodes: "b) Os códigos dos Gift Cards só serão visíveis para o jogador no momento da compra confirmada. Estes códigos não são acessíveis através da interface de gerenciamento.",
    termsGiftCardsUnique: "c) O código é único e gerado apenas uma vez, no ato da compra pelo jogador.",
    termsGiftCardsProblems: "d) Caso haja problemas com o código, o jogador deverá verificar o procedimento de ativação ou entrar em contato diretamente com a empresa provedora do Gift Card.",
    termsGiftCardsIntermediary: "e) A Gamefik atua apenas como intermediadora na venda de Gift Cards, e os códigos são fornecidos pelas respectivas empresas. Não nos responsabilizamos por eventuais problemas com os códigos.",
    termsResponsibilitiesTitle: "5. RESPONSABILIDADES E OBRIGAÇÕES DO USUÁRIO",
    termsResponsibilitiesA: "a) O usuário é responsável por todas as transações realizadas em sua conta.",
    termsResponsibilitiesB: "b) A Gamefik se reserva o direito de bloquear o saldo e funções da loja caso o cliente esteja inadimplente com a plataforma.",
    termsResponsibilitiesC: "c) Ao cancelar a assinatura da Gamefik, o usuário perderá o acesso e direitos sobre o saldo e os Gift Cards adquiridos.",
    termsIPTitle: "6. PROPRIEDADE INTELECTUAL",
    termsIPText: "Todos os direitos, títulos e interesses associados ao serviço Gamefik, incluindo, mas não se limitando ao seu design, texto, gráficos e todos os softwares e códigos associados, são propriedade da Gamefik.",
    termsPrivacyTitle: "7. POLÍTICA DE PRIVACIDADE",
    termsPrivacyText: "Ao aceitar estes termos, você concorda com a nossa Política de Privacidade. Recomendamos que leia a nossa Política de Privacidade disponível no nosso site.",
    termsChangesTitle: "8. ALTERAÇÕES NOS TERMOS",
    termsChangesText: "Estes Termos de Uso podem ser atualizados ocasionalmente. Ao continuar a utilizar o serviço após qualquer atualização, você concorda com os novos termos. Notificaremos os usuários sobre qualquer mudança significativa através dos canais de comunicação habituais.",
    // table-extract non-i18n labels
    boletoPix: "Boleto/Pix",
    boletoMethod: "Boleto",
    creditCardPayment: "Cartão de crédito",
    adminPayment: "Admin",
    pixPayment: "PIX",
    notInformed: "Não informado",
    giftPurchaseType: "Compra de Gift",
    refundType: "Reembolso",
    userOrigin: "Usuário",
    adminAddBalance: "Admin - Adicionar saldo",
    adminRemoveBalance: "Admin - Remover saldo",
    balancePayment: "Saldo",
    invalidProductType: "Produto Inválido",
    orderAlreadyProcessedType: "Pedido Já Processado",
    connectionProblemType: "Problema de Conexão",
    timeoutType: "Timeout",
    communicationErrorType: "Erro de Comunicação",
    basicInfo: "Informações Básicas",
    descriptionLabel2: "Descrição:",
    noDescription: "Sem descrição",
    typeLabel: "Tipo:",
    rewardType: "Recompensa",
    priceLabel: "Preço:",
    giftCardValue: "Valor do Gift Card:",
    datesLabel: "Datas",
    createdAtLabel: "Criado em:",
    lastUpdateLabel: "Última atualização:",
    statusAndStock: "Status e Estoque",
    statusLabel: "Status:",
    inStockLabel: "Em estoque",
    outOfStockLabel: "Fora de estoque",
    indicatorsLabel: "Indicadores:",
    noGameSelected: "Nenhum segmento selecionado",
    priceLabel2: "Preço",
    availableStockLabel: "Estoque disponível",
    creationDateLabel: "Data de criação:",
    priceLabel3: "Preço:",
    confirmDeletion: "Confirmar exclusão",
    confirmDeletionDescription: "Você tem certeza que deseja excluir as seguintes recompensas?",
    cancelAction: "Cancelar",
    rewardsPageTitle: "Recompensas | Gamefik Escolas no level máximo.",
    tipCreateRewards: "Crie recompensas atrativas",
    tipCreateRewardsDesc: "Ofereça recompensas variadas que motivem diferentes tipos de alunos.",
    tipCreateRewardsPlaceholder: "Video mostrando como criar recompensas eficazes",
    tipStrategicPrices: "Configure preços estratégicos",
    tipStrategicPricesDesc: "Balance o valor dos coins para manter o engajamento sem tornar as recompensas muito fáceis.",
    tipStrategicPricesPlaceholder: "Video sobre estratégias de precificação de recompensas",
    tipAISuggestions: "Use a IA para sugestões",
    tipAISuggestionsDesc: "Aproveite a geração automática de recompensas para economizar tempo.",
    tipAISuggestionsPlaceholder: "Video tutorial sobre como usar IA para criar recompensas",
    tipMonitorStock: "Monitore o estoque",
    tipMonitorStockDesc: "Mantenha controle sobre as recompensas disponíveis e reponha quando necessário.",
    tipMonitorStockPlaceholder: "Video sobre gestão de estoque de recompensas",
    tipAnalyzePopularity: "Analise a popularidade",
    tipAnalyzePopularityDesc: "Veja quais recompensas são mais procuradas e ajuste sua estratégia.",
    tipAnalyzePopularityPlaceholder: "Video sobre análise de dados de recompensas",
    errorProcessingRequest: "Ocorreu um erro ao processar sua solicitação",
    editButton: "Editar",
    editReward: "Editar recompensa",
    deleteButton: "Excluir",
    newReward: "Nova Recompensa",
    editRewardTitle: "Editar Recompensa",
    myStore: "Minha Loja",
    // redesign page
    redesignPageTitle: "Recompensas — Gamefik",
    newRewardShort: "Nova",
    filterAllRewards: "Todas",
    filterActiveRewards: "Ativas",
    filterInactiveRewards: "Inativas",
    filters: "Filtros",
    activeFilter: "{{count}} filtro ativo",
    activeFilters: "{{count}} filtros ativos",
    segmentFilter: "Segmento",
    allSegments: "Todos os segmentos",
    rewardFilter: "Recompensa",
    allRewards: "Todas as recompensas",
    classFilter: "Turma",
    allClasses: "Todas as turmas",
    periodFilter: "Período",
    allDates: "Qualquer data",
    today: "Hoje",
    last7Days: "Últimos 7 dias",
    last30Days: "Últimos 30 dias",
    clearFilters: "Limpar filtros",
    viewList: "Ver em lista",
    viewGrid: "Ver em grade",
    statementTab: "Extrato",
    // estoque de gift cards comprados (cart-checkout) — seção na aba Recompensas
    giftStockTitle: "Gift cards comprados",
    giftStockSubtitle: "Seu estoque pago. Disponibilize na loja para os alunos resgatarem com moedas.",
    giftStockAvailable: "{{count}} disponível",
    giftStockAvailablePlural: "{{count}} disponíveis",
    giftStockPublishedBadge: "Na loja",
    giftStockPublishCta: "Disponibilizar na loja",
    giftStockModalTitle: "Disponibilizar gift card na loja",
    giftStockModalDescription: "Defina quanto os alunos pagam em moedas para resgatar este gift card.",
    giftStockPriceLabel: "Preço em moedas",
    giftStockQuantityLabel: "Quantidade a disponibilizar",
    giftStockLimitLabel: "Limite por aluno",
    giftStockClassesLabel: "Turmas",
    giftStockSelectAllClasses: "Todas as turmas",
    giftStockSubmit: "Disponibilizar",
    giftStockSubmitting: "Disponibilizando...",
    giftStockSuccess: "Gift card disponível na loja!",
    giftStockError: "Não foi possível disponibilizar o gift card. Tente novamente.",
    statementLoadError: "Não foi possível carregar o extrato.",
    statementRetry: "Tentar novamente",
    statementShowMore: "Ver mais {{count}} itens",
    statementShowLess: "Ver menos",
    searchRewardPlaceholder: "Buscar recompensa...",
    searchOrdersPlaceholder: "Buscar pedido ou aluno...",
    tryAnotherSearch: "Tente buscar por outro nome",
    noRewardsRegistered: "Nenhuma recompensa cadastrada",
    clickToCreateFirstReward: "Clique em Nova Recompensa para começar",
    noOrdersFound: "Nenhum pedido encontrado",
    adjustFilters: "Tente ajustar os filtros",
    ordersWillAppearHere: "Os pedidos dos alunos aparecerão aqui",
    statusUpdatedSuccess: "Status atualizado com sucesso",
    statusUpdatedError: "Erro ao atualizar o status",
    rewardDeletedSuccessMsg: "Recompensa excluída com sucesso",
    rewardDeletedErrorMsg: "Erro ao excluir a recompensa",
  },
  schoolDetails: {
    active: "Ativa",
    inactive: "Inativa",
    email: "Email",
    status: "Status",
    engagement: "Engajamento",
    noTags: "Nenhuma tag",
  },
  exportModal: {
    exportTitle: "Exportar Dados",
    selectColumns: "Selecionar colunas",
    selectAll: "Selecionar todas",
    deselectAll: "Desmarcar todas",
    export: "Exportar",
    cancel: "Cancelar",
    exporting: "Exportando...",
    recommendedForAnalysis: "Recomendado para análises",
    compatibleWithAny: "Compatível com qualquer programa",
    noSorting: "Sem ordenação",
    descending: "Decrescente",
    ascending: "Crescente",
    exportSummary: "Resumo da exportação",
  },
  filterTable: {
    searchPlaceholder: "Pesquisar...",
    noResults: "Nenhum resultado encontrado",
    showing: "Mostrando",
    of: "de",
    results: "resultados",
    previous: "Anterior",
    next: "Próximo",
  },
  selectFrequency: {
    daily: "Diariamente",
    weekly: "Semanalmente",
    biweekly: "Quinzenal",
    monthly: "Mensalmente",
    selectFrequency: "Frequência",
    monToFri: "Seg. a Sex.",
    custom: "Personalizado",
    daysOfWeek: "Dias da Semana",
  },
  multipleSelect: {
    selectAll: "Selecionar todos",
    deselectAll: "Desmarcar todos",
    selected: "selecionado(s)",
    search: "Pesquisar...",
    allClassesCanSee: "Todas as turmas poderão ver esta missão",
    allYourClassesCanSee: "Todas as suas turmas poderão ver esta missão",
    selectGameToSeeClasses: "Selecione um segmento para ver as turmas",
  },
  infoModal: {
    close: "Fechar",
    gotIt: "Entendi",
  },
  carousel: {
    previous: "Anterior",
    next: "Próximo",
  },
  aiMaterialPreview: {
    description: "{{type}} · {{size}}",
    unknownType: "Tipo não informado",
    imageAlt: "Prévia de {{name}}",
    pdfTitle: "PDF {{name}}",
    unavailable: "A prévia não está disponível para este formato.",
    openNewTab: "Abrir em nova aba",
    openPreview: "Visualizar {{name}}",
    remove: "Remover material {{name}}",
    materialsUsed: "Materiais usados",
  },
  chatIa: {
    titlePlaceholder: "Título da atividade",
    descriptionPlaceholder: "Uma linha explicando do que se trata",
    deleteCardTitle: "Excluir o cartão {{n}}?",
    deleteCardDescription: "A frente e o verso desse cartão somem. Não dá para desfazer.",
    deleteCardCancel: "Manter o cartão",
    copilotSeeAnswer: "Ver o que mudou",
    copilotSendToApply: "Aperte enviar para aplicar · {{cost}} créditos de IA",
    leaveGuardGeneratingTitle: "A IA ainda está criando",
    leaveGuardGeneratingDescription: "Se sair agora, a criação para no meio e os créditos de IA deste pedido não voltam.",
    leaveGuardGeneratingStay: "Esperar terminar",
    leaveGuardUnsentTitle: "Sair sem mandar pra turma?",
    leaveGuardUnsentDescription: "Guardamos seu rascunho, mas a atividade ainda não chegou a nenhum aluno.",
    deleteQuestionTitle: "Excluir a pergunta {{n}}?",
    deleteQuestionDescription: "A pergunta e as alternativas dela somem. Não dá para desfazer.",
    deleteQuestionCancel: "Manter a pergunta",
    deleteQuestionConfirm: "Excluir",
    copilotTriggerLabel: "Editar com IA",
    stateEditing: "Editando...",
    stateSavedNow: "Salvo",
    stateUnsaved: "Alterações não salvas",
    leaveGuardTitle: "Sair sem salvar?",
    leaveGuardDescription: "Você editou esta atividade e ainda não salvou. Se sair agora, as alterações se perdem.",
    leaveGuardStay: "Continuar editando",
    leaveGuardLeave: "Sair mesmo assim",
    removeQuestion: "Excluir esta pergunta",
    discardDraft: "Descartar rascunho",
    attachFile: "Anexar arquivo",
    send: "Enviar",
    // --- GFK-166: copiloto como barra + painel sob demanda ---
    copilotName: "Professor Gamefik",
    copilotSubtitleQuiz: "Ajusta este quiz",
    copilotSubtitleFlashcard: "Ajusta estes cartões",
    copilotSubtitleMissao: "Ajusta esta missão",
    copilotSubtitleTrilha: "Ajusta esta trilha",
    copilotOpenConversation: "Conversa",
    copilotCloseConversation: "Fechar conversa",
    copilotNewAnswer: "Resposta nova do copiloto",
    copilotToolsLabel: "O que você quer mudar",
    copilotHistoryLabel: "Conversa",
    copilotCostHint: "Cada pedido usa {{cost}} créditos de IA",
    copilotBalance: "Você tem {{balance}}",
    copilotEditPlaceholder: "Peça uma mudança. Ex.: deixe a pergunta 5 mais fácil",
    copilotEditPlaceholderFlashcard: "Peça uma mudança. Ex.: acrescente 2 cartões sobre o tema",
    copilotEditPlaceholderMissao: "Peça uma mudança. Ex.: aceite vídeo além de foto",
    copilotEditPlaceholderTrilha: "Peça uma mudança. Ex.: junte as fases 2 e 3",
    aiChangedBadge: "a IA mudou",
    aiChangedGoTo: "Ir para {{target}}",
    aiChangedTargetQuestion: "a pergunta {{n}}",
    aiChangedTargetCard: "o cartão {{n}}",
    aiChangedTargetMission: "a missão",
    aiChangedTargetPhase: "a fase {{n}}",
    useWithClass: "Usar com a turma",
    endOfQuiz: "Fim do quiz.",
    endOfFlashcards: "Fim dos cartões.",
    endOfMission: "Fim da missão.",
    reviewedCount: "{{count}} itens, revisados.",
    draftSavedAuto: "Salvo automaticamente",
    draftSaving: "Salvando...",
    quickChipMoreCards: "+ Mais cartões",
    quickChipSimpler: "Mais simples",
    quickChipChangeProof: "Mudar o comprovante",
    quickChipChangeReward: "Mudar a recompensa",
    manualQuizReady: "Quiz em branco pronto! Edite no editor e publique quando quiser. Se precisar, me peça ajuda por aqui.",
    manualMissionReady: "Missão em branco pronta! Edite no editor e publique quando quiser. Se precisar, me peça ajuda por aqui.",
    manualQuizToast: "Quiz em branco criado.",
    manualMissionToast: "Missão em branco criada.",
    manualFlashcardReady: "Baralho de flashcards em branco pronto! Edite os cards no editor e publique quando quiser. Se precisar, me peça ajuda por aqui.",
    manualFlashcardToast: "Flashcards em branco criados.",
    heroTitle: "O que vamos",
    heroTitleHighlight: "criar hoje?",
    heroSubtitle: "Descreva um tema, cole um texto ou anexe material. A IA gera um quiz ou uma missao prontos para editar e salvar.",
    textareaPlaceholder: "Ex: Quiz sobre fotossintese para o 7o ano com 5 questoes de multipla escolha...",
    options: "Opcoes",
    typeAuto: "Tipo: Auto",
    typeQuiz: "Quiz",
    typeMission: "Missao",
    difficultyAuto: "Dificuldade: Auto",
    difficultyChild: "Crianca (4-6 anos)",
    difficultyElementary1: "Fundamental I (7-10 anos)",
    difficultyElementary2: "Fundamental II (11-14 anos)",
    difficultyHighSchool: "Ensino Medio",
    difficultyExam: "Nivel ENEM",
    difficultyCollege: "Nivel Faculdade",
    difficultyPostGrad: "Pos-graduacao",
    questionsAuto: "Questoes: Auto",
    questionsCount: "{{count}} questoes",
    typeFlashcard: "Flashcards",
    typeFlashcardVf: "Flashcards VF",
    retryGeneration: "Tentar novamente",
    flashcardVfStatement: "Afirmação",
    flashcardVfExplanation: "Explicação",
    flashcardVfAnswerLabel: "A afirmação é...",
    flashcardVfTrue: "Verdadeira",
    flashcardVfFalse: "Falsa",
    flashcardVariantLabel: "Tipo:",
    flashcardVariantClassic: "Vice-versa",
    flashcardVariantVf: "Verdadeiro ou Falso",
    cardsAuto: "Cards: Auto",
    cardsCount: "{{count}} cards",
    maxCardsReached: "O baralho pode ter no maximo 30 cards.",
    minCards: "O baralho precisa manter pelo menos um card.",
    flashcardCards: "Cards do baralho",
    flashcardCardsCount: "{{count}} cards",
    flashcardCardNumber: "Card {{current}}",
    flashcardOf: "Card {{current}} de {{total}}",
    flashcardRemoveCard: "Remover card",
    flashcardFront: "Frente",
    flashcardBack: "Verso",
    flashcardFrontPlaceholder: "Conceito, termo ou pergunta",
    flashcardBackPlaceholder: "Explicacao ou resposta",
    flashcardAddCard: "Adicionar card",
    flashcardTapToFlip: "Toque para virar",
    flashcardPrevCard: "Card anterior",
    flashcardNextCard: "Proximo card",
    flashcardPreviewEmpty: "Adicione cards para visualizar o baralho.",
    flashcardPublishError: "Não foi possível publicar os flashcards: {{message}}",
    flashcardUpdatedSuccess: "Flashcards atualizados com sucesso!",
    flashcardNeedsOneCard: "Preencha pelo menos um card completo (frente e verso).",
    languageAuto: "Idioma: Auto",
    languagePtBr: "Portugues (Brasil)",
    languageEnUs: "Ingles",
    languageEsEs: "Espanhol",
    clear: "Limpar",
    attachPdf: "Anexar PDF ou imagem",
    createWithAi: "Criar com IA",
    generating: "Gerando...",
    processing: "Processando...",
    connecting: "Conectando com a IA...",
    processingDescription: "Estamos processando seu pedido. Isso pode levar alguns segundos...",
    applyingChanges: "Aplicando alterações...",
    phaseRouter: "Analisando intencao...",
    phasePlanner: "Planejando operacao...",
    phaseExecutor: "Gerando conteudo...",
    phaseReviewer: "Revisando qualidade...",
    phasePatch: "Aplicando alterações...",
    phaseClarification: "Preparando pergunta...",
    phaseDefault: "Iniciando...",
    phaseRouterDesc: "A IA esta analisando seu pedido...",
    phasePlannerDesc: "Definindo a estrategia para criar ou modificar sua atividade...",
    phaseReviewerDesc: "Verificando se o conteudo gerado atende ao seu pedido...",
    phasePatchDesc: "Aplicando as alteracoes na atividade...",
    phaseClarificationDesc: "Preparando uma pergunta para esclarecer seu pedido...",
    fileNotSupported: "O arquivo \"{{name}}\" nao e suportado.",
    chatTitle: "Chat IA",
    chatSubtitle: "Gamefik IA",
    describeActivity: "Descreva sua atividade...",
    quickChipMoreQuestions: "+ Mais perguntas",
    quickChipHarder: "Mais difícil",
    quickChipEasier: "Mais fácil",
    quickChipChangeTheme: "Mudar tema",
    quickChipAddImages: "Adicionar imagens",
    welcomeMessage: "Olá! Descreva a atividade que voce quer criar ou envie materiais em PDF/imagem. Eu gero um quiz ou uma missão completos para você.",
    trailSuggestionTitle: "Parece uma trilha",
    trailSuggestionDescription:
      "Trilhas completas (fases com várias atividades) são criadas no editor de trilhas. Quer levar esse pedido para lá?",
    trailSuggestionGo: "Criar como trilha",
    trailSuggestionStay: "Continuar aqui",
    generatingActivity: "Gerando atividade com a IA...",
    unsavedChangesConfirm: "Você tem alterações não salvas. Deseja sair mesmo assim?",
    thinkingWord1: "Pensando",
    thinkingWord2: "Analisando",
    thinkingWord3: "Criando",
    thinkingWord4: "Agindo",
    thinkingWord5: "Organizando",
    activityGenerated: "Atividade gerada com sucesso.",
    activityGeneratedFallback: "Atividade criada com sucesso. Revise os detalhes no editor ao lado.",
    currentActivityInvalid: "Houve um problema ao carregar a atividade atual. Criando uma nova atividade.",
    noActivityEmpty: "A IA vai gerar a atividade aqui. Comece descrevendo o que voce precisa no chat.",
    noActivityTitle: "Nenhuma atividade gerada ainda",
    save: "Salvar",
    saving: "Salvando...",
    quiz: "Quiz",
    mission: "Missao",
    tabInfo: "Informacoes",
    tabQuestions: "Questoes",
    title: "Titulo",
    description: "Descricao",

    statement: "Enunciado",
    points: "Pontos",
    alternatives: "Alternativas",
    addQuestion: "Adicionar questao",
    addAlternative: "Adicionar alternativa",
    proofType: "Tipo de comprovacao",
    proofPhoto: "Foto",
    proofVideo: "Video",
    proofText: "Texto",
    proofFile: "Arquivo",
    validationType: "Validacao",
    validationAi: "IA",
    validationManual: "Manual",
    validationAuto: "Automatica",
    validationAiFull: "IA Automatica",
    validationAutoFull: "Auto-validacao",
    validationAiDescription: "Aluno envia comprovante e a IA valida na hora",
    validationManualDescription: "Aluno envia comprovante e o professor valida",
    validationAutoDescription: "Sem comprovante: aluno apenas confirma a conclusao",
    proofPhotoDescription: "Imagem como comprovante",
    proofVideoDescription: "Gravacao de video",
    proofTextDescription: "Resposta escrita",
    proofFileDescription: "PDF ou documento",
    missionApprovalSection: "Comprovação e aprovação",
    missionHasProofLabel: "Missão terá comprovantes",
    missionHasProofDescription: "Aluno envia foto como comprovante",
    missionAiApprovalLabel: "Aprovação automática com IA",
    missionTeacherApprovalLabel: "Professores podem aprovar",
    missionTeacherApprovalDescription: "Professor pode aprovar a missão manualmente, com ou sem comprovante",
    missionNoProofHint: "Aluno apenas confirma a conclusão e coleta a recompensa",
    missionNoProofTeacherHint: "Aluno confirma a conclusão e o professor aprova manualmente",
    missionNoProofBadge: "Sem comprovante",
    richTextPhoto: "Foto",
    richTextVideo: "Video",
    richTextPdf: "PDF",
    bold: "Negrito",
    italic: "Italico",
    taskSentTitle: "Tarefa criada!",
    missionSentTitle: "Missao criada!",
    taskSentDescription: "Agora seus alunos precisam realizar o download do app para realizar essa tarefa",
    shareWithStudents: "Compartilhe o link com seus alunos",
    copyActivityLink: "Copiar link da atividade",
    linkCopied: "Link copiado!",
    downloadAppTitle: "Baixe o app Gamefik:",
    nextStepsTitle: "Proximos passos:",
    nextStep1: "Adicione seus alunos a Gamefik na pagina Turmas",
    nextStep2: "Compartilhe o Link de acesso",
    nextStep3: "Seus alunos baixam o app e aprendem se divertindo!",
    finish: "Concluir",
    attachmentContext: "Contexto dos anexos",
    maxQuestionsReached: "O quiz pode ter no maximo 30 questoes.",
    minQuestions: "O quiz precisa ter pelo menos uma questao.",
    maxAlternatives: "Cada questao pode ter no maximo 6 alternativas.",
    minAlternatives: "Cada questao precisa ter ao menos 2 alternativas.",
    generateOrLoad: "Gere ou carregue uma atividade antes de salvar.",
    fillRequired: "Preencha todos os campos obrigatorios antes de salvar.",
    errorTooManyQuestions: "Quantidade de questoes acima do permitido",
    errorTooManyQuestionsDesc: "Esse pedido ultrapassou o limite atual de questoes que a interface consegue organizar de uma vez.",
    errorTooManyQuestionsSuggestion: "Tente pedir um numero menor de questoes agora ou divida em dois pedidos.",
    errorApiKeyMissing: "Configuracao da IA ausente",
    errorApiKeyMissingDesc: "A chave da IA nao esta configurada corretamente neste ambiente.",
    errorApiKeyMissingSuggestion: "Verifique a configuracao da chave da IA e tente novamente.",
    errorInvalidJson: "Resposta da IA veio em formato inesperado",
    errorInvalidJsonDesc: "A resposta recebida nao pode ser interpretada com seguranca.",
    errorInvalidJsonSuggestion: "Tente novamente com um pedido mais especifico.",
    errorUnsupportedFile: "Formato de arquivo nao suportado",
    errorUnsupportedFileDesc: "No momento, a interface aceita apenas imagens e arquivos PDF como anexo.",
    errorUnsupportedFileSuggestion: "Envie um PDF ou uma imagem e tente novamente.",
    errorFileTooLarge: "Arquivo muito grande",
    errorFileTooLargeDesc: "Um dos anexos ultrapassou o tamanho maximo permitido.",
    errorFileTooLargeSuggestion: "Reduza o arquivo para menos de 50 MB e tente novamente.",
    errorNoContext: "Faltou contexto para gerar a atividade",
    errorNoContextDesc: "Nenhum texto nem anexo foi enviado para a IA trabalhar.",
    errorNoContextSuggestion: "Descreva a atividade desejada ou envie um material de apoio.",
    errorAiFailed: "A IA nao conseguiu concluir esse pedido",
    errorAiFailedDesc: "O sistema tentou refinar a resposta, mas nao chegou a uma operacao segura para aplicar.",
    errorAiFailedSuggestion: "Reformule o pedido com mais clareza e tente novamente.",
    errorGeneric: "Nao foi possivel concluir sua solicitacao",
    errorGenericDesc: "Aconteceu um problema durante a geracao ou edicao da atividade.",
    errorGenericSuggestion: "Tente novamente em instantes ou reformule o pedido.",
    operationCheckingTitle: "Estamos confirmando sua geração",
    operationCheckingDesc: "A conexão foi interrompida, mas a operação ainda pode estar em andamento.",
    operationCheckingSuggestion: "Aguarde enquanto verificamos o resultado sem gerar ou cobrar novamente.",
    operationAuthTitle: "Sua sessão precisa ser renovada",
    operationAuthDesc: "Não foi possível confirmar esta geração porque sua sessão expirou ou não tem acesso.",
    operationAuthSuggestion: "Entre novamente ou recarregue a página. Não inicie outra geração enquanto isso.",
    operationInvalidTitle: "Não foi possível confirmar esta operação",
    operationInvalidDesc: "A verificação da geração recebeu uma solicitação inválida.",
    operationInvalidSuggestion: "Recarregue a página antes de tentar gerar novamente.",
    committedNoResultTitle: "A atividade foi concluída, mas o resultado não chegou",
    committedNoResultDesc: "Os créditos foram confirmados, porém esta tela não recebeu o resultado final.",
    committedNoResultSuggestion: "Não tente gerar novamente agora. Atualize a página ou consulte suas atividades em instantes.",
    noAttachmentContext: "Nenhum contexto de anexo foi usado nesta atividade.",
    details: "Detalhes",
    clickCircleHint: "clique no círculo para marcar a correta",
    selectCorrectAnswer: "Selecione a alternativa correta",
    questionNumber: "Questão {{current}}",
    ofTotal: "de {{total}}",
    removeAlternative: "Remover alternativa",
    streamingFailed: "Nao foi possivel concluir a geracao em streaming.",
    needMoreDetails: "Preciso de mais detalhes para continuar.",
    generateFromAttachment: "Gerar atividade a partir do anexo \"{{name}}\".",
    generateFromAttachments: "Gerar atividade usando {{count}} anexos enviados.",
    errorGenericFallback: "Nao foi possivel gerar a atividade no momento.",
    back: "Voltar",
    chat: "Chat",
    edit: "Editar",
    openChat: "Conversar com a IA",
    closeChat: "Fechar conversa",
    editActivity: "Editar atividade",
    editMission: "Editar missao",
    newActivity: "Nova atividade",
    draft: "Rascunho",
    updateDraft: "Salvar como rascunho",
    publish: "Publicar",
    publishing: "Publicando...",
    preview: "Pre-visualizar",
    invalidEditContext: "Contexto de edicao invalido.",
    editContextNotFound: "Contexto de edicao nao encontrado.",
    editContextMismatch: "Contexto de edicao nao corresponde a atividade aberta.",
    editLoadFailed: "Nao foi possivel carregar a atividade para edicao.",
    attemptLabel: "---- Tentativa {{count}} ----",
    loadedActivityMismatchQuiz: "A atividade carregada nao corresponde ao quiz original.",
    loadedActivityMismatchMission: "A atividade carregada nao corresponde a missao original.",
    loadedActivityMismatchFlashcard: "A atividade carregada nao corresponde aos flashcards originais.",
    quizUpdatedSuccess: "Quiz atualizado com sucesso!",
    missionUpdatedSuccess: "Missao atualizada com sucesso!",
    quizPublishedSuccess: "Quiz publicado com sucesso!",
    missionPublishedSuccess: "Missao publicada com sucesso!",
    insufficientCredits: "Creditos de IA insuficientes. Voce precisa de {{needed}}, mas tem apenas {{remaining}}.",
    publishErrorFallback: "Erro ao publicar atividade. Tente novamente.",
    teacherCoinLimitPreviewTitle: "Saldo de moedas por turma",
    teacherCoinLimitPreviewDescription: "Confira o consumo antes de publicar.",
    teacherCoinLimitPreviewValues: "Solicitado: {{requested}} · Saldo: {{remaining}}",
    teacherCoinLimitUnlimited: "Ilimitado",
    teacherCoinLimitDisabled: "As atividades com moedas estão desabilitadas para educadores.",
    teacherCoinLimitExceeded: "Uma ou mais turmas excedem o limite de moedas. Ajuste o valor ou as turmas para tentar novamente.",
    teacherCoinLimitUnavailable: "Não foi possível verificar os limites de moedas agora. Tente novamente em instantes.",
    turmasWithoutSegmentError: "Nao foi possivel enviar: a(s) turma(s) {{turmas}} estao sem segmento definido ou com o segmento excluido. Defina um segmento valido para essas turmas (em Turmas) antes de enviar — sem isso os alunos nao recebem a recompensa.",
    draftUpdatedSuccess: "Rascunho atualizado com sucesso!",
    draftSavedSuccess: "Rascunho salvo com sucesso!",
    draftErrorFallback: "Erro ao salvar rascunho. Tente novamente.",
    assistantAvatarAlt: "Assistente IA",
    attachAction: "Anexar",
    enterToSend: "Enter para enviar",
    createAction: "Criar",
    footerTagline: "Gamefik IA · Criacao inteligente de atividades educacionais",
    suggestionCapitals: "Quiz sobre as Sete Maravilhas do Mundo",
    suggestionReadingMission: "Missao de leitura em familia",
    suggestionMultiplicationQuiz: "Quiz de tabuada divertido",
    suggestionScienceChallenge: "Desafio de ciencias",
    startDateAfterEndDate: "Data de inicio nao pode ser posterior ao prazo final",
    coverImage: "Imagem de capa",
    coverImageAlt: "Capa",
    addCoverImage: "Adicionar imagem de capa",
    chooseFromBank: "Escolher do banco",
    startDate: "Data de Inicio",
    endDate: "Prazo Final",
    selectDate: "Selecione a data",
    continuousMissionLabel: "Missão contínua",
    continuousMissionHint: "Pode ser concluída e aprovada várias vezes pelos alunos.",
    continuousMissionNoDeadline: "Sem prazo (contínua)",
    classes: "Turmas",
    selectClasses: "Selecione turmas",
    allClasses: "Todas as turmas",
    classesSelectedSingle: "1 turma",
    classesSelectedMultiple: "{{count}} turmas",
    selectAllClasses: "Selecionar todas",
    noClassesFound: "Nenhuma turma encontrada",
    selectAtLeastOneClass: "Selecione pelo menos uma turma para publicar.",
    selectEndDate: "Selecione a data de prazo final para publicar.",
    coins: "Moedas",
    coinOptionEasy: "Facil",
    coinOptionMedium: "Medio",
    coinOptionHard: "Dificil",
    customCoinValue: "Valor personalizado",
    coinsLockedTitle: "Recompensas com moedas indisponíveis",
    coinsLockedDescription: "Seu plano atual não inclui moeda personalizada. Faça upgrade para liberar a distribuição de moedas.",
    coinsLockedCta: "Ver planos",
    coinsInvalidTitle: "Plano com pagamento pendente",
    coinsInvalidDescription: "Sua assinatura está com o pagamento atrasado ou foi cancelada. Regularize seu plano para distribuir moedas aos alunos.",
    coinsInvalidCta: "Regularizar plano",
    debugIaButton: "Debug IA",
    debugActive: "ativo",
    previewAspectRatioLabel: "Aspecto",
    previewAspectTallPhone: "Alto 9:19.5",
    previewAspectPhone: "Celular 9:16",
    previewAspectTablet: "Tablet 3:4",
    previewAspectSquare: "Quadrado 1:1",
    previewPreparing: "Preparando preview em tempo real...",
    previewIframeTitle: "Preview de quiz no app do aluno",
    previewEmptyTitle: "Gere uma atividade para visualizar",
    previewEmptyDescription: "Assim que a IA responder, a pre-visualizacao do aluno aparecera aqui.",
    previewCorrectFeedback: "Boa! Essa e a alternativa correta.",
    previewIncorrectFeedback: "Essa nao e a correta. Voce pode avancar mesmo assim ou trocar sua resposta.",
    previewResult: "Resultado: {{correct}} de {{total}} acertos",
    previewRestart: "Reiniciar preview",
    previewNextQuestion: "Proxima questao",
    previewStartHint: "Toque em \"Jogar este Quiz\" para iniciar a experiencia do aluno.",
    previewRetake: "Refazer preview",
    previewPlayQuiz: "Jogar este Quiz",
    previewStartMission: "Iniciar Missao",
    previewCreatedBy: "Criado por",
    previewTeacherName: "Professor Gamefik",
    generatingAltThinking: "Shiny pensando",
    generatingAltHappy: "Shiny feliz",
    generatingStepIdeas: "Desenhando ideias...",
    generatingStepCreativity: "Recheando de criatividade...",
    generatingStepMixing: "Misturando ingredientes magicos...",
    generatingStepFun: "Polvilhando um pouco de diversao...",
    generatingStepKnowledge: "Temperando com conhecimento...",
    generatingStepSpecialTouch: "Adicionando um toque especial...",
    generatingStepShapingQuestions: "Dando forma às questões...",
    generatingStepShining: "Deixando tudo brilhar...",
    generatingStepAdjusting: "Ajustando os detalhes...",
    generatingStepAlmostDone: "Quase pronto...",
    testAsStudent: "Testar como aluno",
    testAsStudentSubtitle: "Veja a demo dessa atividade",
    openDemo: "Abrir demo",
    sendAsTask: "Enviar como tarefa",
    sendAsTaskDescription: "Defina um prazo. Cada aluno faz no ritmo dele, de casa ou da escola.",
    playLive: "Jogar ao vivo",
    playLiveDescription: "Todo mundo joga agora, junto, pelo celular.",
    comingSoon: "Em breve",
    present: "Apresentar",
    presentDescription: "Você conduz a discussão, os alunos acompanham.",
    backToEditor: "Voltar ao editor",
    autoSave: "Suas alterações são salvas automaticamente",
    activityReady: "Atividade pronta!",
    howToUseNow: "Como você quer usar agora?",
    studentPreviewTitle: "Preview do aluno",
    studentPreviewSubtitle: "Interaja com o app abaixo para testar",
    shinyThumbsUpAlt: "Shiny dando joinha",
    quizCreatedTitle: "Quiz criado com sucesso!",
    missionCreatedTitle: "Missão criada com sucesso!",
    newQuiz: "Novo Quiz",
    newMission: "Nova Missão",
    activityPublishedDescription: "Sua atividade foi publicada e já está disponível para os alunos.",
    viewMyActivities: "Ver minhas atividades",
    redirectingIn: "Redirecionando em {{seconds}}s...",
    selectClassesPlaceholder: "Selecione as turmas",
    add: "Adicionar",
    startDateLabel: "Início",
    deadlineLabel: "Prazo",
    selectPlaceholder: "Selecione",
    classesWillReceive: "Selecione as turmas que receberão esta atividade",
    sendMission: "Enviar missão",
    sendTask: "Enviar tarefa",
    sendTaskDescription: "Configure as opções da tarefa antes de enviar para os alunos",
    startLiveSession: "Iniciar Ao Vivo",
    startLiveSessionDescription: "Escolha as turmas e a moeda antes de iniciar a sessão",
  },
  home: {
    greeting: {
      morning: "Bom dia, {name} 👋",
      afternoon: "Boa tarde, {name} 👋",
      evening: "Boa noite, {name} 👋",
      morningNoName: "Bom dia 👋",
      afternoonNoName: "Boa tarde 👋",
      eveningNoName: "Boa noite 👋",
      subtitle: "O que vamos criar hoje?",
    },
    chatBar: {
      placeholder: "✨ Descreva o que você quer criar — a IA faz o resto",
      /** Versão curta pro pill mobile — a longa trunca no meio da palavra numa
       * tela estreita (achado do critique da Home mobile). */
      placeholderMobile: "✨ O que criar?",
      create: "Criar",
      createWithAi: "Criar com IA ✨",
      attach: "Anexar PDF ou imagem",
      attachHint: "ou arraste e solte aqui",
      dropHere: "Solte para anexar",
      suggestionsLabel: "Exemplos:",
      attachLimit: "Máximo de {count} arquivos, {size}MB cada",
      typeLabel: "Tipo de atividade",
      suggestion1: "Quiz sobre o sistema solar · 6º ano",
      suggestion2: "Missão de leitura com foto de comprovação",
      expandedPlaceholder: {
        quiz: "Sobre o que será seu quiz? Ex.: frações para o 5º ano, 10 perguntas",
        missao: "Qual será a missão? Ex.: ler um capítulo e enviar foto do resumo",
        flashcard: "Sobre o que serão os cartões? Ex.: vocabulário de inglês",
        flashcard_vf: "Sobre o que serão as afirmações? Ex.: fatos históricos do Brasil",
        trilha: "Descreva a jornada. Ex.: trilha de matemática básica com 5 etapas",
      },
    },
    checklist: {
      title: "Seus primeiros passos",
      progress: "{completed} de {total}",
      dismiss: "Ocultar",
      reopen: "Primeiros passos",
      completeTitle: "Sua turma já pode jogar! 🎉",
      completeSubtitle: "Você completou todos os passos. Agora é só acompanhar.",
      footer: "Complete os passos e sua turma estará jogando ainda esta semana 🚀",
      heroes: {
        microcopy: "Complete os {total} passos e liberte os heróis 🔓",
        bubble: "Psiu! A gente precisa da sua ajuda 👀",
        imageAltCaged: "Heróis da Gamefik presos numa jaula",
        imageAltFree: "Heróis da Gamefik livres, comemorando",
        imageButtonLabel: "Liberte os heróis da Gamefik",
        modalTitle: "Liberte os heróis da Gamefik",
        modalSpeech:
          "Oi, prof! A gente ficou preso aqui e só você pode nos libertar: complete seus primeiros passos. Tem recompensa esperando: um desconto exclusivo no plano Shiny. 🎁",
        modalSpeechSchool:
          "Oi! A gente ficou preso aqui e só você pode nos libertar: complete os primeiros passos e deixe sua escola prontinha para engajar os alunos. 💪",
        modalStepsTitle: "Passos que faltam",
        rewardLocked: "Complete tudo para revelar seu cupom",
        rewardHint: "Cupom de {percent}% vitalício no plano Shiny",
        modalCta: "Continuar",
        celebrationTitle: "Você libertou os heróis! 🎉",
        celebrationSubtitle:
          "Todos os passos completos. A Gamefik inteira desbloqueada, e eles deixaram um presente:",
        couponNote: "{percent}% de desconto vitalício no plano Shiny",
        couponCopy: "Copiar",
        couponCopied: "Copiado!",
        celebrationCta: "Seja Shiny",
        completedSubtitle: "Todos os passos concluídos. Sua recompensa está te esperando.",
        completedSubtitleSchool: "Todos os passos concluídos. Sua escola está pronta para engajar os alunos!",
        rewardCta: "Resgatar recompensa",
        rewardCountdown: "Sua recompensa expira em {time}",
        rewardClaimed: "Recompensa resgatada",
        rewardPitch:
          "Você desbloqueou toda a Gamefik. Com o plano Shiny sua turma vai ainda mais longe: potencial máximo, sem limites.",
      },
      journey: {
        title: "Complete a jornada e liberte os heróis",
        subtitle: "Libere o potencial máximo da Gamefik e ganhe um presente. 🎁",
        subtitleSchool: "Configure sua escola e libere o potencial máximo da Gamefik.",
        remainingSingle: "Falta 1 passo para libertá-los!",
        remainingPlural: "Faltam {count} passos para libertá-los",
        stepDone: "concluído",
        stepCurrent: "passo atual",
        stepLocked: "ainda não iniciado",
      },
      topbar: {
        label: "Primeiros passos",
        ariaLabel: "Primeiros passos: {completed} de {total} concluídos",
        tooltip: "Acompanhe seus primeiros passos aqui",
        currentStep: "Passo atual",
        continue: "Continuar",
        seeJourney: "Ver jornada completa",
        rewardCta: "Resgatar recompensa",
        rewardClaimed: "Recompensa resgatada",
        celebration: "Jornada completa!",
        celebrationTitle: "Sua escola está pronta!",
        celebrationBody: "Todos os primeiros passos concluídos. Agora é engajar os alunos.",
      },
      sidebar: {
        bubble1: "oiiii, tá aí? 👀",
        bubble2: "Não esquece de soltar a gente! 🔓",
        bubble3: "Socorro! Ajuda a gente 🙏",
        bubble4: "Tá quase! Continua 💪",
        bubble5: "Psiu! Por aqui 😄",
        bubble6: "A gente acredita em você! ⭐",
      },
      toast: {
        stepDone: "{title} concluído!",
        remainingSingle: "Falta 1 passo para libertar os heróis",
        remainingPlural: "Faltam {count} passos para libertar os heróis",
        nextStep: "Próximo passo",
        allDoneTitle: "Você libertou os heróis!",
        allDoneBody: "Todos os primeiros passos concluídos.",
        seeCelebration: "Ver celebração",
      },
      emptyState: {
        chip: "Passo {number} da jornada",
      },
      stepModal: {
        close: "Fechar",
        watchVideo: "Assistir vídeo",
        videoSubtitle: "Tutorial rápido de como fazer",
        backToSteps: "Voltar aos passos",
        downloadApp: "Baixar o app da Gamefik",
      },
      steps: {
        conta: { title: "Conta criada" },
        trilha: {
          title: "Crie sua 1ª trilha",
          cta: "Criar trilha",
          time: "~3 min",
          detail: "Fases, conquistas e progresso: monte uma trilha de aprendizado e a turma avança como num joguinho.",
          tutorial1: "Clique em Criar trilha (ou descreva sua ideia no chat)",
          tutorial2: "Diga o tema e a IA monta as fases para você",
          tutorial3: "Revise as fases e atividades no editor",
          tutorial4: "Publique quando estiver pronta",
        },
        // Jornada da ESCOLA: "atividade_ia" (junto com turma/recompensa/
        // convidar_professores) é passo do checklist do admin/gestor. Ids
        // próprios porque o backend semeia os legados no signup da escola.
        atividade_ia: {
          title: "Crie uma atividade com IA",
          cta: "Criar com IA",
          time: "~2 min",
          detail: "Descreva o que você quer ensinar e a IA cria a atividade pronta para revisar e publicar para as turmas.",
          tutorial1: "Aqui na home, crie com IA ou escolha um dos tipos de atividade. Quanto mais detalhes você der (tema, série, número de questões), melhor o resultado",
          tutorial2: "Clique em Criar e revise o que a IA gerou. Converse com ela no chat para refinar questões, dificuldade ou tema",
          tutorial3: "Quando estiver pronta, clique em Publicar",
          tutorial4: "Escolha como aplicar: tarefa (cada aluno no seu ritmo), ao vivo (todos juntos em sala) ou transmitida na tela (você conduz com a turma)",
          tutorial5: "Preencha as definições de início e término, valor em coins e turmas, e confirme o envio",
        },
        turma: {
          title: "Crie turmas e compartilhe o acesso",
          cta: "Importar turmas",
          time: "~3 min",
          detail: "Traga suas turmas em minutos: importe a planilha de alunos e baixe os acessos prontos para distribuir. A etapa conclui quando pelo menos 1 aluno entrar com o acesso dele.",
          tutorial1: "Vá em Turmas, clique em Importar turmas e baixe o modelo de planilha",
          tutorial2: "Preencha o modelo com o nome do aluno e a turma e salve em .csv",
          tutorial3: "Volte ao app, envie a planilha preenchida e confirme em Importar turmas",
          tutorial4: "Na tela de Turmas, clique em Selecionar várias, escolha a turma e abra Acesso alunos no menu ⋮",
          tutorial5: "Baixe em PDF ou planilha: vai com usuário, senha e QR Code de cada aluno para entrar no app",
        },
        recompensa: {
          title: "Adicione uma recompensa",
          cta: "Criar recompensa",
          time: "~2 min",
          detail: "Recompensas dão valor real às coins que os alunos ganham. É o que faz o engajamento disparar.",
          tutorial1: "Vá em Recompensas e clique em + Nova Recompensa",
          tutorial2: "Preencha os campos e capriche na foto: recompensas com imagem atraem muito mais resgates",
          tutorial3: "Defina o preço em coins. Se precisar, use a calculadora para converter o valor de reais",
          tutorial4: "Clique em Criar Recompensa",
        },
        preview_aluno: {
          title: "Ver como o aluno recebe",
          cta: "Ver preview",
          detail: "Veja exatamente a tela que seus alunos vão ver no app, antes de publicar para a turma.",
          tutorial1: "Crie ou abra uma atividade no editor",
          tutorial2: "Clique em Testar como aluno",
          tutorial3: "Veja a tela exata que o aluno vai ver no app",
          tutorial4: "Ajuste o que achar necessário antes de publicar de vez",
        },
        convidar_professores: {
          title: "Convide seus professores",
          cta: "Convidar professores",
          time: "~1 min",
          detail: "Convide os professores da escola: cada um cria atividades com IA e acompanha as próprias turmas.",
          tutorial1: "Clique no seu nome de usuário (canto superior direito) e abra Configurações",
          tutorial2: "Na aba Usuários, clique em + Adicionar usuário",
          tutorial3: "Preencha o e-mail, a permissão e as turmas que o professor vai acessar",
          tutorial4: "Clique em Enviar. O professor recebe por e-mail um link para definir a senha e entrar na Gamefik",
        },
        alunos: {
          title: "Importe seus alunos",
          cta: "Importar alunos",
          time: "~2 min",
          detail: "É super simples! Traga sua turma em minutos e deixe tudo pronto para jogar.",
          tutorial1: "Vá em Turmas e escolha (ou crie) uma turma",
          tutorial2: "Clique em Importar alunos",
          tutorial3: "Cole a lista de nomes ou envie a planilha",
          tutorial4: "Pronto! A turma já pode receber trilhas e atividades",
        },
        aplicar_turma: {
          title: "Enviar a atividade para a turma",
          cta: "Enviar",
          detail: "Escolha a turma e o prazo para que seus alunos comecem a jogar.",
          tutorial1: "No editor da atividade, clique em Publicar",
          tutorial2: "Escolha Enviar como tarefa",
          tutorial3: "Selecione a turma e defina o prazo",
          tutorial4: "Os alunos recebem o acesso automaticamente",
        },
        app: {
          title: "Compartilhe com seus alunos",
          cta: "Abrir app do aluno",
          time: "~1 min",
          detail: "Mostre o app do aluno e compartilhe o acesso: é assim que a mágica chega na turma.",
          tutorial1: "Peça para os alunos baixarem o app da Gamefik (links abaixo)",
          tutorial2: "Abra o App do aluno no menu para ver os acessos da turma",
          tutorial3: "Copie o acesso individual do aluno, ou imprima o de toda a turma",
          tutorial4: "Com o app e o acesso em mãos, a turma já pode jogar",
        },
      },
    },
    types: {
      title: "Criar uma atividade",
      quiz: { title: "Quiz", description: "Perguntas e alternativas" },
      missao: { title: "Missão", description: "Desafios com foto ou vídeo" },
      flashcard: { title: "Flashcards", description: "Cartões de memorização" },
      flashcard_vf: { title: "V ou F", description: "Verdadeiro ou falso rápido" },
    },
    trail: {
      title: "Trilha estilo Duolingo",
      /** Rótulo curto pro chip de tipo (fileira compacta mobile) — o título
       * cheio ("Trilha estilo Duolingo") quebra a consistência visual ao lado
       * de chips curtos como "Quiz"/"Missão". */
      chipLabel: "Trilha",
      subtitle: "Fases, conquistas e progresso: a turma aprende avançando como num joguinho",
      cta: "Criar trilha",
    },
    recent: {
      title: "Acompanhe sua turma",
      draft: "Rascunho",
      continue: "Continuar",
      review: "Revisar",
      pendingProofsSingle: "{{count}} comprovante para revisar",
      pendingProofsPlural: "{{count}} comprovantes para revisar",
      responsesSingle: "{{count}} resposta",
      responsesPlural: "{{count}} respostas",
      viewAll: "Ver todas as atividades",
    },
    celebration: {
      title: "🎉 Seus alunos começaram a jogar!",
      subtitle: "{count} aluno(s) já entraram na sua trilha.",
      cta: "Ver resultados",
    },
  },
  onboarding: {
    professor: {
      step0: {
        title: "Bem-vindo à Gamefik!",
        subtitle: "Sua conta Free está pronta. Crie atividades gamificadas e engaje sua turma.",
        description: "Faça upgrade para Epic ou Shiny quando quiser desbloquear tudo.",
      },
      stepApp: {
        title: "Uma experiência incrível para seus alunos",
        descriptionBefore: "Você cria atividades e seus alunos se divertem aprendendo! Ao completarem as atividades, eles colecionam",
        descriptionHighlight: "Lendas incríveis",
        descriptionAfter: "e ganham moedas para trocar por recompensas.",
      },
      stepAi: {
        title: "Crie Quizzes e Missões com IA",
        descriptionBefore: "Descreva um tema ou escolha uma ação rápida e nossa",
        descriptionHighlight: "Inteligência Artificial",
        descriptionAfter: "gera atividades completas em segundos. Quizzes, missões e muito mais!",
      },
      stepHow: {
        title: "Como funciona?",
        item1Title: "Adicione turmas e alunos",
        item1Desc: "Na página de Turmas, cadastre suas turmas e alunos",
        item2Title: "Compartilhe o app",
        item2Desc: "Envie o código de acesso para os alunos entrarem no app",
        item3Title: "Crie atividades e a magia acontece",
        item3Desc: "Use a IA para criar quizzes e missões em segundos",
      },
      step1: {
        title: "Quase tudo pronto!",
        subtitle: "Informe qual matéria você leciona e vamos começar!",
      },
      step2: {
        title: "Complete seu perfil",
        subtitle: "Adicione uma foto e informe sua escola",
      },
      step3: {
        title: "Tudo pronto! 🎉",
        subtitle: "Explore a Gamefik e engaje seus alunos de um jeito novo.",
        trialDays: "Você tem {{days}} dias de trial restantes.",
        trialExpired: "Seu trial expirou. Considere fazer upgrade para continuar.",
      },
      subject: {
        matematica: "Matemática",
        portugues: "Português",
        ciencias: "Ciências",
        historia: "História",
        geografia: "Geografia",
        ingles: "Inglês",
        fisica: "Física",
        quimica: "Química",
        biologia: "Biologia",
        ed_fisica: "Ed. Física",
        arte: "Arte",
        outra: "Outra",
      },
      stepFinal: {
        title: "Tudo pronto! Vamos começar?",
        subtitle: "Explore a Gamefik e engaje seus alunos de um jeito completamente novo.",
      },
      btn: {
        start: "Começar",
        skip: "Pular por agora",
        next: "Próximo",
        complete: "Concluir",
        close: "Pular",
        back: "Voltar",
        continue: "Continuar",
        continueIn: "Continuar em {{countdown}}s",
        explore: "Começar a explorar",
        exploreSolo: "Explorar sozinho",
      },
      photoOptional: "Foto opcional",
      schoolLabel: "Escola onde você leciona",
      schoolPlaceholder: "Ex: Colégio Estadual Dom Pedro II",
      countryLabel: "País",
      countryPlaceholder: "Selecione seu país",
      countrySearch: "Buscar país...",
      countryNotFound: "Nenhum país encontrado.",
      phoneLabel: "Celular / Telefone",
      phonePlaceholder: "Número de telefone",
      phoneOptional: "Opcional",
      phoneInvalid: "Número inválido para o país selecionado.",
    },
    escola: {
      step1: {
        title: "Bem-vindo à Gamefik, {{schoolName}}!",
        subtitle: "Seu trial de {{days}} dias começou. Vamos configurar tudo em poucos minutos.",
        subtitleNoTrial: "Vamos configurar tudo em poucos minutos.",
      },
      step2: {
        title: "Engaje seus alunos com a Gamefik",
        subtitle: "Missões com IA e quizzes alinhados ao currículo vão elevar o {{schoolGoal}}.",
        card1: "Missões e quizzes criados por IA",
        card2: "Gestão de turmas e alunos",
        card3: "Gamificação para deixar seus alunos super engajados",
      },
      step3: {
        title: "Pronto para ativar sua escola?",
        subtitle: "Preparamos um passo a passo rápido para você começar",
      },
      btn: {
        next: "Próximo",
        back: "Voltar",
        start: "Começar configuração",
        explore: "Explorar sozinho",
        close: "Fechar",
      },
    },
    schoolWelcomeModal: {
      defaultSchoolName: "Escola",
      shinyGifAlt: "Mascote Shiny feliz",
      appExperienceAlt: "Experiência Gamefik no app",
      aiCreateAlt: "Criação de atividades com IA",
      classesAlt: "Turmas Gamefik",
      teacherIllustrationAlt: "Professor",
      step1: {
        title: "Bem-vindo à Gamefik, {{schoolName}}!",
        subtitle: "Seu trial de {{days}} dias começou. Vamos configurar tudo em poucos minutos.",
      },
      step2: {
        title: "Uma experiência incrível para os alunos",
        descriptionBefore: "Professores criam atividades e os alunos se divertem aprendendo! Ao completarem as atividades, eles colecionam",
        descriptionHighlight: "Lendas incríveis",
        descriptionAfter: "e ganham moedas para trocar por recompensas.",
      },
      step3: {
        title: "Dados que transformam decisões",
        descriptionBefore: "Acompanhe o",
        descriptionHighlight1: "engajamento dos alunos",
        descriptionMiddle: ", desempenho das",
        descriptionHighlight2: "turmas e professores",
        descriptionAfter: ", tudo em tempo real para tomar decisões baseadas em dados.",
        reportAltEngagement: "Engajamento geral dos alunos",
        reportAltClasses: "Comparativo entre turmas",
        reportAltTeachers: "Atividade dos professores",
        reportAltActivities: "Desempenho das atividades",
        tabEngagement: "Engajamento",
        tabClasses: "Turmas",
        tabTeachers: "Professores",
        tabActivities: "Atividades",
      },
      step4: {
        title: "Criação de atividades com IA",
        descriptionBefore: "Seus professores poderão criar",
        descriptionHighlight: "Quizzes, Missões e Flashcards",
        descriptionAfter:
          "em segundos usando nossa Inteligência Artificial, economizando horas de trabalho.",
      },
      step6: {
        title: "Adicione seus professores",
        subtitle:
          "Dê aos seus professores uma ferramenta de IA que economiza tempo e gera dados preciosos de engajamento para a escola.",
        benefit1: "Economiza horas de preparação de aulas",
        benefit2: "Dados precisos de engajamento e desempenho",
        benefit3: "Melhora resultados de aprendizagem",
      },
      step7: {
        title: "Pronto para ativar sua escola?",
        subtitle:
          "Preparamos um passo a passo rápido para você começar a transformar a educação na sua escola.",
      },
      btn: {
        next: "Próximo",
        back: "Voltar",
        continue: "Continuar",
        startSetup: "Começar configuração",
        exploreSolo: "Explorar sozinho",
      },
    },
    primeiros_passos: {
      header: {
        title: "Primeiros passos",
        subtitle: "Configure sua conta em poucos minutos",
      },
      video: {
        timeLabel: "Vídeo tutorial - 25 minutos",
        title: "Como usar a Gamefik",
        playPrompt: "Clique para assistir o tutorial completo",
        playDesc: "Aprenda tudo sobre a plataforma em 25 minutos",
        fallbackLabel: "Assista o vídeo desta etapa",
      },
      tutorial: { heading: "Passo a passo" },
      checklist: {
        title: "Checklist de configuração",
        auto: "Tarefas concluídas automaticamente pela plataforma",
        done: "Parabéns! Todos os passos foram concluídos.",
      },
      celebration: {
        title: "Configuração completa!",
        subtitle: "Sua conta está pronta para usar a Gamefik",
      },
      btn: {
        back: "Voltar ao início",
        view: "Veja como",
        close: "Fechar",
      },
      footer: "{{count}} de {{total}} completos",
      steps: {
        alunos: {
          title: "Adicione seus alunos",
          description: "Crie turmas e adicione seus primeiros alunos",
          videoLabel: "Veja como criar turmas e adicionar alunos",
          tutorial: {
            t1: { title: "Acesse a página de turmas", description: "No menu lateral, clique em 'Turmas' para acessar a lista de turmas da sua escola." },
            t2: { title: "Crie uma nova turma e acesse essa turma", description: "Clique no botão '+ Nova Turma', preencha os dados e depois clique na turma criada para acessá-la." },
            t3: { title: "Adicione seu primeiro aluno", description: "Dentro da turma, clique em 'Adicionar Aluno' e preencha os dados do aluno." },
            t4: { title: "Compartilhe o código desse aluno", description: "Cada aluno recebe um código único de acesso. Compartilhe com ele para que entre na plataforma." },
          },
        },
        atividade: {
          title: "Crie sua primeira atividade",
          description: "Crie um quiz ou missão com ajuda da IA",
          videoLabel: "Aprenda a criar atividades incríveis com IA",
          tutorial: {
            t1: { title: "Acesse a página Chat", description: "No menu lateral, clique em 'Chat' para abrir o assistente de criação com IA." },
            t2: { title: "Descreva o que quer criar hoje", description: "Digite o que você quer criar. Quanto mais detalhes, melhor o resultado!" },
            t3: { title: "Visualize e edite a atividade", description: "Após criar, você consegue ver como seus alunos vão ver aquela atividade e também pode editar." },
            t4: { title: "Ajuste os detalhes e publique", description: "Ajuste os detalhes na aba de informações e publique para seus alunos!" },
          },
        },
        professores: {
          title: "Convide seus professores",
          description: "Adicione outros usuários à sua escola",
          videoLabel: "Saiba como adicionar usuários à sua escola",
          tutorial: {
            t1: { title: "Acesse configurações na sua foto de perfil", description: "Clique na sua foto de perfil no canto superior direito e selecione 'Configurações'." },
            t2: { title: "Acesse a página de usuários", description: "No menu de configurações, clique em 'Usuários' para ver a lista de usuários da escola." },
            t3: { title: "Adicione um novo usuário", description: "Clique em 'Adicionar Usuário' para convidar um novo professor ou coordenador." },
            t4: { title: "Preencha os campos e confirme", description: "Preencha nome, email e cargo. O usuário adicionado receberá um email para finalizar o cadastro." },
          },
        },
        app: {
          title: "Acesse o app dos alunos",
          description: "Veja como seus alunos vão usar a plataforma",
          videoLabel: "Entenda tudo sobre o app do aluno nesse vídeo!",
          tutorial: {
            t1: { title: "Você tem 2 formas de ver a experiência dos seus alunos", description: "Escolha a forma mais conveniente para explorar o app dos alunos." },
            t2: { title: "1ª forma: Acesse a página Acesso Aluno por aqui mesmo", description: "No menu lateral, clique em 'Acesso Aluno', selecione um aluno e espere o aplicativo carregar." },
            t3: { title: "2ª forma: Baixe o aplicativo Gamefik", description: "Baixe na Play Store ou App Store buscando por 'Gamefik'." },
            t4: { title: "Explore as funcionalidades", description: "Explore as funcionalidades e crie atividades para elevar o aprendizado dos seus alunos!" },
          },
        },
      },
    },
  },
  limitModal: {
    limitReachedBadge: "Limite atingido",
    limitReachedTitle: "Limite de {{type}} atingido",
    classesLimitDesc: "Você atingiu o limite de {{count}} turmas do plano Free.",
    studentsLimitDesc: "Você atingiu o limite de {{count}} alunos do plano Free.",
    activitiesLimitDesc: "Você atingiu o limite de {{count}} atividades por mês do plano Free.",
    aiCreditsLimitDesc: "Você usou todos os {{count}} créditos de IA do plano Free este mês.",
    schoolClassesLimitDesc: "Sua escola atingiu o limite de turmas do plano Starter. Faça upgrade para Pro para ter turmas ilimitadas.",
    schoolStudentsLimitDesc: "Sua escola atingiu o limite de {{count}} alunos do plano Starter. Faça upgrade para Pro ou adicione um pacote de +50 alunos.",
    schoolTeachersLimitDesc: "Sua escola atingiu o limite de {{count}} professores do plano Starter. Faça upgrade para Pro e tenha professores ilimitados.",
    schoolAICreditsLimitDesc: "Seus professores usaram todos os {{count}} créditos de IA do plano Starter este mês. Adicione o add-on de IA Ilimitada.",
    upgradeToContinue: "Faça upgrade para continuar usando sem limites",
    unlockWith: "Desbloquear com {{plan}}",
    keepCurrentPlan: "Mantenha seu plano atual",
    addOnlyWhatYouNeed: "Adicione apenas o que precisa",
    cancelAnytime: "Cancele quando quiser",
    addonBadge: "Add-on",
    addon50StudentsName: "+50 Alunos",
    addon50StudentsDesc: "Adicione mais 50 alunos ao seu plano",
    addonUnlimitedAIName: "IA Ilimitada",
    addonUnlimitedAIDesc: "Créditos ilimitados por professor/mês",
    upgradeToPro: "Fazer upgrade para Pro",
    addAddon: "Adicionar {{name}}",
  },
  trialEndedModal: {
    title: "Poxa, {{name}}... seu trial acabou",
    body: "Foram {{days}} dias incríveis juntos! Seus alunos vão sentir falta da gamificação completa.",
    statsActivities: "atividades criadas",
    statsStudents: "alunos engajados",
    unlockWith: "Desbloquear com {{plan}}",
  },
  loginTestimonials: {
    badgeLabel: "Depoimentos",
    slides: {
      s1: {
        quote: "Os alunos adoram cumprir missões, ganhar moedas e subir de nível. Isso aumentou muito a participação nas atividades.",
        title: "Professor de História",
      },
      s2: {
        quote: "A Gamefik ajuda muito a manter os alunos focados e motivados. Eles querem participar e acompanhar seu progresso.",
        title: "Professora de Ciências",
      },
      s3: {
        quote: "A gamificação transformou minha sala de aula em um ambiente muito mais envolvente e cheio de aprendizado significativo.",
        title: "Professora de Matemática",
      },
      s4: {
        quote: "A Gamefik ajudou muito os professores no gerenciamento de sala. Os alunos ficaram mais atentos e isso reduziu bastante o tempo gasto com intervenções pedagógicas e processos administrativos.",
        title: "Coordenadora Pedagógica – TFLA Idioma",
      },
      s5: {
        quote: "Somos parceiros da Gamefik há mais de 4 anos. Quando começamos, nossa escola tinha cerca de 80 alunos e hoje já passamos de 400. A gamificação se tornou um grande diferencial para novas matrículas e também ajudou muito na retenção dos estudantes.",
        title: "Diretor do Colégio Alvorecer",
      },
      s6: {
        quote: "Meu filho ficou muito mais animado com a escola depois que começaram a usar a Gamefik. Ele chega em casa contando das missões.",
        title: "Mãe de aluno",
      },
    },
  },
  helpChip: {
    label: "Ajuda",
    tourTitle: "Tour guiado",
    tourSubtitle: "Aprenda passo a passo",
    videoTitle: "Assistir vídeo",
    videoSubtitle: "Tutorial completo",
    helpCenterTitle: "Central de ajuda",
    helpCenterSubtitle: "Artigos e FAQs",
    videoTitleDefault: "Tutorial em vídeo",
    videoModalSubtitle: "Assista o tutorial completo",
    videoComingSoonTitle: "Vídeo em breve",
    videoComingSoonDescription: "O tutorial em vídeo desta página ainda será adicionado. Enquanto isso, acesse a Central de ajuda para tirar suas dúvidas.",
    closeAria: "Fechar",
  },
  interactiveHint: {
    previewBefore: "Este é o app do aluno.",
    previewEmphasis: "Teste a atividade!",
    arrowJogar: "Clique em Jogar",
    arrowEdit: "Edite aqui",
    dismissAria: "Fechar dica",
  },
  tour: {
    loading: "Carregando...",
    skip: "Pular tour",
    next: "Próximo",
    previous: "Anterior",
    finish: "Concluir",
    stepCounter: "Passo {{current}} de {{total}}",
    mobileNotAvailable: "O tour guiado está disponível apenas no desktop. Acesse pelo computador para ver passo a passo.",
    welcome: {
      defaultTitle: "Bem-vindo!",
      defaultDescription: "Parece que é sua primeira vez aqui. Quer que eu te mostre como usar esta página?",
      startCta: "Iniciar tour guiado",
      exploreCta: "Explorar sozinho",
    },
    complete: {
      defaultTitle: "Parabéns!",
      defaultDescription: "Você concluiu o tour desta página. Agora você está pronto para começar a usar!",
      cta: "Começar a usar",
    },
    chatIa: {
      welcomeTitle: "Vamos criar sua primeira atividade!",
      welcomeDescription: "Te mostro em poucos passos como o Chat IA funciona — desde gerar a atividade até publicar para os alunos.",
      completeTitle: "Pronto para criar!",
      completeDescription: "Agora você sabe como gerar uma atividade com a IA, pré-visualizar como o aluno vai ver, editar e publicar. Bora criar a primeira!",
      steps: {
        create: {
          title: "Crie com a IA",
          description: "Digite aqui o tema da sua atividade (ex: 'Quiz sobre fotossíntese para o 7º ano') e clique em Criar. A IA gera tudo pra você em segundos! Continue o tour depois que ela terminar de gerar.",
        },
        editWithAi: {
          title: "Edite com a IA",
          description: "Depois que a atividade for gerada, este chat continua disponível pra você pedir mudanças por IA. Exemplos: 'mais difícil', 'adicione mais 3 questões', 'mude o tema pra Brasil colônia'.",
        },
        preview: {
          title: "Pré-visualização",
          description: "Depois que a IA gerar, este painel mostra exatamente como o aluno vai ver a atividade no app do celular. Confira se está tudo certo antes de publicar.",
        },
        editor: {
          title: "Edite a atividade",
          description: "Clique em Editar pra ajustar título, descrição, questões, alternativas, datas e moedas. Você tem controle total antes de publicar.",
        },
        publish: {
          title: "Publicar",
          description: "Quando estiver pronto, clique em Publicar pra enviar a atividade para as turmas que você escolher. Os alunos vão ver no app na hora!",
        },
      },
    },
    classDetail: {
      welcomeTitle: "Bem-vindo a esta turma!",
      welcomeDescription: "Quer um tour rápido pra entender como gerenciar seus alunos aqui?",
      completeTitle: "Tudo pronto!",
      completeDescription: "Agora você sabe como adicionar alunos, lançar atitudes e compartilhar acesso. Bom uso!",
      steps: {
        welcome: {
          title: "Esta é a sua turma",
          description: "Aqui você gerencia todos os alunos desta turma. Vamos te mostrar as principais ações.",
        },
        addStudent: {
          title: "Adicionar aluno",
          description: "Clique aqui pra adicionar um aluno. Dentro do modal, você ainda pode clicar em 'Importar muitos alunos' e colar uma lista direto do Word ou Excel (Ctrl+C / Ctrl+V) pra cadastrar vários de uma vez.",
        },
        selectStudent: {
          title: "Selecionar um aluno",
          description: "Clique no card de um aluno pra selecioná-lo. Você verá uma marcação aparecer indicando que ele está selecionado. Pode selecionar quantos quiser ao mesmo tempo.",
        },
        launch: {
          title: "Lançar atitudes e pontos",
          description: "Selecione um ou mais alunos clicando nos cards e use este botão pra lançar atitudes, pontos, moedas ou conquistas em massa.",
        },
        shareAccess: {
          title: "Compartilhar acesso de vários alunos",
          description: "Selecione vários alunos, clique aqui no menu de ações e escolha 'Acesso alunos'. Você gera as instruções de acesso (QR Code + link) de todos os selecionados de uma vez só — perfeito pra entregar pros pais.",
        },
        final: {
          title: "Pronto pra começar!",
          description: "Explore a turma à vontade. Quando precisar rever este tour, é só clicar em 'Ajuda' aqui em cima.",
        },
      },
    },
    classes: {
      welcomeTitle: "Bem-vindo às Turmas!",
      welcomeDescription: "Parece que é sua primeira vez aqui. Quer que eu te mostre como usar esta página?",
      completeTitle: "Tour concluído!",
      completeDescription: "Você já sabe como criar turmas, importar alunos em massa e abrir uma turma. Mãos à obra!",
      steps: {
        welcome: {
          title: "Bem-vindo às Turmas!",
          description: "Esta é a área onde você gerencia todas as suas turmas e alunos. Vamos te mostrar como usar cada funcionalidade.",
        },
        newClass: {
          title: "Criar nova turma",
          description: "Clique aqui para criar uma nova turma. Você pode definir o nome e depois adicionar os alunos.",
        },
        classCard: {
          title: "Acessar uma turma",
          description: "Clique em qualquer turma para ver os alunos e gerenciar a turma. Você pode lançar atividades, adicionar alunos e muito mais.",
        },
        import: {
          title: "Importar turmas e alunos",
          description: "Precisa cadastrar muitas turmas de uma vez? Clique em Importar, baixe o modelo de planilha, preencha com nome da turma e nome do aluno, e faça o upload. O sistema cria tudo automaticamente!",
        },
        final: {
          title: "Tudo pronto!",
          description: "Agora você sabe como criar e importar turmas. Explore a plataforma e comece a gamificar suas aulas!",
        },
      },
    },
  },
  reportsDashboard: reportsDashboardPtBR,
  roomTools: roomToolsPtBR,
  tooltips: {
    classes: {
      editClass: "Editar nome e configurações da turma",
      lancarSelected: "Lançar pontos, moedas ou conquistas para os alunos selecionados",
      lancarEmpty: "Selecione alunos para lançar",
      moreActions: "Mais ações (acesso, mover, excluir)",
      copyLink: "Copiar link de acesso da turma",
      classAccessLink: "Link de acesso da turma",
    },
    chatIa: {
      title: "O título aparece para os alunos no app. Seja claro e objetivo!",
      description: "Descreva a atividade de forma clara para o aluno entender o que precisa fazer",

      coverImage: "Imagem que aparece como capa da atividade no app do aluno",
      startDate: "A partir desta data, os alunos poderão ver e iniciar a atividade",
      endDate: "Após esta data, os alunos não poderão mais responder",
      coins: "Moedas que o aluno ganha ao completar. Podem ser trocadas por recompensas!",
    },
  },
  onboardingB: {
    welcome: { title: "Bem-vindo à Gamefik!", subtitle: "Crie aulas que engajam de verdade — onde o aluno não quer parar de aprender.", cta: "Vamos nessa" },
    nome: { eyebrow: "Sobre você", title: "Qual seu nome?", placeholder: "Seu nome", cta: "Continuar" },
    pais: { eyebrow: "Sobre você", title: "Onde você ensina?", paisLabel: "País", phoneLabel: "Telefone (opcional)", phoneHint: "Pra te avisar quando a turma jogar. Sem spam.", cta: "Continuar" },
    motivacao: { eyebrow: "Conta pra gente", title: "O que você mais quer pra sua turma?", engajar: "Engajar a turma", engajarSub: "Quero alunos participando de verdade", tempo: "Ganhar tempo", tempoSub: "Preparar aula em minutos, não horas", resultados: "Acompanhar resultados", resultadosSub: "Ver quem aprendeu, em tempo real", diversao: "Aula mais divertida", diversaoSub: "Transformar o conteúdo em jogo", comportamento: "Melhorar o comportamento", comportamentoSub: "Turma mais focada e participativa", cta: "Continuar" },
    loop: { eyebrow: "Como funciona", title: "Da ideia à atividade publicada em segundos.", subtitle: "Um processo de aprendizado personalizado e adaptativo em poucos toques.", step1: "Descreva o tema", step1Sub: "Em uma frase, diga o que quer ensinar.", step2: "A IA cria a atividade", step2Sub: "Questões, alternativas e correção — prontas.", step3: "Publique pra sua turma", step3Sub: "Compartilhe e acompanhe os resultados.", cta: "Continuar" },
    alunoApp: { eyebrow: "A sua turma", title: "Eles jogam a trilha no app Gamefik.", subtitle: "Para a melhor experiência, seus alunos baixam o app Gamefik e avançam pela trilha como num jogo — pontos, fases e ranking.", storeHint: "Disponível para baixar grátis", cta: "Bora criar a sua" },
    materia: { eyebrow: "Sua matéria", title: "Qual matéria você ensina?", cta: "Continuar" },
    tema: { eyebrow: "O tema da trilha", title: "O que a trilha vai ensinar?", placeholder: "Ex: frações", hint: "Digite um tema ou toque em um exemplo", cta: "Montar minha trilha" },
    montando: { eyebrow: "Montando sua trilha", title: "Sua trilha de {{tema}} está nascendo.", phasesProgress: "{{done}} de {{total}} etapas geradas", preparing: "Preparando sua trilha…", genErrorHint: "Continue para finalizar seu cadastro — você cria suas trilhas depois.", step1: "Trilha", step1Sub: "As fases do conteúdo", step2: "Recompensas", step2Sub: "Pontos e conquistas", step3: "Ranking", step3Sub: "A turma na disputa", task1: "Criando as fases e atividades…", task1Done: "Fases e atividades criadas", task2: "Gerando recompensas e ranking…", task2Done: "Recompensas e ranking prontos", task3: "Preparando o link pra compartilhar com seus alunos…", task3Done: "Link pronto pra compartilhar", cta: "Continuar" },
    mais: { eyebrow: "Não para por aí", title: "E temos muito mais pra transformar sua sala", subtitle: "Na Gamefik você cria vários tipos de atividade gamificada pros alunos jogarem e aprenderem.", atividadesIa: "Crie atividades gamificadas com IA em segundos", gestaoTurmas: "Gestão de turmas", relatorios: "Relatórios pedagógicos", trilhas: "Trilhas de aprendizado", muralTurma: "Mural da turma", recompensas: "Recompensas", more: "e muito mais", cta: "Continuar" },
    resultados: { eyebrow: "Resultados de verdade", title: "Você quer esses resultados para seus alunos?", statEngajamentoValue: "90%", statEngajamentoLabel: "de engajamento da turma", statProfessoresValue: "+10 mil", statProfessoresLabel: "professores já usam a Gamefik", statTempoValue: "+2h", statTempoLabel: "economizadas por semana", statMelhoraValue: "90%", statMelhoraLabel: "dos alunos melhoram o desempenho", quote: "A gamificação transformou minha sala de aula em um ambiente muito mais envolvente.", quoteAuthor: "Juliana Martins", quoteRole: "Professora de Matemática", cta: "Sim, quero pra minha turma!" },
    preview: { eyebrow: "Pronto", title: "Sua trilha de {{tema}} está pronta!", ready: "Pronta pra publicar", phaseLabel: "Fase {{n}}", studentsHint: "Seus alunos jogam tudo isso no app Gamefik", cta: "Continuar" },
    planos: { eyebrow: "Desbloqueie tudo", title: "Experimente a Gamefik completa, grátis.", subtitle: "Cartão obrigatório. Cancele quando quiser.", priceSuffix: "/mês", yearlyCaption: "cobrado {{price}}/ano · economize {{percent}}%", cycleMonthly: "Mensal", cycleYearly: "Anual", yearlyBadge: "Maior economia no anual", shinyName: "Shiny", shinyBadge: "Mais completo", shinyTrial: "7 dias grátis", shinyCta: "Começar 7 dias grátis", shinyF1: "Turmas, alunos e atividades ilimitados", shinyF2: "IA ilimitada (fair use)", shinyF3: "Trilhas ilimitadas", shinyF4: "Recompensas e moeda personalizada", skip: "Agora não, ver minha trilha", skipQuiz: "Agora não, ver meu quiz" },
    payoff: {
      gamificacao: {
        eyebrow: "Engajamento de verdade",
        title: "Seus alunos não vão querer parar de estudar",
        sub: "Cada atividade vira pontos: alunos ganham gemas, trocam por lendas na coleção e desbloqueiam conquistas.",
        tarefa: "Concluem as tarefas",
        gema: "Ganham gemas",
        lenda: "Compram lendas",
        badge: "Desbloqueiam conquistas",
      },
      produtividade: {
        eyebrow: "Menos trabalho, mais clareza",
        title: "Da ideia à atividade publicada em segundos",
        sub: "Crie atividades e minigames em segundos e acompanhe, em relatórios, exatamente onde a turma trava.",
        relatorios: "Relatórios que mostram onde a turma precisa de ajuda",
      },
      comportamento: {
        eyebrow: "Uma turma mais focada",
        title: "Reforce o bom comportamento",
        sub: "Envie feedbacks personalizados e bonifique alunos que se destacam — o estímulo certo, na hora certa.",
        feedback: "Feedbacks personalizados",
        bonificar: "Bonifique o bom comportamento",
      },
      cta: "Quero isso na minha sala",
    },
    criar: {
      eyebrow: "Vamos começar",
      title: "Vamos criar sua primeira atividade gamificada?",
      cta: "Criar minha atividade",
      trilha: "Trilha estilo Duolingo",
      trilhaSub: "Uma jornada de fases que vicia.",
      quiz: "Quiz",
      quizSub: "Perguntas rápidas pra fixar o conteúdo.",
      flashcard: "Flashcards",
      flashcardSub: "Memorização com cartões.", emBreveHint: "Flashcards chegam em breve — escolha Trilha ou Quiz pra continuar.",
      emBreve: "Em breve",
    },
    temaQuiz: {
      title: "Sobre o que será seu quiz?",
      placeholder: "Ex.: revolução industrial",
      cta: "Montar meu quiz",
    },
    montandoQuiz: {
      eyebrow: "Quase lá",
      title: "Montando seu quiz sobre {{tema}}",
      task1: "Escrevendo as perguntas",
      task1Done: "Perguntas escritas",
      task2: "Montando as alternativas",
      task2Done: "Alternativas prontas",
      task3: "Revisando o quiz",
      task3Done: "Quiz revisado",
    },
    previewQuiz: {
      title: "Seu quiz de {{tema}} está pronto",
      ready: "Pronto pra publicar",
    },
  },
  liveSession: {
    lobby: {
      exit: "Sair",
      typeMission: "Missão",
      typeQuiz: "Quiz",
      typeFlashcard: "Flashcards",
      coins: "moedas",
      exitFullscreen: "Sair da tela cheia",
      enterFullscreen: "Tela cheia",
      joinAt: "Entre em",
      linkCopied: "Link copiado!",
      copyLink: "Copiar link",
      gamePin: "PIN do jogo",
      copied: "Copiado!",
      copyPin: "Copiar PIN",
      scanToJoin: "Escaneie para entrar",
      playerCompleted: "{{count}} jogador concluiu",
      playersCompleted: "{{count}} jogadores concluíram",
      waitingMore: "Aguardando mais jogadores...",
      waitingPlayers: "Aguardando jogadores concluírem...",
      shareHint: "Compartilhe o PIN ou QR Code com a turma",
      finishGame: "Finalizar jogo",
      waitAtLeastOne: "Aguarde pelo menos 1 jogador concluir",
    },
    results: {
      back: "Voltar",
      finalResult: "Resultado Final",
      podium: "Pódio",
      report: "Relatório",
    },
    report: {
      noAnswers: "Nenhuma resposta registrada ainda.",
      title: "Desempenho por questão",
      subtitle: "Todas as questões respondidas",
      questionFallback: "Questão {{number}}",
      correct: "{{count}} acertos",
      wrong: "{{count}} erros",
      outOf: "de {{count}}",
    },
    podium: {
      defaultName: "Jogador",
    },
  },
} as const;
